module.exports = {
    BubblesData: () => {
        return [
            [
                {
                    num:"105",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[597.526,810.04],[597.526,913.583],[418.026,793.57],[418.026,890.815]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[598.234,430.997],[598.234,327.429],[418.651,437.583],[418.651,340.316]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[598.234,553.266],[598.234,449.698],[418.651,552.413],[418.651,455.146]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[598.234,568.214],[598.234,671.782],[418.651,566.452],[418.651,663.719]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[598.234,687.357],[598.234,790.925],[418.651,678.347],[418.651,775.615]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[555.016,324.595],[555.016,228.979],[514.567,327.58],[514.567,233.293]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[560.332,317.608],[560.332,218.88],[529.132,321.849],[529.132,225.009]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[584.872,314.576],[584.872,214.496],[560.332,317.608],[560.332,218.88]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[626.135,310.244],[626.135,208.236],[584.872,314.576],[584.872,214.496]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[803.951,423.453],[803.951,312.667],[599.333,430.957],[599.333,327.35]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[803.951,554.242],[803.951,443.456],[599.333,553.271],[599.333,449.664]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[803.951,570.232],[803.951,681.018],[599.333,568.225],[599.333,671.831]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[803.951,697.679],[803.951,808.465],[599.333,687.413],[599.333,791.019]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[803.951,828.981],[803.951,939.766],[599.333,810.206],[599.333,913.812]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[685.47,307.047],[685.47,203.614],[630.419,310.077],[630.419,207.994]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[725.068,305.242],[725.068,201.004],[685.47,307.047],[685.47,203.614]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[782.467,302.907],[782.467,197.63],[725.067,305.242],[725.067,201.004]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[782.468,302.907],[782.468,197.63],[807.1,306.149],[807.1,202.317]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[893.464,423.55],[803.95,423.453],[893.464,312.858],[803.95,312.667]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[893.464,554.23],[893.464,443.537],[803.95,554.242],[803.95,443.456]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[893.464,570.206],[803.95,570.232],[893.464,680.898],[803.95,681.018]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[893.464,697.546],[803.95,697.679],[893.464,808.238],[803.95,808.465]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[893.699,828.684],[803.95,828.981],[893.699,939.356],[803.95,939.766]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[856.257,302.524],[856.257,197.076],[807.1,306.149],[807.1,202.317]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[856.256,302.524],[942.865,304.045],[856.256,197.076],[942.865,199.275]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[893.464,423.55],[893.464,312.858],[934.718,426.383],[934.718,318.401]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[893.464,554.23],[893.464,443.537],[934.718,553.863],[934.718,445.881]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[893.464,570.206],[893.464,680.898],[934.718,569.448],[934.718,677.43]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[893.464,697.546],[893.464,808.238],[934.718,693.669],[934.718,801.651]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[893.699,828.684],[893.699,939.356],[933.023,821.926],[933.023,930.015]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[975.244,825.558],[975.244,935.035],[933.024,821.927],[933.024,930.015]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[975.386,424.987],[975.386,315.67],[934.719,426.383],[934.719,318.401]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[975.386,554.043],[975.386,444.726],[934.719,553.863],[934.719,445.881]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[975.386,569.821],[975.386,679.139],[934.719,569.448],[934.719,677.43]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[975.386,695.579],[975.386,804.896],[934.719,693.669],[934.719,801.651]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[942.865,304.045],[942.865,199.275],[1028.88,308.401],[1028.88,205.57]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[975.385,424.988],[975.384,315.67],[1053.96,430.59],[1053.96,326.632]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[975.385,554.044],[975.384,444.726],[1053.96,553.318],[1053.96,449.361]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[975.384,569.821],[975.385,679.139],[1053.96,568.323],[1053.96,672.281]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[975.384,695.579],[975.385,804.896],[1053.96,687.915],[1053.96,791.873]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[975.244,825.558],[975.244,935.034],[1059.08,810.582],[1059.08,914.332]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[1028.88,308.401],[1028.88,205.57],[1134.82,316.09],[1134.82,216.685]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[1124.5,428.34],[1124.5,322.23],[1053.96,430.59],[1053.96,326.632]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[1124.5,553.61],[1124.5,447.5],[1053.96,553.318],[1053.96,449.361]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[1124.5,568.925],[1124.5,675.034],[1053.96,568.323],[1053.96,672.281]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[1124.5,690.992],[1124.5,797.102],[1053.96,687.915],[1053.96,791.873]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[1122.2,816.773],[1122.2,922.891],[1051.99,811.167],[1051.99,915.141]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[1122.2,816.773],[1122.2,922.891],[1230.81,806.213],[1230.81,908.293]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[1124.5,428.34],[1124.5,322.23],[1227.42,432.317],[1227.42,330.012]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[1124.5,553.61],[1124.5,447.5],[1227.42,553.095],[1227.42,450.789]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[1124.5,568.925],[1124.5,675.034],[1227.42,567.861],[1227.42,670.166]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[1124.5,690.992],[1124.5,797.102],[1227.42,685.552],[1227.42,787.857]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[1145.42,315.411],[1145.42,215.704],[1230.44,324.306],[1230.44,228.561]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[1230.44,324.306],[1230.44,228.561],[1297.94,335.072],[1297.94,244.122]]
                },{
                    num:"503",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[1211.06,436.19],[1211.06,334.377],[1391.36,449.782],[1391.36,361.397]]
                },{
                    num:"403",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[1211.06,556.386],[1211.06,454.573],[1391.36,554.126],[1391.36,465.741]]
                },{
                    num:"303",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[1211.06,571.081],[1211.06,672.894],[1391.36,566.883],[1391.36,655.268]]
                },{
                    num:"203",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[1211.06,688.206],[1211.06,790.018],[1391.36,668.561],[1391.36,756.946]]
                },{
                    num:"103",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[1211.06,805.514],[1211.06,907.327],[1391.36,770.398],[1391.36,858.783]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[1297.94,335.071],[1297.94,244.122],[1329.47,344.494],[1329.47,257.74]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[1323.52,345.251],[1323.52,258.836],[1336.04,354.157],[1336.04,271.708]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[1411.2,446.867],[1411.2,358.482],[1423.63,451.164],[1423.63,366.889]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[1411.2,551.211],[1411.2,462.826],[1423.63,550.655],[1423.63,466.381]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[1411.2,563.968],[1411.2,652.353],[1423.63,562.819],[1423.63,647.093]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:1,
                    verts:[[1411.2,665.645],[1411.2,754.03],[1423.63,659.767],[1423.63,744.042]]
                },
                ],
                [
                {
                    num:"105",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[635.091,810.945],[635.091,914.835],[437.062,796.389],[437.062,894.712]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[635.866,430.638],[635.866,326.727],[437.756,436.459],[437.756,338.116]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[635.866,553.312],[635.866,449.401],[437.756,552.559],[437.756,454.216]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[635.866,568.31],[635.866,672.221],[437.756,566.753],[437.756,665.095]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[635.866,687.848],[635.866,791.759],[437.756,679.885],[437.756,778.228]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[528.787,325.932],[528.787,230.911],[522.338,332.737],[522.338,240.748]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[573.161,323.295],[573.161,227.1],[528.787,325.932],[528.787,230.911]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[585.966,316.406],[585.966,217.143],[549.733,320.354],[549.733,222.849]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[614.073,313.609],[614.073,213.1],[585.967,316.407],[585.967,217.143]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[660.385,309.679],[660.385,207.419],[614.073,313.609],[614.073,213.099]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[859.11,424.08],[859.11,313.894],[637.07,430.603],[637.07,326.658]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[859.11,554.161],[859.11,443.975],[637.07,553.317],[637.07,449.372]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[859.11,570.064],[859.11,680.25],[637.07,568.319],[637.07,672.264]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[859.11,696.821],[859.11,807.007],[637.07,687.897],[637.07,791.842]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[859.11,827.412],[859.11,937.598],[637.07,811.091],[637.07,915.036]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[723.518,307.04],[723.518,203.604],[664.886,309.551],[664.886,207.233]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[765.137,305.609],[765.137,201.536],[723.518,307.04],[723.518,203.604]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[824.938,303.821],[824.938,198.951],[765.136,305.609],[765.136,201.536]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[824.939,303.821],[824.939,198.951],[846.136,307.22],[846.136,203.864]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[898.725,304.097],[898.725,199.349],[846.136,307.22],[846.136,203.864]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[859.11,424.08],[947.622,424.56],[859.11,313.894],[947.622,314.834]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[859.11,554.161],[859.11,443.975],[947.622,554.099],[947.622,444.373]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[859.11,570.064],[859.11,680.25],[947.622,569.936],[947.622,679.662]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[859.11,696.821],[947.622,696.164],[859.11,807.007],[947.622,805.89]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[859.11,827.412],[947.808,826.155],[859.11,937.598],[947.808,935.86]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[898.724,304.097],[898.724,199.35],[982.797,306.342],[982.797,202.595]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[947.622,424.56],[947.622,314.834],[982.116,427.5],[982.116,320.587]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[947.622,554.099],[947.622,444.373],[982.116,553.718],[982.116,446.805]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[947.622,569.936],[947.622,679.662],[982.116,569.149],[982.116,676.063]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[947.622,696.164],[947.622,805.89],[982.116,692.141],[982.116,799.055]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[947.808,826.155],[947.808,935.86],[980.689,819.143],[980.689,926.167]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[1025.4,822.239],[1025.4,930.447],[980.69,819.143],[980.69,926.167]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[1025.17,426.31],[1025.17,318.258],[982.117,427.5],[982.117,320.587]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[1025.17,553.872],[1025.17,445.82],[982.117,553.718],[982.117,446.805]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[1025.17,569.468],[1025.17,677.52],[982.117,569.149],[982.117,676.063]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[1025.17,693.77],[1025.17,801.822],[982.117,692.141],[982.117,799.055]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[982.797,306.342],[982.797,202.595],[1062.9,311.328],[1062.9,209.801]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[1025.17,426.31],[1025.17,318.258],[1090,432.084],[1090,329.556]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[1025.17,553.872],[1025.17,445.82],[1090,553.125],[1090,450.597]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[1025.17,569.468],[1025.17,677.52],[1090,567.923],[1090,670.451]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[1025.17,693.77],[1025.17,801.822],[1090,685.871],[1090,788.399]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[1025.4,822.239],[1025.4,930.447],[1094.54,806.807],[1094.54,909.115]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[1062.9,311.328],[1062.9,209.801],[1158.57,319.684],[1158.57,221.88]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[1163.62,430.183],[1163.62,325.836],[1090,432.084],[1090,329.556]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[1163.62,553.371],[1163.62,449.024],[1090,553.125],[1090,450.597]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[1163.62,568.432],[1163.62,672.778],[1090,567.923],[1090,670.451]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[1163.62,688.471],[1163.62,792.818],[1090,685.871],[1090,788.399]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[1161.4,812.185],[1161.4,916.548],[1088.1,807.447],[1088.1,909.999]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[1161.4,812.185],[1161.4,916.548],[1257.57,800.887],[1257.57,900.931]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[1163.62,430.183],[1163.62,325.836],[1254.81,434.441],[1254.81,334.167]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[1163.62,553.371],[1163.62,449.024],[1254.81,552.82],[1254.81,452.546]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[1163.62,568.432],[1163.62,672.778],[1254.81,567.293],[1254.81,667.566]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[1163.62,688.471],[1163.62,792.818],[1254.81,682.646],[1254.81,782.92]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[1169.56,319.112],[1169.56,221.054],[1243.09,328.413],[1243.09,234.497]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[1243.1,328.413],[1243.1,234.497],[1297.54,339.344],[1297.54,250.297]]
                },{
                    num:"503",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[1237.9,438.169],[1237.9,338.311],[1381.53,451.926],[1381.53,365.658]]
                },{
                    num:"403",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[1237.9,556.057],[1237.9,456.199],[1381.53,553.77],[1381.53,467.502]]
                },{
                    num:"303",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[1237.9,570.47],[1237.9,670.328],[1381.53,566.221],[1381.53,652.489]]
                },{
                    num:"203",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[1237.9,685.346],[1237.9,785.204],[1381.53,665.463],[1381.53,751.731]]
                },{
                    num:"103",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[1237.9,800.402],[1237.9,900.26],[1381.53,764.861],[1381.53,851.129]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[1297.54,339.343],[1297.54,250.296],[1318.57,348.684],[1318.57,263.796]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[1400.51,449.146],[1400.51,362.942],[1403.34,453.329],[1403.34,371.126]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[1400.51,550.916],[1400.51,464.712],[1403.34,550.375],[1403.34,468.172]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[1400.51,563.358],[1400.51,649.563],[1403.34,562.239],[1403.34,644.442]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:2,
                    verts:[[1400.51,662.527],[1400.51,748.732],[1403.34,656.805],[1403.34,739.008]]
                },
                ],
                [
                {
                    num:"105",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[675.114,811.495],[675.114,915.595],[460.568,799.015],[460.568,898.343]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[675.947,430.422],[675.947,326.304],[461.327,435.412],[461.327,336.068]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[675.947,553.34],[675.947,449.222],[461.327,552.694],[461.327,453.35]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[675.947,568.368],[675.947,672.486],[461.327,567.033],[461.327,666.377]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[675.947,688.144],[675.947,792.262],[461.327,681.318],[461.327,780.662]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[546.464,324.398],[546.464,228.694],[532.706,331.118],[532.706,238.408]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[594.371,322.137],[594.371,225.425],[546.465,324.398],[546.465,228.694]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[614.588,315.409],[614.588,215.701],[573.659,319.026],[573.659,220.928]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[645.97,312.875],[645.97,212.037],[614.588,315.409],[614.588,215.701]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[696.807,309.381],[696.807,206.988],[645.97,312.875],[645.97,212.037]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[913.662,424.895],[913.662,315.49],[677.24,430.392],[677.24,326.245]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[913.662,554.056],[913.662,444.65],[677.24,553.344],[677.24,449.197]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[913.662,569.846],[913.662,679.252],[677.24,568.376],[677.24,672.523]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[913.662,695.705],[913.662,805.111],[677.24,688.185],[677.24,792.332]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[913.662,825.371],[913.662,934.777],[677.24,811.619],[677.24,915.766]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[762.982,307.32],[762.982,204.008],[701.475,309.293],[701.475,206.861]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[806.108,306.27],[806.108,202.491],[762.982,307.32],[762.982,204.008]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[867.556,305.03],[867.556,200.698],[806.107,306.27],[806.107,202.491]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[867.557,305.03],[867.557,200.698],[885.151,308.546],[885.151,205.781]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[940.462,305.937],[940.462,202.009],[885.151,308.546],[885.151,205.781]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[913.661,424.895],[913.661,315.49],[1000.04,425.736],[1000.04,317.135]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[913.661,554.056],[913.661,444.65],[1000.04,553.947],[1000.04,445.346]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[913.661,569.846],[913.661,679.252],[1000.04,569.621],[1000.04,678.222]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[913.661,695.705],[913.661,805.111],[1000.04,694.555],[1000.04,803.156]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[913.661,825.371],[913.661,934.777],[1000.18,823.212],[1000.18,931.792]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[940.462,305.937],[940.462,202.009],[1021.11,308.848],[1021.11,206.217]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[1000.04,425.736],[1000.04,317.135],[1027.6,428.746],[1027.6,323.023]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[1000.04,553.947],[1000.04,445.346],[1027.6,553.557],[1027.6,447.835]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[1000.04,569.621],[1000.04,678.222],[1027.6,568.816],[1027.6,674.538]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[1000.04,694.555],[1000.04,803.156],[1027.6,690.438],[1027.6,796.16]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[1000.18,823.212],[1000.18,931.792],[1026.45,816.035],[1026.45,921.871]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[1021.1,308.848],[1021.1,206.217],[1094.65,314.376],[1094.65,214.208]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[1072.98,818.595],[1072.98,925.409],[1026.45,816.035],[1026.45,921.871]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[1072.41,427.762],[1072.41,321.098],[1027.6,428.745],[1027.6,323.023]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[1072.41,553.684],[1072.41,447.021],[1027.6,553.557],[1027.6,447.835]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[1072.41,569.079],[1072.41,675.743],[1027.6,568.816],[1027.6,674.538]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[1072.41,691.784],[1072.41,798.447],[1027.6,690.438],[1027.6,796.16]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[1072.41,427.762],[1072.41,321.098],[1123.37,433.636],[1123.37,332.593]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[1072.41,553.685],[1072.41,447.021],[1123.37,552.924],[1123.37,451.881]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[1072.41,569.079],[1072.41,675.743],[1123.37,567.508],[1123.37,668.551]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[1072.41,691.784],[1072.41,798.447],[1123.37,683.747],[1123.37,784.791]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[1072.98,818.595],[1072.98,925.409],[1127.3,802.896],[1127.3,903.708]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[1094.65,314.376],[1094.65,214.208],[1179.59,323.274],[1179.59,227.068]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[1199.07,432.077],[1199.07,329.542],[1123.37,433.636],[1123.37,332.593]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[1199.07,553.126],[1199.07,450.591],[1123.37,552.924],[1123.37,451.881]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[1199.07,567.925],[1199.07,670.46],[1123.37,567.508],[1123.37,668.551]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[1199.07,685.88],[1199.07,788.415],[1123.37,683.747],[1123.37,784.791]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[1196.95,807.467],[1196.95,910.026],[1121.58,803.581],[1121.58,904.654]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[1190.84,322.805],[1190.84,226.391],[1252.88,332.394],[1252.88,240.251]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[1196.95,807.467],[1196.95,910.026],[1280.42,795.609],[1280.42,893.633]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[1199.07,432.077],[1199.07,329.542],[1278.26,436.548],[1278.26,338.29]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[1199.07,553.126],[1199.07,450.591],[1278.26,552.547],[1278.26,454.29]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[1199.07,567.925],[1199.07,670.46],[1278.26,566.729],[1278.26,664.986]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[1199.07,685.88],[1199.07,788.415],[1278.26,679.763],[1278.26,778.021]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[1252.88,332.394],[1252.88,240.251],[1294.68,343.383],[1294.68,256.135]]
                },{
                    num:"503",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[1261.02,440.135],[1261.02,342.219],[1369.31,453.92],[1369.31,369.623]]
                },{
                    num:"403",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[1261.02,555.73],[1261.02,457.815],[1369.31,553.439],[1369.31,469.141]]
                },{
                    num:"303",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[1261.02,569.863],[1261.02,667.778],[1369.31,565.605],[1369.31,649.903]]
                },{
                    num:"203",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[1261.02,682.504],[1261.02,780.42],[1369.31,662.58],[1369.31,746.877]]
                },{
                    num:"103",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[1261.02,795.323],[1261.02,893.239],[1369.31,759.708],[1369.31,844.005]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:3,
                    verts:[[1294.68,343.383],[1294.68,256.135],[1305.77,352.577],[1305.77,269.423]]
                },
                ],
                [
                {
                    num:"105",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[489.959,788.029],[489.959,883.155],[451.011,786.371],[451.011,880.863]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[492.017,439.908],[492.017,344.866],[454.478,440.546],[454.478,346.114]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[492.017,552.112],[492.017,457.07],[454.478,552.03],[454.478,457.597]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[492.017,565.83],[492.017,660.872],[454.478,565.659],[454.478,660.091]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[492.017,675.166],[492.017,770.208],[454.478,674.293],[454.478,768.725]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[488.992,434.428],[488.992,334.142],[458.683,437.394],[458.683,339.945]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[488.992,552.822],[488.992,452.536],[458.683,552.438],[458.683,454.989]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[488.992,567.296],[488.992,667.582],[458.683,566.503],[458.683,663.951]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[488.992,682.664],[488.992,782.949],[458.683,678.606],[458.683,776.055]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[488.175,801.484],[488.175,901.756],[458.172,794.025],[458.172,891.444]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[717.917,430.321],[717.917,326.105],[488.992,434.428],[488.992,334.142]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[717.917,553.353],[717.917,449.138],[488.992,552.822],[488.992,452.536]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[717.917,568.395],[717.917,672.61],[488.992,567.296],[488.992,667.582]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[717.917,688.283],[717.917,792.498],[488.992,682.664],[488.992,782.949]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[717.036,811.758],[717.036,915.958],[488.175,801.484],[488.175,901.756]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[567.296,322.944],[567.296,226.592],[546.256,329.524],[546.256,236.102]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[618.312,321.08],[618.312,223.897],[567.297,322.944],[567.297,226.591]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[645.774,314.571],[645.774,214.49],[600.541,317.823],[600.541,219.19]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[680.107,312.321],[680.107,211.237],[645.775,314.571],[645.775,214.49]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[734.906,309.293],[734.906,206.861],[680.107,312.321],[680.107,211.237]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[966.996,425.852],[966.996,317.361],[719.285,430.296],[719.285,326.057]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[966.996,553.932],[966.996,445.441],[719.285,553.356],[719.285,449.118]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[966.996,569.59],[966.996,678.081],[719.285,568.401],[719.285,672.64]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[966.996,694.397],[966.996,802.888],[719.285,688.317],[719.285,792.555]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[966.996,822.979],[966.996,931.47],[719.285,811.859],[719.285,916.098]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[803.359,307.818],[803.359,204.728],[739.686,309.245],[739.686,206.791]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[847.485,307.15],[803.359,307.818],[847.485,203.762],[803.359,204.729]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[909.85,306.452],[847.484,307.15],[909.85,202.754],[847.484,203.762]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[909.85,306.452],[909.85,202.754],[923.74,310.049],[923.74,207.953]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[981.08,307.955],[981.08,204.927],[923.74,310.049],[923.74,207.953]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[966.996,425.852],[966.996,317.361],[1050.25,427.026],[1050.25,319.659]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[966.996,553.932],[966.996,445.441],[1050.25,553.78],[1050.25,446.413]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[966.996,569.59],[966.996,678.081],[1050.25,569.276],[1050.25,676.643]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[966.996,694.397],[966.996,802.888],[1050.25,692.79],[1050.25,800.157]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[966.996,822.979],[966.996,931.47],[1050.34,819.985],[1050.34,927.331]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[981.079,307.955],[981.079,204.927],[1057.53,311.471],[1057.53,210.009]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[1050.25,427.026],[1050.25,319.659],[1070.83,430.071],[1070.83,325.617]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[1050.25,553.78],[1050.25,446.413],[1070.83,553.386],[1070.83,448.932]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[1050.25,569.276],[1050.25,676.643],[1070.83,568.461],[1070.83,672.915]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[1050.25,692.79],[1050.25,800.157],[1070.83,688.624],[1070.83,793.078]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[1050.34,819.985],[1050.34,927.331],[1069.96,812.722],[1069.96,917.291]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[1057.53,311.472],[1057.53,210.009],[1124.03,317.459],[1124.03,218.664]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[1117.69,814.754],[1069.96,812.722],[1117.69,920.1],[1069.96,917.291]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[1116.8,429.29],[1116.79,324.089],[1070.83,430.071],[1070.83,325.617]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[1116.8,553.487],[1116.79,448.285],[1070.83,553.385],[1070.83,448.932]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[1116.79,568.67],[1116.8,673.871],[1070.83,568.461],[1070.83,672.915]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[1116.79,689.693],[1116.8,794.894],[1070.83,688.624],[1070.83,793.078]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[1116.79,429.29],[1116.79,324.089],[1154.01,435.203],[1154.01,335.659]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[1116.79,553.487],[1116.79,448.286],[1154.01,552.721],[1154.01,453.177]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[1116.79,568.67],[1116.79,673.872],[1154.01,567.089],[1154.01,666.633]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[1116.79,689.693],[1116.79,794.894],[1154.01,681.603],[1154.01,781.147]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[1117.69,814.754],[1117.69,920.1],[1157.33,798.955],[1157.33,898.259]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[1124.03,317.46],[1124.03,218.665],[1197.98,326.782],[1197.98,232.14]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[1230.88,433.974],[1230.88,333.254],[1154.01,435.203],[1154.01,335.659]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[1230.88,552.88],[1230.88,452.16],[1154.01,552.721],[1154.01,453.177]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[1230.88,567.417],[1230.88,668.137],[1154.01,567.089],[1154.01,666.633]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[1230.88,683.285],[1230.88,784.005],[1154.01,681.603],[1154.01,781.147]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[1228.88,802.739],[1228.88,903.49],[1152.32,799.674],[1152.32,899.254]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[1209.37,326.413],[1209.37,231.606],[1260.06,336.189],[1260.06,245.737]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[1228.88,802.739],[1228.88,903.49],[1299.58,790.475],[1299.58,886.537]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[1230.88,433.974],[1230.88,333.254],[1298.01,438.6],[1298.01,342.305]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[1230.88,552.88],[1230.88,452.16],[1298.01,552.282],[1298.01,455.987]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[1230.88,567.417],[1230.88,668.137],[1298.01,566.18],[1298.01,662.475]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[1230.88,683.285],[1230.88,784.005],[1298.01,676.956],[1298.01,773.251]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[1260.06,336.189],[1260.06,245.737],[1289.68,347.149],[1289.68,261.579]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[1289.68,347.149],[1289.68,261.579],[1291.4,356.147],[1291.4,274.584]]
                },{
                    num:"503",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[1280.63,442.051],[1280.63,346.027],[1355.1,455.755],[1355.1,373.269]]
                },{
                    num:"403",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[1280.63,555.412],[1280.63,459.389],[1355.1,553.134],[1355.1,470.648]]
                },{
                    num:"303",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[1280.63,569.271],[1280.63,665.294],[1355.1,565.039],[1355.1,647.524]]
                },{
                    num:"203",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[1280.63,679.735],[1280.63,775.758],[1355.1,659.929],[1355.1,742.414]]
                },{
                    num:"103",
                    tipo:"TorreD",
                    frame:4,
                    verts:[[1280.63,790.373],[1280.63,886.397],[1355.1,754.969],[1355.1,837.454]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[527.869,444.491],[527.868,353.832],[462.978,445.258],[462.977,355.334]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[527.869,551.519],[527.868,460.86],[462.978,551.42],[462.977,461.495]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[527.868,564.604],[527.869,655.263],[462.977,564.398],[462.978,654.323]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[527.868,668.897],[527.869,759.556],[462.977,667.846],[462.978,757.771]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[527.668,776.479],[527.668,867.19],[463.012,774.564],[463.012,864.542]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[509.309,790.393],[509.309,886.424],[467.942,789.093],[467.942,884.627]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[511.216,438.971],[511.216,343.031],[471.355,439.471],[471.355,344.01]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[511.216,552.234],[511.216,456.294],[471.355,552.169],[471.355,456.708]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[511.216,566.081],[511.216,662.02],[471.355,565.947],[471.355,661.408]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[511.216,676.449],[511.216,772.388],[471.355,675.764],[471.355,771.225]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[520.397,433.492],[520.397,332.311],[482.748,436.336],[482.748,337.876]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[520.397,552.943],[520.397,451.761],[482.748,552.575],[482.748,454.114]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[520.397,567.546],[520.397,668.728],[482.748,566.785],[482.748,665.246]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[520.397,683.944],[520.397,785.125],[482.748,680.053],[482.748,778.513]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[519.531,803.834],[519.531,905.004],[482.156,796.676],[482.156,895.109]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[760.373,811.8],[760.373,916.017],[519.531,803.834],[519.531,905.005]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[761.292,430.307],[761.292,326.079],[520.397,433.492],[520.397,332.311]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[761.292,553.355],[761.292,449.127],[520.397,552.943],[520.397,451.761]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[761.292,568.398],[761.292,672.626],[520.397,567.546],[520.397,668.728]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[761.292,688.301],[761.292,792.529],[520.397,683.944],[520.397,785.125]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[562.771,327.922],[562.771,233.787],[557.672,335.442],[557.672,244.657]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[591.005,321.533],[591.005,224.553],[562.771,327.922],[562.771,233.787]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[644.682,320.085],[644.682,222.46],[591.005,321.533],[591.005,224.553]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[679.152,313.848],[679.152,213.444],[630.041,316.708],[630.041,217.578]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[716.087,311.9],[716.087,210.628],[679.153,313.848],[679.153,213.444]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[774.255,309.359],[774.255,206.955],[716.087,311.9],[716.087,210.628]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[1018.66,426.905],[1018.66,319.422],[762.719,430.288],[762.719,326.042]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[1018.66,553.795],[1018.66,446.312],[762.719,553.357],[762.719,449.111]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[1018.66,569.309],[1018.66,676.792],[762.719,568.403],[762.719,672.649]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[1018.66,692.956],[1018.66,800.439],[762.719,688.327],[762.719,792.573]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[1018.66,820.343],[1018.66,927.827],[762.719,811.878],[762.719,916.124]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[844.231,308.472],[844.231,205.674],[779.097,309.351],[779.097,206.944]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[888.866,308.181],[844.231,308.472],[888.866,205.253],[844.231,205.674]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[951.455,308.014],[888.866,308.181],[951.455,205.011],[888.866,205.253]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[951.456,308.014],[951.456,205.011],[961.594,311.658],[961.594,210.279]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[1020.3,310.075],[1020.3,207.991],[961.594,311.658],[961.594,210.279]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[1018.66,426.905],[1018.66,319.422],[1097.93,428.385],[1097.93,322.317]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[1018.66,553.795],[1018.66,446.312],[1097.93,553.604],[1097.93,447.536]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[1018.66,569.309],[1018.66,676.792],[1097.93,568.913],[1097.93,674.98]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[1018.66,692.956],[1018.66,800.439],[1097.93,690.932],[1097.93,796.999]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[1018.66,820.344],[1018.66,927.827],[1097.97,816.586],[1097.97,922.633]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[1020.3,310.075],[1020.3,207.991],[1091.93,314.135],[1091.93,213.859]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[1091.93,314.135],[1091.93,213.859],[1151.04,320.505],[1151.04,223.067]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[1097.93,428.385],[1097.93,322.317],[1111.61,431.436],[1111.61,328.288]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[1097.93,553.604],[1097.93,447.536],[1111.61,553.209],[1111.61,450.061]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[1097.93,568.913],[1097.93,674.98],[1111.61,568.096],[1111.61,671.244]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[1097.93,690.932],[1097.93,796.999],[1111.61,686.757],[1111.61,789.905]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[1097.97,816.586],[1097.97,922.633],[1111.01,809.308],[1111.01,912.572]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[1158.17,430.852],[1158.17,327.145],[1111.61,431.436],[1111.61,328.288]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[1158.17,553.284],[1158.17,449.577],[1111.61,553.209],[1111.61,450.061]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[1158.17,568.253],[1158.17,671.96],[1111.61,568.096],[1111.61,671.244]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[1158.17,687.556],[1158.17,791.263],[1111.61,686.757],[1111.61,789.905]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[1159.36,810.828],[1111.01,809.308],[1159.36,914.673],[1111.01,912.572]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[1151.04,320.505],[1151.04,223.067],[1213.88,330.152],[1213.88,237.01]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[1158.16,430.852],[1158.16,327.145],[1181.92,436.75],[1181.92,338.686]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[1158.16,553.284],[1158.16,449.577],[1181.92,552.521],[1181.92,454.457]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[1158.16,568.253],[1158.16,671.96],[1181.92,566.675],[1181.92,664.738]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[1158.16,687.556],[1158.16,791.263],[1181.92,679.486],[1181.92,777.55]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[1159.36,810.828],[1159.36,914.673],[1184.62,795.07],[1184.62,892.889]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[1259.15,435.836],[1259.15,336.898],[1181.92,436.75],[1181.92,338.686]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[1259.15,552.639],[1259.15,453.701],[1181.92,552.521],[1181.92,454.457]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[1259.15,566.919],[1259.15,665.857],[1181.92,566.675],[1181.92,664.738]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[1259.15,680.737],[1259.15,779.675],[1181.92,679.486],[1181.92,777.55]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[1257.28,798.095],[1180.36,795.816],[1257.28,897.071],[1180.36,893.921]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[1225.3,329.877],[1225.3,236.613],[1264.88,339.754],[1264.88,250.89]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[1257.28,798.095],[1257.28,897.071],[1315.35,785.561],[1315.35,879.744]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[1259.15,435.837],[1259.15,336.898],[1314.34,440.565],[1314.34,346.151]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[1259.15,552.639],[1259.15,453.701],[1314.34,552.027],[1314.34,457.613]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[1259.15,566.919],[1259.15,665.857],[1314.34,565.654],[1314.34,660.068]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[1259.15,680.737],[1259.15,779.675],[1314.34,674.267],[1314.34,768.681]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[1264.89,339.754],[1264.89,250.89],[1282.85,350.615],[1282.85,266.589]]
                },{
                    num:"503",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[1296.97,443.887],[1296.97,349.679],[1339.24,457.422],[1339.24,376.584]]
                },{
                    num:"403",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[1296.97,555.107],[1296.97,460.898],[1339.24,552.856],[1339.24,472.019]]
                },{
                    num:"303",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[1296.97,568.704],[1296.97,662.912],[1339.24,564.524],[1339.24,645.362]]
                },{
                    num:"203",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[1296.97,677.081],[1296.97,771.289],[1339.24,657.519],[1339.24,738.357]]
                },{
                    num:"103",
                    tipo:"TorreD",
                    frame:5,
                    verts:[[1296.97,785.628],[1296.97,879.837],[1339.24,750.661],[1339.24,831.498]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[538.412,443.6],[538.411,352.09],[470.28,444.146],[470.279,353.157]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[538.412,551.634],[538.411,460.124],[470.28,551.564],[470.279,460.575]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[538.411,564.842],[538.412,656.352],[470.279,564.696],[470.28,655.685]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[538.411,670.115],[538.412,761.625],[470.279,669.369],[470.28,760.358]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[538.326,778.708],[538.326,870.271],[470.44,777.348],[470.44,868.391]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[531.94,792.777],[531.94,889.72],[488.464,791.855],[488.464,888.445]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[533.675,438.025],[533.675,341.18],[491.791,438.38],[491.79,341.874]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[533.675,552.356],[533.675,455.511],[491.791,552.31],[491.79,455.805]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[533.675,566.334],[533.675,663.178],[491.79,566.239],[491.791,662.744]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[533.675,677.743],[533.675,774.588],[491.79,677.257],[491.791,773.763]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[554.307,806.102],[554.307,908.139],[509.772,799.308],[509.772,898.747]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[555.215,432.589],[555.215,330.544],[510.44,435.286],[510.44,335.822]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[555.215,553.06],[555.215,451.015],[510.44,552.71],[510.44,453.246]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[555.215,567.788],[555.215,669.833],[510.44,567.066],[510.44,666.531]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[555.215,685.18],[555.215,787.224],[510.44,681.489],[510.44,780.954]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[804.706,811.683],[804.706,915.854],[554.307,806.102],[554.307,908.139]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[805.653,430.358],[805.653,326.178],[555.215,432.589],[555.215,330.544]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[805.653,553.348],[805.653,449.169],[555.215,553.06],[555.215,451.015]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[805.653,568.385],[805.653,672.564],[555.215,567.788],[555.215,669.833]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[805.653,688.232],[805.653,792.411],[555.215,685.18],[555.215,787.224]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[582.055,326.284],[582.055,231.419],[569.103,333.751],[569.103,242.213]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[617.334,320.134],[617.334,222.531],[582.056,326.284],[582.056,231.419]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[673.209,319.117],[673.209,221.061],[617.336,320.134],[617.336,222.531]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[714.386,313.198],[714.386,212.506],[661.856,315.643],[661.856,216.039]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[753.556,311.567],[753.556,210.147],[714.387,313.199],[714.387,212.506]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[814.488,309.528],[814.488,207.2],[753.556,311.567],[753.556,210.147]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[1068.32,428.018],[1068.32,321.6],[807.123,430.345],[807.123,326.153]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[1068.32,553.651],[1068.32,447.233],[807.123,553.35],[807.123,449.158]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[1068.32,569.011],[1068.32,675.429],[807.123,568.388],[807.123,672.58]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[1068.32,691.433],[1068.32,797.851],[807.123,688.25],[807.123,792.442]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[1068.32,817.559],[1068.32,923.977],[807.123,811.737],[807.123,915.929]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[885.251,309.227],[819.342,309.56],[885.251,206.764],[819.342,207.246]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[929.926,309.305],[885.251,309.227],[929.926,206.878],[885.251,206.764]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[929.925,309.305],[992.091,309.652],[929.925,206.878],[992.091,207.379]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[992.092,309.652],[992.092,207.379],[998.478,313.313],[998.478,212.671]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[1057.92,312.231],[998.478,313.313],[1057.92,211.107],[998.478,212.671]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[1057.92,312.231],[1057.92,211.107],[1124.2,316.775],[1124.2,217.675]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[1068.32,428.018],[1068.32,321.6],[1142.89,429.774],[1142.89,325.036]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[1068.32,553.651],[1068.32,447.233],[1142.89,553.424],[1142.89,448.686]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[1068.32,569.011],[1068.32,675.429],[1142.89,568.541],[1142.89,673.279]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[1068.32,691.433],[1068.32,797.851],[1142.89,689.031],[1142.89,793.769]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[1068.32,817.559],[1068.32,923.977],[1142.88,813.111],[1142.88,917.829]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[1124.2,316.775],[1124.2,217.675],[1175.71,323.457],[1175.71,227.334]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[1142.89,429.774],[1142.89,325.036],[1149.8,432.806],[1149.8,330.969]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[1142.89,553.424],[1142.89,448.686],[1149.8,553.031],[1149.8,451.194]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[1142.89,568.541],[1142.89,673.279],[1149.8,567.73],[1149.8,669.567]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[1142.89,689.031],[1142.89,793.769],[1149.8,684.882],[1149.8,786.72]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[1142.88,813.111],[1142.88,917.829],[1149.47,805.879],[1149.47,907.831]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[1197.92,806.907],[1149.47,805.879],[1197.92,909.252],[1149.47,907.831]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[1196.46,432.411],[1149.8,432.806],[1196.45,330.196],[1149.8,330.969]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[1196.46,553.083],[1196.45,450.867],[1149.8,553.031],[1149.8,451.194]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[1196.45,567.835],[1196.46,670.051],[1149.8,567.73],[1149.8,669.567]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[1196.45,685.423],[1149.8,684.882],[1196.46,787.638],[1149.8,786.719]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[1175.71,323.457],[1175.71,227.334],[1227.44,333.338],[1227.44,241.616]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[1196.45,432.411],[1196.45,330.196],[1207.17,438.25],[1207.17,341.621]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[1196.45,553.083],[1196.45,450.867],[1207.17,552.327],[1207.17,455.698]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[1196.45,567.835],[1196.45,670.051],[1207.17,566.273],[1207.17,662.902]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[1196.45,685.423],[1196.45,787.638],[1207.17,677.434],[1207.17,774.063]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[1197.92,806.907],[1197.92,909.252],[1209.26,791.309],[1209.26,887.69]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[1284.04,437.635],[1207.17,438.25],[1284.04,340.418],[1207.17,341.621]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[1284.04,552.406],[1284.04,455.189],[1207.17,552.327],[1207.17,455.698]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[1284.04,566.438],[1284.04,663.655],[1207.17,566.273],[1207.17,662.902]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[1284.04,678.276],[1207.17,677.434],[1284.04,775.493],[1207.17,774.063]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[1282.31,793.608],[1205.74,792.075],[1282.31,890.869],[1205.74,888.749]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[1238.8,333.153],[1238.8,241.349],[1267.57,343.059],[1267.57,255.667]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[1267.57,343.059],[1267.57,255.667],[1274.39,353.765],[1274.39,271.141]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[1282.31,793.608],[1282.31,890.869],[1327.98,780.919],[1327.98,873.327]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[1284.04,437.635],[1284.04,340.418],[1327.5,442.424],[1327.5,349.789]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[1284.04,552.406],[1284.04,455.189],[1327.5,551.786],[1327.5,459.151]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[1284.04,566.438],[1284.04,663.655],[1327.5,565.157],[1327.5,657.792]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:6,
                    verts:[[1284.04,678.276],[1284.04,775.493],[1327.5,671.724],[1327.5,764.359]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[551.746,442.656],[551.745,350.243],[480.799,442.967],[480.798,350.851]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[551.746,551.756],[551.745,459.343],[480.799,551.716],[480.798,459.6]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[551.745,565.095],[551.746,657.508],[480.798,565.011],[480.799,657.128]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[551.745,671.406],[551.746,763.82],[480.798,670.981],[480.799,763.097]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[551.779,781.071],[551.779,873.537],[481.088,780.295],[481.088,872.465]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[557.684,795.209],[557.684,893.081],[512.428,794.683],[512.428,892.354]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[559.23,437.059],[559.23,339.291],[515.639,437.262],[515.638,339.687]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[559.23,552.481],[559.23,454.713],[515.639,552.455],[515.638,454.88]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[559.23,566.592],[559.23,664.36],[515.638,566.538],[515.639,664.113]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[559.23,679.064],[559.23,776.832],[515.638,678.787],[515.639,776.362]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[592.229,808.317],[592.229,911.201],[540.817,801.948],[540.817,902.398]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[593.173,431.707],[593.173,328.818],[541.558,434.233],[541.558,333.762]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[593.173,553.174],[593.173,450.285],[541.558,552.847],[541.558,452.375]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[593.173,568.024],[593.173,670.913],[541.558,567.348],[541.558,667.82]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[593.173,686.386],[593.173,789.275],[541.558,682.93],[541.558,783.402]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[583.112,331.951],[583.112,239.611],[573.87,342.161],[573.87,254.369]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[603.958,324.584],[603.958,228.963],[583.112,331.951],[583.112,239.611]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[849.7,811.456],[849.7,915.54],[592.229,808.317],[592.229,911.201]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[850.665,430.453],[850.665,326.363],[593.173,431.707],[593.173,328.818]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[850.665,553.336],[850.665,449.247],[593.173,553.174],[593.173,450.285]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[850.665,568.359],[850.665,672.448],[593.173,568.024],[593.173,670.913]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[850.665,688.102],[850.665,792.192],[593.173,686.386],[593.173,789.275]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[646.084,318.72],[646.084,220.487],[603.958,324.584],[603.958,228.963]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[703.676,318.146],[703.676,219.657],[646.086,318.72],[646.086,220.487]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[751.209,312.589],[751.209,211.625],[695.739,314.598],[695.739,214.529]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[792.235,311.286],[792.235,209.741],[751.209,312.589],[751.209,211.625]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[855.316,309.759],[855.316,207.535],[792.235,311.286],[792.235,209.741]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[1115.77,429.161],[1115.77,323.836],[852.162,430.445],[852.162,326.349]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[1115.77,553.503],[1115.77,448.178],[852.162,553.337],[852.162,449.241]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[1115.77,568.705],[1115.77,674.03],[852.162,568.361],[852.162,672.457]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[1115.77,689.87],[1115.77,795.194],[852.162,688.113],[852.162,792.209]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[1115.77,814.699],[1115.77,920.024],[852.162,811.486],[852.162,915.582]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[860.133,309.831],[926.154,310.035],[860.133,207.638],[926.154,207.934]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[926.154,310.035],[970.426,310.474],[926.154,207.934],[970.426,208.567]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[970.425,310.474],[1031.56,311.314],[970.425,208.567],[1031.56,209.782]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[1031.56,311.314],[1031.56,209.782],[1034.24,314.966],[1034.24,215.06]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[1093.84,314.372],[1034.24,314.966],[1093.84,214.202],[1034.24,215.06]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[1093.84,314.372],[1093.84,214.202],[1154.34,319.343],[1154.34,221.388]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[1115.77,429.161],[1115.77,323.836],[1185.02,431.165],[1185.02,327.757]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[1115.77,553.503],[1115.77,448.179],[1185.02,553.244],[1185.02,449.836]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[1115.77,568.705],[1115.77,674.03],[1185.02,568.169],[1185.02,671.577]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[1115.77,689.87],[1115.77,795.195],[1185.02,687.128],[1185.02,790.536]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[1115.77,814.699],[1115.77,920.024],[1184.97,809.633],[1184.97,913.021]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[1154.34,319.343],[1154.34,221.388],[1198.09,326.275],[1198.09,231.406]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[1185.39,434.156],[1231.68,433.941],[1185.39,333.61],[1231.68,333.19]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[1185.39,552.857],[1231.68,552.885],[1185.39,452.311],[1231.68,452.133]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[1185.39,567.369],[1231.68,567.426],[1185.39,667.915],[1231.68,668.177]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[1185.39,683.036],[1231.68,683.33],[1185.39,783.582],[1231.68,784.081]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[1185.32,802.499],[1233.39,803.057],[1185.32,903.158],[1233.39,903.93]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[1198.09,326.275],[1198.09,231.406],[1238.82,336.312],[1238.82,245.914]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[1229.86,439.683],[1305.73,439.35],[1229.86,344.425],[1305.73,343.774]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[1229.86,552.141],[1229.86,456.883],[1305.73,552.184],[1305.73,456.608]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[1229.86,565.89],[1305.73,565.979],[1229.86,661.148],[1305.73,661.556]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[1229.86,675.474],[1305.73,675.929],[1229.86,770.733],[1305.73,771.506]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[1228.56,788.5],[1304.16,789.33],[1228.56,883.807],[1304.16,884.954]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[1250.04,336.211],[1250.04,245.769],[1268.32,346.086],[1268.32,260.043]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[1304.16,789.33],[1304.16,884.954],[1337.73,776.581],[1337.73,867.331]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[1305.73,439.35],[1305.73,343.774],[1337.77,444.163],[1337.77,353.19]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[1305.73,552.184],[1305.73,456.608],[1337.77,551.561],[1337.77,460.589]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[1305.73,565.979],[1305.73,661.556],[1337.77,564.692],[1337.77,655.664]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:7,
                    verts:[[1305.73,675.929],[1305.73,771.506],[1337.77,669.345],[1337.77,760.318]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[494.492,441.715],[494.491,348.401],[483.647,446.51],[483.647,357.783]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[494.492,551.878],[494.491,458.564],[483.647,551.258],[483.647,462.531]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[494.491,565.346],[494.492,658.661],[483.647,564.064],[483.647,652.79]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[494.491,672.694],[494.492,766.008],[483.647,666.134],[483.647,754.861]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[567.799,441.649],[567.798,348.272],[494.492,441.715],[494.491,348.401]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[567.799,551.887],[567.798,458.51],[494.492,551.878],[494.491,458.564]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[567.798,565.364],[567.799,658.741],[494.491,565.346],[494.492,658.661]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[567.798,672.784],[567.799,766.162],[494.491,672.694],[494.492,766.008]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[567.954,783.591],[567.954,877.021],[494.913,783.427],[494.913,876.794]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[586.404,797.71],[539.721,797.598],[586.404,896.538],[539.721,896.384]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[587.741,436.066],[587.741,337.347],[542.783,436.108],[542.782,337.43]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[587.741,552.61],[587.741,453.891],[542.783,552.604],[542.782,453.926]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[587.741,566.858],[587.741,665.577],[542.782,566.846],[542.783,665.524]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[587.741,680.423],[587.741,779.142],[542.782,680.365],[542.783,779.043]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[634.033,430.837],[634.033,327.115],[575.928,433.169],[575.928,331.678]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[634.033,553.286],[634.033,449.565],[575.928,552.985],[575.928,451.494]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[634.033,568.257],[634.033,671.978],[575.928,567.633],[575.928,669.123]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[634.033,687.577],[634.033,791.298],[575.928,684.386],[575.928,785.877]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[633.065,810.504],[633.065,914.224],[575.12,804.619],[575.12,906.09]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[599.62,330.021],[599.62,236.822],[579.754,340.189],[579.754,251.519]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[628.356,322.803],[628.356,226.389],[599.62,330.021],[599.62,236.822]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[677.084,317.269],[677.084,218.389],[628.356,322.803],[628.356,226.389]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[895.072,811.158],[895.072,915.129],[633.065,810.504],[633.065,914.224]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[896.046,430.575],[896.046,326.603],[634.033,430.837],[634.033,327.115]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[896.046,553.32],[896.046,449.348],[634.033,553.286],[634.033,449.565]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[896.046,568.327],[896.046,672.298],[634.033,568.257],[634.033,671.978]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[896.046,687.935],[896.046,791.907],[634.033,687.577],[634.033,791.298]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[735.9,317.149],[677.085,317.269],[735.9,218.216],[677.085,218.389]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[789.39,311.994],[789.39,210.764],[731.483,313.55],[731.483,213.014]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[831.884,311.028],[831.884,209.368],[789.39,311.994],[789.39,210.764]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[896.496,310.022],[896.496,207.913],[831.884,311.028],[831.884,209.368]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[897.555,430.574],[1160.84,430.311],[897.555,326.6],[1160.84,326.086]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[897.555,553.32],[897.555,449.347],[1160.84,553.354],[1160.84,449.13]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[897.555,568.327],[1160.84,568.397],[897.555,672.3],[1160.84,672.622]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[897.555,687.937],[1160.84,688.297],[897.555,791.91],[1160.84,792.521]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[897.555,811.165],[1160.84,811.822],[897.555,915.138],[1160.84,916.047]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[901.23,310.131],[966.725,310.864],[901.23,208.072],[966.725,209.131]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[966.725,310.864],[1010.18,311.65],[966.725,209.131],[1010.18,210.267]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[1010.17,311.65],[1010.17,210.267],[1069.73,312.964],[1069.73,212.167]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[1068.75,316.581],[1127.96,316.46],[1068.75,217.395],[1127.96,217.22]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[1127.96,316.46],[1127.96,217.22],[1182.34,321.806],[1182.34,224.948]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[1160.84,430.311],[1160.84,326.086],[1224.29,432.535],[1224.29,330.438]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[1160.84,553.355],[1160.84,449.13],[1224.29,553.067],[1224.29,450.97]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[1160.84,568.397],[1160.84,672.622],[1224.29,567.802],[1224.29,669.899]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[1160.84,688.297],[1160.84,792.521],[1224.29,685.254],[1224.29,787.35]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[1160.84,811.822],[1160.84,916.047],[1224.19,806.207],[1224.19,908.284]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[1182.34,321.806],[1182.34,224.948],[1218.28,328.929],[1218.28,235.243]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[1218.28,328.929],[1218.28,235.243],[1248.14,339.054],[1248.14,249.878]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[1218.36,435.466],[1263.88,435.423],[1218.36,336.173],[1263.88,336.089]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[1218.36,552.687],[1218.36,453.395],[1263.88,552.693],[1263.88,453.359]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[1218.36,567.018],[1218.36,666.311],[1263.88,567.03],[1263.88,666.364]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[1218.36,681.243],[1263.88,681.302],[1218.36,780.536],[1263.88,780.636]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[1218.54,799.215],[1265.81,799.328],[1218.54,898.619],[1265.81,898.775]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[1259.16,339.034],[1259.16,249.849],[1267.3,348.826],[1267.3,264.004]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[1250.07,441.035],[1250.07,347.071],[1324.41,440.969],[1324.41,346.94]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[1250.07,551.966],[1250.07,458.002],[1324.41,551.975],[1324.41,457.946]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[1250.07,565.528],[1250.07,659.493],[1324.41,565.546],[1324.41,659.574]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[1250.07,673.624],[1250.07,767.589],[1324.41,673.716],[1324.41,767.744]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[1248.92,785.125],[1322.98,785.291],[1248.92,879.141],[1322.98,879.371]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[1322.98,785.292],[1322.98,879.371],[1344.84,772.567],[1344.84,861.781]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[1324.41,440.969],[1324.41,346.94],[1345.37,445.773],[1345.37,356.341]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[1324.41,551.975],[1324.41,457.946],[1345.37,551.353],[1345.37,461.921]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[1324.41,565.546],[1324.41,659.574],[1345.37,564.261],[1345.37,653.693]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:8,
                    verts:[[1324.41,673.716],[1324.41,767.744],[1345.37,667.142],[1345.37,756.574]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[511.361,440.382],[511.36,345.793],[489.649,445.178],[489.649,355.177]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[511.361,552.051],[511.36,457.462],[489.649,551.43],[489.649,461.429]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[511.36,565.703],[511.361,660.292],[489.649,564.42],[489.649,654.421]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[511.36,674.517],[511.361,769.106],[489.649,667.956],[489.649,757.957]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[586.54,440.573],[586.54,346.166],[511.361,440.382],[511.36,345.793]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[586.54,552.026],[586.54,457.619],[511.361,552.051],[511.36,457.462]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[586.54,565.652],[586.54,660.059],[511.36,565.703],[511.361,660.292]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[586.54,674.257],[586.54,768.663],[511.36,674.517],[511.361,769.106]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[586.818,786.283],[511.914,786.758],[586.818,880.742],[511.914,881.399]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[617.998,800.293],[570.263,800.613],[617.998,900.109],[570.263,900.552]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[619.11,435.039],[573.145,434.915],[619.11,335.337],[573.145,335.096]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[619.11,552.743],[619.11,453.041],[573.145,552.758],[573.145,452.939]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[619.11,567.133],[619.11,666.834],[573.145,567.165],[573.145,666.985]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[619.11,681.828],[573.145,681.997],[619.11,781.53],[573.145,781.816]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[587.857,338.108],[587.857,248.51],[578.65,347.909],[578.65,262.677]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[618.582,327.95],[618.582,233.828],[587.953,338.017],[587.953,248.379]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[676.612,812.675],[676.612,917.226],[612.546,807.332],[612.546,909.84]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[677.596,429.973],[677.596,325.425],[613.417,432.088],[613.417,329.563]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[677.596,553.398],[677.596,448.85],[613.417,553.125],[613.417,450.6]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[677.596,568.488],[677.596,673.036],[613.417,567.922],[613.417,670.447]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[677.596,688.759],[677.596,793.307],[613.417,685.866],[613.417,788.391]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[655.164,320.929],[655.164,223.68],[618.582,327.95],[618.582,233.828]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[710.2,315.768],[710.2,216.22],[655.164,320.929],[655.164,223.68]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[940.584,810.817],[676.612,812.675],[940.584,914.657],[676.612,917.226]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[941.556,430.715],[677.596,429.973],[941.556,326.878],[677.596,325.425]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[941.556,553.302],[677.596,553.398],[941.556,449.464],[677.596,448.85]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[941.556,568.289],[677.596,568.488],[941.556,672.127],[677.596,673.036]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[941.556,687.743],[677.596,688.759],[941.556,791.581],[677.596,793.307]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[769.733,316.111],[710.201,315.768],[769.733,216.716],[710.201,216.22]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[828.735,311.396],[828.735,209.9],[768.912,312.484],[768.912,211.473]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[872.3,310.775],[828.735,311.396],[872.3,209.002],[828.735,209.9]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[937.827,310.293],[872.3,310.775],[937.827,208.306],[872.3,209.002]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[942.432,310.44],[942.432,208.518],[1006.78,311.688],[1006.78,210.322]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[943.063,430.72],[943.063,326.886],[1203.44,431.452],[1203.44,328.319]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[943.063,553.302],[943.063,449.468],[1203.44,553.207],[1203.44,450.074]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[943.063,568.288],[943.063,672.122],[1203.44,568.092],[1203.44,671.225]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[943.063,687.737],[943.063,791.571],[1203.44,686.735],[1203.44,789.868]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[943.063,810.799],[943.063,914.633],[1203.44,808.966],[1203.44,912.099]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[1006.78,311.688],[1006.78,210.322],[1049.02,312.81],[1049.02,211.944]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[1049.02,312.81],[1049.02,211.944],[1106.46,314.575],[1106.46,214.496]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[1101.93,318.136],[1160.24,318.471],[1101.93,219.642],[1160.24,220.127]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[1160.24,318.471],[1160.24,220.127],[1208.23,324.142],[1208.23,228.324]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[1203.44,431.452],[1203.44,328.319],[1260.67,433.87],[1260.67,333.051]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[1203.44,553.207],[1203.44,450.074],[1260.67,552.894],[1260.67,452.074]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[1203.44,568.092],[1203.44,671.225],[1260.67,567.445],[1260.67,668.264]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[1203.44,686.735],[1203.44,789.868],[1260.67,683.427],[1260.67,784.246]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[1203.44,808.966],[1203.44,912.099],[1260.53,802.867],[1260.53,903.668]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[1208.23,324.142],[1208.23,228.324],[1236.33,331.405],[1236.33,238.822]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[1236.33,331.405],[1236.33,238.822],[1255.53,341.557],[1255.53,253.496]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[1248.73,436.725],[1248.73,338.637],[1293.12,436.844],[1293.12,338.87]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[1248.73,552.524],[1248.73,454.436],[1293.12,552.509],[1293.12,454.535]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[1248.73,566.681],[1248.73,664.769],[1293.12,566.649],[1293.12,664.624]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[1248.73,679.521],[1248.73,777.609],[1293.12,679.358],[1293.12,777.332]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[1249.15,796.058],[1295.24,795.748],[1249.15,894.254],[1295.24,893.827]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[1267.92,442.3],[1267.92,349.545],[1340.21,442.483],[1340.21,349.904]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[1267.92,551.803],[1267.92,459.048],[1340.21,551.779],[1340.21,459.2]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[1267.92,565.19],[1267.92,657.945],[1340.21,565.141],[1340.21,657.72]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[1267.92,671.894],[1267.92,764.648],[1340.21,671.643],[1340.21,764.222]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[1266.91,781.968],[1266.91,874.777],[1338.95,781.511],[1338.95,874.145]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[1340.21,442.483],[1340.21,349.904],[1350.46,447.253],[1350.46,359.237]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[1340.21,551.779],[1340.21,459.2],[1350.46,551.161],[1350.46,463.145]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[1340.21,565.141],[1340.21,657.72],[1350.46,563.865],[1350.46,651.881]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[1340.21,671.643],[1340.21,764.223],[1350.46,665.118],[1350.46,753.134]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:9,
                    verts:[[1338.95,781.511],[1338.95,874.145],[1349.48,768.88],[1349.48,856.685]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[531.452,438.967],[531.451,343.023],[498.592,443.735],[498.592,352.353]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[531.452,552.234],[531.451,456.291],[498.592,551.617],[498.592,460.235]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[531.451,566.082],[531.452,662.025],[498.592,564.806],[498.592,656.188]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[531.451,676.454],[531.452,772.397],[498.592,669.931],[498.592,761.313]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[537.258,777.206],[521.405,777.431],[537.258,868.194],[521.405,868.505]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[607.976,439.426],[531.452,438.967],[607.975,343.921],[531.451,343.023]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[607.976,552.175],[607.975,456.67],[531.452,552.234],[531.451,456.291]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[607.975,565.959],[531.451,566.082],[607.976,661.464],[531.452,662.025]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[607.975,675.827],[531.451,676.454],[607.976,771.331],[531.452,772.397]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[608.38,789.152],[532.139,790.296],[608.38,884.709],[532.139,886.29]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[598.311,335.727],[598.311,245.07],[578.901,345.537],[578.901,259.25]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[639.994,325.732],[639.994,230.622],[598.502,335.637],[598.502,244.939]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[652.405,802.961],[604.022,803.729],[652.405,903.797],[604.022,904.859]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[653.274,433.977],[606.691,433.682],[653.274,333.26],[606.69,332.682]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[653.274,552.88],[606.691,552.918],[653.274,452.163],[606.69,451.918]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[653.274,567.417],[606.69,567.496],[653.274,668.134],[606.691,668.495]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[653.274,683.281],[606.69,683.685],[653.274,783.998],[606.691,784.684]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[684.332,318.958],[684.332,220.831],[639.994,325.732],[639.994,230.622]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[653.002,810.086],[653.002,913.647],[652.405,802.961],[652.405,903.797]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[723.697,429.115],[723.697,323.746],[653.926,430.99],[653.926,327.415]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[723.697,553.509],[723.697,448.14],[653.926,553.267],[653.926,449.692]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[723.697,568.717],[723.697,674.086],[653.926,568.216],[653.926,671.791]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[723.697,689.933],[723.697,795.302],[653.926,687.367],[653.926,790.942]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[722.706,814.831],[722.706,920.206],[653.002,810.086],[653.002,913.647]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[745.329,314.215],[745.329,213.974],[684.332,318.958],[684.332,220.831]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[722.706,814.831],[722.706,920.206],[986.03,810.444],[986.03,914.141]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[723.697,429.115],[723.697,323.746],[986.99,430.868],[986.99,327.176]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[723.697,553.509],[723.697,448.14],[986.99,553.282],[986.99,449.591]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[723.697,568.717],[723.697,674.086],[986.99,568.248],[986.99,671.94]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[723.697,689.933],[723.697,795.302],[986.99,687.534],[986.99,791.226]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[745.33,314.215],[805.056,315.028],[745.33,213.974],[805.056,215.15]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[807.885,311.396],[807.885,209.901],[805.055,315.028],[805.055,215.15]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[869.084,310.788],[807.885,311.396],[869.084,209.022],[807.885,209.9]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[913.314,310.519],[869.084,310.788],[913.314,208.632],[869.084,209.022]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[913.314,310.519],[979.135,310.564],[913.314,208.632],[979.135,208.697]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[983.571,310.746],[983.571,208.961],[1046.19,312.496],[1046.19,211.491]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[988.479,430.878],[988.479,327.196],[1243.47,432.576],[1243.47,330.518]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[988.479,553.281],[988.479,449.599],[1243.47,553.061],[1243.47,451.004]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[988.479,568.246],[988.479,671.928],[1243.47,567.791],[1243.47,669.849]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[988.479,687.52],[988.479,791.203],[1243.47,685.197],[1243.47,787.255]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[988.479,810.403],[988.479,914.085],[1243.47,806.154],[1243.47,908.212]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[1046.19,312.496],[1046.19,211.491],[1086.83,313.94],[1086.83,213.578]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[1086.83,313.94],[1086.83,213.578],[1141.69,316.134],[1141.69,216.749]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[1133.7,319.618],[1133.7,221.784],[1190.63,320.393],[1190.63,222.905]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[1190.63,320.393],[1190.63,222.905],[1232.01,326.341],[1232.01,231.503]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[1232.01,326.341],[1232.01,231.503],[1252.31,333.696],[1252.31,242.133]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[1243.47,432.576],[1243.47,330.518],[1294.16,435.163],[1294.16,335.581]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[1243.47,553.061],[1243.47,451.004],[1294.16,552.726],[1294.16,453.144]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[1243.47,567.791],[1243.47,669.849],[1294.16,567.099],[1294.16,666.682]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[1243.47,685.197],[1243.47,787.255],[1294.16,681.658],[1294.16,781.24]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[1243.47,806.155],[1243.47,908.212],[1293.98,799.635],[1293.98,899.199]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[1252.31,333.696],[1252.31,242.134],[1261.06,343.822],[1261.06,256.769]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[1276.53,437.927],[1276.53,340.989],[1319.45,438.199],[1319.44,341.521]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[1276.53,552.369],[1276.53,455.431],[1319.45,552.333],[1319.44,455.656]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[1276.53,566.36],[1276.53,663.298],[1319.44,566.287],[1319.45,662.965]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[1276.53,677.876],[1276.53,774.814],[1319.44,677.504],[1319.45,774.182]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[1277.18,793.042],[1277.18,890.086],[1321.73,792.335],[1321.73,889.108]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[1283.47,443.474],[1283.47,351.843],[1353.28,443.893],[1353.28,352.662]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[1283.47,551.651],[1283.47,460.019],[1353.28,551.596],[1353.28,460.366]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[1283.47,564.876],[1283.47,656.507],[1353.28,564.764],[1353.28,655.995]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[1283.47,670.287],[1283.47,761.918],[1353.28,669.715],[1353.28,760.946]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:10,
                    verts:[[1282.61,779.036],[1282.61,870.723],[1352.18,777.992],[1352.18,869.281]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[554.846,437.47],[554.846,340.094],[510.593,442.179],[510.593,349.308]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[554.846,552.428],[554.846,455.052],[510.593,551.818],[510.593,458.948]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[554.846,566.482],[554.846,663.858],[510.593,565.222],[510.593,658.093]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[554.846,678.502],[554.846,775.878],[510.593,672.06],[510.593,764.93]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[533,781.125],[533,873.612],[528.072,768.859],[528.072,856.656]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[533.34,781.118],[549.417,780.753],[533.34,873.602],[549.417,873.098]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[555.666,794.038],[555.666,891.462],[549.417,780.753],[549.417,873.098]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[554.846,437.47],[632.139,438.208],[554.846,340.094],[632.138,341.539]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[554.846,552.428],[554.846,455.052],[632.139,552.332],[632.138,455.663]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[554.846,566.482],[554.846,663.858],[632.138,566.285],[632.139,662.954]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[554.846,678.502],[632.138,677.492],[554.846,775.878],[632.139,774.161]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[555.666,794.038],[632.67,792.195],[555.666,891.462],[632.67,888.915]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[581.308,342.905],[581.308,255.444],[573.42,353.549],[573.42,270.829]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[611.174,333.138],[611.174,241.326],[581.308,342.905],[581.308,255.444]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[663.874,323.37],[663.874,227.208],[611.461,333.047],[611.461,241.196]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[640.977,806.935],[640.977,909.29],[629.107,791.447],[629.107,887.88]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[643.401,432.412],[643.401,330.197],[632.138,438.208],[632.138,341.539]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[643.401,553.083],[643.401,450.868],[632.138,552.332],[632.138,455.663]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[643.401,567.835],[643.401,670.05],[632.138,566.285],[632.138,662.954]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[643.401,685.422],[643.401,787.637],[632.138,677.492],[632.138,774.161]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[640.977,806.935],[689.576,805.703],[640.977,909.29],[689.576,907.588]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[643.402,432.412],[690.189,432.885],[643.401,330.197],[690.189,331.123]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[643.402,553.083],[643.401,450.868],[690.189,553.021],[690.189,451.259]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[643.401,567.835],[643.402,670.05],[690.189,567.709],[690.189,669.471]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[643.401,685.422],[690.189,684.775],[643.402,787.637],[690.189,786.537]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[715.825,316.896],[715.825,217.85],[663.874,323.37],[663.874,227.208]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[696.401,812.869],[696.401,917.494],[689.576,805.703],[689.576,907.588]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[697.372,429.881],[697.372,325.245],[690.189,432.885],[690.189,331.123]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[697.372,553.41],[697.372,448.774],[690.189,553.021],[690.189,451.259]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[697.372,568.512],[697.372,673.148],[690.189,567.709],[690.189,669.471]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[697.372,688.884],[697.372,793.52],[690.189,684.775],[690.189,786.537]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[771.188,816.959],[771.188,923.148],[696.401,812.869],[696.401,917.494]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[772.175,428.268],[772.175,322.089],[697.372,429.881],[697.372,325.245]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[772.175,553.619],[772.175,447.44],[697.372,553.41],[697.372,448.774]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[772.175,568.944],[772.175,675.123],[697.372,568.512],[697.372,673.148]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[772.175,691.091],[772.175,797.27],[697.372,688.884],[697.372,793.52]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[782.382,312.614],[782.382,211.661],[715.825,316.896],[715.825,217.85]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[771.188,816.959],[771.188,923.148],[1031.2,810.038],[1031.2,913.581]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[772.175,428.268],[772.175,322.089],[1032.14,431.034],[1032.14,327.501]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[772.175,553.619],[772.175,447.44],[1032.14,553.261],[1032.14,449.728]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[772.175,568.944],[772.175,675.123],[1032.14,568.204],[1032.14,671.737]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[772.175,691.091],[772.175,797.27],[1032.14,687.307],[1032.14,790.84]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[782.382,312.614],[841.76,313.906],[782.382,211.661],[841.76,213.528]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[848.269,310.292],[848.269,208.304],[841.759,313.906],[841.759,213.528]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[910.279,310.177],[848.269,310.292],[910.279,208.138],[848.269,208.304]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[910.279,310.177],[954.759,310.263],[910.279,208.138],[954.759,208.263]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[954.759,310.263],[1020.25,310.835],[954.759,208.263],[1020.25,209.09]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[1024.47,311.052],[1024.47,209.403],[1084.78,313.288],[1084.78,212.635]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[1033.6,431.049],[1033.6,327.531],[1280.86,433.679],[1280.86,332.678]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[1033.6,553.259],[1033.6,449.741],[1280.86,552.918],[1280.86,451.917]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[1033.6,568.2],[1033.6,671.718],[1280.86,567.496],[1280.86,668.498]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[1033.6,687.286],[1033.6,790.804],[1280.86,683.688],[1280.86,784.69]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[1033.6,809.974],[1033.6,913.493],[1280.86,803.394],[1280.86,904.395]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[1084.78,313.288],[1084.78,212.635],[1123.47,315.04],[1123.47,215.167]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[1123.47,315.04],[1123.47,215.167],[1175.29,317.639],[1175.29,218.923]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[1163.99,321.026],[1163.99,223.819],[1219.08,322.223],[1219.08,225.55]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[1219.08,322.223],[1219.08,225.55],[1253.68,328.404],[1253.68,234.484]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[1253.68,328.404],[1253.68,234.484],[1266.24,335.806],[1266.24,245.183]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[1280.86,433.68],[1280.86,332.678],[1324.73,436.411],[1324.73,338.023]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[1280.86,552.918],[1280.86,451.917],[1324.73,552.565],[1324.73,454.176]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[1280.86,567.496],[1280.86,668.498],[1324.73,566.765],[1324.73,665.154]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[1280.86,683.688],[1280.86,784.69],[1324.73,679.951],[1324.73,778.339]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[1280.86,803.394],[1280.86,904.395],[1324.52,796.515],[1324.52,894.886]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[1301.74,439.071],[1301.74,343.228],[1342.89,439.487],[1342.89,344.042]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[1301.74,552.22],[1301.74,456.377],[1342.89,552.167],[1342.89,456.721]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[1301.74,566.054],[1301.74,661.897],[1342.89,565.942],[1342.89,661.388]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[1301.74,676.311],[1301.74,772.155],[1342.89,675.742],[1342.89,771.187]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[1302.61,790.17],[1302.61,886.115],[1345.32,789.088],[1345.32,884.619]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[1296.77,444.56],[1296.77,353.968],[1363.7,445.2],[1363.7,355.219]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[1296.77,551.51],[1296.77,460.918],[1363.7,551.427],[1363.7,461.447]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[1296.77,564.585],[1296.77,655.178],[1363.7,564.414],[1363.7,654.395]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[1296.77,668.802],[1296.77,759.395],[1363.7,667.927],[1363.7,757.907]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:11,
                    verts:[[1296.06,776.324],[1296.06,866.975],[1362.76,774.728],[1362.76,864.769]]
                },
                ],
                [
                {
                    num:"506",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[545.284,443.885],[545.284,349.674],[501.409,457.298],[501.409,376.338]]
                },{
                    num:"406",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[545.284,555.107],[545.284,460.896],[501.409,552.877],[501.409,471.917]]
                },{
                    num:"306",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[545.284,568.705],[545.284,662.915],[501.409,564.562],[501.409,645.522]]
                },{
                    num:"206",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[545.284,677.084],[545.284,771.295],[501.409,657.698],[501.409,738.658]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[581.665,435.897],[581.664,337.017],[525.825,440.512],[525.825,346.048]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[581.665,552.631],[581.664,453.751],[525.825,552.034],[525.825,457.569]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[581.664,566.903],[581.665,665.783],[525.825,565.668],[525.825,660.133]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[581.664,680.654],[581.665,779.534],[525.825,674.339],[525.825,768.804]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[547.986,785.083],[547.986,879.083],[532.116,772.683],[532.116,861.942]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[548.328,785.072],[564.52,784.561],[548.328,879.068],[564.52,878.362]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[582.617,797.966],[582.617,896.892],[564.52,784.561],[564.52,878.362]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[585.995,340.012],[585.995,251.263],[567.01,350.738],[567.01,266.767]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[581.665,435.897],[581.664,337.017],[659.096,436.928],[659.095,339.034]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[581.665,552.631],[581.664,453.751],[659.096,552.498],[659.095,454.604]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[581.664,566.903],[581.665,665.783],[659.095,566.627],[659.096,664.521]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[581.664,680.654],[581.665,779.534],[659.095,679.244],[659.096,777.138]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[582.617,797.966],[659.752,795.396],[582.617,896.892],[659.752,893.339]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[626.55,330.345],[626.55,237.29],[585.996,340.012],[585.996,251.263]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[690.268,320.879],[690.268,223.607],[626.937,330.256],[626.937,237.161]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[681.133,810.205],[681.133,913.811],[655.462,794.672],[655.462,892.338]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[683.279,431.115],[683.277,327.661],[659.095,436.928],[659.094,339.034]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[683.279,553.25],[683.277,449.796],[659.095,552.498],[659.094,454.604]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[683.277,568.182],[683.279,671.637],[659.094,566.627],[659.095,664.521]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[683.277,687.196],[683.279,790.65],[659.094,679.244],[659.095,777.138]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[681.133,810.205],[729.482,808.496],[681.133,913.811],[729.482,911.449]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[683.279,431.115],[683.279,327.661],[729.823,431.772],[729.823,328.946]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[683.279,553.25],[683.279,449.796],[729.823,553.165],[729.823,450.339]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[683.279,568.182],[683.279,671.637],[729.823,568.006],[729.823,670.833]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[683.279,687.196],[683.279,790.65],[729.823,686.297],[729.823,789.124]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[749.627,314.759],[749.627,214.762],[690.268,320.879],[690.268,223.607]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[743.678,428.773],[743.678,323.077],[729.823,431.772],[729.823,328.945]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[743.678,553.554],[743.678,447.857],[729.823,553.165],[729.823,450.339]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[743.678,568.809],[743.678,674.505],[729.823,568.006],[729.823,670.833]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[743.678,690.401],[743.678,796.097],[729.823,686.297],[729.823,789.124]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[742.668,815.652],[742.668,921.341],[729.482,808.496],[729.482,911.449]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[821.898,819.03],[821.898,926.01],[742.668,815.652],[742.668,921.341]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[822.872,427.445],[822.872,320.478],[743.678,428.773],[743.678,323.077]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[822.872,553.726],[822.872,446.759],[743.678,553.554],[743.678,447.857]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[822.872,569.164],[822.872,676.131],[743.678,568.809],[743.678,674.505]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[822.872,692.218],[822.872,799.185],[743.678,690.401],[743.678,796.097]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[821.276,310.986],[821.276,209.308],[749.627,314.759],[749.627,214.762]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[821.277,310.986],[821.277,209.308],[879.742,312.759],[879.742,211.871]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[821.898,819.03],[821.898,926.01],[1075.91,809.586],[1075.91,912.956]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[822.872,427.445],[822.872,320.478],[1076.81,431.218],[1076.81,327.861]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[822.872,553.726],[822.872,446.759],[1076.81,553.237],[1076.81,449.88]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[822.872,569.164],[822.872,676.131],[1076.81,568.155],[1076.81,671.511]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[822.872,692.218],[822.872,799.185],[1076.81,687.055],[1076.81,790.412]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[889.93,309.189],[889.93,206.711],[879.74,312.759],[879.74,211.871]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[889.93,309.189],[952.164,309.577],[889.93,206.71],[952.164,207.27]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[952.164,309.577],[996.468,310.022],[952.164,207.27],[996.468,207.914]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[996.468,310.022],[996.468,207.914],[1061,311.119],[1061,209.5]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[1064.97,311.369],[1064.97,209.861],[1122.41,314.073],[1122.41,213.77]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[1078.22,431.239],[1078.22,327.902],[1315.49,434.764],[1315.49,334.801]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[1078.22,553.234],[1078.22,449.898],[1315.49,552.778],[1315.49,452.814]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[1078.22,568.149],[1078.22,671.486],[1315.49,567.206],[1315.49,667.17]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[1078.22,687.027],[1078.22,790.364],[1315.49,682.203],[1315.49,782.167]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[1078.22,809.5],[1078.22,912.837],[1315.49,800.679],[1315.49,900.643]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[1122.41,314.073],[1122.41,213.77],[1158.82,316.117],[1158.82,216.724]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[1158.82,316.117],[1158.82,216.724],[1207.18,319.096],[1207.18,221.03]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[1192.71,322.367],[1192.71,225.759],[1245.54,323.969],[1245.54,228.074]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[1245.54,323.969],[1245.54,228.074],[1273.22,330.339],[1273.22,237.281]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[1273.22,330.339],[1273.22,237.281],[1278.14,337.745],[1278.14,247.987]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[1315.49,434.765],[1315.49,334.801],[1352.36,437.617],[1352.36,340.382]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[1315.49,552.778],[1315.49,452.814],[1352.36,552.409],[1352.36,455.174]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[1315.49,567.206],[1315.49,667.17],[1352.36,566.443],[1352.36,663.678]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[1315.49,682.203],[1315.49,782.167],[1352.36,678.301],[1352.36,775.536]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[1315.49,800.679],[1315.49,900.643],[1352.12,793.5],[1352.12,890.719]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[1324.36,440.161],[1324.36,345.36],[1363.46,440.712],[1363.46,346.439]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[1324.36,552.079],[1324.36,457.278],[1363.46,552.008],[1363.46,457.735]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[1324.36,565.762],[1324.36,660.563],[1363.46,565.615],[1363.46,659.888]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[1324.36,674.82],[1324.36,769.622],[1363.46,674.066],[1363.46,768.339]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[1325.42,787.433],[1325.42,882.332],[1366.01,785.998],[1366.01,880.349]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[1307.84,445.562],[1307.84,355.928],[1371.53,446.41],[1371.53,357.587]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[1307.84,551.38],[1307.84,461.747],[1371.53,551.271],[1371.53,462.448]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[1307.84,564.317],[1307.84,653.951],[1371.53,564.09],[1371.53,652.913]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[1307.84,667.431],[1307.84,757.065],[1371.53,666.271],[1371.53,755.094]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:12,
                    verts:[[1307.28,773.821],[1307.28,863.515],[1370.74,771.706],[1370.74,860.591]]
                },
                ],
                [
                {
                    num:"101",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[503.456,753.668],[503.456,835.656],[483.049,744.637],[483.049,823.171]]
                },{
                    num:"506",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[563.924,442.244],[563.924,346.413],[488.086,455.744],[488.086,373.248]]
                },{
                    num:"406",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[563.924,555.38],[563.924,459.548],[488.086,553.135],[488.086,470.64]]
                },{
                    num:"306",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[563.924,569.211],[563.924,665.043],[488.086,565.042],[488.086,647.538]]
                },{
                    num:"206",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[563.924,679.455],[563.924,775.286],[488.086,659.944],[488.086,742.44]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[511.577,764.306],[511.577,850.362],[489.365,754.159],[489.365,836.334]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[566.214,789.288],[566.214,884.896],[538.936,776.825],[538.936,867.667]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[612.04,434.262],[612.04,333.818],[544.493,438.744],[544.493,342.587]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[612.04,552.843],[612.04,452.399],[544.493,552.263],[544.493,456.106]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[612.04,567.34],[612.04,667.784],[544.493,566.141],[544.493,662.298]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[612.04,682.89],[612.04,783.335],[544.493,676.759],[544.493,772.916]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[562.61,347.622],[562.61,262.263],[560.203,356.526],[560.203,275.132]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[593.119,336.868],[593.119,246.719],[562.61,347.622],[562.61,262.263]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[566.556,789.274],[582.738,788.61],[566.556,884.876],[582.738,883.959]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[613.123,802.049],[613.123,902.537],[582.738,788.61],[582.738,883.959]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[644.562,327.368],[644.562,232.986],[593.12,336.868],[593.12,246.719]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[612.04,434.262],[612.04,333.818],[688.911,435.596],[688.911,336.428]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[612.04,552.843],[612.04,452.399],[688.911,552.67],[688.911,453.502]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[612.04,567.34],[612.04,667.785],[688.911,566.983],[688.911,666.152]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[612.04,682.89],[612.04,783.335],[688.911,681.066],[688.911,780.234]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[613.123,802.049],[613.123,902.537],[689.694,798.723],[689.694,897.939]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[719.221,318.282],[719.221,219.853],[645.047,327.28],[645.047,232.86]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[724.472,813.496],[724.472,918.361],[684.685,798.03],[684.685,896.981]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[726.308,429.81],[726.307,325.106],[688.911,435.596],[688.91,336.428]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[726.308,553.419],[726.307,448.715],[688.911,552.67],[688.91,453.502]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[726.307,568.531],[726.308,673.235],[688.91,566.983],[688.911,666.152]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[726.307,688.982],[726.308,793.686],[688.91,681.066],[688.911,780.234]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[785.708,312.578],[785.708,211.608],[719.221,318.282],[719.221,219.853]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[724.472,813.497],[772.069,811.298],[724.472,918.361],[772.069,915.323]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[726.309,429.81],[726.308,325.106],[772.125,430.654],[772.125,326.759]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[726.309,553.419],[726.308,448.715],[772.125,553.31],[772.125,449.414]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[726.308,568.531],[726.309,673.235],[772.125,568.305],[772.125,672.201]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[726.308,688.982],[726.309,793.686],[772.125,687.826],[772.125,791.722]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[792.735,427.683],[792.735,320.944],[772.125,430.654],[772.125,326.759]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[792.735,553.695],[792.735,446.956],[772.125,553.31],[772.125,449.414]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[792.735,569.1],[792.735,675.839],[772.125,568.305],[772.125,672.201]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[792.735,691.892],[792.735,798.631],[772.125,687.826],[772.125,791.722]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[791.696,818.388],[791.696,925.124],[772.069,811.298],[772.069,915.323]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[861.907,309.36],[861.907,206.958],[785.708,312.578],[785.708,211.608]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[874.638,820.999],[874.638,928.733],[791.696,818.388],[791.696,925.124]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[875.587,426.661],[875.587,318.945],[792.735,427.683],[792.735,320.944]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[875.587,553.827],[875.587,446.111],[792.735,553.695],[792.735,446.956]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[875.587,569.374],[875.587,677.09],[792.735,569.1],[792.735,675.839]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[875.587,693.289],[875.587,801.005],[792.735,691.892],[792.735,798.631]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[861.908,309.36],[861.908,206.958],[918.873,311.618],[918.873,210.221]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[874.638,820.999],[874.638,928.733],[1119.89,809.061],[1119.89,912.23]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[875.587,426.661],[875.587,318.945],[1120.76,431.431],[1120.76,328.278]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[875.587,553.827],[875.587,446.111],[1120.76,553.209],[1120.76,450.057]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[875.587,569.374],[875.587,677.09],[1120.76,568.098],[1120.76,671.251]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[875.587,693.289],[875.587,801.005],[1120.76,686.764],[1120.76,789.917]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[932.71,308.117],[932.71,205.161],[918.872,311.618],[918.872,210.221]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[932.71,308.117],[994.553,309.015],[932.71,205.161],[994.553,206.458]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[994.553,309.015],[1038.24,309.821],[994.553,206.458],[1038.24,207.624]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[1038.24,309.821],[1038.24,207.624],[1101.18,311.438],[1101.18,209.96]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[1104.86,311.719],[1104.86,210.367],[1158.89,314.87],[1158.89,214.922]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[1122.11,431.457],[1122.11,328.33],[1347.25,435.837],[1347.25,336.9]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[1122.11,553.206],[1122.11,450.078],[1347.25,552.639],[1347.25,453.702]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[1122.11,568.091],[1122.11,671.218],[1347.25,566.919],[1347.25,665.856]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[1122.11,686.728],[1122.11,789.856],[1347.25,680.736],[1347.25,779.673]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[1122.11,808.953],[1122.11,912.081],[1347.25,797.995],[1347.25,896.932]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[1158.89,314.87],[1158.89,214.922],[1192.7,317.189],[1192.7,218.274]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[1192.7,317.189],[1192.7,218.274],[1237.2,320.523],[1237.2,223.093]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[1219.73,323.66],[1219.73,227.627],[1269.89,325.647],[1269.89,230.499]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[1269.89,325.647],[1269.89,230.499],[1290.57,332.161],[1290.57,239.915]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[1347.25,435.837],[1347.25,336.9],[1376.97,438.787],[1376.97,342.671]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[1347.25,552.639],[1347.25,453.702],[1376.97,552.257],[1376.97,456.142]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[1347.25,566.919],[1347.25,665.856],[1376.97,566.13],[1376.97,662.245]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[1347.25,680.736],[1347.25,779.673],[1376.97,676.7],[1376.97,772.816]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[1347.25,797.995],[1347.25,896.932],[1376.7,790.576],[1376.7,886.676]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[1344.31,441.203],[1344.31,347.399],[1381.12,441.881],[1381.12,348.726]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[1344.31,551.944],[1344.31,458.14],[1381.12,551.857],[1381.12,458.702]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[1344.31,565.483],[1344.31,659.288],[1381.12,565.302],[1381.12,658.457]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[1344.31,673.395],[1344.31,767.199],[1381.12,672.467],[1381.12,765.622]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:13,
                    verts:[[1345.57,784.814],[1345.57,878.711],[1383.76,783.05],[1383.76,876.272]]
                },
                ],
                [
                {
                    num:"101",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[491.599,757.956],[491.599,841.584],[462.46,748.9],[462.46,829.065]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[509.441,768.739],[509.441,856.49],[477.465,758.569],[477.465,842.431]]
                },{
                    num:"506",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[586.059,440.522],[586.059,342.989],[476.886,454.026],[476.886,369.834]]
                },{
                    num:"406",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[586.059,555.666],[586.059,458.133],[476.886,553.421],[476.886,469.228]]
                },{
                    num:"306",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[586.059,569.743],[586.059,667.276],[476.886,565.573],[476.886,649.765]]
                },{
                    num:"206",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[586.059,681.944],[586.059,779.477],[476.886,662.427],[476.886,746.619]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[587.895,793.706],[587.895,891.004],[548.774,781.263],[548.774,873.802]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[560.424,344.21],[560.424,257.33],[548.752,353.256],[548.752,270.404]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[602.873,333.492],[602.873,241.838],[560.423,344.21],[560.423,257.33]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[646.107,432.584],[646.106,330.535],[566.828,436.887],[566.828,338.954]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[646.107,553.06],[646.106,451.011],[566.828,552.503],[566.828,454.57]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[646.106,567.789],[646.107,669.839],[566.828,566.638],[566.828,664.571]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[646.106,685.186],[646.107,787.236],[566.828,679.299],[566.828,777.232]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[588.235,793.689],[604.266,792.865],[588.235,890.98],[604.266,889.841]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[665.346,324.234],[665.346,228.457],[602.874,333.492],[602.874,241.838]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[647.316,806.239],[647.316,908.328],[604.266,792.865],[604.266,889.841]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[646.107,432.584],[646.106,330.535],[721.646,434.232],[721.646,333.758]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[646.107,553.06],[646.106,451.011],[721.646,552.847],[721.646,452.373]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[646.106,567.789],[646.107,669.839],[721.646,567.348],[721.646,667.822]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[646.106,685.186],[646.107,787.236],[721.646,682.932],[721.646,783.406]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[647.316,806.239],[647.316,908.328],[722.555,802.131],[722.555,902.65]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[750.772,315.617],[750.772,216.002],[665.932,324.149],[665.932,228.334]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[770.945,816.75],[770.945,922.859],[716.84,801.477],[716.84,901.746]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[772.437,428.519],[772.436,322.58],[721.646,434.232],[721.645,333.758]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[772.437,553.586],[772.436,447.648],[721.646,552.847],[721.645,452.373]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[772.436,568.877],[772.437,674.816],[721.645,567.348],[721.646,667.822]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[772.436,690.748],[772.437,796.687],[721.645,682.932],[721.646,783.406]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[824.014,310.394],[824.014,208.451],[750.772,315.617],[750.772,216.002]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[770.945,816.75],[770.945,922.859],[817.248,814.054],[817.248,919.132]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[772.438,428.519],[772.437,322.58],[817.009,429.555],[817.009,324.607]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[772.438,553.586],[772.437,447.648],[817.009,553.452],[817.009,448.504]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[772.437,568.877],[772.438,674.816],[817.009,568.6],[817.009,673.548]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[772.437,690.748],[772.438,796.687],[817.009,689.331],[817.009,794.279]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[844.385,426.636],[844.385,318.897],[817.009,429.555],[817.009,324.606]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[844.385,553.83],[844.385,446.09],[817.009,553.452],[817.009,448.504]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[844.385,569.38],[844.385,677.12],[817.009,568.6],[817.009,673.548]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[844.385,693.323],[844.385,801.063],[817.009,689.331],[817.009,794.279]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[843.327,821.017],[843.327,928.757],[817.248,814.054],[817.248,919.132]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[904.132,307.78],[904.132,204.673],[824.014,310.394],[824.014,208.451]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[929.152,822.806],[929.152,931.231],[843.327,821.017],[843.327,928.757]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[930.064,425.943],[930.064,317.54],[844.385,426.637],[844.385,318.897]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[930.064,553.92],[930.064,445.517],[844.385,553.83],[844.385,446.09]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[930.064,569.566],[930.064,677.969],[844.385,569.38],[844.385,677.12]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[930.064,694.272],[930.064,802.675],[844.385,693.323],[844.385,801.063]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[904.134,307.78],[904.134,204.673],[958.989,310.52],[958.989,208.634]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[929.152,822.806],[929.152,931.231],[1162.88,808.426],[1162.88,911.352]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[930.064,425.943],[930.064,317.54],[1163.7,431.688],[1163.7,328.782]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[930.064,553.92],[930.064,445.517],[1163.7,553.176],[1163.7,450.269]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[930.064,569.566],[930.064,677.969],[1163.7,568.029],[1163.7,670.936]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[930.064,694.272],[930.064,802.675],[1163.7,686.412],[1163.7,789.318]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[976.405,307.118],[976.405,203.716],[958.987,310.52],[958.987,208.634]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[976.406,307.118],[976.406,203.716],[1037.22,308.529],[1037.22,205.757]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[1037.22,308.529],[1037.22,205.757],[1079.84,309.695],[1079.84,207.442]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[1079.84,309.695],[1079.84,207.442],[1140.56,311.823],[1140.56,210.517]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[1143.91,312.133],[1143.91,210.966],[1194.01,315.708],[1194.01,216.133]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[1164.97,431.72],[1164.97,328.843],[1375.94,436.908],[1375.94,338.994]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[1164.97,553.172],[1164.97,450.295],[1375.94,552.501],[1375.94,454.587]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[1164.97,568.021],[1164.97,670.897],[1375.94,566.633],[1375.94,664.546]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[1164.97,686.369],[1164.97,789.246],[1375.94,679.271],[1375.94,777.185]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[1164.97,808.297],[1164.97,911.174],[1375.94,795.317],[1375.94,893.23]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[1194.01,315.708],[1194.01,216.133],[1224.92,318.284],[1224.92,219.856]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[1224.92,318.284],[1224.92,219.856],[1265.2,321.944],[1265.2,225.146]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[1244.91,324.928],[1244.91,229.459],[1292.01,327.279],[1292.01,232.858]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[1292.01,327.279],[1292.01,232.858],[1305.65,333.894],[1305.65,242.419]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:14,
                    verts:[[1362.95,782.287],[1362.95,875.218],[1398.51,780.217],[1398.51,872.357]]
                },
                ],
                [
                {
                    num:"101",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[482.034,762.654],[482.034,848.077],[443.725,753.626],[443.725,835.597]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[447.322,449.318],[447.322,363.277],[444.497,453.458],[444.496,371.378]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[447.322,550.894],[447.322,464.853],[444.497,550.358],[444.496,468.278]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[447.322,563.313],[447.322,649.353],[444.496,562.205],[444.497,644.285]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[447.322,662.293],[447.322,748.334],[444.496,656.629],[444.497,738.708]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[510.13,773.523],[510.13,863.103],[467.939,763.396],[467.939,849.104]]
                },{
                    num:"506",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[611.92,438.738],[611.92,339.442],[468.112,452.148],[468.112,366.101]]
                },{
                    num:"406",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[611.92,555.963],[611.92,456.667],[468.112,553.733],[468.112,467.685]]
                },{
                    num:"306",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[611.92,570.294],[611.92,669.59],[468.112,566.153],[468.112,652.2]]
                },{
                    num:"206",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[611.92,684.523],[611.92,783.819],[468.112,665.141],[468.112,751.189]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[536.145,349.923],[536.145,265.588],[532.937,358.53],[532.937,278.03]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[560.705,340.517],[560.705,251.993],[539.278,349.66],[539.278,265.207]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[615.482,329.913],[615.482,236.666],[560.704,340.517],[560.704,251.993]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[613.257,798.286],[613.257,897.335],[561.911,785.962],[561.911,880.299]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[683.977,430.891],[683.976,327.221],[593.083,434.964],[593.083,335.19]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[683.977,553.279],[683.976,449.61],[593.083,552.752],[593.083,452.979]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[683.976,568.242],[683.977,671.912],[593.083,567.153],[593.083,666.926]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[683.976,687.503],[683.977,791.173],[593.083,681.931],[593.083,781.704]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[613.589,798.266],[629.311,797.274],[613.589,897.306],[629.311,895.936]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[689.048,320.986],[689.048,223.761],[615.483,329.913],[615.483,236.666]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[685.307,810.466],[685.307,914.172],[629.311,797.274],[629.311,895.936]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[683.977,430.891],[683.976,327.221],[757.339,432.859],[757.339,331.073]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[683.977,553.279],[683.976,449.61],[757.339,553.025],[757.339,451.238]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[683.976,568.242],[683.977,671.912],[757.339,567.716],[757.339,669.502]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[683.976,687.503],[683.977,791.173],[757.339,684.81],[757.339,786.596]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[685.307,810.466],[685.307,914.172],[758.368,805.557],[758.368,907.387]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[784.935,312.937],[784.935,212.128],[689.735,320.904],[689.735,223.643]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[820.441,819.886],[820.441,927.194],[751.975,804.949],[751.975,906.546]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[821.557,427.274],[821.557,320.144],[757.339,432.859],[757.338,331.073]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[821.557,553.748],[821.557,446.617],[757.339,553.025],[757.338,451.238]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[821.557,569.21],[821.557,676.34],[757.338,567.716],[757.339,669.502]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[821.557,692.451],[821.557,799.582],[757.338,684.81],[757.339,786.596]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[864.448,308.262],[864.448,205.37],[784.935,312.937],[784.935,212.128]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[820.441,819.886],[820.441,927.194],[864.874,816.69],[864.874,922.776]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[821.559,427.274],[821.557,320.144],[864.331,428.502],[864.331,322.546]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[821.559,553.748],[821.557,446.618],[864.331,553.589],[864.331,447.633]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[821.557,569.21],[821.559,676.34],[864.331,568.881],[864.331,674.837]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[821.557,692.451],[821.559,799.581],[864.331,690.771],[864.331,796.727]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[947.76,306.299],[947.76,202.532],[864.447,308.262],[864.447,205.37]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[898.396,425.666],[898.396,316.997],[864.331,428.502],[864.331,322.546]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[898.396,553.956],[898.396,445.287],[864.331,553.589],[864.331,447.633]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[898.396,569.64],[898.396,678.309],[864.331,568.881],[864.331,674.837]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[898.396,694.651],[898.396,803.32],[864.331,690.771],[864.331,796.727]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[897.333,823.457],[897.333,932.13],[864.874,816.69],[864.874,922.776]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[985.101,824.375],[897.333,823.457],[985.101,933.4],[897.333,932.13]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[985.965,425.32],[898.396,425.666],[985.965,316.32],[898.396,316.997]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[985.965,554.001],[985.965,445.001],[898.396,553.956],[898.396,445.287]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[985.965,569.733],[985.965,678.732],[898.396,569.64],[898.396,678.309]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[985.965,695.125],[898.396,694.651],[985.965,804.124],[898.396,803.32]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[947.76,306.299],[947.76,202.532],[999.877,309.515],[999.877,207.181]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[985.101,824.376],[985.101,933.4],[1204.54,807.634],[1204.54,910.257]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[985.965,425.32],[985.965,316.32],[1205.31,432.008],[1205.31,329.407]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[985.965,554.001],[985.965,445.001],[1205.31,553.135],[1205.31,450.534]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[985.965,569.733],[985.965,678.732],[1205.31,567.943],[1205.31,670.544]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[985.965,695.125],[985.965,804.124],[1205.31,685.974],[1205.31,788.575]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[1020.76,306.242],[1020.76,202.45],[999.876,309.515],[999.876,207.181]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[1020.76,306.241],[1020.76,202.45],[1079.88,308.167],[1079.88,205.233]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[1079.88,308.167],[1079.88,205.233],[1120.98,309.689],[1120.98,207.432]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[1120.98,309.689],[1120.98,207.432],[1178.83,312.314],[1178.83,211.227]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[1181.82,312.651],[1181.82,211.714],[1227.5,316.621],[1227.5,217.453]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[1206.49,432.044],[1206.49,329.478],[1401.38,437.987],[1401.38,341.106]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[1206.49,553.13],[1206.49,450.564],[1401.38,552.361],[1401.38,455.48]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[1206.49,567.934],[1206.49,670.5],[1401.38,566.344],[1401.38,663.225]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[1206.49,685.925],[1206.49,788.491],[1401.38,677.794],[1401.38,774.675]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[1206.49,807.485],[1206.49,910.051],[1401.38,792.616],[1401.38,889.497]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[1227.5,316.621],[1227.5,217.453],[1255.23,319.432],[1255.23,221.515]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[1255.23,319.432],[1255.23,221.515],[1290.96,323.387],[1290.96,227.232]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[1268.07,326.199],[1268.07,231.297],[1311.74,328.893],[1311.74,235.19]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:15,
                    verts:[[1311.74,328.893],[1311.74,235.19],[1318.35,335.561],[1318.35,244.83]]
                },
                ],
                [
                {
                    num:"101",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[475.108,767.742],[475.108,855.111],[427.184,758.809],[427.184,842.763]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[440.515,447.149],[440.515,359.034],[428.241,451.386],[428.24,367.324]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[440.515,551.175],[440.515,463.06],[428.241,550.626],[428.24,466.564]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[440.515,563.893],[440.515,652.008],[428.24,562.759],[428.241,646.821]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[440.515,665.26],[440.515,753.375],[428.24,659.463],[428.241,743.525]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[513.995,778.624],[513.995,870.155],[461.15,768.622],[461.15,856.329]]
                },{
                    num:"506",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[641.71,436.92],[641.71,335.829],[462.132,450.117],[462.132,362.064]]
                },{
                    num:"406",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[641.71,556.265],[641.71,455.174],[462.132,554.071],[462.132,466.017]]
                },{
                    num:"306",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[641.71,570.855],[641.71,671.947],[462.132,566.78],[462.132,654.834]]
                },{
                    num:"206",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[641.71,687.15],[641.71,788.241],[462.132,668.076],[462.132,756.13]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[528.557,346.003],[528.557,259.923],[516.231,354.778],[516.231,272.606]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[563.746,336.574],[563.746,246.294],[532.072,345.757],[532.072,259.565]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[631.178,326.177],[631.178,231.265],[563.746,336.574],[563.746,246.294]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[642.502,802.956],[642.502,903.791],[578.642,790.869],[578.642,887.082]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[725.701,429.217],[725.7,323.946],[623.488,433.003],[623.488,331.353]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[725.701,553.496],[725.7,448.225],[623.488,553.006],[623.488,451.357]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[725.7,568.69],[725.701,673.961],[623.488,567.677],[623.488,669.327]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[725.7,689.793],[725.701,795.064],[623.488,684.614],[623.488,786.263]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[715.788,317.679],[715.788,218.982],[631.179,326.177],[631.179,231.265]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[642.825,802.932],[658.059,801.768],[642.825,903.757],[658.059,902.149]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[727.142,814.641],[727.142,919.944],[658.059,801.768],[658.059,902.149]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[821.665,310.306],[821.665,208.325],[716.573,317.602],[716.573,218.87]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[725.701,429.217],[725.7,323.946],[795.962,431.511],[795.961,328.435]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[725.701,553.496],[725.7,448.225],[795.962,553.199],[795.961,450.123]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[725.7,568.69],[725.701,673.961],[795.961,568.076],[795.962,671.152]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[725.7,689.793],[725.701,795.064],[795.961,686.654],[795.962,789.73]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[727.142,814.641],[727.142,919.944],[797.105,808.921],[797.105,912.037]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[872.743,822.807],[872.743,931.232],[790.072,808.368],[790.072,911.272]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[873.456,426.113],[873.455,317.873],[795.961,431.511],[795.961,328.435]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[873.456,553.898],[873.455,445.657],[795.961,553.199],[795.961,450.123]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[873.455,569.52],[873.456,677.761],[795.961,568.076],[795.961,671.152]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[873.455,694.039],[873.456,802.28],[795.961,686.654],[795.961,789.73]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[906.832,306.251],[906.832,202.463],[821.665,310.306],[821.665,208.325]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[872.743,822.807],[872.743,931.232],[914.701,819.115],[914.701,926.129]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[873.456,426.113],[873.456,317.873],[913.851,427.532],[913.851,320.648]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[873.456,553.898],[873.456,445.657],[913.851,553.714],[913.851,446.831]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[873.456,569.52],[873.456,677.761],[913.851,569.141],[913.851,676.024]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[873.456,694.039],[873.456,802.28],[913.851,692.099],[913.851,798.982]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[992.507,304.984],[992.507,200.631],[906.832,306.251],[906.832,202.463]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[954.418,424.809],[954.418,315.32],[913.851,427.531],[913.851,320.648]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[954.418,554.067],[954.418,444.578],[913.851,553.714],[913.851,446.831]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[954.418,569.869],[954.418,679.358],[913.851,569.141],[913.851,676.024]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[954.418,695.824],[954.418,805.312],[913.851,692.099],[913.851,798.982]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[953.362,825.612],[953.362,935.109],[914.701,819.115],[914.701,926.129]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[953.362,825.612],[1042.03,825.618],[953.362,935.109],[1042.03,935.118]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[954.418,424.809],[1042.84,424.827],[954.418,315.32],[1042.84,315.356]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[954.418,554.067],[1042.84,554.064],[954.418,444.578],[1042.84,444.593]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[954.418,569.869],[1042.84,569.864],[954.418,679.358],[1042.84,679.336]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[954.418,695.824],[1042.84,695.799],[954.418,805.312],[1042.84,805.27]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[992.508,304.983],[992.508,200.631],[1041.25,308.663],[1041.25,205.95]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[1065.44,305.55],[1065.44,201.451],[1041.25,308.663],[1041.25,205.95]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[1042.03,825.618],[1042.03,935.118],[1244.48,806.632],[1244.48,908.872]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[1042.84,424.827],[1042.84,315.356],[1245.18,432.411],[1245.18,330.196]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[1042.84,554.064],[1042.84,444.593],[1245.18,553.083],[1245.18,450.868]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[1042.84,569.864],[1042.84,679.336],[1245.18,567.835],[1245.18,670.05]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[1042.84,695.799],[1042.84,805.27],[1245.18,685.423],[1245.18,787.638]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[1065.44,305.55],[1065.44,201.45],[1122.18,307.984],[1122.18,204.968]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[1122.18,307.984],[1122.18,204.968],[1161.29,309.852],[1161.29,207.668]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[1161.29,309.852],[1161.29,207.668],[1215.65,312.955],[1215.65,212.154]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[1218.25,313.317],[1218.25,212.676],[1259.06,317.649],[1259.06,218.938]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[1246.27,432.452],[1246.27,330.276],[1423.32,439.089],[1423.32,343.262]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[1246.27,553.077],[1246.27,450.901],[1423.32,552.218],[1423.32,456.391]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[1246.27,567.825],[1246.27,670.001],[1423.32,566.049],[1423.32,661.876]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[1246.27,685.367],[1246.27,787.543],[1423.32,676.287],[1423.32,772.114]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[1246.27,806.465],[1246.27,908.641],[1423.32,789.86],[1423.32,885.687]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[1259.06,317.649],[1259.06,218.938],[1283.35,320.67],[1283.35,223.305]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[1283.35,320.67],[1283.35,223.305],[1314.24,324.886],[1314.24,229.399]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:16,
                    verts:[[1288.98,327.508],[1288.98,233.189],[1328.89,330.518],[1328.89,237.54]]
                },
                ],
                [
                {
                    num:"101",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[471.252,773.188],[471.252,862.639],[413.278,764.433],[413.278,850.537]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[437.052,444.829],[437.052,354.495],[414.638,449.139],[414.637,362.927]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[437.052,551.475],[437.052,461.14],[414.638,550.917],[414.637,464.705]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[437.052,564.513],[437.052,654.848],[414.637,563.36],[414.638,649.573]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[437.052,668.433],[437.052,758.768],[414.637,662.538],[414.638,748.75]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[521.441,783.992],[521.441,877.575],[457.549,774.215],[457.549,864.06]]
                },{
                    num:"506",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[675.602,435.106],[675.602,332.222],[459.395,447.947],[459.395,357.749]]
                },{
                    num:"406",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[675.602,556.567],[675.602,453.683],[459.395,554.432],[459.395,464.233]]
                },{
                    num:"306",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[675.602,571.416],[675.602,674.3],[459.395,567.45],[459.395,657.648]]
                },{
                    num:"206",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[675.602,689.772],[675.602,792.656],[459.395,671.213],[459.395,761.411]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[501.576,350.694],[501.577,266.703],[499.297,356.71],[499.297,275.398]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[523.595,341.801],[523.595,253.848],[501.577,350.694],[501.577,266.703]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[569.888,332.422],[569.888,240.292],[527.495,341.575],[527.495,253.52]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[650.204,322.341],[650.204,225.72],[569.887,332.422],[569.887,240.292]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[675.808,807.623],[675.808,910.242],[599.28,795.912],[599.28,894.053]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[745.651,314.386],[745.651,214.222],[650.205,322.341],[650.205,225.72]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[771.246,427.608],[771.246,320.797],[658.237,431.043],[658.237,327.52]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[771.246,553.704],[771.246,446.894],[658.237,553.26],[658.237,449.736]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[771.246,569.12],[771.246,675.931],[658.237,568.201],[658.237,671.725]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[771.246,691.994],[771.246,798.805],[658.237,687.294],[658.237,790.818]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[676.116,807.595],[690.666,806.256],[676.116,910.203],[690.666,908.352]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[772.789,818.654],[772.789,925.491],[690.666,806.256],[690.666,908.352]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[860.851,307.804],[860.851,204.708],[746.533,314.314],[746.533,214.118]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[771.246,427.608],[771.246,320.797],[837.417,430.227],[837.417,325.922]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[771.246,553.704],[771.246,446.894],[837.417,553.365],[837.417,449.06]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[771.246,569.12],[771.246,675.931],[837.417,568.42],[837.417,672.725]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[771.246,691.994],[771.246,798.805],[837.417,688.411],[837.417,792.716]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[772.789,818.654],[772.789,925.491],[838.669,812.125],[838.669,916.465]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[927.516,825.4],[927.516,934.816],[831.047,811.635],[831.047,915.788]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[927.8,425.082],[927.8,315.855],[837.417,430.227],[837.417,325.922]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[927.8,554.031],[927.8,444.804],[837.417,553.365],[837.417,449.06]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[927.8,569.796],[927.8,679.023],[837.417,568.42],[837.417,672.725]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[927.8,695.45],[927.8,804.677],[837.417,688.411],[837.417,792.716]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[950.912,304.44],[950.912,199.846],[860.851,307.804],[860.851,204.708]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[927.516,825.4],[927.516,934.816],[966.376,821.226],[966.376,929.047]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[927.801,425.082],[927.8,315.855],[965.217,426.686],[965.217,318.993]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[927.801,554.031],[927.8,444.804],[965.217,553.824],[965.217,446.131]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[927.8,569.796],[927.801,679.023],[965.217,569.367],[965.217,677.06]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[927.8,695.45],[927.801,804.677],[965.217,693.256],[965.217,800.949]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[1038.01,303.909],[950.911,304.44],[1038.01,199.078],[950.911,199.846]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[1011.98,424.109],[1011.98,313.952],[965.217,426.685],[965.217,318.993]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[1011.98,554.157],[1011.98,444],[965.217,553.824],[965.217,446.131]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[1011.98,570.056],[1011.98,680.214],[965.217,569.367],[965.217,677.06]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[1011.98,696.781],[1011.98,806.938],[965.217,693.256],[965.217,800.949]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[1010.94,827.373],[1010.94,937.544],[966.376,821.226],[966.376,929.047]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[1010.94,827.373],[1099.38,826.435],[1010.94,937.544],[1099.38,936.248]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[1011.98,424.109],[1011.98,313.952],[1100.11,424.504],[1100.11,314.724]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[1011.98,554.157],[1011.98,444],[1100.11,554.106],[1100.11,444.326]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[1011.98,570.056],[1011.98,680.214],[1100.11,569.951],[1100.11,679.731]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[1011.98,696.781],[1011.98,806.938],[1100.11,696.241],[1100.11,806.021]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[1038.01,303.909],[1038.01,199.078],[1082.74,308.03],[1082.74,205.035]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[1110.01,305.112],[1110.01,200.817],[1082.74,308.03],[1082.74,205.035]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[1099.38,826.435],[1099.38,936.248],[1282.25,805.365],[1282.25,907.12]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[1100.11,424.504],[1100.11,314.724],[1282.88,432.921],[1282.88,331.193]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[1100.11,554.106],[1100.11,444.326],[1282.88,553.017],[1282.88,451.289]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[1100.11,569.951],[1100.11,679.731],[1282.88,567.699],[1282.88,669.427]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[1100.11,696.241],[1100.11,806.021],[1282.88,684.726],[1282.88,786.454]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[1110.01,305.112],[1110.01,200.816],[1163.69,308.039],[1163.69,205.048]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[1163.69,308.039],[1163.69,205.048],[1200.37,310.241],[1200.37,208.23]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[1200.37,310.241],[1200.37,208.23],[1250.63,313.796],[1250.63,213.369]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[1252.81,314.178],[1252.81,213.922],[1288.33,318.833],[1288.33,220.65]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[1283.85,432.965],[1283.85,331.28],[1441.52,440.226],[1441.52,345.487]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[1283.85,553.011],[1283.85,451.326],[1441.52,552.071],[1441.52,457.332]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[1283.85,567.687],[1283.85,669.372],[1441.52,565.745],[1441.52,660.484]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[1283.85,684.665],[1283.85,786.35],[1441.52,674.732],[1441.52,769.471]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[1283.85,805.18],[1283.85,906.865],[1441.52,787.015],[1441.52,881.754]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[1288.33,318.833],[1288.33,220.65],[1308.97,322.037],[1308.97,225.281]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[1308.97,322.037],[1308.97,225.281],[1334.77,326.475],[1334.77,231.696]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:17,
                    verts:[[1307.41,328.889],[1307.41,235.185],[1343.24,332.188],[1343.24,239.953]]
                },
                ],
                [
                {
                    num:"101",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[463.055,766.213],[463.055,852.998],[394.508,758.14],[394.508,841.838]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[463.249,448.702],[463.249,362.072],[399.086,451.717],[399.086,367.971]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[463.249,550.974],[463.249,464.344],[399.086,550.584],[399.086,466.838]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[463.249,563.477],[463.249,650.107],[399.086,562.671],[399.086,646.416]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[463.249,663.135],[463.249,749.765],[399.086,659.011],[399.086,742.757]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[470.951,778.942],[470.951,870.594],[402.534,770.466],[402.534,858.878]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[437.469,442.378],[437.469,349.698],[404.212,446.729],[404.211,358.211]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[437.469,551.792],[437.469,459.113],[404.212,551.229],[404.211,462.712]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[437.469,565.169],[437.469,657.849],[404.211,564.005],[404.212,652.523]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[437.469,671.787],[437.469,764.467],[404.211,665.835],[404.212,754.353]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[532.89,789.555],[532.89,885.265],[457.64,780.123],[457.64,872.226]]
                },{
                    num:"506",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[713.675,433.339],[713.675,328.71],[460.407,445.657],[460.407,353.197]]
                },{
                    num:"406",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[713.675,556.86],[713.675,452.231],[460.407,554.812],[460.407,462.352]]
                },{
                    num:"306",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[713.675,571.961],[713.675,676.59],[460.407,568.157],[460.407,660.618]]
                },{
                    num:"206",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[713.675,692.326],[713.675,796.955],[460.407,674.523],[460.407,766.983]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[489.381,346.305],[489.381,260.359],[480.612,352.456],[480.612,269.25]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[521.667,337.356],[521.667,247.423],[489.382,346.305],[489.382,260.359]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[579.481,328.119],[579.481,234.072],[525.948,337.154],[525.948,247.13]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[672.764,318.48],[672.764,220.14],[579.481,328.119],[579.481,234.072]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[713.256,812.172],[713.256,916.53],[624.098,800.996],[624.098,901.081]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[778.648,311.193],[778.648,209.606],[672.764,318.48],[672.764,220.14]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[820.438,426.115],[820.438,317.876],[697.432,429.134],[697.432,323.783]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[820.438,553.898],[820.438,445.659],[697.432,553.507],[697.432,448.156]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[820.438,569.52],[820.438,677.759],[697.432,568.712],[697.432,674.063]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[820.438,694.037],[820.438,802.276],[697.432,689.907],[697.432,795.258]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[713.545,812.14],[727.195,810.625],[713.545,916.486],[727.195,914.392]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[822.066,822.374],[822.066,930.634],[727.195,810.625],[727.195,914.392]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[902.267,305.521],[902.267,201.408],[779.621,311.127],[779.621,209.511]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[820.439,426.115],[820.438,317.876],[881.485,429.051],[881.485,323.621]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[820.439,553.898],[820.438,445.659],[881.485,553.518],[881.485,448.088]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[820.438,569.52],[820.439,677.759],[881.485,568.734],[881.485,674.164]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[820.438,694.037],[820.439,802.276],[881.485,690.02],[881.485,795.449]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[822.066,822.374],[822.066,930.634],[882.833,815.055],[882.833,920.515]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[984.253,827.539],[984.253,937.773],[874.689,814.638],[874.689,919.939]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[984.091,424.23],[984.091,314.188],[881.485,429.051],[881.484,323.621]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[984.091,554.142],[984.091,444.1],[881.485,553.518],[881.484,448.088]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[984.091,570.024],[984.091,680.066],[881.484,568.734],[881.485,674.164]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[984.091,696.615],[984.091,806.657],[881.484,690.02],[881.485,795.45]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[996.301,302.919],[996.301,197.647],[902.267,305.521],[902.267,201.408]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[984.092,424.23],[984.091,314.188],[1017.94,426.009],[1017.94,317.669]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[984.092,554.142],[984.091,444.1],[1017.94,553.911],[1017.94,445.571]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[984.091,570.024],[984.092,680.066],[1017.94,569.548],[1017.94,677.888]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[984.091,696.615],[984.092,806.657],[1017.94,694.182],[1017.94,802.522]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[984.254,827.539],[984.254,937.774],[1019.4,822.909],[1019.4,931.373]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[996.301,302.919],[1083.79,303.156],[996.301,197.647],[1083.79,197.99]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[1070.43,423.614],[1070.43,312.983],[1017.94,426.009],[1017.94,317.669]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[1070.43,554.221],[1070.43,443.59],[1017.94,553.911],[1017.94,445.571]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[1070.43,570.189],[1070.43,680.82],[1017.94,569.548],[1017.94,677.888]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[1070.43,697.458],[1070.43,808.09],[1017.94,694.182],[1017.94,802.522]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[1069.43,828.624],[1069.43,939.273],[1019.4,822.909],[1019.4,931.373]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[1069.43,828.624],[1069.43,939.273],[1156.41,826.726],[1156.41,936.65]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[1070.43,423.614],[1070.43,312.983],[1157.06,424.391],[1157.06,314.503]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[1070.43,554.221],[1070.43,443.59],[1157.06,554.121],[1157.06,444.233]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[1070.43,570.189],[1070.43,680.82],[1157.06,569.981],[1157.06,679.869]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[1070.43,697.458],[1070.43,808.09],[1157.06,696.396],[1157.06,806.284]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[1083.79,303.156],[1083.79,197.99],[1123.88,307.688],[1123.88,204.541]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[1153.96,304.997],[1153.96,200.651],[1123.88,307.688],[1123.88,204.541]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[1153.96,304.997],[1153.96,200.651],[1203.9,308.396],[1203.9,205.564]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[1156.41,826.726],[1156.41,936.65],[1317.35,803.777],[1317.35,904.926]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[1157.06,424.391],[1157.06,314.502],[1317.9,433.557],[1317.9,332.439]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[1157.06,554.121],[1157.06,444.233],[1317.9,552.934],[1317.9,451.816]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[1157.06,569.981],[1157.06,679.869],[1317.9,567.529],[1317.9,668.647]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[1157.06,696.396],[1157.06,806.284],[1317.9,683.855],[1317.9,784.973]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[1203.9,308.396],[1203.9,205.564],[1237.7,310.911],[1237.7,209.2]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[1237.7,310.911],[1237.7,209.2],[1283.31,314.884],[1283.31,214.943]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[1285.04,315.284],[1285.04,215.52],[1314.94,320.215],[1314.94,222.647]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[1314.94,320.215],[1314.94,222.647],[1331.74,323.571],[1331.74,227.499]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[1318.75,433.606],[1318.75,332.534],[1455.69,441.41],[1455.69,347.805]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[1318.75,552.928],[1318.75,451.856],[1455.69,551.918],[1455.69,458.312]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[1318.75,567.516],[1318.75,668.588],[1455.69,565.428],[1455.69,659.033]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[1318.75,683.788],[1318.75,784.861],[1455.69,673.111],[1455.69,766.716]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[1318.75,803.578],[1318.75,904.65],[1455.69,784.051],[1455.69,877.656]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[1331.74,323.571],[1331.74,227.499],[1352.26,328.19],[1352.26,234.174]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:18,
                    verts:[[1323.08,330.377],[1323.08,237.335],[1354.56,333.932],[1354.56,242.474]]
                },
                ],
                [
                {
                    num:"101",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[454.773,771.931],[454.773,860.903],[375.772,764.237],[375.772,850.267]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[412.525,450.472],[412.525,365.536],[378.559,451.757],[378.559,368.05]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[412.525,550.745],[412.525,465.808],[378.559,550.578],[378.559,466.871]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[412.525,563.004],[412.525,647.94],[378.559,562.66],[378.559,646.367]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[412.525,660.714],[412.525,745.65],[378.559,658.956],[378.559,742.663]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[454.602,446.422],[454.601,357.61],[380.679,449.294],[380.679,363.231]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[454.602,551.269],[454.601,462.458],[380.679,550.897],[380.679,464.834]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[454.601,564.087],[454.602,652.899],[380.679,563.319],[380.679,649.382]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[454.601,666.255],[454.602,755.067],[380.679,662.325],[380.679,748.389]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[474.735,784.932],[474.735,878.875],[395.566,776.859],[395.566,867.714]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[442.357,439.825],[442.357,344.703],[397.577,444.177],[397.577,353.217]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[442.357,552.123],[442.357,457.001],[397.577,551.56],[397.577,460.6]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[442.357,565.852],[442.357,660.974],[397.577,564.688],[397.577,655.647]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[442.357,675.28],[442.357,770.402],[397.577,669.326],[397.577,760.286]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[548.767,795.22],[548.767,893.096],[461.976,786.273],[461.976,880.728]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[480.124,341.65],[480.124,253.63],[464.403,347.896],[464.403,262.658]]
                },{
                    num:"506",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[755.887,431.673],[755.887,325.399],[465.718,443.277],[465.718,348.465]]
                },{
                    num:"406",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[755.887,557.137],[755.887,450.863],[465.718,555.208],[465.718,460.396]]
                },{
                    num:"306",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[755.887,572.476],[755.887,678.75],[465.718,568.892],[465.718,663.704]]
                },{
                    num:"206",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[755.887,694.733],[755.887,801.007],[465.718,677.963],[465.718,772.775]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[523.225,332.724],[523.225,240.729],[480.124,341.65],[480.125,253.63]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[592.88,323.738],[592.88,227.739],[527.879,332.552],[527.879,240.478]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[699.01,314.687],[699.01,214.657],[592.879,323.738],[592.879,227.739]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[754.811,816.466],[754.811,922.467],[653.311,806.003],[653.311,908.003]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[814.688,308.199],[814.688,205.28],[699.011,314.687],[699.011,214.657]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[872.932,424.796],[872.932,315.296],[741.046,427.33],[741.046,320.254]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[872.932,554.068],[872.932,444.568],[741.046,553.74],[741.046,446.664]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[872.932,569.873],[872.932,679.373],[741.046,569.195],[741.046,676.271]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[872.932,695.841],[872.932,805.341],[741.046,692.374],[741.046,799.451]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[755.076,816.431],[767.598,814.744],[755.076,922.417],[767.598,920.086]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[874.627,825.656],[874.627,935.171],[767.598,814.744],[767.598,920.086]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[945.566,303.558],[945.566,198.571],[815.746,308.142],[815.746,205.196]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[872.933,424.796],[872.932,315.296],[927.806,428.034],[927.805,321.631]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[872.933,554.068],[872.932,444.568],[927.806,553.649],[927.805,447.246]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[872.932,569.873],[872.933,679.373],[927.805,569.006],[927.806,675.409]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[872.932,695.841],[872.933,805.341],[927.805,691.411],[927.806,797.814]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[874.627,825.656],[874.627,935.171],[929.236,817.586],[929.236,924.015]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[1042.28,829.093],[1042.28,939.922],[920.656,817.251],[920.656,923.551]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[1041.66,423.61],[1041.66,312.975],[927.805,428.034],[927.805,321.631]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[1041.66,554.222],[1041.66,443.587],[927.805,553.649],[927.805,447.246]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[1041.66,570.19],[1041.66,680.825],[927.805,569.006],[927.805,675.409]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[1041.66,697.464],[1041.66,808.099],[927.805,691.411],[927.805,797.814]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[1042.49,301.78],[1042.49,196.001],[945.565,303.558],[945.565,198.571]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[1041.66,423.61],[1041.66,312.975],[1071.36,425.549],[1071.36,316.769]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[1041.66,554.222],[1041.66,443.587],[1071.36,553.971],[1071.36,445.191]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[1041.66,570.19],[1041.66,680.825],[1071.36,569.671],[1071.36,678.451]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[1041.66,697.464],[1041.66,808.099],[1071.36,694.811],[1071.36,803.591]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[1042.49,301.78],[1042.49,196.001],[1129.25,302.806],[1129.25,197.484]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[1042.28,829.093],[1042.28,939.922],[1073.1,824.046],[1073.1,932.945]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[1128.97,423.37],[1128.97,312.505],[1071.36,425.549],[1071.36,316.769]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[1128.97,554.253],[1128.97,443.388],[1071.36,553.971],[1071.36,445.191]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[1128.97,570.254],[1128.97,681.119],[1071.36,569.671],[1071.36,678.451]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[1128.97,697.792],[1128.97,808.657],[1071.36,694.811],[1071.36,803.591]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[1128.02,829.246],[1128.02,940.133],[1073.1,824.046],[1073.1,932.945]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[1128.02,829.246],[1128.02,940.133],[1212.3,826.392],[1212.3,936.187]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[1129.25,302.806],[1129.25,197.484],[1164.14,307.708],[1164.14,204.569]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[1128.97,423.37],[1128.97,312.505],[1212.85,424.527],[1212.85,314.77]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[1128.97,554.253],[1128.97,443.388],[1212.85,554.103],[1212.85,444.345]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[1128.97,570.254],[1128.97,681.119],[1212.85,569.945],[1212.85,679.702]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[1128.97,697.792],[1128.97,808.657],[1212.85,696.209],[1212.85,805.966]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[1196.67,305.277],[1196.67,201.055],[1164.14,307.707],[1164.14,204.569]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[1196.67,305.277],[1196.67,201.055],[1242.24,309.114],[1242.24,206.602]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[1212.3,826.392],[1212.3,936.187],[1349.25,801.82],[1349.25,902.22]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[1212.85,424.527],[1212.85,314.77],[1349.71,434.342],[1349.71,333.973]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[1212.85,554.103],[1212.85,444.345],[1349.71,552.833],[1349.71,452.464]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[1212.85,569.945],[1212.85,679.702],[1349.71,567.319],[1349.71,667.687]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[1212.85,696.209],[1212.85,805.966],[1349.71,682.782],[1349.71,783.15]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[1242.24,309.114],[1242.24,206.602],[1272.75,311.918],[1272.75,210.654]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[1272.75,311.918],[1272.75,210.654],[1313.2,316.265],[1313.2,216.938]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[1314.47,316.677],[1314.47,217.534],[1338.45,321.833],[1338.45,224.986]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[1338.45,321.833],[1338.45,224.986],[1351.3,325.307],[1351.3,230.007]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[1350.43,434.393],[1350.43,334.074],[1465.61,442.653],[1465.61,350.236]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[1350.43,552.826],[1350.43,452.507],[1465.61,551.757],[1465.61,459.34]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[1350.43,567.305],[1350.43,667.624],[1465.61,565.095],[1465.61,657.512]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[1350.43,682.711],[1350.43,783.03],[1465.61,671.411],[1465.61,763.828]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[1350.43,801.608],[1350.43,901.927],[1465.61,780.942],[1465.61,873.359]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:19,
                    verts:[[1351.3,325.307],[1351.3,230.007],[1366.42,330.059],[1366.42,236.876]]
                },
                ],
                [
                {
                    num:"101",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[392.328,767.276],[392.328,854.467],[355.661,764.415],[355.661,850.512]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[396.363,448.048],[396.363,360.793],[357.806,449.25],[357.806,363.144]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[396.363,551.058],[396.363,463.803],[357.806,550.903],[357.806,464.797]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[396.363,563.652],[396.363,650.907],[357.806,563.331],[357.806,649.436]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[396.363,664.029],[396.363,751.284],[357.806,662.386],[357.806,748.491]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[450.285,777.904],[450.285,869.159],[360.553,770.72],[360.553,859.228]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[449.717,444.038],[449.716,352.947],[365.78,446.72],[365.779,358.194]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[449.717,551.578],[449.716,460.486],[365.78,551.23],[365.779,462.704]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[449.716,564.725],[449.717,655.817],[365.779,564.007],[365.78,652.533]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[449.716,669.516],[449.717,760.607],[365.779,665.847],[365.78,754.373]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[483.164,791.066],[483.164,887.354],[393.065,783.537],[393.065,876.946]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[452.335,437.211],[452.335,339.587],[395.423,441.512],[395.423,348.004]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[452.335,552.461],[452.335,454.838],[395.423,551.904],[395.423,458.396]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[452.335,566.552],[452.335,664.175],[395.423,565.401],[395.423,658.909]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[452.335,678.857],[452.335,776.48],[395.423,672.972],[395.423,766.48]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[474.349,336.783],[474.349,246.595],[451.221,343.072],[451.221,255.686]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[569.463,800.868],[569.463,900.904],[471.142,792.57],[471.142,889.433]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[528.747,327.979],[528.747,233.87],[474.35,336.783],[474.35,246.595]]
                },{
                    num:"506",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[802.036,430.168],[802.036,322.407],[475.903,440.844],[475.903,343.629]]
                },{
                    num:"406",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[802.036,557.387],[802.036,449.626],[475.903,555.612],[475.903,458.398]]
                },{
                    num:"306",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[802.036,572.941],[802.036,680.702],[475.903,569.644],[475.903,666.858]]
                },{
                    num:"206",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[802.036,696.908],[802.036,804.669],[475.903,681.479],[475.903,778.694]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[610.411,319.371],[610.411,221.427],[533.758,327.842],[533.758,233.669]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[729.01,311.068],[729.01,209.426],[610.411,319.371],[610.411,221.427]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[800.28,820.355],[800.28,927.843],[687.036,810.798],[687.036,914.63]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[853.561,305.517],[853.561,201.402],[729.011,311.068],[729.011,209.426]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[928.189,423.714],[928.188,313.178],[788.884,425.697],[788.884,317.058]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[928.189,554.208],[928.188,443.673],[788.884,553.952],[788.884,445.313]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[928.188,570.162],[928.189,680.698],[788.884,569.632],[788.884,678.271]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[928.188,697.322],[928.189,807.857],[788.884,694.609],[788.884,803.248]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[800.517,820.316],[811.679,818.466],[800.517,927.789],[811.679,925.231]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[929.929,828.345],[929.929,938.888],[811.679,818.466],[811.679,925.231]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[990.264,302.018],[990.264,196.345],[854.693,305.468],[854.693,201.331]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[928.189,423.714],[928.188,313.178],[975.868,427.227],[975.868,320.053]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[928.189,554.208],[928.188,443.673],[975.868,553.754],[975.868,446.579]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[928.188,570.162],[928.189,680.698],[975.868,569.222],[975.868,676.397]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[928.188,697.322],[928.189,807.857],[975.868,692.515],[975.868,799.689]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[929.929,828.345],[929.929,938.888],[977.364,819.589],[977.364,926.784]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[1100.73,829.933],[1100.73,941.083],[968.453,819.344],[968.453,926.445]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[1099.65,423.273],[1099.65,312.314],[975.868,427.227],[975.868,320.053]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[1099.65,554.266],[1099.65,443.307],[975.868,553.754],[975.868,446.579]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[1099.65,570.28],[1099.65,681.239],[975.868,569.222],[975.868,676.397]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[1099.65,697.926],[1099.65,808.884],[975.868,692.515],[975.868,799.69]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[1088.86,301.117],[990.264,302.018],[1088.86,195.043],[990.264,196.345]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[1088.85,301.117],[1088.85,195.043],[1173.7,302.937],[1173.7,197.673]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[1099.65,423.273],[1099.65,312.314],[1124.69,425.352],[1124.69,316.383]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[1099.65,554.266],[1099.65,443.307],[1124.69,553.997],[1124.69,445.027]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[1099.65,570.28],[1099.65,681.239],[1124.69,569.724],[1124.69,678.693]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[1099.65,697.926],[1099.65,808.884],[1124.69,695.081],[1124.69,804.05]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[1100.73,829.933],[1100.73,941.083],[1126.7,824.522],[1126.7,933.603]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[1186.66,423.421],[1186.66,312.604],[1124.69,425.352],[1124.69,316.383]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[1186.66,554.246],[1186.66,443.43],[1124.69,553.996],[1124.69,445.027]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[1186.66,570.241],[1186.66,681.057],[1124.69,569.724],[1124.69,678.693]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[1186.66,697.723],[1186.66,808.539],[1124.69,695.081],[1124.69,804.05]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[1185.77,829.13],[1185.77,939.973],[1126.7,824.522],[1126.7,933.603]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[1173.7,302.937],[1173.7,197.673],[1202.9,308.155],[1202.9,205.215]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[1185.77,829.13],[1185.77,939.973],[1266.08,825.345],[1266.08,934.741]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[1186.66,423.421],[1186.66,312.604],[1266.54,424.948],[1266.54,315.593]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[1186.66,554.246],[1186.66,443.43],[1266.54,554.049],[1266.54,444.693]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[1186.66,570.241],[1186.66,681.057],[1266.54,569.832],[1266.54,679.187]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[1186.66,697.723],[1186.66,808.539],[1266.54,695.633],[1266.54,804.989]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[1237.47,306.015],[1237.47,202.122],[1202.89,308.155],[1202.89,205.215]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[1237.47,306.015],[1237.47,202.122],[1278.09,310.247],[1278.09,208.239]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[1266.08,825.345],[1266.08,934.741],[1377.4,799.454],[1377.4,898.949]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[1266.54,424.948],[1266.54,315.593],[1377.78,435.289],[1377.78,335.827]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[1266.54,554.049],[1266.54,444.693],[1377.78,552.71],[1377.78,453.248]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[1266.54,569.832],[1266.54,679.187],[1377.78,567.065],[1377.78,666.527]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[1266.54,695.633],[1266.54,804.989],[1377.78,681.486],[1377.78,780.947]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[1278.09,310.247],[1278.09,208.239],[1304.95,313.305],[1304.95,212.66]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[1304.95,313.305],[1304.95,212.66],[1339.8,317.976],[1339.8,219.411]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[1340.6,318.396],[1340.6,220.019],[1358.49,323.719],[1358.49,227.712]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[1358.49,323.719],[1358.49,227.712],[1367.3,327.272],[1367.3,232.848]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[1367.3,327.272],[1367.3,232.848],[1376.97,332.108],[1376.97,239.838]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[1378.36,435.343],[1378.36,335.933],[1471.05,443.96],[1471.05,352.793]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[1378.36,552.703],[1378.36,453.293],[1471.05,551.588],[1471.05,460.421]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[1378.36,567.051],[1378.36,666.461],[1471.05,564.746],[1471.05,655.912]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[1378.36,681.412],[1378.36,780.822],[1471.05,669.623],[1471.05,760.79]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:20,
                    verts:[[1378.36,799.231],[1378.36,898.642],[1471.05,777.672],[1471.05,868.839]]
                },
                ],
                [
                {
                    num:"101",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[379.674,773.67],[379.674,863.307],[338.527,771.066],[338.527,859.706]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[384.054,445.506],[384.054,355.818],[340.801,446.599],[340.801,357.958]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[384.054,551.388],[384.054,461.7],[340.801,551.246],[340.801,462.605]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[384.054,564.332],[384.054,654.02],[340.801,564.04],[340.801,652.681]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[384.054,667.508],[384.054,757.196],[340.801,666.012],[340.801,754.653]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[450.203,784.043],[450.203,877.646],[349.607,777.518],[349.607,868.626]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[449.21,441.587],[449.209,348.15],[355.136,444.022],[355.136,352.915]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[449.21,551.895],[449.209,458.458],[355.136,551.58],[355.136,460.473]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[449.209,565.381],[449.21,658.817],[355.136,564.729],[355.136,655.836]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[449.209,672.869],[449.21,766.306],[355.136,669.538],[355.136,760.645]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[496.769,797.222],[496.769,895.864],[395.755,790.401],[395.755,886.435]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[467.99,434.585],[467.99,334.45],[398.467,438.775],[398.467,342.648]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[467.99,552.801],[467.99,452.666],[398.467,552.259],[398.467,456.132]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[467.99,567.254],[467.99,667.389],[398.467,566.133],[398.467,662.26]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[467.99,682.448],[467.99,782.583],[398.467,676.717],[398.467,772.844]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[441.67,338.044],[441.671,248.418],[436.783,344.077],[436.783,257.139]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[472.63,331.777],[472.63,239.36],[441.67,338.044],[441.671,248.418]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[538.691,323.213],[538.691,226.98],[472.63,331.777],[472.631,239.36]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[595.278,806.359],[595.278,908.495],[485.688,798.889],[485.688,898.169]]
                },{
                    num:"506",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[851.701,428.887],[851.701,319.859],[491.502,438.408],[491.502,338.786]]
                },{
                    num:"406",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[851.701,557.6],[851.701,448.573],[491.502,556.018],[491.502,456.396]]
                },{
                    num:"306",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[851.701,573.336],[851.701,682.364],[491.502,570.396],[491.502,670.018]]
                },{
                    num:"206",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[851.701,698.76],[851.701,807.788],[491.502,685],[491.502,784.622]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[632.324,315.126],[632.324,215.292],[544.031,323.115],[544.031,226.837]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[762.693,307.74],[762.693,204.616],[632.323,315.126],[632.323,215.292]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[849.258,823.676],[849.258,932.434],[725.226,815.223],[725.226,920.747]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[894.888,303.261],[894.888,198.141],[762.694,307.74],[762.694,204.616]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[985.432,422.93],[985.431,311.644],[840.519,424.302],[840.519,314.328]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[985.432,554.31],[985.431,443.024],[840.519,554.132],[840.519,444.159]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[985.431,570.372],[985.432,681.658],[840.519,570.005],[840.519,679.978]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[985.431,698.394],[985.432,809.68],[840.519,696.517],[840.519,806.491]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[849.461,823.634],[849.461,932.375],[859.035,821.635],[859.035,929.612]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[987.192,830.287],[987.192,941.573],[859.035,821.635],[859.035,929.612]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[1035.72,301.003],[1035.72,194.877],[896.082,303.222],[896.082,198.085]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[985.432,422.93],[985.432,311.644],[1024.98,426.682],[1024.98,318.986]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[985.432,554.31],[985.432,443.024],[1024.98,553.824],[1024.98,446.128]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[985.432,570.372],[985.432,681.658],[1024.98,569.368],[1024.98,677.064]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[985.432,698.394],[985.432,809.68],[1024.98,693.261],[1024.98,800.956]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[987.192,830.287],[987.192,941.573],[1026.53,820.937],[1026.53,928.647]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[1157.05,423.264],[1157.05,312.297],[1024.98,426.682],[1024.98,318.986]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[1157.05,554.267],[1157.05,443.3],[1024.98,553.824],[1024.98,446.128]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[1157.05,570.283],[1157.05,681.249],[1024.98,569.368],[1024.98,677.064]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[1157.05,697.938],[1157.05,808.904],[1024.98,693.261],[1024.98,800.957]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[1158.58,829.944],[1158.58,941.098],[1017.4,820.788],[1017.4,928.441]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[1035.72,301.003],[1134.63,301.014],[1035.72,194.877],[1134.63,194.894]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[1134.62,301.014],[1134.62,194.894],[1216.36,303.616],[1216.36,198.654]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[1157.05,423.264],[1157.05,312.297],[1176.99,425.457],[1176.99,316.588]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[1157.05,554.267],[1157.05,443.3],[1176.99,553.983],[1176.99,445.114]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[1157.05,570.283],[1157.05,681.249],[1176.99,569.696],[1176.99,678.564]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[1157.05,697.938],[1157.05,808.904],[1176.99,694.937],[1176.99,803.806]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[1158.58,829.944],[1158.58,941.098],[1179.25,824.237],[1179.25,933.209]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[1242.41,423.803],[1242.41,313.352],[1176.99,425.457],[1176.99,316.588]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[1242.41,554.197],[1242.41,443.746],[1176.99,553.983],[1176.99,445.114]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[1242.41,570.138],[1242.41,680.589],[1176.99,569.696],[1176.99,678.564]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[1242.41,697.2],[1242.41,807.651],[1176.99,694.937],[1176.99,803.806]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[1241.6,828.184],[1241.6,938.664],[1179.25,824.237],[1179.25,933.209]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[1216.36,303.616],[1216.36,198.654],[1239.46,309.086],[1239.46,206.562]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[1275.61,307.263],[1275.61,203.926],[1239.46,309.086],[1239.46,206.562]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[1242.41,423.803],[1242.41,313.352],[1317.09,425.679],[1317.09,317.023]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[1242.41,554.197],[1242.41,443.746],[1317.09,553.954],[1317.09,445.298]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[1242.41,570.138],[1242.41,680.589],[1317.09,569.636],[1317.09,678.292]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[1242.41,697.2],[1242.41,807.651],[1317.09,694.633],[1317.09,803.289]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[1241.6,828.184],[1241.6,938.664],[1316.74,823.521],[1316.74,932.218]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[1275.61,307.263],[1275.61,203.926],[1310.78,311.835],[1310.78,210.535]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[1310.78,311.835],[1310.78,210.535],[1333.71,315.109],[1333.71,215.267]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[1317.09,425.679],[1317.09,317.023],[1401.59,436.41],[1401.59,338.02]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[1317.09,553.954],[1317.09,445.298],[1401.59,552.565],[1401.59,454.175]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[1317.09,569.636],[1317.09,678.292],[1401.59,566.766],[1401.59,665.156]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[1317.09,694.633],[1317.09,803.289],[1401.59,679.952],[1401.59,778.342]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[1316.74,823.521],[1316.74,932.219],[1401.31,796.653],[1401.31,895.077]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[1333.71,315.109],[1333.71,215.267],[1362.63,320.043],[1362.63,222.399]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[1362.96,320.467],[1362.96,223.012],[1374.67,325.893],[1374.67,230.855]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[1374.67,325.893],[1374.67,230.855],[1379.44,329.486],[1379.44,236.049]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[1379.44,329.486],[1379.44,236.048],[1383.67,334.353],[1383.67,243.084]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[1402.03,436.466],[1402.03,338.129],[1471.87,445.334],[1471.87,355.483]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[1402.03,552.558],[1402.03,454.221],[1471.87,551.41],[1471.87,461.558]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[1402.03,566.751],[1402.03,665.087],[1471.87,564.378],[1471.87,654.23]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[1402.03,679.876],[1402.03,778.213],[1471.87,667.743],[1471.87,757.594]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:21,
                    verts:[[1402.03,796.423],[1402.03,894.759],[1471.87,774.234],[1471.87,864.085]]
                },
                ],
                [
                {
                    num:"101",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[371.64,780.282],[371.64,872.447],[325.98,778.001],[325.98,869.293]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[376.356,442.879],[376.356,350.678],[328.373,443.836],[328.373,352.552]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[376.356,551.728],[376.356,459.527],[328.373,551.604],[328.373,460.319]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[376.356,565.035],[376.356,657.236],[328.373,564.779],[328.373,656.064]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[376.356,671.102],[376.356,763.303],[328.373,669.792],[328.373,761.077]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[455.154,790.236],[455.154,886.206],[343.761,784.539],[343.761,878.331]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[453.708,439.112],[453.707,343.308],[349.564,441.238],[349.563,347.468]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[453.708,552.215],[453.707,456.411],[349.564,551.94],[349.563,458.169]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[453.707,566.043],[453.708,661.847],[349.563,565.474],[349.564,659.245]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[453.707,676.255],[453.708,772.059],[349.563,673.347],[349.564,767.117]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[516.023,803.259],[516.023,904.209],[404.366,797.325],[404.366,896.007]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[489.841,432.011],[489.841,329.413],[407.433,436.016],[407.432,337.249]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[489.841,553.134],[489.841,450.536],[407.433,552.616],[407.432,453.849]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[489.841,567.943],[489.841,670.541],[407.432,566.871],[407.433,665.638]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[489.841,685.97],[489.841,788.568],[407.432,680.491],[407.433,779.258]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[436.407,332.887],[436.407,240.964],[424.647,339.038],[424.647,249.855]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[475.552,326.722],[475.553,232.053],[436.407,332.887],[436.407,240.964]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[553.47,318.533],[553.47,220.216],[475.553,326.722],[475.553,232.053]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[626.383,811.533],[626.383,915.647],[506.104,805.084],[506.105,906.733]]
                },{
                    num:"506",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[904.244,427.891],[904.244,317.881],[512.983,436.026],[512.983,334.05]]
                },{
                    num:"406",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[904.244,557.766],[904.244,447.755],[512.983,556.414],[512.983,454.438]]
                },{
                    num:"306",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[904.244,573.644],[904.244,683.654],[512.983,571.132],[512.983,673.107]]
                },{
                    num:"206",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[904.244,700.199],[904.244,810.21],[512.983,688.443],[512.983,790.418]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[658.762,311.127],[658.762,209.511],[559.101,318.48],[559.101,220.138]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[799.838,304.83],[799.838,200.409],[658.762,311.127],[658.762,209.511]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[901.126,826.269],[901.126,936.018],[767.651,819.113],[767.651,926.125]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[938.136,301.545],[938.136,195.661],[799.838,304.83],[799.838,200.41]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[1043.69,422.5],[1043.69,310.802],[895.29,423.213],[895.29,312.198]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[1043.69,554.366],[1043.69,442.668],[895.29,554.273],[895.29,443.258]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[1043.69,570.487],[1043.69,682.184],[895.29,570.296],[895.29,681.311]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[1043.69,698.983],[1043.69,810.68],[895.29,698.007],[895.29,809.022]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[901.291,826.224],[901.291,935.956],[909.064,824.098],[909.064,933.016]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[1045.44,831.343],[1045.44,943.032],[909.064,824.098],[909.064,933.016]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[1081.17,300.602],[939.377,301.517],[1081.17,194.299],[939.377,195.621]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[1043.69,422.5],[1043.69,310.802],[1074.32,426.445],[1074.32,318.521]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[1043.69,554.366],[1043.69,442.668],[1074.32,553.855],[1074.32,445.932]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[1043.69,570.487],[1043.69,682.184],[1074.32,569.432],[1074.32,677.355]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[1043.69,698.983],[1043.69,810.68],[1074.32,693.586],[1074.32,801.509]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[1045.44,831.343],[1045.44,943.032],[1075.88,821.515],[1075.88,929.446]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[1212.72,423.619],[1212.72,312.993],[1074.32,426.445],[1074.32,318.521]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[1212.72,554.221],[1212.72,443.594],[1074.32,553.855],[1074.32,445.931]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[1212.72,570.188],[1212.72,680.814],[1074.32,569.432],[1074.32,677.355]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[1212.72,697.451],[1212.72,808.077],[1074.32,693.586],[1074.32,801.509]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[1214.68,829.035],[1214.68,939.841],[1066.68,821.467],[1066.68,929.38]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[1081.17,300.602],[1081.17,194.299],[1178.96,301.541],[1178.96,195.656]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[1178.96,301.542],[1178.96,195.656],[1256.42,304.891],[1256.42,200.498]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[1212.72,423.619],[1212.72,312.993],[1227.24,425.896],[1227.24,317.448]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[1212.72,554.221],[1212.72,443.594],[1227.24,553.926],[1227.24,445.478]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[1212.72,570.188],[1212.72,680.814],[1227.24,569.578],[1227.24,678.027]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[1212.72,697.451],[1212.72,808.077],[1227.24,694.336],[1227.24,802.785]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[1214.68,829.035],[1214.68,939.841],[1229.71,823.113],[1229.71,931.654]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[1295.1,424.542],[1295.1,314.798],[1227.24,425.896],[1227.24,317.447]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[1295.1,554.101],[1295.1,444.357],[1227.24,553.926],[1227.24,445.478]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[1295.1,569.941],[1295.1,679.685],[1227.24,569.578],[1227.24,678.027]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[1295.1,696.189],[1295.1,805.933],[1227.24,694.336],[1227.24,802.785]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[1294.38,826.343],[1294.38,936.121],[1229.71,823.113],[1229.71,931.654]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[1256.42,304.891],[1256.42,200.498],[1273.15,310.542],[1273.15,208.666]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[1310.38,309.054],[1273.15,310.542],[1310.38,206.516],[1273.15,208.665]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[1294.38,826.343],[1294.38,936.121],[1363.25,820.88],[1363.25,928.568]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[1295.1,424.542],[1295.1,314.798],[1363.49,426.736],[1363.49,319.091]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[1295.1,554.101],[1295.1,444.357],[1363.49,553.817],[1363.49,446.172]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[1295.1,569.941],[1295.1,679.685],[1363.49,569.354],[1363.49,676.999]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[1295.1,696.189],[1295.1,805.933],[1363.49,693.188],[1363.49,800.833]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[1310.38,309.054],[1310.38,206.516],[1339.72,313.904],[1339.72,213.525]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[1339.72,313.904],[1339.72,213.525],[1358.49,317.348],[1358.49,218.503]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[1358.49,317.348],[1358.49,218.503],[1381.25,322.479],[1381.25,225.921]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[1363.25,820.88],[1363.25,928.568],[1420.51,793.41],[1420.51,890.595]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[1363.49,426.736],[1363.49,319.091],[1420.7,437.706],[1420.7,340.557]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[1363.49,553.817],[1363.49,446.172],[1420.7,552.397],[1420.7,455.248]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[1363.49,569.354],[1363.49,676.999],[1420.7,566.419],[1420.7,663.568]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[1363.49,693.188],[1363.49,800.833],[1420.7,678.178],[1420.7,775.328]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[1381.12,322.902],[1381.12,226.531],[1386.66,328.366],[1386.66,234.429]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[1386.66,328.366],[1386.66,234.429],[1387.45,331.957],[1387.45,239.62]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[1421,437.763],[1421,340.668],[1468,446.775],[1468,358.302]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[1421,552.39],[1421,455.295],[1468,551.223],[1468,462.75]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[1421,566.404],[1421,663.499],[1468,563.993],[1468,652.466]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[1421,678.101],[1421,775.196],[1468,665.772],[1468,754.245]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:22,
                    verts:[[1421,793.176],[1421,890.271],[1468,770.629],[1468,859.102]]
                },
                ],
                [
                {
                    num:"101",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[318.898,785.116],[318.898,879.129],[314.706,777.687],[314.706,868.86]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[321.396,441.002],[321.396,347.006],[317.499,443.967],[317.499,352.808]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[321.396,551.971],[321.396,457.974],[317.499,551.587],[317.499,460.427]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[321.396,565.537],[321.396,659.533],[317.499,564.744],[317.499,655.903]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[321.396,673.669],[321.396,767.666],[317.499,669.613],[317.499,760.772]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[369.013,787.001],[369.013,881.734],[318.898,785.116],[318.898,879.129]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[374.045,440.211],[374.045,345.459],[321.396,441.002],[321.396,347.006]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[374.045,552.073],[374.045,457.32],[321.396,551.971],[321.396,457.974]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[374.045,565.749],[374.045,660.501],[321.396,565.537],[321.396,659.533]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[374.045,674.751],[374.045,769.504],[321.396,673.669],[321.396,767.666]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[465.71,796.348],[465.71,894.655],[343.855,791.662],[343.855,888.177]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[463.79,436.668],[463.79,338.524],[349.892,438.416],[349.892,341.945]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[463.79,552.532],[463.79,454.389],[349.892,552.305],[349.892,455.835]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[463.79,566.697],[463.79,664.84],[349.892,566.229],[349.892,662.7]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[463.79,679.6],[463.79,777.743],[349.892,677.208],[349.892,773.678]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[445.234,338.4],[445.234,248.933],[415.855,339.286],[415.855,250.213]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[436.083,327.695],[436.083,233.459],[416.972,333.899],[416.972,242.427]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[541.262,809.01],[541.262,912.16],[419.557,804.154],[419.557,905.447]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[518.257,429.559],[518.257,324.615],[422.972,433.298],[422.971,331.93]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[518.257,553.452],[518.257,448.508],[422.972,552.968],[422.971,451.601]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[518.257,568.599],[518.257,673.542],[422.971,567.598],[422.972,668.965]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[518.257,689.325],[518.257,794.269],[422.971,684.21],[422.972,785.577]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[483.663,321.726],[483.663,224.831],[436.083,327.695],[436.083,233.459]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[573.393,314.064],[573.393,213.756],[483.664,321.726],[483.664,224.831]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[662.751,816.216],[662.751,922.122],[532.736,810.984],[532.736,914.889]]
                },{
                    num:"506",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[958.794,427.24],[958.794,316.585],[540.669,433.764],[540.669,329.555]]
                },{
                    num:"406",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[958.794,557.874],[958.794,447.22],[540.669,556.789],[540.669,452.581]]
                },{
                    num:"306",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[958.794,573.845],[958.794,684.499],[540.669,571.83],[540.669,676.039]]
                },{
                    num:"206",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[958.794,701.141],[958.794,811.795],[540.669,691.711],[540.669,795.92]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[689.711,307.503],[689.711,204.273],[579.264,314.062],[579.264,213.751]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[840.035,302.461],[840.035,196.985],[689.71,307.503],[689.71,204.273]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[955.03,827.985],[955.03,938.39],[813.848,822.303],[813.848,930.536]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[982.604,300.473],[982.604,194.111],[840.036,302.461],[840.036,196.985]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[952.283,422.493],[1101.79,422.47],[952.283,310.789],[1101.79,310.744]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[952.283,554.367],[952.283,442.662],[1101.79,554.37],[1101.79,442.643]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[952.283,570.489],[1101.79,570.495],[952.283,682.193],[1101.79,682.221]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[952.283,698.992],[1101.79,699.024],[952.283,810.696],[1101.79,810.75]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[955.154,827.938],[955.154,938.325],[960.948,825.711],[960.948,935.246]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[1103.5,831.398],[1103.5,943.108],[960.948,825.711],[960.948,935.246]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[983.874,300.456],[1125.75,300.889],[983.874,194.087],[1125.75,194.713]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[1101.79,422.47],[1101.79,310.744],[1122.91,426.551],[1122.91,318.729]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[1101.79,554.37],[1101.79,442.643],[1122.91,553.841],[1122.91,446.019]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[1101.79,570.495],[1101.79,682.221],[1122.91,569.403],[1122.91,677.225]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[1101.79,699.024],[1101.79,810.75],[1122.91,693.441],[1122.91,801.263]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[1103.5,831.398],[1103.5,943.108],[1124.48,821.232],[1124.48,929.055]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[1265.48,424.362],[1265.48,314.446],[1122.91,426.551],[1122.91,318.728]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[1265.48,554.125],[1265.48,444.209],[1122.91,553.841],[1122.91,446.019]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[1265.48,569.989],[1265.48,679.905],[1122.91,569.403],[1122.91,677.225]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[1265.48,696.435],[1265.48,806.351],[1122.91,693.441],[1122.91,801.263]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[1267.83,827.151],[1267.83,937.237],[1115.33,821.287],[1115.33,929.131]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[1125.75,300.889],[1125.75,194.713],[1220.97,302.746],[1220.97,197.397]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[1220.97,302.746],[1220.97,197.397],[1293.07,306.79],[1293.07,203.242]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[1265.48,424.362],[1265.48,314.446],[1274.4,426.687],[1274.4,318.996]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[1265.48,554.125],[1265.48,444.209],[1274.4,553.824],[1274.4,446.132]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[1265.48,569.989],[1265.48,679.904],[1274.4,569.367],[1274.4,677.058]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[1265.48,696.435],[1265.48,806.35],[1274.4,693.254],[1274.4,800.945]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[1267.83,827.151],[1267.83,937.237],[1277.04,821.103],[1277.04,928.877]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[1343.59,425.648],[1343.59,316.962],[1274.4,426.687],[1274.4,318.996]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[1343.59,553.958],[1343.59,445.272],[1274.4,553.824],[1274.4,446.132]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[1343.59,569.645],[1343.59,678.33],[1274.4,569.367],[1274.4,677.058]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[1343.59,694.676],[1343.59,803.361],[1274.4,693.254],[1274.4,800.945]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[1342.98,823.582],[1277.04,821.103],[1342.98,932.304],[1277.04,928.877]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[1293.07,306.79],[1293.07,203.242],[1303.3,312.541],[1303.3,211.556]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[1341.08,311.403],[1303.3,312.541],[1341.08,209.91],[1303.3,211.556]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[1341.08,311.403],[1341.08,209.91],[1364.33,316.457],[1364.33,217.216]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[1342.98,823.582],[1342.98,932.304],[1404.66,817.419],[1404.66,923.784]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[1343.59,425.648],[1343.59,316.962],[1404.78,428.119],[1404.78,321.798]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[1343.59,553.958],[1343.59,445.273],[1404.78,553.638],[1404.78,447.317]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[1343.59,569.645],[1343.59,678.33],[1404.78,568.984],[1404.78,675.305]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[1343.59,694.676],[1343.59,803.361],[1404.78,691.295],[1404.78,797.616]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[1364.33,316.457],[1364.33,217.216],[1378.81,320.022],[1378.81,222.369]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[1378.81,320.022],[1378.81,222.369],[1395.32,325.281],[1395.32,229.97]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[1404.78,428.119],[1404.78,321.798],[1434.78,439.174],[1434.78,343.429]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[1404.78,553.638],[1404.78,447.317],[1434.78,552.207],[1434.78,456.462]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[1404.78,568.984],[1404.78,675.305],[1434.78,566.026],[1434.78,661.771]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[1404.78,691.295],[1404.78,797.616],[1434.78,676.17],[1434.78,771.916]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[1404.66,817.419],[1404.66,923.785],[1434.68,789.739],[1434.68,885.519]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[1434.93,439.231],[1434.93,343.541],[1459.47,448.276],[1459.47,361.239]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[1434.93,552.2],[1434.93,456.509],[1459.47,551.029],[1459.47,463.992]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[1434.93,566.011],[1434.93,661.701],[1459.47,563.591],[1459.47,650.628]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[1434.93,676.092],[1434.93,771.783],[1459.47,663.718],[1459.47,750.755]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:23,
                    verts:[[1434.93,789.503],[1434.93,885.194],[1459.47,766.873],[1459.47,853.911]]
                },
                ],
                [
                {
                    num:"101",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[318.159,792.283],[318.159,889.037],[306.564,784.693],[306.564,878.545]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[320.742,438.149],[320.742,341.422],[309.468,441.179],[309.468,347.352]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[320.742,552.34],[320.742,455.614],[309.468,551.948],[309.468,458.121]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[320.742,566.301],[320.742,663.027],[309.468,565.49],[309.468,659.317]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[320.742,677.573],[320.742,774.3],[309.468,673.428],[309.468,767.255]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[372.548,793.692],[372.548,890.985],[318.159,792.283],[318.159,889.037]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[377.863,437.557],[377.863,340.266],[320.742,438.149],[320.742,341.422]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[377.863,552.416],[377.863,455.125],[320.742,552.34],[320.742,455.614]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[377.863,566.459],[377.863,663.75],[320.742,566.301],[320.742,663.027]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[377.863,678.382],[377.863,775.674],[320.742,677.573],[320.742,774.3]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[482.339,802.226],[482.339,902.781],[350.689,798.74],[350.689,897.962]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[479.934,434.314],[479.933,333.918],[356.905,435.614],[356.904,336.463]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[479.934,552.836],[479.933,452.441],[356.905,552.668],[356.904,453.517]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[479.933,567.326],[479.934,667.722],[356.904,566.979],[356.905,666.13]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[479.933,682.82],[479.934,783.215],[356.904,681.041],[356.905,780.192]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[438.842,333.601],[438.842,241.996],[407.233,334.259],[407.233,242.947]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[441.309,322.578],[441.309,226.063],[414.44,328.756],[414.44,234.993]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[497.416,316.911],[497.417,217.871],[441.309,322.578],[441.309,226.063]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[572.634,814.299],[572.634,919.471],[441.853,810.71],[441.853,914.51]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[553.387,427.307],[553.387,320.208],[445.597,430.691],[445.596,326.83]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[553.387,553.743],[553.387,446.645],[445.597,553.305],[445.596,449.444]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[553.387,569.201],[553.387,676.3],[445.596,568.296],[445.597,672.157]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[553.387,692.407],[553.387,799.506],[445.596,687.777],[445.597,791.638]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[598.62,309.938],[598.62,207.793],[497.417,316.911],[497.417,217.871]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[704.124,820.235],[704.124,927.677],[565.73,816.405],[565.73,922.382]]
                },{
                    num:"506",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[1014.28,426.978],[1014.28,316.066],[574.673,431.695],[574.673,325.443]]
                },{
                    num:"406",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[1014.28,557.918],[1014.28,447.005],[574.673,557.133],[574.673,450.881]]
                },{
                    num:"306",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[1014.28,573.926],[1014.28,684.838],[574.673,572.469],[574.673,678.722]]
                },{
                    num:"206",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[1014.28,701.519],[1014.28,812.431],[574.673,694.701],[574.673,800.954]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[724.963,304.387],[724.963,199.769],[604.665,309.991],[604.665,207.868]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[882.688,300.746],[882.688,194.506],[724.962,304.387],[724.962,199.769]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[1009.92,828.704],[1009.92,939.384],[863.121,824.641],[863.121,933.768]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[1027.46,300.126],[882.688,300.746],[1027.46,193.61],[882.688,194.506]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[1010.37,422.192],[1010.37,310.2],[1158.46,422.869],[1158.46,311.526]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[1010.37,554.405],[1010.37,442.414],[1158.46,554.318],[1158.46,442.974]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[1010.37,570.569],[1010.37,682.561],[1158.46,570.388],[1158.46,681.732]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[1010.37,699.404],[1010.37,811.396],[1158.46,698.477],[1158.46,809.821]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[1010,828.655],[1010,939.316],[1013.68,826.36],[1013.68,936.144]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[1160.11,830.378],[1160.11,941.698],[1013.68,826.36],[1013.68,936.144]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[1028.74,300.122],[1028.74,193.604],[1168.53,301.908],[1168.53,196.186]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[1158.46,422.869],[1158.46,311.526],[1169.74,427.023],[1169.74,319.653]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[1158.46,554.318],[1158.46,442.974],[1169.74,553.78],[1169.74,446.41]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[1158.46,570.388],[1158.46,681.732],[1169.74,569.277],[1169.74,676.647]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[1158.46,698.477],[1158.46,809.821],[1169.74,692.794],[1169.74,800.164]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[1160.11,830.378],[1160.11,941.698],[1171.28,820.032],[1171.28,927.396]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[1168.53,301.908],[1168.53,196.186],[1259.78,304.647],[1259.78,200.145]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[1314.16,425.497],[1314.16,316.666],[1169.74,427.023],[1169.74,319.653]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[1314.16,553.978],[1314.16,445.147],[1169.74,553.78],[1169.74,446.41]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[1314.16,569.685],[1314.16,678.516],[1169.74,569.277],[1169.74,676.647]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[1314.16,694.883],[1314.16,803.713],[1169.74,692.794],[1169.74,800.164]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[1316.85,824.281],[1162.34,820.19],[1316.85,933.269],[1162.34,927.615]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[1259.78,304.647],[1259.78,200.145],[1325.58,309.311],[1325.58,206.886]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[1314.17,425.497],[1314.16,316.666],[1317.46,427.834],[1317.46,321.239]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[1314.17,553.978],[1314.16,445.147],[1317.46,553.675],[1317.46,447.081]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[1314.16,569.685],[1314.17,678.516],[1317.46,569.06],[1317.46,675.655]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[1314.16,694.883],[1314.17,803.713],[1317.46,691.685],[1317.46,798.28]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[1386.87,427.115],[1317.46,427.834],[1386.87,319.834],[1317.46,321.239]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[1386.87,553.768],[1386.87,446.486],[1317.46,553.675],[1317.46,447.081]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[1386.87,569.252],[1317.46,569.06],[1386.87,676.534],[1317.46,675.654]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[1386.87,692.668],[1317.46,691.685],[1386.87,799.95],[1317.46,798.28]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[1316.85,824.281],[1316.85,933.269],[1320.22,818.203],[1320.22,924.867]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[1386.37,819.916],[1320.22,818.203],[1386.37,927.236],[1320.22,924.867]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[1325.58,309.311],[1325.58,206.886],[1329.32,315.081],[1329.32,215.226]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[1367.13,314.294],[1329.32,315.081],[1367.13,214.089],[1329.32,215.226]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[1367.13,314.294],[1367.13,214.089],[1384.17,319.478],[1384.17,221.582]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[1384.17,319.478],[1384.17,221.582],[1394.32,323.113],[1394.32,226.836]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[1386.37,819.916],[1386.37,927.236],[1440.14,813.175],[1440.14,917.917]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[1386.87,427.115],[1386.87,319.834],[1440.15,429.815],[1440.15,325.117]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[1386.87,553.768],[1386.87,446.486],[1440.15,553.419],[1440.15,448.72]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[1386.87,569.252],[1386.87,676.534],[1440.15,568.53],[1440.15,673.229]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[1386.87,692.668],[1386.87,799.95],[1440.15,688.974],[1440.15,793.673]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[1394.32,323.113],[1394.32,226.836],[1404.6,328.426],[1404.6,234.516]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[1440.15,429.815],[1440.15,325.117],[1443.6,440.8],[1443.6,346.61]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[1440.15,553.419],[1440.15,448.72],[1443.6,551.997],[1443.6,457.807]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[1440.15,568.53],[1440.15,673.229],[1443.6,565.591],[1443.6,659.781]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[1440.15,688.974],[1440.15,793.673],[1443.6,673.946],[1443.6,768.136]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[1440.14,813.175],[1440.14,917.917],[1443.59,785.671],[1443.59,879.896]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[1443.62,440.856],[1443.62,346.721],[1446.44,449.827],[1446.44,364.273]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[1443.62,551.99],[1443.62,457.854],[1446.44,550.828],[1446.44,465.275]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[1443.62,565.576],[1443.62,659.712],[1446.44,563.176],[1446.44,648.73]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:24,
                    verts:[[1443.62,673.869],[1443.62,768.005],[1446.44,661.596],[1446.44,747.15]]
                },
                ],
                [
                {
                    num:"101",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[324.568,799.349],[324.568,898.804],[304.998,791.693],[304.998,888.221]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[327.21,435.336],[327.21,335.92],[307.989,438.394],[307.989,341.903]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[327.21,552.704],[327.21,453.287],[307.989,552.308],[307.989,455.817]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[327.21,567.053],[327.21,666.469],[307.989,566.235],[307.989,662.726]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[327.21,681.421],[327.21,780.837],[307.989,677.238],[307.989,773.729]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[382.904,800.203],[382.904,899.985],[324.568,799.349],[324.568,898.804]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[388.454,434.978],[388.454,335.219],[327.21,435.336],[327.21,335.92]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[388.454,552.75],[388.454,452.991],[327.21,552.704],[327.21,453.287]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[388.454,567.149],[388.454,666.908],[327.21,567.053],[327.21,666.469]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[388.454,681.911],[388.454,781.67],[327.21,681.421],[327.21,780.837]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[505.34,807.704],[505.34,910.354],[364.943,805.604],[364.943,907.45]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[502.447,432.116],[502.446,329.619],[371.266,432.9],[371.265,331.152]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[502.447,553.121],[502.446,450.623],[371.266,553.019],[371.265,451.271]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[502.446,567.914],[502.447,670.412],[371.265,567.705],[371.266,669.453]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[502.446,685.826],[502.447,788.324],[371.265,684.755],[371.266,786.503]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[437.609,328.877],[437.609,235.168],[403.949,329.273],[403.949,235.741]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[452.587,317.659],[452.587,218.954],[417.669,323.719],[417.669,227.712]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[517.118,312.408],[517.118,211.363],[452.587,317.659],[452.587,218.954]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[610.037,818.945],[610.037,925.893],[471.561,816.799],[471.561,922.927]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[595.097,425.333],[595.097,316.346],[475.603,428.273],[475.603,322.099]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[595.097,553.999],[595.097,445.012],[475.603,553.618],[475.603,447.444]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[595.097,569.729],[595.097,678.716],[475.603,568.943],[475.603,675.117]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[595.097,695.107],[595.097,804.094],[475.603,691.084],[475.603,797.258]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[629.109,306.291],[629.109,202.521],[517.118,312.408],[517.118,211.364]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[749.974,823.424],[749.974,932.085],[604.966,821.159],[604.966,928.953]]
                },{
                    num:"506",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[1069.48,427.138],[1069.48,316.383],[614.841,429.892],[614.841,321.858]]
                },{
                    num:"406",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[1069.48,557.891],[1069.48,447.136],[614.841,557.433],[614.841,449.399]]
                },{
                    num:"306",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[1069.48,573.876],[1069.48,684.632],[614.841,573.026],[614.841,681.06]]
                },{
                    num:"206",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[1069.48,701.288],[1069.48,812.043],[614.841,697.308],[614.841,805.342]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[764.094,301.902],[764.094,196.177],[635.249,306.402],[635.249,202.68]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[927.022,299.777],[927.022,193.106],[764.093,301.901],[764.093,196.176]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[1064.6,828.346],[1064.6,938.889],[914.547,826.001],[914.547,935.648]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[927.022,299.777],[1071.76,300.559],[927.022,193.106],[1071.76,194.235]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[1064.63,828.296],[1064.63,938.82],[1066.13,825.97],[1066.13,935.604]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[1213.96,828.26],[1066.13,825.97],[1213.96,938.77],[1066.13,935.604]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[1068.25,422.344],[1068.25,310.497],[1212.41,423.709],[1212.41,313.168]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[1068.25,554.386],[1068.25,442.539],[1212.41,554.209],[1212.41,443.668]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[1068.25,570.529],[1068.25,682.375],[1212.41,570.164],[1212.41,680.705]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[1068.25,699.196],[1068.25,811.042],[1212.41,697.329],[1212.41,807.87]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[1073.03,300.567],[1073.03,194.247],[1208.6,303.673],[1208.6,198.736]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[1208.6,303.673],[1208.6,198.736],[1294.59,307.231],[1294.59,203.879]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[1212.41,423.709],[1212.41,313.168],[1213.79,427.869],[1213.79,321.307]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[1212.41,554.209],[1212.41,443.668],[1213.79,553.671],[1213.79,447.109]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[1212.41,570.164],[1212.41,680.705],[1213.79,569.051],[1213.79,675.612]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[1212.41,697.329],[1212.41,807.87],[1213.79,691.638],[1213.79,798.199]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[1213.79,427.868],[1357.73,427.009],[1213.79,321.307],[1357.73,319.625]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[1213.79,553.671],[1213.79,447.109],[1357.73,553.782],[1357.73,446.398]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[1213.79,569.051],[1357.73,569.281],[1213.79,675.612],[1357.73,676.664]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[1213.79,691.638],[1357.73,692.814],[1213.79,798.199],[1357.73,800.197]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[1213.96,828.26],[1213.96,938.77],[1215.28,817.9],[1215.28,924.449]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[1206.69,818.156],[1360.71,820.46],[1206.69,924.803],[1360.71,927.988]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[1294.59,307.231],[1294.59,203.879],[1353.32,312.425],[1353.32,211.387]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[1350.74,318.131],[1388.07,317.692],[1350.74,219.635],[1388.07,219]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[1355.52,429.322],[1424.08,428.921],[1355.52,324.151],[1424.08,323.366]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[1355.52,553.482],[1355.52,448.312],[1424.08,553.534],[1424.08,447.98]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[1355.52,568.662],[1355.52,673.833],[1424.08,568.769],[1424.08,674.324]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[1355.52,689.65],[1424.08,690.198],[1355.52,794.821],[1424.08,795.753]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[1358.36,814.447],[1423.68,815.403],[1358.36,919.675],[1423.68,920.997]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[1388.07,317.692],[1388.07,219],[1398.93,322.928],[1398.93,226.569]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[1398.93,322.928],[1398.93,226.569],[1404.81,326.581],[1404.81,231.849]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[1404.81,326.581],[1404.81,231.849],[1409.02,331.878],[1409.02,239.506]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[1424.08,428.921],[1424.08,323.366],[1468.99,431.796],[1468.99,328.992]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[1424.08,553.534],[1424.08,447.98],[1468.99,553.162],[1468.99,450.358]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[1424.08,568.769],[1424.08,674.324],[1468.99,568],[1468.99,670.804]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[1424.08,690.198],[1424.08,795.753],[1468.99,686.265],[1468.99,789.069]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:25,
                    verts:[[1423.68,815.403],[1423.68,920.997],[1469.08,808.217],[1469.08,911.063]]
                },
                ],
                [
                {
                    num:"101",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[338.784,806.141],[338.784,908.193],[310.78,798.533],[310.78,897.676]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[341.453,432.634],[341.453,330.633],[313.825,435.674],[313.825,336.58]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[341.453,553.054],[341.453,451.052],[313.825,552.66],[313.825,453.567]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[341.453,567.776],[341.453,669.777],[313.825,566.963],[313.825,666.056]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[341.453,685.118],[341.453,787.119],[313.825,680.959],[313.825,780.053]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[400.569,806.365],[400.569,908.503],[338.784,806.141],[338.784,908.193]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[406.296,432.541],[406.296,330.449],[341.453,432.634],[341.453,330.633]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[406.296,553.066],[406.296,450.974],[341.453,553.054],[341.453,451.052]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[406.296,567.801],[406.296,669.892],[341.453,567.776],[341.453,669.777]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[406.296,685.246],[406.296,787.337],[341.453,685.118],[341.453,787.119]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[534.784,812.615],[534.784,917.143],[387.098,812.069],[387.098,916.388]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[531.414,430.143],[531.413,325.757],[393.442,430.346],[393.441,326.155]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[531.414,553.376],[531.413,448.991],[393.442,553.35],[393.441,449.159]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[531.413,568.442],[531.414,672.828],[393.441,568.388],[393.442,672.579]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[531.413,688.527],[531.414,792.912],[393.441,688.248],[393.442,792.439]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[442.043,324.335],[406.589,324.438],[442.043,228.602],[406.589,228.751]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[470.262,313.07],[470.262,212.319],[427.159,318.907],[427.159,220.757]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[542.872,308.353],[542.872,205.502],[470.262,313.07],[470.262,212.319]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[653.084,822.777],[653.084,931.19],[508.701,822.224],[508.701,930.426]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[642.928,423.713],[642.928,313.175],[512.995,426.123],[512.995,317.892]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[642.928,554.209],[642.928,443.671],[512.995,553.897],[512.995,445.666]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[642.928,570.163],[642.928,680.7],[512.995,569.518],[512.995,677.749]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[642.928,697.323],[642.928,807.861],[512.995,694.026],[512.995,802.257]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[664.588,303.248],[664.588,198.123],[542.872,308.353],[542.872,205.502]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[799.515,825.646],[799.515,935.156],[650.025,825.068],[650.026,934.358]]
                },{
                    num:"506",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[1123.13,427.729],[1123.13,317.558],[660.715,428.421],[660.715,318.934]]
                },{
                    num:"406",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[1123.13,557.793],[1123.13,447.622],[660.715,557.678],[660.715,448.191]]
                },{
                    num:"306",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[1123.13,573.694],[1123.13,683.865],[660.715,573.48],[660.715,682.967]]
                },{
                    num:"206",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[1123.13,700.433],[1123.13,810.604],[660.715,699.433],[660.715,808.92]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[806.467,300.151],[806.467,193.646],[670.735,303.42],[670.735,198.37]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[972.131,299.617],[806.467,300.151],[972.131,192.874],[806.467,193.646]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[967.032,826.298],[1117.81,826.88],[967.032,936.058],[1117.81,936.863]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[972.132,299.617],[972.132,192.874],[1114.56,301.79],[1114.56,196.015]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[1115.8,301.81],[1115.8,196.044],[1245.14,306.16],[1245.14,202.331]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[1117.1,824.511],[1263.85,825.073],[1117.1,933.587],[1263.85,934.364]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[1124.59,422.961],[1124.59,311.705],[1262.41,424.976],[1262.41,315.647]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[1124.59,554.306],[1124.59,443.05],[1262.41,554.045],[1262.41,444.717]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[1124.59,570.364],[1124.59,681.62],[1262.41,569.825],[1262.41,679.153]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[1124.59,698.352],[1124.59,809.608],[1262.41,695.595],[1262.41,804.924]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[1245.14,306.16],[1245.14,202.331],[1324.74,310.453],[1324.74,208.537]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[1254.12,429.076],[1254.12,323.669],[1395.33,428.867],[1395.33,323.262]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[1254.12,553.514],[1254.12,448.108],[1395.33,553.541],[1395.33,447.936]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[1254.12,568.728],[1254.12,674.134],[1395.33,568.784],[1395.33,674.389]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[1254.12,689.986],[1254.12,795.392],[1395.33,690.271],[1395.33,795.877]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[1247.41,815.211],[1247.41,920.731],[1398.55,815.769],[1398.55,921.504]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[1324.74,310.453],[1324.74,208.537],[1375.86,316.075],[1375.86,216.663]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[1367.27,321.641],[1403.65,321.535],[1367.27,224.709],[1403.65,224.556]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[1387.9,431.121],[1387.9,327.671],[1454.6,431.025],[1454.6,327.483]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[1387.9,553.25],[1387.9,449.8],[1454.6,553.262],[1454.6,449.72]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[1387.9,568.181],[1387.9,671.63],[1454.6,568.206],[1454.6,671.748]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[1387.9,687.188],[1387.9,790.637],[1454.6,687.32],[1454.6,790.862]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[1390.77,809.911],[1454.32,810.141],[1390.77,913.405],[1454.32,913.723]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[1403.65,321.535],[1403.65,224.556],[1408.49,326.75],[1408.49,232.093]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[1408.49,326.75],[1408.49,232.093],[1410.23,330.371],[1410.23,237.327]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[1454.32,810.141],[1454.32,913.723],[1491.13,802.65],[1491.13,903.367]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[1454.6,431.025],[1454.6,327.483],[1490.94,434.02],[1490.94,333.343]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[1454.6,553.262],[1454.6,449.72],[1490.94,552.874],[1490.94,452.198]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[1454.6,568.206],[1454.6,671.748],[1490.94,567.405],[1490.94,668.082]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:26,
                    verts:[[1454.6,687.32],[1454.6,790.862],[1490.94,683.222],[1490.94,783.899]]
                },
                ],
                [
                {
                    num:"101",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[361.229,812.479],[361.229,916.955],[324.494,805.05],[324.494,906.685]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[363.885,430.114],[363.885,325.701],[327.555,433.084],[327.555,331.512]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[363.885,553.38],[363.885,448.967],[327.555,552.996],[327.555,451.424]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[363.885,568.45],[363.885,672.863],[327.555,567.656],[327.555,669.227]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[363.885,688.566],[363.885,792.979],[327.555,684.503],[327.555,786.075]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[425.789,812.006],[361.229,812.479],[425.789,916.301],[361.229,916.955]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[431.618,430.312],[431.618,326.089],[363.885,430.114],[363.885,325.701]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[431.618,553.354],[431.618,449.131],[363.885,553.38],[363.885,448.967]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[431.618,568.397],[431.618,672.62],[363.885,568.45],[363.885,672.863]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[431.618,688.294],[431.618,792.518],[363.885,688.566],[363.885,792.979]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[411.217,325.11],[411.217,229.723],[409.817,328.757],[409.817,234.995]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[415.595,319.864],[415.595,222.141],[411.217,325.11],[411.217,229.723]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[452.506,320.082],[415.595,319.865],[452.506,222.455],[415.595,222.141]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[570.466,816.801],[570.466,922.93],[417.353,817.947],[417.353,924.514]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[566.645,428.455],[566.645,322.455],[423.619,428.028],[423.619,321.619]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[566.645,553.595],[566.645,447.595],[423.619,553.65],[423.619,447.241]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[566.645,568.894],[566.645,674.894],[423.619,569.008],[423.619,675.417]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[566.645,690.835],[566.645,796.835],[423.619,691.42],[423.619,797.828]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[494.451,308.938],[494.451,206.347],[443.229,314.443],[443.229,214.305]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[574.536,304.87],[574.536,200.467],[494.451,308.938],[494.451,206.347]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[701.084,825.651],[552.947,826.799],[701.084,935.163],[552.947,936.75]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[696.08,422.509],[696.08,310.819],[557.435,424.315],[557.435,314.353]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[696.08,554.365],[696.08,442.675],[557.435,554.131],[557.435,444.169]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[696.08,570.485],[696.08,682.174],[557.435,570.001],[557.435,679.963]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[696.08,698.971],[696.08,810.66],[557.435,696.5],[557.435,806.461]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[704.54,300.919],[704.54,194.756],[574.536,304.87],[574.536,200.467]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[851.727,826.802],[700.171,827.986],[851.727,936.754],[700.171,938.391]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[851.254,299.208],[851.254,192.283],[710.597,301.151],[710.597,195.089]]
                },{
                    num:"506",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[711.524,427.341],[711.524,316.786],[1174,428.742],[1174,319.571]]
                },{
                    num:"406",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[711.524,557.857],[711.524,447.303],[1174,557.625],[1174,448.454]]
                },{
                    num:"306",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[711.524,573.814],[711.524,684.369],[1174,573.381],[1174,682.552]]
                },{
                    num:"206",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[711.524,700.995],[711.524,811.55],[1174,698.97],[1174,808.141]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[851.254,299.208],[1017.03,300.289],[851.254,192.283],[1017.03,193.846]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[1017.03,300.289],[1017.03,193.846],[1154.94,303.8],[1154.94,198.92]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[1019.38,825.497],[1019.38,934.951],[1168.34,824.333],[1168.34,933.342]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[1156.13,303.832],[1156.13,198.966],[1277.45,309.313],[1277.45,206.89]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[1165.44,822.009],[1165.44,930.129],[1308.71,820.899],[1308.71,928.594]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[1178.06,424.031],[1178.06,313.799],[1307.41,426.639],[1307.41,318.901]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[1178.06,554.167],[1178.06,443.935],[1307.41,553.83],[1307.41,446.092]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[1178.06,570.077],[1178.06,680.31],[1307.41,569.38],[1307.41,677.118]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[1178.06,696.888],[1178.06,807.12],[1307.41,693.32],[1307.41,801.058]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[1277.45,309.313],[1277.45,206.89],[1349.79,314.239],[1349.79,214.01]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[1289.95,430.616],[1289.95,326.684],[1426.41,431.024],[1426.41,327.482]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[1289.95,553.315],[1289.95,449.383],[1426.41,553.262],[1426.41,449.72]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[1289.95,568.316],[1289.95,672.248],[1426.41,568.207],[1426.41,671.749]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[1289.95,687.879],[1289.95,791.811],[1426.41,687.321],[1426.41,790.863]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[1283.73,811.423],[1283.73,915.495],[1429.79,810.33],[1429.79,913.984]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[1349.79,314.239],[1349.79,214.01],[1392.95,320.182],[1392.95,222.599]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[1378.77,325.539],[1413.79,325.746],[1378.77,230.344],[1413.79,230.642]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[1414.15,433.188],[1414.15,331.716],[1478.12,433.375],[1478.12,332.083]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[1414.15,552.982],[1414.15,451.51],[1478.12,552.958],[1478.12,451.665]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[1414.15,567.628],[1414.15,669.099],[1478.12,567.577],[1478.12,668.87]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[1414.15,684.36],[1414.15,785.832],[1478.12,684.104],[1478.12,785.396]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[1417,804.706],[1417,906.21],[1477.95,804.259],[1477.95,905.592]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[1478.12,433.375],[1478.12,332.083],[1505.92,436.436],[1505.92,338.071]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[1478.12,552.958],[1478.12,451.665],[1505.92,552.562],[1505.92,454.197]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[1478.12,567.578],[1478.12,668.87],[1505.92,566.759],[1505.92,665.124]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[1478.12,684.104],[1478.12,785.396],[1505.92,679.917],[1505.92,778.282]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:27,
                    verts:[[1477.95,804.259],[1477.95,905.592],[1506.2,796.6],[1506.2,895.004]]
                },
                ],
                [
                {
                    num:"101",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[392.021,818.185],[392.021,924.843],[346.476,811.076],[346.476,915.016]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[394.621,427.846],[394.621,321.264],[349.507,430.69],[349.507,326.828]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[394.621,553.674],[394.621,447.091],[349.507,553.305],[349.507,449.443]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[394.621,569.057],[394.621,675.639],[349.507,568.296],[349.507,672.158]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[394.621,691.668],[394.621,798.25],[349.507,687.778],[349.507,791.64]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[458.514,816.965],[392.021,818.185],[458.514,923.156],[392.021,924.843]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[464.359,428.358],[394.621,427.846],[464.359,322.265],[394.621,321.264]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[464.359,553.607],[464.359,447.514],[394.621,553.674],[394.621,447.091]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[464.359,568.92],[464.359,675.013],[394.621,569.057],[394.621,675.639]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[464.359,690.968],[394.621,691.668],[464.359,797.061],[394.621,798.25]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[415.114,324.608],[415.114,228.998],[411.379,329.956],[411.379,236.728]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[420.714,320.93],[420.714,223.681],[415.115,324.608],[415.115,228.998]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[431.215,315.665],[431.215,216.07],[420.714,320.93],[420.714,223.681]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[469.166,316.225],[431.215,315.665],[469.166,216.88],[431.215,216.07]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[611.89,820.129],[455.571,823.061],[611.89,927.53],[455.571,931.584]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[607.661,427.108],[461.65,426.015],[607.661,319.819],[461.65,317.68]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[607.661,553.769],[607.661,446.48],[461.65,553.911],[461.65,445.576]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[607.661,569.254],[461.65,569.547],[607.661,676.543],[461.65,677.881]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[607.661,692.678],[461.65,694.174],[607.661,799.967],[461.65,802.508]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[525.017,305.381],[525.017,201.206],[465.968,310.445],[465.968,208.526]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[611.703,302.067],[611.703,196.416],[525.017,305.381],[525.017,201.206]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[603.613,830.367],[753.078,827.463],[603.613,941.683],[753.078,937.668]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[608.226,422.91],[608.226,311.605],[607.661,427.108],[607.661,319.819]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[608.226,554.313],[608.226,443.007],[607.661,553.769],[607.661,446.48]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[608.226,570.377],[608.226,681.682],[607.661,569.254],[607.661,676.543]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[608.226,698.422],[608.226,809.727],[607.661,692.678],[607.661,799.967]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[753.449,421.766],[753.449,309.367],[608.226,422.91],[608.226,311.605]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[753.449,554.461],[753.449,442.061],[608.226,554.313],[608.226,443.007]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[753.449,570.683],[753.449,683.083],[608.226,570.377],[608.226,681.682]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[753.449,699.987],[753.449,812.386],[608.226,698.422],[608.226,809.727]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[748.219,299.381],[748.219,192.533],[611.703,302.067],[611.703,196.416]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[754.381,829.803],[754.381,940.904],[753.078,827.463],[753.078,937.668]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[754.381,829.803],[905.427,826.844],[754.381,940.904],[905.427,936.813]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[897.489,299.111],[897.489,192.143],[754.086,299.672],[754.086,192.952]]
                },{
                    num:"506",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[766.217,426.69],[766.217,315.492],[1221,430.144],[1221,322.359]]
                },{
                    num:"406",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[766.217,557.966],[766.217,446.768],[1221,557.391],[1221,449.606]]
                },{
                    num:"306",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[766.217,574.015],[766.217,685.213],[1221,572.948],[1221,680.733]]
                },{
                    num:"206",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[766.217,701.936],[766.217,813.134],[1221,696.943],[1221,804.729]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[897.489,299.111],[897.489,192.142],[1060.74,301.78],[1060.74,196]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[1060.74,301.78],[1060.74,196],[1192.09,306.533],[1192.09,202.87]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[1070.39,823.619],[1070.39,932.354],[1215.1,820.783],[1215.1,928.435]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[1193.22,306.575],[1193.22,202.932],[1305.04,313.049],[1305.04,212.29]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[1210.14,818.54],[1210.14,925.333],[1347.78,815.865],[1347.78,921.636]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[1227.5,425.521],[1227.5,316.714],[1346.63,428.646],[1346.63,322.828]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[1227.5,553.975],[1227.5,445.168],[1346.63,553.57],[1346.63,447.752]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[1227.5,569.679],[1227.5,678.486],[1346.63,568.843],[1346.63,674.66]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[1227.5,694.849],[1227.5,803.656],[1346.63,690.574],[1346.63,796.392]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[1305.04,313.049],[1305.04,212.29],[1369.46,318.495],[1369.46,220.161]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[1320.72,432.447],[1320.72,330.266],[1450.68,433.42],[1450.68,332.17]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[1320.72,553.078],[1320.72,450.897],[1450.68,552.952],[1450.68,451.702]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[1320.72,567.826],[1320.72,670.007],[1450.68,567.566],[1450.68,668.816]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[1320.72,685.374],[1320.72,787.555],[1450.68,684.043],[1450.68,785.293]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[1315.05,806.9],[1315.05,909.243],[1454.17,804.291],[1454.17,905.636]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[1369.46,318.495],[1369.46,220.161],[1404.55,324.649],[1404.55,229.057]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[1385.29,329.741],[1385.29,236.417],[1418.62,330.233],[1418.62,237.128]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[1434.07,435.469],[1434.07,336.18],[1494.61,435.913],[1494.61,337.049]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[1434.07,552.687],[1434.07,453.397],[1494.61,552.629],[1494.61,453.765]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[1434.07,567.017],[1434.07,666.307],[1494.61,566.898],[1494.61,665.763]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[1434.07,681.239],[1434.07,780.528],[1494.61,680.631],[1494.61,779.496]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[1436.86,798.966],[1436.86,898.275],[1494.54,797.908],[1494.54,896.812]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[1494.61,435.914],[1494.61,337.049],[1514.1,438.988],[1514.1,343.065]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[1494.61,552.629],[1494.61,453.765],[1514.1,552.231],[1514.1,456.308]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[1494.61,566.898],[1494.61,665.763],[1514.1,566.076],[1514.1,661.999]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[1494.61,680.631],[1494.61,779.496],[1514.1,676.425],[1514.1,772.348]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:28,
                    verts:[[1494.54,797.908],[1494.54,896.812],[1514.45,790.208],[1514.45,886.168]]
                },
                ],
                [
                {
                    num:"101",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[376.748,816.455],[376.748,922.452],[375.712,788.513],[375.712,883.825]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[430.926,823.1],[430.926,931.637],[376.748,816.455],[376.748,922.452]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[378.361,439.762],[378.361,344.579],[377.273,448.861],[377.273,362.383]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[378.361,552.131],[378.361,456.948],[377.273,550.953],[377.273,464.476]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[378.361,565.869],[378.361,661.052],[377.273,563.435],[377.273,649.912]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[378.361,675.366],[378.361,770.549],[377.273,662.918],[377.273,749.395]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[379.7,428.555],[379.7,322.65],[378.367,439.704],[378.367,344.466]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[379.7,553.582],[379.7,447.677],[378.367,552.139],[378.367,456.901]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[379.7,568.867],[379.7,674.772],[378.367,565.884],[378.367,661.122]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[379.7,690.699],[379.7,796.604],[378.367,675.445],[378.367,770.683]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[433.424,425.895],[433.424,317.445],[379.7,428.555],[379.7,322.65]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[433.424,553.926],[433.424,445.477],[379.7,553.582],[379.7,447.677]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[433.424,569.579],[433.424,678.028],[379.7,568.867],[379.7,674.772]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[433.424,694.338],[433.424,802.788],[379.7,690.699],[379.7,796.604]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[426.663,320.805],[426.663,223.5],[416.719,326.166],[416.719,231.25]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[436.634,317.147],[436.634,218.213],[426.663,320.805],[426.663,223.5]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[430.926,823.1],[498.366,821.101],[430.926,931.637],[498.366,928.874]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[433.424,425.895],[504.132,426.732],[433.424,317.445],[504.132,319.084]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[433.424,553.926],[433.424,445.477],[504.132,553.818],[504.132,446.169]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[433.424,569.579],[504.132,569.355],[433.424,678.028],[504.132,677.003]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[433.424,694.338],[504.132,693.193],[433.424,802.788],[504.132,800.841]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[453.459,311.939],[453.459,210.685],[436.633,317.147],[436.633,218.213]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[453.459,311.939],[491.968,312.855],[453.459,210.685],[491.968,212.009]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[495.206,307.014],[495.206,203.567],[491.968,312.855],[491.968,212.009]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[561.546,302.498],[561.546,197.038],[495.205,307.014],[495.205,203.567]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[501.248,827.26],[501.248,937.387],[498.366,821.101],[498.366,928.874]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[501.248,827.26],[658.285,822.501],[501.248,937.387],[658.285,930.81]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[507.027,424.366],[507.027,314.455],[504.132,426.732],[504.132,319.084]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[507.027,554.124],[507.027,444.212],[504.132,553.818],[504.132,446.169]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[507.027,569.988],[507.027,679.899],[504.132,569.355],[504.132,677.003]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[507.027,696.429],[507.027,806.341],[504.132,693.193],[504.132,800.841]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[507.027,424.366],[507.027,314.455],[653.705,426.14],[653.705,317.925]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[507.027,554.124],[507.027,444.212],[653.705,553.894],[653.705,445.68]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[507.027,569.988],[507.027,679.899],[653.705,569.513],[653.705,677.728]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[507.027,696.429],[507.027,806.341],[653.705,694.002],[653.705,802.217]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[653.712,300.022],[653.712,193.46],[561.546,302.498],[561.546,197.038]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[659.679,832.817],[659.679,945.07],[649.251,822.376],[649.251,930.637]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[794.699,298.677],[794.699,191.515],[653.712,300.023],[653.712,193.46]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[664.339,421.953],[664.339,309.732],[653.705,426.14],[653.705,317.926]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[664.339,554.436],[664.339,442.216],[653.705,553.894],[653.705,445.68]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[664.339,570.633],[664.339,682.854],[653.705,569.513],[653.705,677.728]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[664.339,699.731],[664.339,811.952],[653.705,694.002],[653.705,802.217]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[659.679,832.817],[659.679,945.07],[807.897,828.162],[807.897,938.634]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[813.7,421.507],[813.7,308.86],[664.339,421.953],[664.339,309.732]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[813.7,554.494],[813.7,441.847],[664.339,554.436],[664.339,442.216]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[813.7,570.753],[813.7,683.4],[664.339,570.633],[664.339,682.854]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[813.7,700.341],[813.7,812.988],[664.339,699.731],[664.339,811.952]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[800.278,299.023],[944.14,299.854],[800.278,192.013],[944.14,193.217]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[811.421,830.468],[811.421,941.822],[807.897,828.162],[807.897,938.634]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[811.421,830.468],[811.421,941.822],[959.365,825.783],[959.365,935.345]]
                },{
                    num:"506",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[823.538,426.487],[823.538,315.089],[1263.26,431.887],[1263.26,325.823]]
                },{
                    num:"406",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[823.538,557.999],[823.538,446.601],[1263.26,557.102],[1263.26,451.038]]
                },{
                    num:"306",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[823.538,574.077],[823.538,685.475],[1263.26,572.41],[1263.26,678.474]]
                },{
                    num:"206",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[823.538,702.229],[823.538,813.626],[1263.26,694.424],[1263.26,800.488]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[944.14,299.854],[944.14,193.217],[1102.34,304.033],[1102.34,199.258]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[1102.34,304.033],[1102.34,199.258],[1225.38,309.9],[1225.38,207.738]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[1118.94,820.735],[1118.94,928.367],[1257.23,816.355],[1257.23,922.313]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[1226.43,309.951],[1226.43,207.812],[1327.62,317.26],[1327.62,218.376]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[1250.37,814.222],[1250.37,919.365],[1380.56,810.134],[1380.56,913.713]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[1271.99,427.377],[1271.99,320.346],[1379.57,430.933],[1379.57,327.304]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[1271.99,553.734],[1271.99,446.703],[1379.57,553.274],[1379.57,449.645]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[1271.99,569.182],[1271.99,676.214],[1379.57,568.231],[1379.57,671.86]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[1271.99,692.31],[1271.99,799.341],[1379.57,687.445],[1379.57,791.074]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[1327.62,317.26],[1327.62,218.376],[1383.74,323.107],[1383.74,226.828]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[1346.08,434.514],[1346.08,334.31],[1468.16,435.99],[1468.16,337.199]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[1346.08,552.81],[1346.08,452.607],[1468.16,552.619],[1468.16,453.828]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[1346.08,567.273],[1346.08,667.477],[1468.16,566.878],[1468.16,665.669]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[1346.08,682.546],[1346.08,782.75],[1468.16,680.527],[1468.16,779.318]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[1341.01,801.776],[1341.01,902.159],[1471.7,797.817],[1471.7,896.686]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[1383.74,323.107],[1383.74,226.828],[1410.84,329.372],[1410.84,235.883]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[1387.05,334.153],[1387.05,242.794],[1418.41,334.9],[1418.41,243.873]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[1447.73,437.905],[1447.73,340.946],[1504.29,438.575],[1504.29,342.257]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[1447.73,552.371],[1447.73,455.412],[1504.29,552.285],[1504.29,455.967]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[1447.73,566.366],[1447.73,663.324],[1504.29,566.186],[1504.29,662.505]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[1447.73,677.906],[1447.73,774.865],[1504.29,676.99],[1504.29,773.308]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[1450.44,792.842],[1450.44,889.809],[1504.31,791.245],[1504.31,887.602]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[1504.29,438.575],[1504.29,342.257],[1515.88,441.619],[1515.88,348.214]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[1504.29,552.285],[1504.29,455.967],[1515.88,551.891],[1515.88,458.485]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[1504.29,566.186],[1504.29,662.505],[1515.88,565.372],[1515.88,658.778]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[1504.29,676.99],[1504.29,773.308],[1515.88,672.825],[1515.88,766.231]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:29,
                    verts:[[1504.31,791.245],[1504.31,887.602],[1516.3,783.618],[1516.3,877.058]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[389.095,438],[389.095,341.131],[365.726,447.169],[365.726,359.072]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[389.095,552.359],[389.095,455.49],[365.726,551.172],[365.726,463.076]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[389.095,566.34],[389.095,663.209],[365.726,563.887],[365.726,651.984]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[389.095,677.777],[389.095,774.646],[365.726,665.233],[365.726,753.33]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[390.264,792.543],[390.264,889.395],[366.792,769.609],[366.792,857.692]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[414.995,821.052],[414.995,928.807],[386.679,792.952],[386.679,889.961]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[417.816,426.731],[417.816,319.082],[389.243,437.942],[389.243,341.017]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[417.816,553.818],[417.816,446.169],[389.243,552.367],[389.243,455.442]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[417.816,569.355],[417.816,677.004],[389.243,566.356],[389.243,663.28]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[417.816,693.194],[417.816,800.843],[389.243,677.857],[389.243,774.781]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[477.351,827.093],[477.351,937.157],[414.995,821.052],[414.995,928.807]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[479.699,424.311],[479.699,314.346],[417.816,426.731],[417.816,319.082]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[479.699,554.131],[479.699,444.166],[417.816,553.818],[417.816,446.169]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[479.699,570.003],[479.699,679.968],[417.816,569.355],[417.816,677.004]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[479.699,696.505],[479.699,806.47],[417.816,693.194],[417.816,800.843]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[444.458,317.423],[444.458,218.612],[428.117,322.724],[428.117,226.275]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[458.88,313.84],[458.88,213.433],[444.459,317.423],[444.459,218.612]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[482.089,308.77],[482.089,206.104],[458.879,313.84],[458.879,213.433]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[477.351,827.093],[544.649,824.309],[477.351,937.157],[544.649,933.308]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[479.699,424.311],[479.699,314.346],[550.238,425.476],[550.238,316.627]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[479.699,554.131],[479.699,444.166],[550.238,553.98],[550.238,445.131]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[479.699,570.003],[479.699,679.968],[550.238,569.691],[550.238,678.54]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[479.699,696.505],[479.699,806.47],[550.238,694.91],[550.238,803.76]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[482.089,308.77],[520.62,310.047],[482.089,206.105],[520.62,207.951]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[530.507,304.231],[530.507,199.544],[520.621,310.047],[520.621,207.951]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[603.369,300.355],[603.37,193.94],[530.506,304.231],[530.506,199.544]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[553.529,830.43],[553.529,941.769],[544.649,824.309],[544.649,933.308]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[558.897,423.126],[558.897,312.028],[550.238,425.476],[550.238,316.627]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[558.897,554.285],[558.897,443.186],[550.238,553.98],[550.238,445.131]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[558.897,570.319],[558.897,681.418],[550.238,569.691],[550.238,678.54]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[558.897,698.126],[558.897,809.224],[550.238,694.91],[550.238,803.76]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[553.529,830.43],[553.529,941.769],[708.654,823.865],[708.654,932.695]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[558.897,423.126],[558.897,312.028],[703.792,425.573],[703.792,316.816]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[558.897,554.285],[558.897,443.186],[703.792,553.968],[703.792,445.211]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[558.897,570.32],[558.897,681.418],[703.792,569.665],[703.792,678.422]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[558.897,698.126],[558.897,809.224],[703.792,694.778],[703.792,803.535]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[699.689,298.781],[699.689,191.666],[603.369,300.354],[603.37,193.94]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[842.939,298.808],[699.688,298.781],[842.939,191.705],[699.689,191.666]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[719.861,834.089],[719.861,946.828],[699.402,823.845],[699.402,932.667]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[724.486,421.466],[724.487,308.779],[703.792,425.573],[703.792,316.816]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[724.486,554.499],[724.487,441.813],[703.792,553.968],[703.792,445.211]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[724.487,570.764],[724.486,683.45],[703.792,569.665],[703.792,678.422]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[724.487,700.397],[724.486,813.084],[703.792,694.778],[703.792,803.535]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[719.861,834.089],[719.861,946.828],[864.254,827.749],[864.254,938.064]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[875.377,421.73],[724.486,421.466],[875.377,309.295],[724.486,308.779]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[875.377,554.465],[875.377,442.031],[724.486,554.499],[724.486,441.813]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[875.377,570.693],[875.377,683.127],[724.486,570.764],[724.486,683.45]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[875.377,700.036],[724.486,700.397],[875.377,812.471],[724.486,813.084]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[848.142,299.204],[848.142,192.275],[990.188,301.394],[990.188,195.443]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[869.934,829.984],[869.934,941.153],[864.254,827.749],[864.254,938.064]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[869.934,829.984],[869.934,941.153],[1012.31,823.678],[1012.31,932.437]]
                },{
                    num:"506",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[882.122,426.73],[882.122,315.571],[1300.19,433.909],[1300.19,329.842]]
                },{
                    num:"406",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[882.122,557.959],[882.122,446.801],[1300.19,556.766],[1300.19,452.699]]
                },{
                    num:"306",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[882.122,574.003],[882.122,685.161],[1300.19,571.785],[1300.19,675.852]]
                },{
                    num:"206",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[882.122,701.878],[882.122,813.036],[1300.19,691.502],[1300.19,795.569]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[990.188,301.394],[990.188,195.443],[1141.06,306.963],[1141.06,203.492]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[1141.06,306.963],[1141.06,203.492],[1254.37,313.791],[1254.37,213.362]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[1164.09,816.963],[1164.09,923.153],[1294.12,811.204],[1294.12,915.192]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[1255.33,313.851],[1255.33,213.448],[1345.14,321.827],[1345.14,224.977]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[1285.58,809.207],[1285.58,912.431],[1406.87,803.882],[1406.87,905.071]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[1310.88,429.533],[1310.88,324.563],[1406.04,433.43],[1406.04,332.189]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[1310.88,553.455],[1310.88,448.486],[1406.04,552.951],[1406.04,451.71]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[1310.88,568.606],[1310.88,673.575],[1406.04,567.563],[1406.04,668.804]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[1310.88,689.361],[1310.88,794.33],[1406.04,684.03],[1406.04,785.271]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[1345.14,321.827],[1345.14,224.977],[1392.79,327.961],[1392.79,233.844]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[1392.79,327.961],[1392.79,233.844],[1412.15,334.242],[1412.15,242.923]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[1365.95,436.757],[1365.95,338.699],[1479.11,438.668],[1479.11,342.438]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[1365.95,552.52],[1365.95,454.462],[1479.11,552.273],[1479.11,456.043]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[1365.95,566.673],[1365.95,664.731],[1479.11,566.162],[1479.11,662.391]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[1365.95,679.478],[1365.95,777.536],[1479.11,676.863],[1479.11,773.093]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[1361.52,796.2],[1361.52,894.451],[1482.66,791.075],[1482.66,887.367]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[1384.4,338.682],[1384.4,249.341],[1413.6,339.65],[1413.6,250.74]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[1455.42,440.436],[1455.42,345.898],[1507.63,441.299],[1507.63,347.586]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[1455.42,552.044],[1455.42,457.506],[1507.63,551.932],[1507.63,458.22]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[1455.42,565.689],[1455.42,660.227],[1507.63,565.458],[1507.63,659.17]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[1455.42,674.444],[1455.42,768.982],[1507.63,673.264],[1507.63,766.976]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[1458.02,786.484],[1458.02,881.02],[1507.74,784.427],[1507.74,878.177]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[1507.63,441.299],[1507.63,347.586],[1511.84,444.275],[1511.84,353.409]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[1507.63,551.932],[1507.63,458.22],[1511.84,551.547],[1511.84,460.681]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[1507.63,565.458],[1507.63,659.17],[1511.84,564.662],[1511.84,655.527]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[1507.63,673.264],[1507.63,766.977],[1511.84,669.192],[1511.84,760.058]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:30,
                    verts:[[1507.74,784.427],[1507.74,878.177],[1512.32,776.967],[1512.32,867.864]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[406.276,436.423],[406.276,338.046],[359.749,445.547],[359.749,355.9]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[406.276,552.563],[406.276,454.186],[359.749,551.382],[359.749,461.734]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[406.276,566.762],[406.276,665.139],[359.749,564.321],[359.749,653.969]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[406.276,679.934],[406.276,778.312],[359.749,667.451],[359.749,757.099]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[407.443,796.475],[407.443,894.832],[360.821,773.655],[360.821,863.285]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[460.565,824.768],[460.565,933.943],[404.135,796.923],[404.135,895.451]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[463.202,425.259],[463.202,316.201],[406.57,436.365],[406.57,337.933]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[463.202,554.008],[463.202,444.951],[406.57,552.571],[406.57,454.138]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[463.202,569.749],[463.202,678.807],[406.57,566.778],[406.57,665.21]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[463.202,695.208],[463.202,804.266],[406.57,680.013],[406.57,778.445]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[439.283,325.636],[439.284,230.483],[438.787,329.295],[438.787,235.772]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[444.475,320.079],[444.475,222.451],[439.283,325.636],[439.283,230.483]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[468.277,314.523],[468.277,214.42],[445.483,319.686],[445.483,221.884]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[530.369,830.079],[530.369,941.285],[460.565,824.768],[460.565,933.943]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[532.523,423.128],[532.523,312.031],[463.202,425.259],[463.202,316.201]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[532.523,554.284],[532.523,443.188],[463.202,554.008],[463.202,444.951]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[532.523,570.319],[532.523,681.416],[463.202,569.749],[463.202,678.807]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[532.523,698.123],[532.523,809.22],[463.202,695.208],[463.202,804.266]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[487.128,311.069],[487.128,209.427],[468.277,314.523],[468.277,214.42]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[516.623,306.217],[516.623,202.414],[487.127,311.069],[487.127,209.427]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[516.623,306.217],[554.613,307.85],[516.623,202.414],[554.613,204.774]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[530.369,830.079],[530.369,941.285],[596.391,826.528],[596.391,936.376]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[532.523,423.128],[532.523,312.031],[601.705,424.614],[601.705,314.94]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[532.523,554.284],[532.523,443.188],[601.705,554.092],[601.705,444.417]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[532.523,570.319],[532.523,681.416],[601.705,569.921],[601.705,679.596]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[532.523,698.123],[532.523,809.22],[601.705,696.09],[601.705,805.764]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[571.196,302.145],[571.196,196.529],[554.613,307.85],[554.613,204.774]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[649.604,298.984],[649.604,191.96],[571.196,302.145],[571.196,196.529]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[611.267,832.51],[611.267,944.646],[596.391,826.528],[596.391,936.376]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[616.121,422.318],[616.121,310.447],[601.705,424.614],[601.705,314.94]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[616.121,554.389],[616.121,442.518],[601.705,554.092],[601.705,444.417]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[616.121,570.536],[616.121,682.407],[601.705,569.921],[601.705,679.596]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[616.121,699.231],[616.121,811.102],[601.705,696.09],[601.705,805.764]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[611.267,832.51],[611.267,944.646],[761.847,824.219],[761.847,933.185]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[616.121,422.318],[616.122,310.447],[756.782,425.409],[756.782,316.495]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[616.121,554.389],[616.122,442.518],[756.782,553.989],[756.782,445.075]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[616.122,570.536],[616.121,682.407],[756.782,569.709],[756.782,678.623]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[616.122,699.231],[616.121,811.103],[756.782,695.003],[756.782,803.917]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[748.61,298.347],[748.61,191.039],[649.604,298.984],[649.604,191.959]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[748.61,298.347],[891.866,299.737],[748.61,191.039],[891.866,193.048]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[782.715,834.188],[782.715,946.964],[752.528,824.304],[752.528,933.301]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[787.224,421.448],[787.224,308.743],[756.781,425.409],[756.782,316.495]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[787.224,554.502],[787.224,441.798],[756.781,553.989],[756.782,445.075]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[787.224,570.769],[787.224,683.473],[756.782,569.709],[756.781,678.623]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[787.224,700.422],[787.224,813.126],[756.782,695.003],[756.781,803.917]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[782.715,834.188],[782.715,946.964],[920.849,826.284],[920.849,936.039]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[787.224,421.448],[787.224,308.743],[937.018,422.407],[937.018,310.621]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[787.224,554.502],[787.224,441.798],[937.018,554.378],[937.018,442.591]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[787.224,570.769],[787.224,683.473],[937.018,570.512],[937.018,682.298]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[787.224,700.422],[787.224,813.126],[937.018,699.11],[937.018,810.896]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[896.617,300.175],[896.617,193.679],[1034.7,303.651],[1034.7,198.706]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[928.556,828.414],[928.556,938.983],[920.849,826.284],[920.849,936.039]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[928.556,828.414],[928.556,938.983],[1063.18,820.642],[1063.18,928.239]]
                },{
                    num:"506",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[940.609,427.391],[940.609,316.886],[1331.47,436.141],[1331.47,334.28]]
                },{
                    num:"406",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[940.609,557.849],[940.609,447.344],[1331.47,556.394],[1331.47,454.533]]
                },{
                    num:"306",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[940.609,573.798],[940.609,684.303],[1331.47,571.096],[1331.47,672.957]]
                },{
                    num:"206",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[940.609,700.922],[940.609,811.427],[1331.47,688.276],[1331.47,790.137]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[1034.7,303.651],[1034.7,198.706],[1176.3,310.456],[1176.3,208.541]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[1176.3,310.456],[1176.3,208.541],[1278.84,318.082],[1278.84,219.564]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[1205.12,812.454],[1205.12,916.92],[1325.46,805.507],[1325.46,907.316]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[1279.71,318.148],[1279.71,219.659],[1357.72,326.627],[1357.72,231.915]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[1315.46,803.662],[1315.46,904.767],[1426.81,797.292],[1426.81,895.961]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[1343.84,431.913],[1343.84,329.222],[1426.14,436.062],[1426.14,337.339]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[1343.84,553.147],[1343.84,450.456],[1426.14,552.61],[1426.14,453.888]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[1343.84,567.969],[1343.84,670.66],[1426.14,566.859],[1426.14,665.581]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[1343.84,686.104],[1343.84,788.795],[1426.14,680.428],[1426.14,779.151]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[1357.72,326.626],[1357.72,231.915],[1396.94,332.941],[1396.94,241.042]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[1396.94,332.941],[1396.94,241.042],[1408.92,339.16],[1408.92,250.031]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[1380.47,439.114],[1380.47,343.312],[1484.01,441.39],[1484.01,347.764]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[1380.47,552.215],[1380.47,456.413],[1484.01,551.92],[1484.01,458.295]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[1380.47,566.042],[1380.47,661.845],[1484.01,565.433],[1484.01,659.059]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[1380.47,676.252],[1380.47,772.055],[1484.01,673.139],[1484.01,766.765]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[1376.67,790.328],[1376.67,886.333],[1487.52,784.226],[1487.52,877.898]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[1457.6,443.003],[1457.6,350.921],[1505.23,444.026],[1505.23,352.923]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[1457.6,551.711],[1457.6,459.629],[1505.23,551.579],[1505.23,460.476]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[1457.6,565.002],[1457.6,657.084],[1505.23,564.728],[1505.23,655.831]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[1457.6,670.932],[1457.6,763.014],[1505.23,669.532],[1505.23,760.635]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:31,
                    verts:[[1460.07,780.037],[1460.07,872.108],[1505.43,777.598],[1505.43,868.736]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[429.654,435.053],[429.654,335.365],[359.495,444.015],[359.495,352.901]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[429.654,552.741],[429.654,453.053],[359.495,551.581],[359.495,460.467]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[429.654,567.129],[429.654,666.816],[359.495,564.731],[359.495,655.845]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[429.654,681.808],[429.654,781.496],[359.495,669.547],[359.495,760.661]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[430.804,799.89],[430.804,899.553],[360.562,777.479],[360.562,868.571]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[512.523,827.545],[512.523,937.781],[427.828,800.373],[427.828,900.22]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[514.927,424.161],[514.927,314.052],[430.096,434.997],[430.096,335.255]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[514.927,554.151],[514.927,444.042],[430.096,552.748],[430.096,453.006]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[514.927,570.043],[514.927,680.151],[430.096,567.144],[430.096,666.885]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[514.927,696.71],[514.927,806.819],[430.096,681.886],[430.096,781.627]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[450.887,326.638],[450.887,231.932],[446.909,331.596],[446.909,239.098]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[455.502,322.983],[455.502,226.648],[450.887,326.638],[450.887,231.932]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[467.062,317.474],[467.063,218.686],[455.501,322.983],[455.501,226.648]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[497.696,312.139],[497.696,210.974],[468.538,317.091],[468.538,218.132]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[520.848,308.866],[520.848,206.244],[497.697,312.139],[497.697,210.974]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[588.8,832.022],[588.8,943.97],[512.523,827.545],[512.523,937.781]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[590.72,422.361],[590.72,310.53],[514.927,424.161],[514.927,314.052]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[590.72,554.384],[590.72,442.553],[514.927,554.151],[514.927,444.042]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[590.72,570.524],[590.72,682.355],[514.927,570.043],[514.927,680.151]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[590.72,699.173],[590.72,811.004],[514.927,696.71],[514.927,806.819]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[556.372,304.308],[556.372,199.654],[520.848,308.866],[520.848,206.244]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[556.372,304.308],[556.372,199.654],[593.254,306.282],[593.254,202.508]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[588.8,832.022],[588.8,943.97],[652.424,827.746],[652.424,938.06]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[590.72,422.36],[590.72,310.53],[657.374,424.15],[657.374,314.03]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[590.72,554.384],[590.72,442.553],[657.374,554.152],[657.374,444.033]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[590.72,570.524],[590.72,682.355],[657.374,570.046],[657.374,680.165]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[590.72,699.173],[590.72,811.004],[657.374,696.726],[657.374,806.845]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[616.411,300.773],[616.411,194.545],[593.254,306.282],[593.254,202.508]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[699.228,298.382],[699.228,191.089],[616.411,300.773],[616.411,194.545]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[673.116,833.495],[673.116,946.006],[652.424,827.746],[652.424,938.06]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[677.368,421.944],[677.368,309.715],[657.374,424.15],[657.374,314.03]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[677.368,554.438],[677.368,442.208],[657.374,554.152],[657.374,444.033]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[677.368,570.636],[677.368,682.865],[657.374,570.046],[657.374,680.165]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[677.368,699.743],[677.368,811.972],[657.374,696.726],[657.374,806.845]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[673.116,833.495],[673.116,946.006],[816.662,823.609],[816.662,932.341]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[677.368,421.944],[677.369,309.715],[811.475,425.63],[811.476,316.926]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[677.368,554.438],[677.369,442.208],[811.475,553.96],[811.476,445.257]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[677.369,570.636],[677.368,682.865],[811.476,569.65],[811.475,678.353]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[677.369,699.743],[677.368,811.972],[811.476,694.701],[811.475,803.404]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[799.389,298.688],[699.228,298.382],[799.389,191.531],[699.228,191.089]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[799.388,298.688],[799.389,191.531],[940.459,301.39],[940.46,195.436]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[846.755,833.172],[846.755,945.561],[807.425,823.796],[807.425,932.599]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[851.073,421.873],[851.073,309.575],[811.474,425.63],[811.475,316.927]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[851.073,554.447],[851.073,442.149],[811.474,553.96],[811.475,445.257]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[851.073,570.655],[851.073,682.952],[811.475,569.65],[811.474,678.353]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[851.073,699.841],[851.073,812.138],[811.475,694.701],[811.474,803.404]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[846.755,833.172],[846.755,945.561],[976.467,823.871],[976.467,932.703]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[851.073,421.873],[851.073,309.575],[997.279,423.492],[997.279,312.744]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[851.073,554.447],[851.073,442.149],[997.279,554.237],[997.279,443.489]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[851.073,570.655],[851.073,682.952],[997.279,570.222],[997.279,680.97]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[851.073,699.841],[851.073,812.138],[997.279,697.625],[997.279,808.374]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[944.696,301.863],[944.696,196.119],[1076.91,306.519],[1076.91,202.85]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[986.022,825.867],[986.022,935.462],[976.467,823.871],[976.467,932.703]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[986.022,825.867],[986.022,935.462],[1111.04,816.818],[1111.04,922.953]]
                },{
                    num:"506",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[997.749,428.427],[997.749,318.945],[1357.06,438.513],[1357.06,338.996]]
                },{
                    num:"406",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[997.749,557.677],[997.749,448.195],[1357.06,556],[1357.06,456.483]]
                },{
                    num:"306",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[997.749,573.478],[997.749,682.96],[1357.06,570.363],[1357.06,669.881]]
                },{
                    num:"206",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[997.749,699.425],[997.749,808.906],[1357.06,684.847],[1357.06,784.365]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[1076.91,306.519],[1076.91,202.85],[1207.69,314.386],[1207.69,214.222]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[1207.69,314.386],[1207.69,214.222],[1298.77,322.643],[1298.77,226.158]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[1241.56,807.377],[1241.56,909.902],[1351.19,799.442],[1351.19,898.932]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[1299.54,322.714],[1299.54,226.26],[1365.65,331.541],[1365.65,239.019]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[1339.97,797.761],[1339.97,896.609],[1440.71,790.539],[1440.71,886.625]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[1365.65,331.541],[1365.65,239.019],[1396.65,337.941],[1396.65,248.269]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[1370.83,434.444],[1370.83,334.173],[1440.19,438.761],[1440.2,342.62]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[1370.83,552.82],[1370.83,452.549],[1440.19,552.261],[1440.2,456.12]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[1370.83,567.292],[1370.83,667.562],[1440.2,566.137],[1440.19,662.277]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[1370.83,682.642],[1370.83,782.913],[1440.2,676.736],[1440.19,772.876]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[1396.64,337.941],[1396.64,248.269],[1401.69,344.03],[1401.69,257.071]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[1389.92,441.527],[1389.92,348.033],[1483.48,444.099],[1483.48,353.065]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[1389.92,551.903],[1389.92,458.409],[1483.48,551.57],[1483.48,460.536]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[1389.92,565.397],[1389.92,658.89],[1483.48,564.709],[1483.48,655.743]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[1389.92,672.951],[1389.92,766.445],[1483.48,669.433],[1483.48,760.467]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[1386.77,784.307],[1386.77,878.01],[1486.91,777.411],[1486.91,868.478]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[1454.87,445.555],[1454.87,355.914],[1497.82,446.708],[1497.82,358.17]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[1454.87,551.381],[1454.87,461.741],[1497.82,551.232],[1497.82,462.694]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[1454.87,564.319],[1454.87,653.96],[1497.82,564.011],[1497.82,652.548]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[1454.87,667.441],[1454.87,757.081],[1497.82,665.863],[1497.82,754.401]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:32,
                    verts:[[1457.18,773.631],[1457.18,863.253],[1498.09,770.883],[1498.09,859.454]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[458.791,433.902],[458.791,333.112],[364.963,442.584],[364.963,350.101]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[458.791,552.89],[458.791,452.1],[364.963,551.766],[364.963,459.283]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[458.791,567.437],[458.791,668.226],[364.963,565.114],[364.963,657.597]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[458.791,683.384],[458.791,784.173],[364.963,671.506],[364.963,763.989]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[459.907,802.759],[459.907,903.519],[366.013,781.05],[366.013,873.508]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[569.716,829.37],[569.716,940.305],[457.314,803.271],[457.314,904.226]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[468.131,324.32],[468.131,228.581],[458.526,329.235],[458.526,235.686]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[571.845,423.441],[571.845,312.643],[459.379,433.847],[459.379,333.006]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[571.845,554.244],[571.845,443.447],[459.379,552.897],[459.379,452.055]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[571.845,570.235],[571.845,681.033],[459.379,567.451],[459.379,668.292]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[571.845,697.696],[571.845,808.493],[459.379,683.458],[459.379,784.299]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[476.931,320.713],[476.931,223.367],[468.131,324.32],[468.131,228.581]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[494.895,315.323],[494.895,215.577],[476.93,320.713],[476.931,223.367]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[532.123,310.285],[532.123,208.294],[496.831,314.954],[496.831,215.044]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[559.345,307.241],[559.345,203.894],[532.123,310.285],[532.123,208.294]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[600.49,303.042],[600.49,197.825],[559.344,307.241],[559.344,203.894]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[651.297,832.936],[651.297,945.234],[569.716,829.37],[569.716,940.305]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[652.948,422.002],[652.948,309.829],[571.845,423.441],[571.845,312.643]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[652.948,554.43],[652.948,442.257],[571.845,554.244],[571.845,443.447]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[652.948,570.62],[652.948,682.793],[571.845,570.235],[571.845,681.033]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[652.948,699.663],[652.948,811.836],[571.845,697.696],[571.845,808.493]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[600.49,303.042],[600.49,197.825],[635.72,305.334],[635.72,201.138]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[665.167,300.098],[665.167,193.57],[635.72,305.334],[635.72,201.138]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[651.297,832.936],[651.297,945.234],[711.475,827.999],[711.475,938.41]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[652.948,422.002],[652.948,309.829],[715.981,424.068],[715.981,313.87]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[652.948,554.43],[652.948,442.257],[715.981,554.163],[715.981,443.965]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[652.948,570.62],[652.948,682.793],[715.981,570.068],[715.981,680.265]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[652.948,699.663],[652.948,811.836],[715.981,696.838],[715.981,807.035]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[751.152,298.508],[751.152,191.271],[665.167,300.098],[665.167,193.57]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[737.636,833.429],[737.636,945.916],[711.475,827.999],[711.475,938.41]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[741.219,421.985],[741.219,309.795],[715.981,424.068],[715.981,313.87]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[741.219,554.432],[741.219,442.242],[715.981,554.163],[715.981,443.965]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[741.219,570.625],[741.219,682.815],[715.981,570.068],[715.981,680.265]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[741.219,699.687],[741.219,811.877],[715.981,696.838],[715.981,807.035]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[737.636,833.429],[737.636,945.916],[871.925,822.122],[871.925,930.285]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[741.219,421.985],[741.22,309.795],[866.699,426.201],[866.699,318.044]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[741.219,554.432],[741.22,442.242],[866.699,553.887],[866.699,445.73]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[741.22,570.625],[741.219,682.815],[866.699,569.497],[866.699,677.654]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[741.22,699.687],[741.219,811.877],[866.699,693.919],[866.699,802.076]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[751.152,298.508],[850.948,299.736],[751.152,191.271],[850.948,193.046]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[850.947,299.736],[850.948,193.046],[987.808,303.666],[987.808,198.727]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[910.57,831.153],[910.57,942.77],[862.91,822.405],[862.91,930.677]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[914.63,422.697],[914.63,311.188],[866.698,426.201],[866.699,318.044]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[914.63,554.34],[914.63,442.831],[866.698,553.887],[866.699,445.73]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[914.63,570.434],[914.63,681.943],[866.699,569.497],[866.698,677.654]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[914.63,698.713],[914.63,810.222],[866.699,693.919],[866.698,802.076]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[910.57,831.153],[910.57,942.77],[1030.06,820.65],[1030.06,928.25]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[914.63,422.697],[914.63,311.188],[1055.01,424.922],[1055.01,315.543]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[914.63,554.34],[914.63,442.831],[1055.01,554.052],[1055.01,444.672]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[914.63,570.434],[914.63,681.943],[1055.01,569.839],[1055.01,679.219]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[914.63,698.713],[914.63,810.222],[1055.01,695.668],[1055.01,805.048]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[991.485,304.167],[991.485,199.449],[1116.19,309.874],[1116.19,207.7]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[1041.25,822.491],[1030.06,820.65],[1041.25,930.795],[1030.06,928.25]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[1041.25,822.491],[1041.25,930.795],[1155.23,812.371],[1155.23,916.806]]
                },{
                    num:"506",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[1052.48,429.78],[1052.48,321.635],[1377.13,440.96],[1377.13,343.859]]
                },{
                    num:"406",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[1052.48,557.452],[1052.48,449.307],[1377.13,555.593],[1377.13,458.493]]
                },{
                    num:"306",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[1052.48,573.061],[1052.48,681.206],[1377.13,569.608],[1377.13,666.708]]
                },{
                    num:"206",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[1052.48,697.47],[1052.48,805.615],[1377.13,681.312],[1377.13,778.412]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[1116.19,309.874],[1116.19,207.7],[1235.02,318.623],[1235.02,220.347]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[1235.02,318.623],[1235.02,220.347],[1314.3,327.353],[1314.3,232.965]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[1273.19,801.905],[1273.19,902.337],[1371.46,793.18],[1371.46,890.276]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[1314.96,327.428],[1314.96,233.073],[1369.31,336.463],[1369.31,246.133]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[1369.31,336.463],[1369.31,246.133],[1392.42,342.866],[1392.42,255.389]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[1359.24,791.668],[1359.24,888.187],[1449.05,783.776],[1449.05,877.277]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[1392.01,437.052],[1392.01,339.277],[1448.68,441.464],[1448.68,347.91]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[1392.01,552.482],[1392.01,454.707],[1448.68,551.911],[1448.68,458.356]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[1392.01,566.594],[1392.01,664.369],[1448.68,565.414],[1448.68,658.968]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[1392.01,679.073],[1392.01,776.848],[1448.68,673.037],[1448.68,766.592]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[1394.74,443.943],[1394.74,352.759],[1478.19,446.746],[1478.19,358.246]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[1394.74,551.59],[1394.74,460.407],[1478.19,551.227],[1478.19,462.726]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[1394.74,564.75],[1394.74,655.934],[1478.19,564],[1478.19,652.501]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[1394.74,669.647],[1394.74,760.83],[1478.19,665.811],[1478.19,754.311]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[1392.21,778.272],[1392.21,869.668],[1481.52,770.753],[1481.52,859.274]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[1447.84,448.047],[1447.84,360.791],[1486.13,449.302],[1486.13,363.246]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[1447.84,551.059],[1447.84,463.802],[1486.13,550.896],[1486.13,464.84]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[1447.84,563.652],[1447.84,650.908],[1486.13,563.317],[1486.13,649.372]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[1447.84,664.031],[1447.84,751.287],[1486.13,662.315],[1486.13,748.37]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:33,
                    verts:[[1450,767.377],[1450,854.607],[1486.46,764.388],[1486.46,850.474]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[493.1,432.97],[493.1,331.289],[376.015,441.26],[376.015,347.511]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[493.1,553.01],[493.1,451.33],[376.015,551.937],[376.015,458.188]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[493.1,567.686],[493.1,669.367],[376.015,565.468],[376.015,659.218]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[493.1,684.658],[493.1,786.339],[376.015,673.317],[376.015,767.066]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[494.168,805.08],[494.168,906.726],[377.036,784.351],[377.036,878.072]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[490.154,322.342],[490.154,225.721],[474.893,327.158],[474.893,232.683]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[503.13,318.826],[503.13,220.639],[490.154,322.342],[490.154,225.721]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[630.879,830.277],[630.879,941.558],[492,805.615],[492,907.466]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[632.698,423.086],[632.698,311.949],[493.83,432.918],[493.83,331.188]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[632.698,554.29],[632.698,443.153],[493.83,553.017],[493.83,451.287]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[632.698,570.33],[632.698,681.467],[493.83,567.7],[493.83,669.43]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[632.698,698.181],[632.698,809.318],[493.83,684.729],[493.83,786.459]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[527.405,313.622],[527.405,213.118],[503.129,318.826],[503.13,220.639]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[570.847,308.948],[570.847,206.361],[529.786,313.273],[529.786,212.613]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[601.818,306.174],[601.818,202.352],[570.847,308.948],[570.847,206.361]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[648.05,302.391],[648.05,196.884],[601.818,306.174],[601.818,202.352]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[716.465,832.882],[716.465,945.16],[630.879,830.277],[630.879,941.558]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[717.823,422.029],[717.823,309.881],[632.698,423.086],[632.698,311.949]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[717.823,554.427],[717.823,442.279],[632.698,554.29],[632.698,443.153]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[717.823,570.613],[717.823,682.761],[632.698,570.33],[632.698,681.467]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[717.823,699.627],[717.823,811.775],[632.698,698.181],[632.698,809.318]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[648.049,302.391],[648.049,196.884],[681.129,304.971],[681.129,200.613]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[716.437,300.074],[716.437,193.534],[681.129,304.971],[681.129,200.613]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[804.31,299.293],[804.31,192.406],[716.437,300.074],[716.437,193.535]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[716.465,832.882],[716.465,945.16],[772.27,827.363],[772.27,937.53]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[717.823,422.029],[717.823,309.881],[776.268,424.338],[776.268,314.399]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[717.823,554.427],[717.823,442.279],[776.268,554.128],[776.268,444.189]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[717.823,570.613],[717.823,682.761],[776.268,569.995],[776.268,679.934]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[717.823,699.627],[717.823,811.774],[776.268,696.468],[776.268,806.407]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[803.42,832.404],[803.42,944.499],[772.27,827.363],[772.27,937.53]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[806.284,422.405],[806.284,310.616],[776.268,424.338],[776.268,314.399]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[806.284,554.378],[806.284,442.589],[776.268,554.128],[776.268,444.189]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[806.284,570.513],[806.284,682.301],[776.268,569.995],[776.268,679.935]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[806.284,699.113],[806.284,810.902],[776.268,696.468],[776.268,806.407]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[803.42,832.404],[803.42,944.499],[926.579,819.877],[926.579,927.181]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[804.31,299.293],[804.31,192.406],[902.302,301.399],[902.302,195.45]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[806.284,422.405],[806.285,310.616],[921.391,427.076],[921.391,319.756]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[806.284,554.378],[806.285,442.589],[921.391,553.773],[921.391,446.454]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[806.285,570.513],[806.284,682.301],[921.391,569.263],[921.391,676.582]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[806.285,699.113],[806.284,810.902],[921.391,692.722],[921.391,800.042]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[902.302,301.399],[902.302,195.45],[1033.17,306.45],[1033.17,202.751]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[972.921,828.275],[972.921,938.791],[917.914,820.249],[917.914,927.697]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[976.668,423.862],[976.669,313.468],[921.391,427.076],[921.391,319.757]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[976.668,554.189],[976.669,443.795],[921.391,553.773],[921.391,446.454]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[976.669,570.123],[976.668,680.517],[921.391,569.263],[921.391,676.582]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[976.669,697.119],[976.668,807.513],[921.391,692.722],[921.391,800.042]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[972.921,828.275],[972.921,938.791],[1080.8,816.781],[1080.8,922.902]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[976.668,423.862],[976.668,313.468],[1109.32,426.628],[1109.32,318.88]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[976.668,554.189],[976.668,443.795],[1109.32,553.831],[1109.32,446.083]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[976.668,570.123],[976.668,680.517],[1109.32,569.383],[1109.32,677.131]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[976.668,697.119],[976.668,807.513],[1109.32,693.335],[1109.32,801.083]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[1036.26,306.97],[1036.26,203.5],[1152.16,313.588],[1152.16,213.068]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[1093.38,818.452],[1080.8,816.781],[1093.38,925.212],[1080.8,922.902]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[1093.38,818.452],[1093.38,925.212],[1195.3,807.473],[1195.3,910.035]]
                },{
                    num:"506",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[1103.97,431.384],[1103.97,324.824],[1392.03,443.421],[1392.03,348.751]]
                },{
                    num:"406",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[1103.97,557.185],[1103.97,450.625],[1392.03,555.184],[1392.03,460.515]]
                },{
                    num:"306",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[1103.97,572.565],[1103.97,679.125],[1392.03,568.848],[1392.03,663.518]]
                },{
                    num:"206",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[1103.97,695.151],[1103.97,801.711],[1392.03,677.755],[1392.03,772.425]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[1152.16,313.588],[1152.16,213.068],[1258.29,323.041],[1258.29,226.733]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[1258.29,323.041],[1258.29,226.733],[1325.69,332.098],[1325.69,239.823]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[1300,796.203],[1300,894.455],[1386.6,786.875],[1386.6,881.561]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[1326.25,332.175],[1326.25,239.935],[1369.18,341.299],[1369.18,253.122]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[1369.18,341.299],[1369.18,253.122],[1384.8,347.639],[1384.8,262.287]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[1373.61,785.532],[1373.61,879.704],[1452.42,777.137],[1452.42,868.099]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[1407.76,439.675],[1407.76,344.409],[1452.2,444.119],[1452.2,353.104]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[1407.76,552.142],[1407.76,456.877],[1452.2,551.567],[1452.2,460.552]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[1407.76,565.892],[1407.76,661.158],[1452.2,564.703],[1452.2,655.718]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[1407.76,675.485],[1407.76,770.751],[1452.2,669.406],[1452.2,760.42]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[1395.43,446.314],[1395.43,357.4],[1468.85,449.294],[1468.85,363.23]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[1395.43,551.283],[1395.43,462.369],[1468.85,550.897],[1468.85,464.833]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[1395.43,564.116],[1395.43,653.03],[1468.85,563.319],[1468.85,649.383]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[1395.43,666.402],[1395.43,755.317],[1468.85,662.326],[1468.85,748.39]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[1393.49,772.34],[1393.49,861.468],[1472.05,764.35],[1472.05,850.423]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[1437.18,450.444],[1437.18,365.48],[1470.88,451.775],[1470.88,368.086]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[1437.18,550.748],[1437.18,465.785],[1470.88,550.576],[1470.88,466.886]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[1437.18,563.011],[1437.18,647.974],[1470.88,562.655],[1470.88,646.345]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:34,
                    verts:[[1437.18,660.752],[1437.18,745.716],[1470.88,658.931],[1470.88,742.62]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[531.897,432.249],[531.897,329.879],[392.395,440.044],[392.395,345.132]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[531.897,553.104],[531.897,450.734],[392.395,552.094],[392.395,457.182]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[531.897,567.879],[531.897,670.249],[392.395,565.793],[392.395,660.706]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[531.897,685.644],[531.897,788.014],[392.395,674.98],[392.395,769.892]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[532.902,806.872],[532.902,909.204],[393.374,787.383],[393.374,882.263]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[525.394,327.663],[525.394,233.412],[493.385,331.211],[493.385,238.542]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[516.5,320.688],[516.5,223.331],[495.649,325.352],[495.649,230.072]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[533.57,317.304],[533.57,218.44],[516.5,320.688],[516.5,223.331]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[694.727,830.335],[694.727,941.639],[531.193,807.425],[531.193,909.969]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[696.21,423.068],[696.21,311.914],[532.762,432.201],[532.762,329.785]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[696.21,554.292],[696.21,443.138],[532.762,553.11],[532.762,450.694]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[696.21,570.335],[696.21,681.489],[532.762,567.892],[532.762,670.308]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[696.21,698.205],[696.21,809.359],[532.762,685.71],[532.762,788.126]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[563.942,312.348],[563.942,211.277],[533.569,317.304],[533.57,218.44]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[613.097,308.095],[613.097,205.128],[566.744,312.022],[566.744,210.805]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[647.422,305.624],[647.422,201.557],[613.097,308.095],[613.097,205.128]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[698.106,302.301],[698.106,196.754],[647.422,305.624],[647.422,201.557]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[782.958,831.96],[782.958,943.885],[694.727,830.335],[694.727,941.639]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[784.007,422.401],[784.007,310.609],[696.21,423.068],[696.21,311.914]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[784.007,554.378],[784.007,442.586],[696.21,554.292],[696.21,443.138]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[784.007,570.513],[784.007,682.306],[696.21,570.335],[696.21,681.489]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[784.007,699.118],[784.007,810.91],[696.21,698.205],[696.21,809.359]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[698.106,302.301],[698.106,196.754],[728.598,305.134],[728.598,200.848]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[769.222,300.63],[769.222,194.338],[728.598,305.134],[728.598,200.848]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[857.721,300.646],[769.222,300.63],[857.721,194.362],[769.222,194.338]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[782.958,831.96],[782.958,943.885],[833.619,825.947],[833.619,935.573]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[784.007,422.401],[784.007,310.609],[837.059,424.916],[837.059,315.53]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[784.007,554.378],[784.007,442.586],[837.059,554.053],[837.059,444.667]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[784.007,570.513],[784.007,682.305],[837.059,569.841],[837.059,679.227]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[784.007,699.118],[784.007,810.91],[837.059,695.677],[837.059,805.063]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[869.172,830.545],[869.172,941.929],[833.619,825.947],[833.619,935.573]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[871.292,423.153],[871.293,312.08],[837.059,424.916],[837.059,315.53]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[871.292,554.281],[871.293,443.208],[837.059,554.053],[837.059,444.667]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[871.293,570.312],[871.292,681.385],[837.059,569.841],[837.059,679.227]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[871.293,698.089],[871.292,809.162],[837.059,695.677],[837.059,805.063]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[857.721,300.646],[857.721,194.362],[952.607,303.57],[952.607,198.588]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[869.172,830.545],[869.172,941.929],[979.732,817.012],[979.732,923.221]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[871.293,423.153],[871.294,312.08],[974.654,428.2],[974.654,321.956]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[871.293,554.281],[871.294,443.208],[974.654,553.628],[974.654,447.384]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[871.294,570.312],[871.293,681.385],[974.654,568.962],[974.654,675.206]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[871.294,698.089],[871.293,809.162],[974.654,691.184],[974.654,797.428]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[952.606,303.57],[952.606,198.588],[1075.98,309.618],[1075.98,207.33]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[1036.19,425.302],[1036.19,316.284],[974.653,428.2],[974.654,321.956]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[1036.19,554.003],[1036.19,444.986],[974.653,553.628],[974.654,447.384]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[1036.19,569.737],[1036.19,678.755],[974.654,568.962],[974.653,675.206]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[1036.19,695.15],[1036.19,804.167],[974.654,691.184],[974.653,797.428]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[1032.8,824.704],[1032.8,933.855],[971.525,817.465],[971.525,923.847]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[1032.8,824.704],[1032.8,933.855],[1128.09,812.431],[1128.09,916.888]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[1036.19,425.302],[1036.19,316.284],[1159.59,428.535],[1159.59,322.611]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[1036.19,554.003],[1036.19,444.986],[1159.59,553.584],[1159.59,447.661]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[1036.19,569.737],[1036.19,678.755],[1159.59,568.872],[1159.59,674.796]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[1036.19,695.15],[1036.19,804.167],[1159.59,690.726],[1159.59,796.649]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[1078.47,310.149],[1078.47,208.096],[1184.58,317.534],[1184.58,218.773]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[1141.81,813.923],[1128.09,812.431],[1141.81,918.951],[1128.09,916.888]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[1141.81,813.923],[1141.81,918.951],[1231.06,802.289],[1231.06,902.869]]
                },{
                    num:"506",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[1151.66,433.172],[1151.66,328.378],[1402.21,445.845],[1402.21,353.57]]
                },{
                    num:"406",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[1151.66,556.888],[1151.66,452.094],[1402.21,554.781],[1402.21,462.506]]
                },{
                    num:"306",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[1151.66,572.013],[1151.66,676.807],[1402.21,568.099],[1402.21,660.374]]
                },{
                    num:"206",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[1151.66,692.567],[1151.66,797.361],[1402.21,674.251],[1402.21,766.526]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[1184.59,317.534],[1184.59,218.773],[1277.6,327.525],[1277.6,233.213]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[1277.6,327.525],[1277.6,233.213],[1333.29,336.78],[1333.29,246.591]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[1322.16,790.422],[1322.16,886.464],[1397.05,780.658],[1397.05,872.966]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[1333.75,336.859],[1333.75,246.705],[1365.72,345.97],[1365.72,259.875]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[1365.72,345.97],[1365.72,259.875],[1374.31,352.194],[1374.31,268.872]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[1383.49,779.48],[1383.49,871.338],[1451.45,770.728],[1451.45,859.239]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[1418.56,442.258],[1418.56,349.463],[1451.36,446.682],[1451.36,358.119]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[1418.56,551.808],[1418.56,459.013],[1451.36,551.235],[1451.36,462.673]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[1418.56,565.201],[1418.56,657.996],[1451.36,564.018],[1451.36,652.58]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[1418.56,671.951],[1418.56,764.746],[1451.36,665.899],[1451.36,754.462]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[1392.51,448.604],[1392.51,361.88],[1456.12,451.71],[1456.12,367.958]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[1392.51,550.987],[1392.51,464.263],[1456.12,550.584],[1456.12,466.833]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[1392.51,563.503],[1392.51,650.227],[1456.12,562.672],[1456.12,646.424]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[1392.51,663.27],[1392.51,749.993],[1456.12,659.02],[1456.12,742.771]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:35,
                    verts:[[1391.13,766.606],[1391.13,853.542],[1459.19,758.277],[1459.19,842.028]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[574.446,431.724],[574.446,328.851],[413.755,438.932],[413.755,342.954]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[574.446,553.172],[574.446,450.299],[413.755,552.239],[413.755,456.261]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[574.446,568.019],[574.446,670.892],[413.755,566.091],[413.755,662.068]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[574.446,686.364],[574.446,789.237],[413.755,676.502],[413.755,772.479]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[575.376,808.179],[575.376,911.011],[414.682,790.159],[414.682,886.1]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[548.18,326.325],[548.18,231.479],[511.714,329.6],[511.714,236.213]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[546.659,319.331],[546.659,221.37],[520.371,323.793],[520.372,227.82]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[567.668,316.115],[567.668,216.722],[546.659,319.331],[546.659,221.37]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[603.822,311.461],[603.822,209.995],[567.668,316.115],[567.668,216.722]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[760.039,829.644],[760.039,940.683],[574.152,808.744],[574.152,911.791]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[761.168,423.348],[761.168,312.462],[575.437,431.679],[575.437,328.764]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[761.168,554.256],[761.168,443.37],[575.437,553.177],[575.437,450.262]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[761.168,570.26],[761.168,681.146],[575.437,568.031],[575.437,670.947]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[761.168,697.822],[761.168,808.708],[575.437,686.424],[575.437,789.34]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[658.088,307.675],[658.088,204.522],[607.01,311.162],[607.01,209.562]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[695.318,305.533],[695.318,201.425],[658.088,307.675],[658.088,204.522]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[749.753,302.701],[749.753,197.331],[695.318,305.533],[695.318,201.425]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[749.753,302.701],[749.753,197.332],[777.293,305.749],[777.293,201.737]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[849.562,830.295],[760.039,829.644],[849.562,941.583],[760.039,940.683]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[850.291,423.068],[850.291,311.914],[761.168,423.348],[761.168,312.462]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[850.291,554.292],[850.291,443.138],[761.168,554.256],[761.168,443.37]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[850.291,570.335],[850.291,681.489],[761.168,570.26],[761.168,681.146]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[850.291,698.205],[850.291,809.359],[761.168,697.822],[761.168,808.708]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[822.609,301.679],[822.609,195.855],[777.293,305.749],[777.293,201.738]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[822.609,301.679],[910.539,302.465],[822.609,195.855],[910.539,196.99]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[849.562,830.295],[849.562,941.583],[894.475,823.879],[894.475,932.714]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[850.291,423.068],[850.291,311.914],[897.323,425.751],[897.323,317.164]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[850.291,554.292],[850.291,443.138],[897.323,553.945],[897.323,445.358]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[850.291,570.335],[850.291,681.489],[897.323,569.617],[897.323,678.204]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[850.291,698.205],[850.291,809.359],[897.323,694.535],[897.323,803.122]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[933.786,827.997],[933.786,938.406],[894.475,823.879],[894.475,932.714]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[935.155,424.172],[935.156,314.075],[897.323,425.751],[897.323,317.164]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[935.155,554.149],[935.156,444.052],[897.323,553.945],[897.323,445.358]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[935.156,570.04],[935.155,680.137],[897.323,569.617],[897.323,678.204]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[935.156,696.694],[935.155,806.792],[897.323,694.535],[897.323,803.122]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[910.539,302.465],[910.539,196.99],[1001.18,306.133],[1001.18,202.293]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[933.786,827.997],[933.786,938.406],[1030.68,813.673],[1030.68,918.605]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[935.156,424.172],[935.157,314.075],[1025.78,429.515],[1025.78,324.53]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[935.156,554.149],[935.157,444.052],[1025.78,553.458],[1025.78,448.472]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[935.157,570.04],[935.156,680.137],[1025.78,568.61],[1025.78,673.596]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[935.157,696.695],[935.156,806.792],[1025.78,689.385],[1025.78,794.371]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[1001.18,306.133],[1001.18,202.293],[1115.85,313.047],[1115.85,212.287]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[1089.45,820.613],[1089.45,928.199],[1023.02,814.196],[1023.02,919.328]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[1092.45,426.947],[1092.46,319.503],[1025.78,429.515],[1025.78,324.53]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[1092.45,553.79],[1092.46,446.347],[1025.78,553.458],[1025.78,448.472]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[1092.46,569.297],[1092.45,676.741],[1025.78,568.61],[1025.78,673.596]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[1092.46,692.899],[1092.45,800.342],[1025.78,689.385],[1025.78,794.37]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[1089.45,820.613],[1089.45,928.199],[1171.56,807.761],[1171.56,910.433]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[1092.45,426.947],[1092.45,319.503],[1205.47,430.574],[1205.47,326.601]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[1092.45,553.79],[1092.45,446.347],[1205.47,553.32],[1205.47,449.347]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[1092.45,569.297],[1092.45,676.741],[1205.47,568.327],[1205.47,672.3]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[1092.45,692.899],[1092.45,800.342],[1205.47,687.937],[1205.47,791.909]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[1117.75,313.584],[1117.75,213.06],[1213.41,321.597],[1213.41,224.645]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[1186.18,809.073],[1171.56,807.761],[1186.18,912.246],[1171.56,910.433]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[1186.18,809.073],[1186.18,912.246],[1262.47,796.971],[1262.47,895.516]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[1213.41,321.597],[1213.41,224.645],[1293.2,331.974],[1293.2,239.644]]
                },{
                    num:"506",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[1195.21,435.079],[1195.21,332.169],[1408.16,448.192],[1408.16,358.235]]
                },{
                    num:"406",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[1195.21,556.571],[1195.21,453.661],[1408.16,554.391],[1408.16,464.435]]
                },{
                    num:"306",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[1195.21,571.424],[1195.21,674.334],[1408.16,567.374],[1408.16,657.331]]
                },{
                    num:"206",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[1195.21,689.811],[1195.21,792.72],[1408.16,670.859],[1408.16,760.816]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[1293.2,331.974],[1293.2,239.644],[1337.48,341.319],[1337.48,253.153]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[1337.85,341.399],[1337.85,253.267],[1359.43,350.417],[1359.43,266.303]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[1339.93,784.69],[1339.93,878.54],[1403.31,774.636],[1403.31,864.641]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[1359.43,350.417],[1359.43,266.303],[1361.45,356.484],[1361.45,275.073]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[1389.34,773.616],[1389.34,863.232],[1446.76,764.63],[1446.76,850.81]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[1424.93,444.757],[1424.93,354.353],[1446.78,449.12],[1446.78,362.891]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[1424.93,551.484],[1424.93,461.081],[1446.78,550.92],[1446.78,464.69]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[1424.93,564.533],[1424.93,654.936],[1446.78,563.365],[1446.78,649.595]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:36,
                    verts:[[1424.93,668.532],[1424.93,758.936],[1446.78,662.563],[1446.78,748.792]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[620.021,431.369],[620.021,328.157],[439.694,437.911],[439.694,340.958]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[620.021,553.218],[620.021,450.006],[439.694,552.371],[439.694,455.417]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[620.021,568.114],[620.021,671.326],[439.694,566.364],[439.694,663.317]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[620.021,686.848],[620.021,790.06],[439.694,677.898],[439.694,774.851]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[620.862,809.057],[620.862,912.225],[440.557,792.703],[440.557,889.617]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[574.179,325.18],[574.179,229.825],[533.572,328.149],[533.572,234.116]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[580.102,318.232],[580.102,219.782],[548.612,322.449],[548.612,225.877]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[604.843,315.217],[604.843,215.423],[580.102,318.232],[580.102,219.782]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[646.37,310.911],[646.37,209.199],[604.842,315.217],[604.842,215.423]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[825.729,828.32],[825.729,938.853],[620.138,809.628],[620.138,913.014]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[826.495,423.879],[826.495,313.5],[621.124,431.329],[621.124,328.079]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[826.495,554.187],[826.495,443.809],[621.124,553.223],[621.124,449.972]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[826.495,570.118],[826.495,680.496],[621.124,568.125],[621.124,671.375]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[826.495,697.096],[826.495,807.474],[621.124,686.903],[621.124,790.153]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[705.08,307.627],[705.08,204.452],[649.908,310.641],[649.908,208.809]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[744.73,305.83],[744.73,201.855],[705.08,307.627],[705.08,204.452]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[802.181,303.508],[802.181,198.498],[744.73,305.83],[744.73,201.855]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[802.18,303.508],[802.18,198.498],[826.481,306.734],[826.481,203.161]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[915.25,828.024],[825.729,828.32],[915.25,938.444],[825.729,938.853]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[875.814,303.127],[875.814,197.947],[826.481,306.734],[826.481,203.161]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[915.661,423.976],[826.495,423.879],[915.661,313.69],[826.495,313.501]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[915.661,554.175],[826.495,554.187],[915.661,443.889],[826.495,443.809]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[915.661,570.092],[826.495,570.118],[915.661,680.378],[826.495,680.496]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[915.661,696.964],[826.495,697.096],[915.661,807.249],[826.495,807.474]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[875.814,303.127],[875.814,197.947],[962.078,304.64],[962.078,200.135]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[915.661,423.976],[915.661,313.69],[956.225,426.788],[956.225,319.194]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[915.661,554.175],[915.661,443.889],[956.225,553.811],[956.225,446.216]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[915.661,570.092],[915.661,680.378],[956.225,569.34],[956.225,676.934]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[915.661,696.964],[915.661,807.249],[956.225,693.116],[956.225,800.71]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[915.25,828.024],[915.25,938.444],[953.985,821.297],[953.985,929.145]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[996.379,824.912],[996.379,934.142],[953.985,821.297],[953.985,929.145]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[997.009,425.403],[997.01,316.482],[956.225,426.788],[956.225,319.194]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[997.009,553.99],[997.01,445.069],[956.225,553.811],[956.225,446.216]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[997.01,569.71],[997.009,678.631],[956.225,569.34],[956.225,676.934]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[997.01,695.011],[997.009,803.932],[956.225,693.116],[956.225,800.71]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[962.078,304.64],[962.078,200.135],[1047.53,308.974],[1047.53,206.399]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[996.379,824.912],[996.379,934.142],[1078.94,810.002],[1078.94,913.53]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[997.01,425.403],[997.011,316.482],[1074.26,430.965],[1074.26,327.366]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[997.01,553.99],[997.011,445.069],[1074.26,553.27],[1074.26,449.671]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[997.011,569.71],[997.01,678.631],[1074.26,568.222],[1074.26,671.821]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[997.011,695.012],[997.01,803.932],[1074.26,687.401],[1074.26,791]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[1047.52,308.974],[1047.52,206.399],[1152.59,316.626],[1152.59,217.459]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[1144.97,428.731],[1144.97,322.995],[1074.26,430.965],[1074.26,327.366]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[1144.97,553.559],[1144.97,447.823],[1074.26,553.27],[1074.26,449.671]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[1144.97,568.82],[1144.97,674.556],[1074.26,568.222],[1074.26,671.821]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[1144.97,690.458],[1144.97,796.193],[1074.26,687.401],[1074.26,791]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[1142.36,816.166],[1142.36,922.052],[1071.89,810.585],[1071.89,914.336]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[1142.36,816.166],[1142.36,922.052],[1211.04,802.921],[1211.04,903.742]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[1144.97,428.731],[1144.97,322.995],[1246.8,432.681],[1246.8,330.723]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[1144.97,553.559],[1144.97,447.823],[1246.8,553.048],[1246.8,451.09]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[1144.97,568.82],[1144.97,674.556],[1246.8,567.763],[1246.8,669.721]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[1144.97,690.458],[1144.97,796.193],[1246.8,685.054],[1246.8,787.012]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[1153.89,317.161],[1153.89,218.231],[1238.69,325.673],[1238.69,230.537]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[1226.34,804.052],[1211.04,802.921],[1226.34,905.306],[1211.04,903.742]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[1226.34,804.052],[1226.34,905.306],[1289.66,791.648],[1289.66,888.159]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[1238.69,325.673],[1238.69,230.537],[1305.36,336.306],[1305.36,245.905]]
                },{
                    num:"506",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[1234.48,437.047],[1234.48,336.08],[1410.41,450.429],[1410.41,362.683]]
                },{
                    num:"406",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[1234.48,556.244],[1234.48,455.278],[1410.41,554.019],[1410.41,466.273]]
                },{
                    num:"306",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[1234.48,570.816],[1234.48,671.783],[1410.41,566.684],[1410.41,654.43]]
                },{
                    num:"206",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[1234.48,686.967],[1234.48,787.933],[1410.41,667.626],[1410.41,755.372]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[1305.36,336.306],[1305.36,245.905],[1338.68,345.651],[1338.68,259.414]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[1338.95,345.73],[1338.95,259.528],[1350.73,354.593],[1350.73,272.338]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[1353.7,779.114],[1353.7,870.831],[1405.88,768.891],[1405.88,856.699]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[1391.64,768.021],[1391.64,855.497],[1438.92,758.905],[1438.92,842.895]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[1427.41,447.139],[1427.41,359.014],[1439.05,451.411],[1439.05,367.372]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[1427.41,551.176],[1427.41,463.051],[1439.05,550.623],[1439.05,466.585]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[1427.41,563.895],[1427.41,652.02],[1439.05,562.753],[1439.05,646.791]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:37,
                    verts:[[1427.41,665.274],[1427.41,753.399],[1439.05,659.429],[1439.05,743.468]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[667.926,431.16],[667.926,327.748],[469.787,436.97],[469.787,339.115]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[667.926,553.245],[667.926,449.832],[469.787,552.492],[469.787,454.638]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[667.926,568.17],[667.926,671.582],[469.787,566.616],[469.787,664.47]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[667.926,687.135],[667.926,790.547],[469.787,679.186],[469.787,777.041]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[668.671,809.574],[668.671,912.94],[470.576,795.052],[470.576,892.864]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[558.588,326.824],[558.588,232.201],[551.574,333.582],[551.574,241.969]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[602.974,324.189],[602.974,228.391],[558.589,326.824],[558.589,232.201]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[616.318,317.347],[616.318,218.502],[579.92,321.28],[579.92,224.187]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[644.529,314.559],[644.529,214.472],[616.318,317.347],[616.318,218.502]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[690.957,310.638],[690.957,208.804],[644.529,314.559],[644.529,214.472]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[890.88,826.487],[890.88,936.319],[668.454,810.145],[668.454,913.729]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[891.284,424.611],[891.284,314.933],[669.13,431.125],[669.13,327.679]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[891.284,554.092],[891.284,444.415],[669.13,553.249],[669.13,449.803]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[891.284,569.922],[891.284,679.6],[669.13,568.18],[669.13,671.626]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[891.284,696.094],[891.284,805.772],[669.13,687.183],[669.13,790.629]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[753.398,307.881],[753.398,204.819],[694.803,310.401],[694.803,208.462]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[794.971,306.44],[794.971,202.737],[753.399,307.881],[753.399,204.819]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[854.691,304.636],[854.691,200.129],[794.971,306.44],[794.971,202.737]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[854.691,304.636],[854.691,200.129],[875.537,308.003],[875.537,204.995]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[928.194,304.876],[928.194,200.476],[875.537,308.003],[875.537,204.996]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[891.284,424.611],[891.284,314.933],[979.303,425.067],[979.303,315.826]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[891.284,554.092],[891.284,444.415],[979.303,554.033],[979.303,444.792]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[891.284,569.922],[891.284,679.6],[979.303,569.8],[979.303,679.041]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[891.284,696.094],[979.303,695.47],[891.284,805.772],[979.303,804.711]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[890.88,826.487],[979.206,825.288],[890.88,936.319],[979.206,934.662]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[928.194,304.876],[928.194,200.476],[1011.82,307.068],[1011.82,203.645]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[979.303,425.067],[979.303,315.826],[1013.11,427.974],[1013.11,321.514]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[979.303,554.033],[979.303,444.792],[1013.11,553.657],[1013.11,447.197]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[979.303,569.8],[979.303,679.041],[1013.11,569.023],[1013.11,675.483]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[979.303,695.47],[979.303,804.711],[1013.11,691.493],[1013.11,797.953]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[979.206,825.288],[979.206,934.662],[1011.49,818.336],[1011.49,925.052]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[1056.3,821.439],[1056.3,929.341],[1011.49,818.336],[1011.49,925.052]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[1011.82,307.068],[1011.82,203.645],[1091.3,311.986],[1091.3,210.754]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[1056.21,426.785],[1056.21,319.186],[1013.11,427.974],[1013.11,321.514]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[1056.21,553.811],[1056.21,446.213],[1013.11,553.657],[1013.11,447.197]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[1056.21,569.341],[1056.21,676.939],[1013.11,569.023],[1013.11,675.483]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[1056.21,693.121],[1056.21,800.719],[1013.11,691.493],[1013.11,797.953]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[1056.21,426.785],[1056.21,319.186],[1119.76,432.497],[1119.76,330.363]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[1056.21,553.811],[1056.21,446.213],[1119.76,553.072],[1119.76,450.938]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[1056.21,569.341],[1056.21,676.939],[1119.76,567.813],[1119.76,669.946]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[1056.21,693.121],[1056.21,800.719],[1119.76,685.306],[1119.76,787.44]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[1056.3,821.439],[1056.3,929.341],[1124.17,806.131],[1124.17,908.179]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[1091.3,311.986],[1091.3,210.754],[1186.11,320.253],[1186.11,222.702]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[1193.47,430.595],[1193.47,326.643],[1119.76,432.497],[1119.76,330.363]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[1193.47,553.318],[1193.47,449.365],[1119.76,553.072],[1119.76,450.938]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[1193.47,568.321],[1193.47,672.274],[1119.76,567.813],[1119.76,669.946]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[1193.47,687.907],[1193.47,791.86],[1119.76,685.306],[1119.76,787.44]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[1191.27,811.515],[1191.27,915.623],[1117.8,806.764],[1117.8,909.055]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[1186.85,320.783],[1186.85,223.466],[1260.58,329.678],[1260.58,236.325]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[1191.27,811.515],[1191.27,915.623],[1246.53,798.038],[1246.53,896.992]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[1193.47,430.595],[1193.47,326.643],[1283.64,434.801],[1283.64,334.871]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[1193.47,553.318],[1193.47,449.365],[1283.64,552.773],[1283.64,452.844]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[1193.47,568.321],[1193.47,672.274],[1283.64,567.196],[1283.64,667.125]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[1193.47,687.907],[1193.47,791.86],[1283.64,682.154],[1283.64,782.083]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[1262.3,798.995],[1246.53,798.038],[1262.3,898.315],[1246.53,896.992]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[1260.58,329.678],[1260.58,236.325],[1314.41,340.453],[1314.41,251.901]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[1262.3,798.995],[1262.3,898.315],[1312.86,786.431],[1312.86,880.946]]
                },{
                    num:"506",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[1269.53,439.024],[1269.53,340.01],[1409.43,452.533],[1409.43,366.866]]
                },{
                    num:"406",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[1269.53,555.915],[1269.53,456.902],[1409.43,553.669],[1409.43,468.002]]
                },{
                    num:"306",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[1269.53,570.206],[1269.53,669.219],[1409.43,566.034],[1409.43,651.701]]
                },{
                    num:"206",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[1269.53,684.11],[1269.53,783.123],[1409.43,664.585],[1409.43,750.252]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[1314.41,340.453],[1314.41,251.901],[1337.25,349.727],[1337.25,265.305]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[1337.44,349.805],[1337.44,265.419],[1340.02,358.464],[1340.02,277.933]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[1363.83,773.775],[1363.83,863.451],[1405.24,763.483],[1405.24,849.224]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[1390.86,762.755],[1390.86,848.217],[1428.45,753.591],[1428.45,835.55]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[1426.54,449.379],[1426.54,363.397],[1428.68,453.537],[1428.68,371.532]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[1426.54,550.886],[1426.54,464.904],[1428.68,550.348],[1428.68,468.344]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[1426.54,563.296],[1426.54,649.278],[1428.68,562.184],[1428.68,644.188]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:38,
                    verts:[[1426.54,662.209],[1426.54,748.191],[1428.68,656.521],[1428.68,738.525]]
                },
                ],
                [
                {
                    num:"102",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[516.624,784.046],[516.624,877.65],[480.517,782.041],[480.517,874.878]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[717.542,431.067],[717.542,327.565],[503.608,436.09],[503.608,337.395]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[717.542,553.257],[717.542,449.755],[503.608,552.606],[503.608,453.911]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[717.542,568.195],[717.542,671.697],[503.608,566.851],[503.608,665.547]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[717.542,687.262],[717.542,790.763],[503.608,680.39],[503.608,779.085]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[718.181,809.802],[718.181,913.254],[504.314,797.245],[504.314,895.896]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[586.41,325.586],[586.41,230.412],[572.177,332.255],[572.177,240.05]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[634.179,323.306],[634.179,227.116],[586.411,325.586],[586.411,230.411]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[654.827,316.625],[654.827,217.459],[613.872,320.242],[613.872,222.686]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[686.214,314.087],[686.214,213.79],[654.827,316.625],[654.827,217.459]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[737.021,310.582],[737.021,208.724],[686.213,314.087],[686.213,213.79]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[954.803,425.496],[954.803,316.664],[718.832,431.037],[718.832,327.506]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[954.803,553.978],[954.803,445.147],[718.832,553.26],[718.832,449.73]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[954.803,569.686],[954.803,678.517],[718.832,568.203],[718.832,671.734]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[954.803,694.884],[954.803,803.715],[718.832,687.303],[718.832,790.834]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[954.757,824.269],[954.757,933.253],[718.473,810.368],[718.473,914.037]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[802.462,308.367],[802.462,205.522],[741.13,310.379],[741.13,208.43]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[845.455,307.287],[845.455,203.961],[802.462,308.367],[802.462,205.522]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[906.717,306.001],[906.717,202.102],[845.456,307.287],[845.456,203.961]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[906.716,306.001],[906.716,202.102],[923.964,309.474],[923.964,207.122]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[979.253,306.835],[979.253,203.307],[923.964,309.474],[923.964,207.122]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[954.803,425.496],[954.803,316.665],[1040.61,426.29],[1040.61,318.219]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[954.803,553.978],[954.803,445.147],[1040.61,553.875],[1040.61,445.804]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[954.803,569.686],[954.803,678.517],[1040.61,569.473],[1040.61,677.544]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[954.803,694.884],[954.803,803.715],[1040.61,693.797],[1040.61,801.869]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[954.757,824.269],[954.757,933.253],[1040.81,822.221],[1040.81,930.423]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[979.253,306.835],[979.253,203.307],[1059.4,309.652],[1059.4,207.379]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[1040.61,426.29],[1040.61,318.219],[1067.53,429.258],[1067.53,324.026]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[1040.61,553.875],[1040.61,445.804],[1067.53,553.491],[1067.53,448.259]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[1040.61,569.473],[1040.61,677.544],[1067.53,568.679],[1067.53,673.911]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[1040.61,693.797],[1040.61,801.869],[1067.53,689.737],[1067.53,794.969]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[1040.81,822.221],[1040.81,930.423],[1066.51,815.123],[1066.51,920.61]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[1059.4,309.652],[1059.4,207.379],[1132.32,315.076],[1132.32,215.22]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[1113.09,817.716],[1113.09,924.194],[1066.51,815.123],[1066.51,920.61]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[1112.33,428.264],[1112.33,322.081],[1067.53,429.258],[1067.53,324.026]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[1112.33,553.619],[1112.33,447.437],[1067.53,553.491],[1067.53,448.259]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[1112.33,568.945],[1112.33,675.128],[1067.53,568.679],[1067.53,673.911]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[1112.33,691.096],[1112.33,797.279],[1067.53,689.737],[1067.53,794.969]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[1112.33,428.264],[1112.33,322.082],[1162.12,434.064],[1162.12,333.429]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[1112.33,553.619],[1112.33,447.437],[1162.12,552.869],[1162.12,452.234]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[1112.33,568.945],[1112.33,675.128],[1162.12,567.393],[1162.12,668.028]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[1112.33,691.096],[1112.33,797.279],[1162.12,683.162],[1162.12,783.797]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[1113.09,817.716],[1113.09,924.194],[1166.23,802.176],[1166.23,902.712]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[1132.32,315.076],[1132.32,215.22],[1216.44,323.843],[1216.44,227.892]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[1237.85,432.487],[1237.85,330.344],[1162.12,434.064],[1162.12,333.429]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[1237.85,553.073],[1237.85,450.93],[1162.12,552.869],[1162.12,452.234]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[1237.85,567.815],[1237.85,669.958],[1162.12,567.393],[1162.12,668.028]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[1237.85,685.319],[1237.85,787.462],[1162.12,683.162],[1162.12,783.797]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[1236.06,806.791],[1236.06,909.092],[1160.56,802.85],[1160.56,903.644]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[1216.64,324.364],[1216.64,228.643],[1279.29,333.54],[1279.29,241.908]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[1236.06,806.791],[1236.06,909.092],[1278.12,793.22],[1278.12,890.332]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[1237.84,432.487],[1237.85,330.344],[1316.12,436.889],[1316.12,338.957]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[1237.84,553.073],[1237.85,450.93],[1316.12,552.503],[1316.12,454.571]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[1237.85,567.815],[1237.84,669.958],[1316.12,566.638],[1316.12,664.569]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[1237.85,685.319],[1237.84,787.462],[1316.12,679.297],[1316.12,777.229]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[1294.18,794.009],[1278.12,793.22],[1294.18,891.422],[1278.12,890.332]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[1279.29,333.54],[1279.29,241.908],[1320.66,344.367],[1320.66,257.557]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[1294.18,794.009],[1294.18,891.422],[1332.33,781.404],[1332.33,873.997]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[1320.66,344.367],[1320.66,257.557],[1333.56,353.512],[1333.56,270.776]]
                },{
                    num:"506",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[1300.48,440.969],[1300.48,343.876],[1405.69,454.489],[1405.69,370.754]]
                },{
                    num:"406",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[1300.48,555.592],[1300.48,458.5],[1405.69,553.344],[1405.69,469.609]]
                },{
                    num:"306",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[1300.48,569.605],[1300.48,666.697],[1405.69,565.43],[1405.69,649.165]]
                },{
                    num:"206",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[1300.48,681.299],[1300.48,778.391],[1405.69,661.758],[1405.69,745.493]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[1370.72,768.735],[1370.72,856.484],[1401.82,758.456],[1401.82,842.275]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:39,
                    verts:[[1387.42,757.86],[1387.42,841.45],[1415.78,748.714],[1415.78,828.807]]
                },
                ],
                [
                {
                    num:"102",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[542.063,786.056],[542.063,880.429],[503.395,784.365],[503.395,878.091]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[542.732,440.664],[542.732,346.344],[505.458,441.315],[505.458,347.617]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[542.732,552.014],[542.732,457.694],[505.458,551.93],[505.458,458.233]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[542.732,565.628],[542.732,659.948],[505.458,565.453],[505.458,659.151]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[542.732,674.132],[542.732,768.452],[505.458,673.242],[505.458,766.939]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[540.761,435.256],[540.761,335.762],[510.213,438.2],[510.213,341.523]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[540.761,552.714],[540.761,453.22],[510.213,552.333],[510.213,455.656]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[540.761,567.075],[540.761,666.569],[510.213,566.287],[510.213,662.964]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[540.761,681.531],[540.761,781.026],[510.213,677.503],[510.213,774.18]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[541.377,799.327],[541.377,898.774],[511.097,791.927],[511.097,888.544]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[768.33,431.062],[768.33,327.555],[540.761,435.256],[540.761,335.762]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[768.33,553.257],[768.33,449.751],[540.761,552.714],[540.761,453.22]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[768.33,568.197],[768.33,671.703],[540.761,567.074],[540.761,666.568]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[768.33,687.269],[768.33,790.776],[540.761,681.531],[540.761,781.025]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[768.858,809.811],[768.858,913.266],[541.376,799.327],[541.376,898.774]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[616.712,324.396],[616.712,228.691],[595.319,330.928],[595.319,238.132]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[667.445,322.49],[667.445,225.935],[616.712,324.396],[616.713,228.691]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[695.207,316.019],[695.207,216.582],[650.086,319.292],[650.086,221.313]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[729.449,313.749],[729.449,213.302],[695.207,316.019],[695.207,216.582]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[784.079,310.684],[784.079,208.87],[729.448,313.749],[729.448,213.302]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[1016.5,426.488],[1016.5,318.606],[769.692,431.036],[769.692,327.506]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[1016.5,553.849],[1016.5,445.967],[769.692,553.261],[769.692,449.73]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[1016.5,569.42],[1016.5,677.302],[769.692,568.203],[769.692,671.734]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[1016.5,693.527],[1016.5,801.409],[769.692,687.304],[769.692,790.834]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[1016.8,821.779],[1016.8,929.811],[769.65,810.367],[769.65,914.036]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[851.79,309.018],[851.79,206.464],[788.407,310.516],[788.407,208.627]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[895.716,308.298],[851.79,309.019],[895.716,205.422],[851.79,206.464]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[957.819,307.524],[895.717,308.298],[957.819,204.304],[895.717,205.422]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[957.817,307.524],[957.817,204.304],[971.381,311.071],[971.381,209.43]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[1028.63,308.92],[1028.63,206.321],[971.381,311.071],[971.381,209.43]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[1016.5,426.488],[1016.5,318.606],[1099.16,427.596],[1099.16,320.774]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[1016.5,553.849],[1016.5,445.967],[1099.16,553.706],[1099.16,446.884]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[1016.5,569.42],[1016.5,677.302],[1099.16,569.124],[1099.16,675.946]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[1016.5,693.527],[1016.5,801.409],[1099.16,692.011],[1099.16,798.833]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[1016.8,821.779],[1016.8,929.811],[1099.66,818.944],[1099.66,925.892]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[1028.63,308.92],[1028.63,206.321],[1104.58,312.307],[1104.58,211.217]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[1099.16,427.596],[1099.16,320.774],[1119.18,430.596],[1119.18,326.644]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[1099.16,553.706],[1099.16,446.884],[1119.18,553.318],[1119.18,449.366]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[1099.16,569.124],[1099.16,675.946],[1119.18,568.321],[1119.18,672.273]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[1099.16,692.011],[1099.16,798.833],[1119.18,687.906],[1119.18,791.858]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[1099.66,818.944],[1099.66,925.892],[1118.75,811.769],[1118.75,915.974]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[1104.58,312.307],[1104.58,211.217],[1170.5,318.163],[1170.5,219.682]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[1165.09,429.794],[1165.09,325.075],[1119.18,430.596],[1119.18,326.644]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[1165.09,553.421],[1165.09,448.702],[1119.18,553.318],[1119.18,449.366]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[1165.09,568.536],[1165.09,673.255],[1119.18,568.321],[1119.18,672.273]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[1165.09,689.003],[1165.09,793.722],[1119.18,687.906],[1119.18,791.858]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[1166.5,813.861],[1118.75,811.769],[1166.5,918.866],[1118.75,915.974]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[1166.5,813.861],[1166.5,918.866],[1205.06,798.235],[1205.06,897.264]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[1165.09,429.794],[1165.09,325.075],[1201.27,435.627],[1201.27,336.488]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[1165.09,553.421],[1165.09,448.702],[1201.27,552.666],[1201.27,453.528]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[1165.09,568.536],[1165.09,673.255],[1201.27,566.975],[1201.27,666.114]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[1165.09,689.003],[1165.09,793.723],[1201.27,681.024],[1201.27,780.162]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[1170.49,318.163],[1170.49,219.682],[1243.69,327.329],[1243.69,232.931]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[1278.15,434.363],[1278.15,334.015],[1201.27,435.627],[1201.27,336.488]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[1278.15,552.83],[1278.15,452.482],[1201.27,552.666],[1201.27,453.528]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[1278.15,567.313],[1278.15,667.661],[1201.27,566.975],[1201.27,666.114]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[1278.15,682.753],[1278.15,783.1],[1201.27,681.023],[1201.27,780.162]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[1276.77,802.101],[1276.77,902.609],[1200.11,798.942],[1200.11,898.242]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[1243.37,327.838],[1243.37,233.664],[1295.05,337.207],[1295.05,247.209]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[1276.77,802.101],[1276.77,902.609],[1306.01,788.552],[1306.01,883.879]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[1278.15,434.363],[1278.15,334.015],[1344.49,438.909],[1344.49,342.911]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[1278.15,552.83],[1278.15,452.482],[1344.49,552.242],[1344.49,456.243]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[1278.15,567.313],[1278.15,667.661],[1344.49,566.097],[1344.49,662.096]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[1278.15,682.753],[1278.15,783.1],[1344.49,676.533],[1344.49,772.531]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[1295.06,337.207],[1295.06,247.209],[1324.41,348.01],[1324.41,262.823]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[1322.18,789.181],[1306.01,788.552],[1322.18,884.749],[1306.01,883.879]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[1322.18,789.181],[1322.18,884.749],[1348.39,776.632],[1348.39,867.4]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[1324.41,348.01],[1324.41,262.823],[1327.89,356.982],[1327.89,275.792]]
                },{
                    num:"506",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[1327.56,442.848],[1327.56,347.613],[1399.56,456.286],[1399.56,374.326]]
                },{
                    num:"406",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[1327.56,555.279],[1327.56,460.044],[1399.56,553.045],[1399.56,471.085]]
                },{
                    num:"306",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[1327.56,569.025],[1327.56,664.26],[1399.56,564.875],[1399.56,646.835]]
                },{
                    num:"206",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[1327.56,678.582],[1327.56,773.817],[1399.56,659.161],[1399.56,741.121]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[1374.72,764.039],[1374.72,849.992],[1396.03,753.835],[1396.03,835.887]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:40,
                    verts:[[1381.68,753.362],[1381.68,835.232],[1401.28,744.285],[1401.28,822.685]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[586.342,445.284],[586.343,355.385],[522.078,446.087],[522.078,356.955]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[586.342,551.416],[586.343,461.517],[522.078,551.312],[522.078,462.181]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[586.343,564.392],[586.342,654.291],[522.078,564.177],[522.078,653.308]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[586.343,667.811],[586.342,757.71],[522.078,666.713],[522.078,755.844]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[587.383,774.412],[587.383,864.331],[523.364,772.411],[523.364,861.566]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[570.301,788.088],[570.301,883.237],[529.353,786.731],[529.353,881.361]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[570.86,439.854],[570.86,344.759],[531.393,440.376],[531.393,345.782]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[570.86,552.119],[570.86,457.025],[531.393,552.051],[531.393,457.457]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[570.86,565.844],[570.86,660.939],[531.393,565.704],[531.393,660.299]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[570.86,675.24],[570.86,770.335],[531.393,674.525],[531.393,769.12]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[580.902,434.449],[580.902,334.182],[543.208,437.279],[543.208,339.721]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[580.902,552.819],[580.902,452.553],[543.208,552.452],[543.208,454.895]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[580.902,567.29],[580.902,667.557],[543.208,566.533],[543.208,664.091]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[580.902,682.636],[580.902,782.902],[543.208,678.763],[543.208,776.32]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[581.42,801.341],[581.42,901.559],[543.968,794.223],[543.968,891.718]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[819.852,431.118],[819.852,327.665],[580.902,434.448],[580.902,334.182]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[819.852,553.25],[819.852,449.797],[580.902,552.819],[580.902,452.553]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[819.852,568.182],[819.852,671.634],[580.902,567.29],[580.902,667.556]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[819.852,687.193],[819.852,790.645],[580.902,682.636],[580.902,782.902]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[820.265,809.667],[820.265,913.067],[581.419,801.341],[581.419,901.558]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[620.784,329.567],[620.784,236.165],[615.15,337],[615.15,246.91]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[649.221,323.215],[649.221,226.984],[620.784,329.567],[620.784,236.165]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[702.484,321.698],[702.484,224.792],[649.222,323.215],[649.222,226.984]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[737.109,315.482],[737.109,215.807],[688.242,318.388],[688.242,220.006]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[773.864,313.496],[773.864,212.936],[737.109,315.482],[737.109,215.807]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[831.745,310.887],[831.745,209.165],[773.864,313.496],[773.864,212.936]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[1076,427.547],[1076,320.678],[821.27,431.098],[821.27,327.626]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[1076,553.712],[1076,446.844],[821.27,553.253],[821.27,449.781]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[1076,569.137],[1076,676.005],[821.27,568.187],[821.27,671.658]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[1076,692.077],[1076,798.946],[821.27,687.22],[821.27,790.691]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[1076.63,819.118],[1076.63,926.132],[821.544,810.21],[821.544,913.818]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[901.004,309.774],[901.004,207.556],[836.244,310.755],[836.244,208.974]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[945.395,309.409],[901.004,309.774],[945.395,207.029],[901.004,207.556]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[1007.68,309.136],[945.396,309.409],[1007.68,206.633],[945.396,207.029]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[1007.68,309.136],[1007.68,206.634],[1017.52,312.728],[1017.52,211.825]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[1076.1,311.06],[1076.1,209.414],[1017.52,312.728],[1017.52,211.825]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[1076.1,311.06],[1076.1,209.414],[1147.24,314.962],[1147.24,215.055]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[1076,427.547],[1076,320.678],[1154.71,428.944],[1154.71,323.411]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[1076,553.712],[1076,446.844],[1154.71,553.531],[1154.71,447.999]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[1076,569.137],[1076,676.005],[1154.71,568.763],[1154.71,674.296]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[1076,692.077],[1076,798.946],[1154.71,690.167],[1154.71,795.699]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[1076.63,819.118],[1076.63,926.132],[1155.47,815.56],[1155.47,921.214]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[1147.24,314.962],[1147.24,215.055],[1205.84,321.183],[1205.84,224.046]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[1154.71,428.944],[1154.71,323.411],[1167.89,431.95],[1167.89,329.294]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[1154.71,553.531],[1154.71,447.999],[1167.89,553.142],[1167.89,450.486]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[1154.71,568.763],[1154.71,674.296],[1167.89,567.959],[1167.89,670.615]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[1154.71,690.167],[1154.71,795.699],[1167.89,686.053],[1167.89,788.709]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[1155.47,815.56],[1155.47,921.214],[1168.04,808.37],[1168.04,911.274]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[1214.39,431.335],[1214.39,328.09],[1167.89,431.95],[1167.89,329.294]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[1214.39,553.222],[1214.39,449.977],[1167.89,553.142],[1167.89,450.486]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[1214.39,568.123],[1214.39,671.368],[1167.89,567.959],[1167.89,670.615]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[1214.39,686.895],[1167.89,686.053],[1214.39,790.14],[1167.89,788.709]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[1216.4,809.975],[1168.04,808.37],[1216.4,913.494],[1168.04,911.274]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[1205.83,321.183],[1205.83,224.046],[1268.01,330.658],[1268.01,237.742]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[1214.39,431.335],[1214.4,328.09],[1237.26,437.155],[1237.26,339.478]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[1214.39,553.222],[1214.4,449.977],[1237.26,552.469],[1237.26,454.792]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[1214.4,568.123],[1214.39,671.368],[1237.26,566.566],[1237.26,664.243]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[1214.4,686.895],[1214.39,790.14],[1237.26,678.933],[1237.26,776.609]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[1216.4,809.975],[1216.4,913.494],[1240.7,794.385],[1240.7,891.943]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[1314.5,436.19],[1314.5,337.591],[1237.26,437.155],[1237.26,339.478]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[1314.5,552.593],[1314.5,453.994],[1237.26,552.469],[1237.26,454.792]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[1314.5,566.824],[1314.5,665.424],[1237.26,566.566],[1237.26,664.243]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[1314.5,680.252],[1314.5,778.852],[1237.26,678.933],[1237.26,776.609]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[1313.52,797.53],[1236.48,795.118],[1313.52,896.289],[1236.48,892.956]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[1267.2,331.152],[1267.2,238.454],[1308.11,340.641],[1308.11,252.171]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[1308.11,340.641],[1308.11,252.171],[1325.93,351.358],[1325.93,267.662]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[1313.52,797.53],[1313.52,896.289],[1330.41,784.098],[1330.41,877.722]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[1314.5,436.19],[1314.5,337.591],[1369.03,440.836],[1369.03,346.681]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[1314.5,552.593],[1314.5,453.994],[1369.03,551.992],[1369.03,457.837]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[1314.5,566.824],[1314.5,665.424],[1369.03,565.582],[1369.03,659.736]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[1314.5,680.253],[1314.5,778.852],[1369.03,673.896],[1369.03,768.051]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[1346.56,784.576],[1330.41,784.098],[1346.56,878.383],[1330.41,877.722]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[1346.56,784.576],[1346.56,878.383],[1361.33,772.161],[1361.33,861.22]]
                },{
                    num:"506",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[1351.03,444.639],[1351.03,351.172],[1391.36,457.92],[1391.36,377.573]]
                },{
                    num:"406",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[1351.03,554.982],[1351.03,461.515],[1391.36,552.774],[1391.36,472.427]]
                },{
                    num:"306",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[1351.03,568.472],[1351.03,661.938],[1391.36,564.37],[1391.36,644.717]]
                },{
                    num:"206",
                    tipo:"TorreD",
                    frame:41,
                    verts:[[1351.03,675.995],[1351.03,769.461],[1391.36,656.8],[1391.36,737.147]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[605.315,444.505],[605.316,353.861],[538.012,445.101],[538.012,355.025]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[605.315,551.517],[605.316,460.872],[538.012,551.44],[538.012,461.365]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[605.316,564.6],[605.315,655.245],[538.012,564.441],[538.012,654.516]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[605.316,668.877],[605.315,759.521],[538.012,668.062],[538.012,758.137]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[606.422,776.352],[606.422,867.014],[539.379,774.869],[539.379,864.963]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[601.128,790.177],[601.128,886.125],[558.2,789.171],[558.2,884.734]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[601.57,439.021],[601.57,343.129],[560.199,439.408],[560.2,343.887]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[601.57,552.227],[601.57,456.335],[560.199,552.177],[560.2,456.656]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[601.57,566.067],[601.57,661.959],[560.2,565.964],[560.199,661.485]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[601.57,676.38],[601.57,772.272],[560.2,675.85],[560.199,771.371]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[623.726,433.653],[623.726,332.626],[579.111,436.349],[579.111,337.9]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[623.726,552.922],[623.726,451.895],[579.111,552.573],[579.111,454.125]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[623.726,567.503],[623.726,668.53],[579.111,566.782],[579.111,665.23]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[623.726,683.724],[623.726,784.751],[579.111,680.036],[579.111,778.484]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[624.138,803.327],[624.138,904.304],[579.74,796.545],[579.74,894.928]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[871.745,431.212],[871.745,327.85],[623.726,433.653],[623.726,332.626]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[871.745,553.238],[871.745,449.875],[623.726,552.922],[623.726,451.895]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[871.745,568.156],[871.745,671.519],[623.726,567.503],[623.726,668.53]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[871.745,687.063],[871.745,790.426],[623.726,683.724],[623.726,784.751]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[872.038,809.428],[872.038,912.737],[624.137,803.327],[624.137,904.303]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[648.383,328.141],[648.383,234.104],[635.034,335.528],[635.034,244.782]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[683.704,322.01],[683.704,225.242],[648.383,328.141],[648.383,234.104]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[739.047,320.896],[739.047,223.631],[683.705,322.01],[683.705,225.242]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[780.233,314.975],[780.233,215.073],[728.061,317.492],[728.061,218.712]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[819.148,313.285],[819.148,212.63],[780.233,314.975],[780.233,215.073]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[879.699,311.146],[879.699,209.538],[819.148,313.285],[819.148,212.63]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[1133.03,428.64],[1133.03,322.818],[873.204,431.198],[873.204,327.821]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[1133.03,553.571],[1133.03,447.748],[873.204,553.24],[873.204,449.863]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[1133.03,568.844],[1133.03,674.667],[873.204,568.16],[873.204,671.536]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[1133.03,690.582],[1133.03,796.404],[873.204,687.083],[873.204,790.459]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[1133.97,816.369],[1133.97,922.333],[873.786,809.955],[873.786,913.465]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[949.807,310.582],[884.324,311.05],[949.807,208.724],[884.324,209.4]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[949.807,310.582],[994.218,310.566],[949.807,208.724],[994.218,208.701]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[994.219,310.566],[1056.06,310.779],[994.219,208.701],[1056.06,209.008]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[1056.06,310.779],[1056.06,209.008],[1062.19,314.389],[1062.19,214.227]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[1121.5,313.195],[1062.19,314.389],[1121.5,212.501],[1062.19,214.227]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[1121.5,313.195],[1121.5,212.501],[1187.35,317.561],[1187.35,218.811]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[1133.03,428.641],[1133.03,322.818],[1207.1,430.301],[1207.1,326.066]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[1133.03,553.571],[1133.03,447.748],[1207.1,553.356],[1207.1,449.121]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[1133.03,568.844],[1133.03,674.667],[1207.1,568.4],[1207.1,672.635]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[1133.03,690.582],[1133.03,796.404],[1207.1,688.31],[1207.1,792.545]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[1133.97,816.369],[1133.97,922.333],[1208.11,812.152],[1208.11,916.502]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[1187.35,317.561],[1187.35,218.811],[1238.4,324.084],[1238.4,228.24]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[1207.1,430.301],[1207.1,326.066],[1213.6,433.292],[1213.6,331.919]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[1207.1,553.356],[1207.1,449.121],[1213.6,552.969],[1213.6,451.596]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[1207.1,568.4],[1207.1,672.635],[1213.6,567.6],[1213.6,668.973]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[1207.1,688.31],[1207.1,792.545],[1213.6,684.218],[1213.6,785.591]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[1208.11,812.152],[1208.11,916.502],[1214.29,804.999],[1214.29,906.614]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[1260.21,432.855],[1213.6,433.292],[1260.21,331.065],[1213.6,331.919]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[1260.21,553.025],[1260.21,451.235],[1213.6,552.969],[1213.6,451.596]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[1260.21,567.717],[1260.21,669.507],[1213.6,567.6],[1213.6,668.973]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[1260.21,684.815],[1213.6,684.218],[1260.21,786.605],[1213.6,785.591]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[1262.76,806.137],[1214.29,804.999],[1262.76,908.187],[1214.29,906.614]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[1238.4,324.084],[1238.4,228.24],[1289.56,333.79],[1289.56,242.27]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[1260.21,432.855],[1260.21,331.065],[1270.17,438.624],[1270.17,342.353]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[1260.21,553.025],[1260.21,451.235],[1270.17,552.278],[1270.17,456.007]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[1260.21,567.717],[1260.21,669.507],[1270.17,566.173],[1270.17,662.444]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[1260.21,684.815],[1260.21,786.605],[1270.17,676.923],[1270.17,773.194]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[1262.76,806.137],[1262.76,908.187],[1273.25,790.688],[1273.25,886.831]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[1347.09,437.944],[1270.17,438.624],[1347.09,341.022],[1270.17,342.353]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[1347.09,552.366],[1347.09,455.444],[1270.17,552.278],[1270.17,456.007]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[1347.09,566.355],[1347.09,663.277],[1270.17,566.173],[1270.17,662.444]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[1347.09,677.853],[1270.17,676.923],[1347.09,774.775],[1270.17,773.194]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[1346.49,793.14],[1269.77,791.44],[1346.49,890.221],[1269.77,887.87]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[1288.3,334.267],[1288.3,242.957],[1318.67,343.814],[1318.67,256.758]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[1318.67,343.814],[1318.67,256.758],[1325.46,354.397],[1325.46,272.055]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[1347.09,437.944],[1347.09,341.022],[1390.01,442.651],[1390.01,350.233]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[1347.09,552.366],[1347.09,455.444],[1390.01,551.757],[1390.01,459.339]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[1347.09,566.355],[1347.09,663.277],[1390.01,565.096],[1390.01,657.514]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[1347.09,677.853],[1347.09,774.775],[1390.01,671.413],[1390.01,763.831]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[1346.49,793.14],[1346.49,890.221],[1351.57,779.903],[1351.57,871.923]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[1367.57,780.24],[1351.57,779.903],[1367.57,872.388],[1351.57,871.923]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:42,
                    verts:[[1367.57,780.24],[1367.57,872.388],[1371.44,768.02],[1371.44,855.496]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[626.468,443.661],[626.469,352.21],[556.538,444.04],[556.538,352.95]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[626.468,551.626],[626.469,460.174],[556.538,551.577],[556.538,460.487]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[626.469,564.826],[626.468,656.278],[556.538,564.724],[556.538,655.815]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[626.469,670.031],[626.468,761.483],[556.538,669.514],[556.538,760.604]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[627.634,778.455],[627.634,869.921],[557.98,777.512],[557.98,868.617]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[634.392,792.355],[634.392,889.136],[589.798,791.717],[589.798,888.254]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[634.711,438.152],[634.711,341.429],[591.739,438.398],[591.74,341.91]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[634.711,552.339],[634.711,455.617],[591.739,552.308],[591.74,455.82]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[634.711,566.3],[634.711,663.023],[591.74,566.234],[591.739,662.722]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[634.711,677.569],[634.711,774.292],[591.74,677.233],[591.739,773.72]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[668.991,432.856],[668.991,331.066],[617.739,435.395],[617.739,336.035]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[668.991,553.025],[668.991,451.235],[617.739,552.696],[617.739,453.336]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[668.991,567.717],[668.991,669.507],[617.739,567.037],[617.739,666.398]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[668.991,684.815],[668.991,786.605],[617.739,681.34],[617.739,780.701]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[669.293,805.318],[669.293,907.056],[618.231,798.924],[618.231,898.217]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[656.899,333.923],[656.899,242.462],[647.071,344.001],[647.071,257.028]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[677.981,326.623],[677.981,231.91],[656.899,333.923],[656.899,242.462]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[923.725,431.326],[923.725,328.072],[668.991,432.856],[668.991,331.066]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[923.725,553.223],[923.725,449.969],[668.991,553.025],[668.991,451.235]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[923.725,568.126],[923.725,671.38],[668.991,567.716],[668.991,669.506]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[923.725,686.908],[923.725,790.162],[668.991,684.815],[668.991,786.605]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[923.898,809.142],[923.898,912.342],[669.292,805.318],[669.292,907.056]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[719.98,320.752],[719.98,223.424],[677.98,326.623],[677.98,231.91]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[776.948,320.051],[776.948,222.411],[719.981,320.752],[719.981,223.424]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[824.348,314.463],[824.348,214.333],[769.334,316.575],[769.334,217.386]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[865.062,313.079],[865.062,212.332],[824.348,314.463],[824.348,214.333]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[927.699,311.419],[927.699,209.934],[865.062,313.079],[865.062,212.332]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[1187.42,429.742],[1187.42,324.973],[925.211,431.317],[925.211,328.054]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[1187.42,553.428],[1187.42,448.659],[925.211,553.224],[925.211,449.962]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[1187.42,568.55],[1187.42,673.319],[925.211,568.128],[925.211,671.391]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[1187.42,689.075],[1187.42,793.844],[925.211,686.92],[925.211,790.182]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[1188.66,813.599],[1188.66,918.503],[926.095,809.648],[926.095,913.042]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[932.405,311.36],[997.981,311.4],[932.405,209.848],[997.981,209.906]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[997.981,311.4],[1041.99,311.725],[997.981,209.906],[1041.99,210.375]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[1041.99,311.725],[1102.82,312.406],[1041.99,210.375],[1102.82,211.361]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[1102.82,312.406],[1102.82,211.361],[1105.27,316.013],[1105.27,216.574]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[1164.74,315.282],[1105.27,316.013],[1164.74,215.516],[1105.27,216.574]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[1164.74,315.282],[1164.74,215.516],[1224.89,320.062],[1224.89,222.426]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[1187.42,429.742],[1187.42,324.973],[1256.28,431.641],[1256.28,328.688]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[1187.42,553.428],[1187.42,448.659],[1256.28,553.182],[1256.28,450.23]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[1187.42,568.55],[1187.42,673.319],[1256.28,568.042],[1256.28,670.994]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[1187.42,689.075],[1187.42,793.844],[1256.28,686.477],[1256.28,789.43]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[1188.66,813.599],[1188.66,918.503],[1257.52,808.784],[1257.52,911.847]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[1224.89,320.062],[1224.89,222.426],[1268.27,326.832],[1268.27,232.212]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[1256.3,434.597],[1302.58,434.333],[1256.3,334.474],[1302.58,333.956]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[1256.3,552.8],[1302.58,552.834],[1256.3,452.676],[1302.58,452.457]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[1256.3,567.251],[1302.58,567.321],[1256.3,667.374],[1302.58,667.698]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[1256.3,682.432],[1302.58,682.794],[1256.3,782.555],[1302.58,783.171]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[1257.51,801.714],[1305.63,802.404],[1257.51,902.073],[1305.63,903.027]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[1268.27,326.832],[1268.27,232.212],[1308.51,336.701],[1308.51,246.477]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[1300.12,440.017],[1376.09,439.607],[1300.12,345.079],[1376.1,344.275]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[1300.12,552.098],[1300.12,457.16],[1376.09,552.151],[1376.1,456.82]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[1300.12,565.801],[1376.1,565.911],[1300.12,660.739],[1376.09,661.242]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[1300.12,675.017],[1376.1,675.579],[1300.12,769.955],[1376.09,770.91]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[1300.08,787.949],[1375.86,788.976],[1300.08,883.045],[1375.86,884.465]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[1306.81,337.16],[1306.81,247.138],[1326.95,346.711],[1326.95,260.946]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[1376.09,439.607],[1376.1,344.275],[1407.69,444.343],[1407.69,353.544]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[1376.09,552.151],[1376.1,456.82],[1407.69,551.538],[1407.69,460.738]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[1376.1,565.911],[1376.09,661.242],[1407.69,564.643],[1407.69,655.443]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[1376.1,675.579],[1376.09,770.91],[1407.69,669.098],[1407.69,759.898]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:43,
                    verts:[[1369.69,775.997],[1385.44,776.2],[1369.69,866.523],[1385.44,866.803]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[577.62,442.895],[577.62,350.709],[566.251,447.613],[566.251,359.941]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[577.62,551.726],[577.62,459.54],[566.251,551.115],[566.251,463.443]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[577.62,565.031],[577.62,657.217],[566.251,563.768],[566.251,651.44]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[577.62,671.081],[577.62,763.266],[566.251,664.625],[566.251,752.297]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[579.128,780.366],[579.128,872.562],[567.402,767.882],[567.402,855.305]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[649.743,442.743],[649.744,350.413],[577.62,442.895],[577.62,350.709]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[649.743,551.745],[649.744,459.415],[577.62,551.726],[577.62,459.54]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[649.744,565.071],[649.743,657.402],[577.62,565.031],[577.62,657.217]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[649.744,671.287],[649.743,763.618],[577.62,671.08],[577.62,763.266]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[650.959,780.743],[650.959,873.083],[579.128,780.366],[579.128,872.562]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[669.979,794.646],[624.052,794.392],[669.979,892.303],[624.052,891.951]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[670.171,437.238],[670.171,339.64],[625.917,437.336],[625.918,339.831]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[670.171,552.458],[670.171,454.86],[625.917,552.445],[625.918,454.941]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[670.171,566.544],[670.171,664.142],[625.918,566.518],[625.917,664.022]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[670.171,678.82],[670.171,776.417],[625.918,678.686],[625.917,776.19]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[652.404,342.676],[652.404,255.112],[650.96,352.098],[650.96,268.732]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[716.502,432.047],[716.502,329.483],[658.951,434.41],[658.951,334.107]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[716.502,553.13],[716.502,450.566],[658.951,552.824],[658.951,452.521]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[716.502,567.933],[716.502,670.497],[658.951,567.301],[658.951,667.604]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[716.502,685.922],[716.502,788.486],[658.951,682.688],[658.951,782.991]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[716.688,807.34],[716.688,909.85],[659.296,801.384],[659.296,901.617]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[680.682,332.166],[680.682,239.921],[660.448,342.217],[660.448,254.45]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[709.478,324.992],[709.478,229.553],[680.682,332.166],[680.682,239.921]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[757.913,319.419],[757.913,221.497],[709.477,324.993],[709.477,229.553]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[975.568,431.444],[975.568,328.304],[716.502,432.046],[716.502,329.482]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[975.568,553.208],[975.568,450.068],[716.502,553.13],[716.502,450.566]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[975.568,568.094],[975.568,671.234],[716.502,567.933],[716.502,670.497]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[975.568,686.746],[975.568,789.886],[716.502,685.922],[716.502,788.486]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[975.619,808.845],[975.619,911.931],[716.687,807.339],[716.687,909.85]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[816.039,319.142],[757.914,319.419],[816.039,221.097],[757.914,221.497]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[869.267,313.921],[869.267,213.549],[811.887,315.612],[811.887,215.995]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[911.414,312.852],[911.414,212.004],[869.267,313.921],[869.267,213.549]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[975.552,311.68],[975.552,210.31],[911.414,312.851],[911.414,212.004]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[977.065,431.441],[1239.08,430.832],[977.065,328.297],[1239.08,327.106]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[977.065,553.208],[977.065,450.065],[1239.08,553.287],[1239.08,449.561]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[977.065,568.095],[977.065,671.238],[1239.08,568.258],[1239.08,671.984]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[977.065,686.75],[1239.08,687.584],[977.065,789.894],[1239.08,791.31]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[978.24,809.328],[1240.58,810.855],[978.24,912.598],[1240.58,914.71]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[980.294,311.656],[1045.36,312.197],[980.294,210.277],[1045.36,211.058]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[1045.36,312.197],[1088.56,312.853],[1045.36,211.058],[1088.56,212.006]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[1088.56,312.853],[1088.56,212.006],[1147.85,313.987],[1147.85,213.645]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[1146.69,317.568],[1205.8,317.286],[1146.69,218.821],[1205.8,218.414]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[1205.8,317.286],[1205.8,218.414],[1259.91,322.435],[1259.91,225.856]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[1239.08,430.832],[1239.08,327.106],[1302.24,432.946],[1302.24,331.242]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[1239.08,553.287],[1239.08,449.561],[1302.24,553.013],[1302.24,451.31]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[1239.08,568.258],[1239.08,671.984],[1302.24,567.693],[1302.24,669.396]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[1239.08,687.584],[1239.08,791.31],[1302.24,684.692],[1302.24,786.396]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[1240.58,810.855],[1240.58,914.71],[1303.69,805.503],[1303.69,907.311]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[1259.91,322.435],[1259.91,225.856],[1295.54,329.403],[1295.54,235.928]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[1295.54,329.403],[1295.54,235.928],[1325,339.375],[1325,250.341]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[1296.03,435.852],[1341.58,435.751],[1296.03,336.928],[1341.58,336.731]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[1296.03,552.637],[1296.03,453.714],[1341.58,552.65],[1341.58,453.63]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[1296.03,566.915],[1296.03,665.839],[1341.58,566.942],[1341.58,665.962]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[1296.03,680.716],[1341.58,680.854],[1296.03,779.639],[1341.58,779.874]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[1297.72,798.554],[1345.08,798.817],[1297.72,897.706],[1345.08,898.069]]
                },{
                    num:"606",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[1322.91,339.814],[1322.91,250.975],[1333.1,349.326],[1333.1,264.725]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[1327.22,441.324],[1327.22,347.635],[1401.72,441.168],[1401.72,347.33]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[1327.22,551.929],[1327.22,458.24],[1401.72,551.949],[1401.72,458.111]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[1327.22,565.451],[1327.22,659.14],[1401.72,565.493],[1401.72,659.331]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[1327.22,673.23],[1327.22,766.918],[1401.72,673.443],[1401.72,767.281]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[1327.53,784.673],[1401.84,785.064],[1327.53,878.517],[1401.84,879.057]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[1401.72,441.168],[1401.72,347.33],[1422.32,445.906],[1422.32,356.602]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[1401.72,551.949],[1401.72,458.111],[1422.32,551.336],[1422.32,462.031]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[1401.72,565.493],[1401.72,659.331],[1422.32,564.225],[1422.32,653.529]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:44,
                    verts:[[1401.72,673.443],[1401.72,767.281],[1422.32,666.96],[1422.32,756.264]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[601.266,441.658],[601.266,348.288],[579.307,446.386],[579.307,357.541]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[601.266,551.886],[601.266,458.517],[579.307,551.274],[579.307,462.428]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[601.266,565.362],[601.266,658.731],[579.307,564.097],[579.307,652.942]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[601.266,672.773],[601.266,766.142],[579.307,666.304],[579.307,755.149]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[602.831,783.448],[602.831,876.824],[579.916,770.936],[579.916,859.527]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[675.12,441.744],[675.121,348.458],[601.266,441.658],[601.266,348.288]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[675.12,551.875],[675.121,458.588],[601.266,551.886],[601.266,458.517]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[675.121,565.339],[675.12,658.625],[601.266,565.362],[601.266,658.731]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[675.121,672.654],[675.12,765.941],[601.266,672.773],[601.266,766.142]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[676.382,783.233],[602.832,783.448],[676.382,876.525],[602.832,876.824]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[666.96,340.626],[666.96,252.148],[655.915,350.109],[655.915,265.857]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[707.816,797.066],[660.908,797.211],[707.816,895.648],[660.908,895.849]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[707.876,436.272],[662.68,436.216],[707.876,337.75],[662.68,337.64]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[707.876,552.583],[707.876,454.061],[662.68,552.59],[662.68,454.015]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[707.876,566.803],[707.876,665.324],[662.68,566.818],[662.68,665.393]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[707.876,680.141],[662.68,680.218],[707.876,778.663],[662.68,778.793]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[706.355,330.24],[706.355,237.138],[675.602,340.218],[675.602,251.56]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[766.104,431.22],[766.104,327.865],[702.646,433.387],[702.646,332.105]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[766.104,553.237],[766.104,449.882],[702.646,552.956],[702.646,451.675]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[766.104,568.154],[766.104,671.509],[702.646,567.574],[702.646,668.856]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[766.104,687.053],[766.104,790.408],[702.646,684.088],[702.646,785.37]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[766.172,809.406],[766.172,912.707],[702.838,803.939],[702.838,905.15]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[742.812,323.235],[742.812,227.013],[706.355,330.24],[706.355,237.138]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[797.399,317.998],[797.399,219.443],[742.81,323.235],[742.81,227.013]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[766.104,431.22],[1027.09,431.559],[766.104,327.865],[1027.09,328.529]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[766.104,553.237],[1027.09,553.193],[766.104,449.882],[1027.09,450.163]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[766.104,568.154],[1027.09,568.063],[766.104,671.509],[1027.09,671.094]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[766.104,687.053],[1027.09,686.589],[766.104,790.408],[1027.09,789.619]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[766.171,809.406],[1027.02,808.558],[766.171,912.707],[1027.02,911.534]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[856.205,318.155],[797.399,317.998],[856.205,219.67],[797.399,219.443]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[914.843,313.334],[914.843,212.701],[855.587,314.59],[855.587,214.517]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[958.046,312.587],[914.843,313.334],[958.046,211.622],[914.843,212.701]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[1023.1,311.908],[958.046,312.587],[1023.1,210.64],[958.046,211.622]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[1027.84,311.921],[1027.84,210.659],[1091.8,312.953],[1091.8,212.15]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[1028.58,431.561],[1028.58,328.533],[1287.92,431.898],[1287.92,329.193]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[1028.58,553.193],[1028.58,450.164],[1287.92,553.149],[1287.92,450.443]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[1028.58,568.063],[1028.58,671.091],[1287.92,567.973],[1287.92,670.678]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[1028.58,686.586],[1028.58,789.614],[1287.92,686.124],[1287.92,788.83]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[1030.03,809.015],[1030.03,912.166],[1289.68,808.169],[1289.68,910.996]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[1091.8,312.953],[1091.8,212.15],[1133.82,313.93],[1133.82,213.563]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[1133.82,313.93],[1133.82,213.563],[1191.06,315.498],[1191.06,215.829]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[1186.38,319.035],[1244.63,319.19],[1186.38,220.942],[1244.63,221.166]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[1244.63,319.19],[1244.63,221.166],[1292.43,324.664],[1292.43,229.079]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[1287.92,431.898],[1287.92,329.193],[1344.99,434.205],[1344.99,333.706]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[1287.92,553.149],[1287.92,450.443],[1344.99,552.85],[1344.99,452.351]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[1287.92,567.973],[1287.92,670.678],[1344.99,567.356],[1344.99,667.855]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[1287.92,686.124],[1287.92,788.83],[1344.99,682.969],[1344.99,783.468]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[1289.68,808.169],[1289.68,910.996],[1346.64,802.335],[1346.64,902.932]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[1292.43,324.664],[1292.43,229.079],[1320.3,331.784],[1320.3,239.37]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[1320.3,331.784],[1320.3,239.37],[1339.15,341.806],[1339.15,253.856]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[1332.81,437.046],[1332.81,339.265],[1377.28,437.101],[1377.28,339.373]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[1332.81,552.483],[1332.81,454.702],[1377.28,552.476],[1377.28,454.747]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[1332.81,566.596],[1332.81,664.377],[1377.28,566.581],[1377.28,664.309]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[1332.81,679.082],[1332.81,776.863],[1377.28,679.007],[1377.28,776.735]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[1334.96,795.543],[1381.19,795.4],[1334.96,893.544],[1381.19,893.345]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[1351.59,442.537],[1351.59,350.01],[1424.12,442.623],[1424.12,350.176]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[1351.59,551.772],[1351.59,459.244],[1424.12,551.761],[1424.12,459.315]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[1351.59,565.126],[1351.59,657.654],[1424.12,565.104],[1424.12,657.55]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[1351.59,671.569],[1351.59,764.096],[1424.12,671.453],[1424.12,763.899]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[1352.23,781.628],[1352.23,874.307],[1424.58,781.415],[1424.58,874.013]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[1424.12,442.623],[1424.12,350.176],[1434.06,447.34],[1434.06,359.406]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[1424.12,551.761],[1424.12,459.315],[1434.06,551.15],[1434.06,463.217]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[1424.12,565.104],[1424.12,657.55],[1434.06,563.842],[1434.06,651.775]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:45,
                    verts:[[1424.12,671.453],[1424.12,763.899],[1434.06,664.999],[1434.06,752.932]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[627.528,440.325],[627.528,345.681],[594.73,445.04],[594.73,354.907]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[627.528,552.058],[627.528,457.414],[594.73,551.448],[594.73,461.315]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[627.528,565.718],[627.528,660.363],[594.73,564.457],[594.73,654.59]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[627.528,674.596],[627.528,769.24],[594.73,668.145],[594.73,758.278]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[629.141,786.77],[629.141,881.415],[594.771,774.29],[594.771,864.163]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[702.621,440.66],[627.528,440.325],[702.621,346.337],[627.528,345.681]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[702.621,552.015],[702.621,457.692],[627.528,552.058],[627.528,457.414]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[702.621,565.629],[627.528,565.718],[702.621,659.952],[627.528,660.363]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[702.621,674.137],[627.528,674.596],[702.621,768.46],[627.528,769.24]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[703.917,785.934],[629.141,786.77],[703.917,880.259],[629.141,881.415]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[683.368,338.346],[683.368,248.853],[662.491,347.852],[662.491,262.595]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[733.925,328.141],[733.925,234.103],[692.571,337.993],[692.571,248.344]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[700.351,800.18],[747.865,799.618],[700.351,899.954],[747.865,899.177]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[702.011,435.036],[747.789,435.252],[702.013,335.332],[747.789,335.755]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[702.011,552.743],[747.789,552.715],[702.013,453.039],[747.789,453.218]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[702.013,567.133],[747.789,567.075],[702.011,666.837],[747.789,666.573]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[702.013,681.832],[747.789,681.536],[702.011,781.536],[747.789,781.033]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[777.953,321.346],[777.953,224.283],[733.925,328.141],[733.925,234.103]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[748.76,432.325],[748.76,330.027],[747.789,435.252],[747.789,335.755]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[748.76,553.094],[748.76,450.796],[747.789,552.715],[747.789,453.218]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[748.76,567.859],[748.76,670.156],[747.789,567.075],[747.789,666.573]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[748.76,685.541],[748.76,787.839],[747.789,681.536],[747.789,781.033]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[748.793,806.593],[748.793,908.819],[747.866,799.618],[747.866,899.177]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[817.677,430.374],[817.677,326.21],[748.76,432.325],[748.76,330.027]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[817.677,553.346],[817.677,449.182],[748.76,553.094],[748.76,450.796]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[817.677,568.38],[817.677,672.544],[748.76,567.859],[748.76,670.156]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[817.677,688.21],[817.677,792.373],[748.76,685.541],[748.76,787.839]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[817.621,811.52],[817.621,915.629],[748.793,806.593],[748.793,908.819]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[838.367,316.485],[838.367,217.255],[777.952,321.346],[777.952,224.283]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[817.677,430.374],[817.677,326.21],[1078.12,431.667],[1078.12,328.739]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[817.677,553.346],[817.677,449.182],[1078.12,553.179],[1078.12,450.251]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[817.677,568.38],[817.677,672.544],[1078.12,568.035],[1078.12,670.962]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[817.677,688.209],[817.677,792.373],[1078.12,686.442],[1078.12,789.369]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[817.621,811.52],[817.621,915.629],[1077.93,808.29],[1077.93,911.164]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[838.367,316.485],[897.361,317.084],[838.367,217.255],[897.361,218.122]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[900.328,313.503],[900.328,212.946],[897.361,317.084],[897.361,218.122]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[960.951,312.696],[900.328,313.503],[960.951,211.779],[900.328,212.946]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[1004.83,312.279],[960.951,312.696],[1004.83,211.177],[960.951,211.779]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[1004.83,312.279],[1070.21,312.097],[1004.83,211.176],[1070.21,210.914]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[1074.89,312.147],[1074.89,210.985],[1137.19,313.66],[1137.19,213.172]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[1079.6,431.674],[1079.6,328.753],[1333.9,432.936],[1333.9,331.222]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[1079.6,553.178],[1079.6,450.257],[1333.9,553.015],[1333.9,451.301]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[1079.6,568.033],[1079.6,670.953],[1333.9,567.695],[1333.9,669.409]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[1079.6,686.432],[1079.6,789.352],[1333.9,684.705],[1333.9,786.419]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[1081.31,808.718],[1081.31,911.756],[1335.88,805.555],[1335.88,907.383]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[1137.19,313.66],[1137.19,213.172],[1177.67,314.948],[1177.67,215.035]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[1177.68,314.948],[1177.68,215.035],[1232.4,316.932],[1232.4,217.902]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[1224.29,320.406],[1224.29,222.923],[1281.23,320.984],[1281.23,223.76]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[1281.23,320.984],[1281.23,223.76],[1322.5,326.744],[1322.5,232.085]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[1322.5,326.744],[1322.5,232.085],[1342.62,333.974],[1342.62,242.535]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[1333.9,432.936],[1333.9,331.222],[1384.54,435.413],[1384.54,336.07]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[1333.9,553.015],[1333.9,451.301],[1384.54,552.694],[1384.54,453.351]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[1333.9,567.695],[1333.9,669.409],[1384.54,567.032],[1384.54,666.376]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[1333.9,684.705],[1333.9,786.419],[1384.54,681.316],[1384.54,780.659]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[1335.88,805.555],[1335.88,907.383],[1386.36,799.295],[1386.36,898.729]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[1342.62,333.974],[1342.62,242.535],[1351.07,343.998],[1351.07,257.024]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[1366.68,438.176],[1366.68,341.476],[1409.74,438.379],[1409.74,341.874]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[1366.68,552.336],[1366.68,455.636],[1409.74,552.31],[1409.74,455.805]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[1366.68,566.293],[1366.68,662.993],[1409.74,566.239],[1409.74,662.744]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[1366.68,677.536],[1366.68,774.236],[1409.74,677.258],[1409.74,773.763]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[1369.26,792.691],[1369.26,889.6],[1414.02,792.161],[1414.02,888.867]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[1373.3,443.658],[1373.3,352.203],[1443.43,443.971],[1443.43,352.816]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[1373.3,551.627],[1373.3,460.171],[1443.43,551.586],[1443.43,460.431]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[1373.3,564.827],[1373.3,656.282],[1443.43,564.743],[1443.43,655.898]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[1373.3,670.036],[1373.3,761.492],[1443.43,669.607],[1443.43,760.763]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:46,
                    verts:[[1374.26,778.814],[1374.26,870.417],[1444.2,778.031],[1444.2,869.334]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[656.482,438.896],[656.482,342.885],[612.624,443.572],[612.624,352.035]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[656.482,552.243],[656.482,456.232],[612.624,551.638],[612.624,460.1]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[656.482,566.101],[656.482,662.112],[612.624,564.85],[612.624,656.387]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[656.482,676.551],[656.482,772.562],[612.624,670.153],[612.624,761.691]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[658.132,790.331],[658.132,886.338],[612.073,777.952],[612.073,869.226]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[656.482,438.896],[732.276,439.493],[656.482,342.885],[732.277,344.052]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[656.482,552.243],[656.482,456.232],[732.276,552.166],[732.277,456.725]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[656.482,566.101],[656.482,662.112],[732.277,565.941],[732.276,661.382]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[656.482,676.551],[732.277,675.735],[656.482,772.562],[732.276,771.175]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[658.133,790.331],[733.599,788.845],[658.133,886.338],[733.599,884.284]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[670.756,345.32],[670.756,258.935],[663.072,355.788],[663.072,274.066]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[701.688,335.832],[701.688,245.22],[670.756,345.32],[670.756,258.935]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[763.413,325.867],[763.413,230.818],[711.409,335.539],[711.409,244.798]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[742.382,803.292],[742.382,904.255],[730.069,788.098],[730.069,883.251]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[743.911,433.799],[743.912,332.912],[732.276,439.493],[732.277,344.052]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[743.911,552.903],[743.912,452.016],[732.276,552.166],[732.277,456.725]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[743.912,567.464],[743.911,668.352],[732.277,565.941],[732.276,661.381]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[743.912,683.524],[743.911,784.411],[732.277,675.735],[732.276,771.175]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[742.38,803.292],[790.099,802.297],[742.38,904.255],[790.099,902.88]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[743.911,433.799],[789.883,434.182],[743.911,332.912],[789.883,333.661]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[743.911,552.903],[743.911,452.016],[789.883,552.853],[789.883,452.332]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[743.911,567.464],[743.911,668.351],[789.883,567.362],[789.883,667.883]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[743.911,683.524],[789.883,683],[743.911,784.411],[789.883,783.521]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[814.88,319.33],[814.88,221.368],[763.413,325.867],[763.413,230.818]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[797.234,431.228],[797.234,327.881],[789.883,434.182],[789.883,333.661]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[797.234,553.236],[797.234,449.889],[789.883,552.853],[789.883,452.332]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[797.234,568.152],[797.234,671.499],[789.883,567.362],[789.883,667.883]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[797.234,687.042],[797.234,790.388],[789.883,683],[789.883,783.521]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[797.102,809.335],[797.102,912.609],[790.1,802.297],[790.1,902.879]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[871.094,429.515],[871.094,324.529],[797.234,431.228],[797.234,327.881]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[871.094,553.458],[871.094,448.472],[797.234,553.236],[797.234,449.889]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[871.094,568.61],[871.094,673.596],[797.234,568.152],[797.234,671.499]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[871.094,689.385],[871.094,794.371],[797.234,687.042],[797.234,790.388]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[870.914,813.669],[870.914,918.6],[797.102,809.335],[797.102,912.609]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[880.747,314.884],[880.746,214.942],[814.879,319.33],[814.879,221.368]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[871.094,429.515],[871.094,324.529],[1128.49,431.768],[1128.49,328.938]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[871.094,553.458],[871.094,448.471],[1128.49,553.166],[1128.49,450.336]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[871.094,568.61],[871.094,673.596],[1128.49,568.007],[1128.49,670.838]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[871.094,689.385],[871.094,794.371],[1128.49,686.303],[1128.49,789.133]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[870.913,813.669],[870.913,918.6],[1128.18,808.037],[1128.18,910.815]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[880.747,314.884],[939.418,315.935],[880.747,214.942],[939.418,216.461]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[946.001,312.358],[946.001,211.291],[939.418,315.935],[939.418,216.461]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[1007.46,312.014],[946.001,312.358],[1007.46,210.793],[946.001,211.291]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[1007.46,312.014],[1051.61,311.933],[1007.46,210.793],[1051.61,210.676]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[1051.62,311.933],[1116.73,312.252],[1051.61,210.676],[1116.73,211.137]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[1121.33,312.337],[1121.33,211.26],[1181.39,314.32],[1181.39,214.127]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[1129.94,431.781],[1129.94,328.963],[1376.92,433.943],[1376.92,333.193]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[1129.94,553.164],[1129.94,450.346],[1376.92,552.884],[1376.92,452.135]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[1129.94,568.004],[1129.94,670.822],[1376.92,567.426],[1376.92,668.175]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[1129.94,686.285],[1129.94,789.103],[1376.92,683.327],[1376.92,784.077]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[1131.9,808.435],[1131.9,911.364],[1379.1,803.014],[1379.1,903.87]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[1181.39,314.32],[1181.39,214.127],[1220,315.909],[1220,216.423]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[1220,315.909],[1220,216.423],[1271.77,318.29],[1271.77,219.865]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[1260.35,321.684],[1260.35,224.77],[1315.53,322.672],[1315.53,226.199]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[1315.53,322.672],[1315.53,226.199],[1350.09,328.678],[1350.09,234.88]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[1350.09,328.677],[1350.09,234.879],[1362.51,335.979],[1362.51,245.433]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[1376.92,433.943],[1376.92,333.193],[1420.87,436.571],[1420.87,338.335]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[1376.92,552.884],[1376.92,452.135],[1420.87,552.544],[1420.87,454.308]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[1376.92,567.426],[1376.92,668.175],[1420.87,566.723],[1420.87,664.959]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[1376.92,683.327],[1376.92,784.077],[1420.87,679.732],[1420.87,777.968]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[1379.1,803.014],[1379.1,903.87],[1422.83,796.381],[1422.83,894.701]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[1397.64,439.243],[1397.64,343.564],[1439,439.588],[1439,344.238]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[1397.64,552.198],[1397.64,456.519],[1439,552.154],[1439,456.804]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[1397.64,566.008],[1397.64,661.687],[1439,565.916],[1439,661.265]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[1397.64,676.076],[1397.64,771.755],[1439,675.605],[1439,770.954]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[1400.61,789.993],[1400.61,885.871],[1443.58,789.096],[1443.58,884.631]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[1392.39,444.688],[1392.39,354.218],[1459.72,445.218],[1459.72,355.255]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[1392.39,551.493],[1392.39,461.024],[1459.72,551.425],[1459.72,461.462]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[1392.39,564.551],[1392.39,655.021],[1459.72,564.409],[1459.72,654.372]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[1392.39,668.627],[1392.39,759.096],[1459.72,667.902],[1459.72,757.865]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:47,
                    verts:[[1393.66,776.225],[1393.66,866.838],[1460.8,774.9],[1460.8,865.007]]
                },
                ],
                [
                {
                    num:"503",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[648.715,445.699],[648.715,353.28],[605.137,458.776],[605.137,379.276]]
                },{
                    num:"403",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[648.715,554.805],[648.715,462.387],[605.137,552.631],[605.137,473.131]]
                },{
                    num:"303",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[648.715,568.144],[648.715,660.563],[605.137,564.106],[605.137,643.606]]
                },{
                    num:"203",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[648.715,674.462],[648.715,766.881],[605.137,655.562],[605.137,735.063]]
                },{
                    num:"103",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[648.715,780.947],[648.715,873.366],[605.137,747.163],[605.137,826.663]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[689.912,794.12],[689.912,891.576],[631.969,781.92],[631.969,874.711]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[688.236,437.376],[688.236,339.91],[633.138,441.983],[633.138,348.925]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[688.236,552.44],[688.236,454.974],[633.138,551.844],[633.138,458.786]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[688.236,566.507],[688.236,663.973],[633.138,565.275],[633.138,658.332]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[688.236,678.631],[688.236,776.097],[633.138,672.327],[633.138,765.385]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[680.816,342.51],[680.816,254.873],[662.315,353.095],[662.315,270.174]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[722.012,333.09],[722.012,241.255],[680.816,342.51],[680.816,254.873]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[688.236,437.376],[688.236,339.91],[764.145,438.246],[764.145,341.612]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[688.236,552.44],[688.236,454.974],[764.145,552.327],[764.145,455.694]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[688.236,566.507],[688.236,663.973],[764.145,566.275],[764.145,662.908]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[688.236,678.631],[688.236,776.097],[764.145,677.441],[764.145,774.074]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[689.913,794.12],[765.485,791.953],[689.913,891.576],[765.485,888.581]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[794.859,323.432],[794.859,227.298],[732.204,332.861],[732.204,240.927]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[787.005,806.524],[787.005,908.723],[761.246,791.226],[761.246,887.576]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[788.386,432.514],[788.387,330.397],[764.145,438.246],[764.145,341.612]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[788.386,553.069],[788.387,450.952],[764.145,552.327],[764.145,455.694]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[788.387,567.808],[788.386,669.925],[764.145,566.275],[764.145,662.908]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[788.387,685.282],[788.386,787.399],[764.145,677.441],[764.145,774.074]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[787.004,806.524],[834.494,805.08],[787.004,908.723],[834.494,906.727]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[788.385,432.514],[788.386,330.397],[834.136,433.069],[834.136,331.484]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[788.385,553.069],[788.386,450.952],[834.136,552.997],[834.136,451.412]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[788.386,567.808],[788.385,669.925],[834.136,567.659],[834.136,669.245]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[788.386,685.282],[788.385,787.399],[834.136,684.522],[834.136,786.107]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[853.579,317.201],[853.579,218.291],[794.859,323.432],[794.859,227.298]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[848.009,430.107],[848.009,325.687],[834.136,433.069],[834.136,331.484]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[848.009,553.381],[848.009,448.961],[834.136,552.997],[834.136,451.412]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[848.009,568.452],[848.009,672.872],[834.136,567.659],[834.136,669.245]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[848.009,688.576],[848.009,792.995],[834.136,684.522],[834.136,786.108]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[847.708,812.14],[847.708,916.486],[834.495,805.08],[834.495,906.727]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[925.918,815.827],[925.918,921.583],[847.708,812.14],[847.708,916.486]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[926.224,428.653],[926.224,322.842],[848.009,430.107],[848.009,325.687]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[926.224,553.569],[926.224,447.758],[848.009,553.381],[848.009,448.961]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[926.224,568.841],[926.224,674.652],[848.009,568.452],[848.009,672.872]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[926.224,690.565],[926.224,796.376],[848.009,688.576],[848.009,792.995]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[924.467,313.214],[924.467,212.528],[853.577,317.201],[853.577,218.291]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[924.468,313.214],[924.468,212.528],[982.282,314.724],[982.282,214.711]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[926.224,428.653],[926.224,322.841],[1178.01,431.871],[1178.01,329.14]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[926.224,553.569],[926.224,447.758],[1178.01,553.153],[1178.01,450.421]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[926.224,568.841],[926.224,674.652],[1178.01,567.98],[1178.01,670.711]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[926.224,690.565],[926.224,796.376],[1178.01,686.161],[1178.01,788.893]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[925.917,815.827],[925.917,921.583],[1177.58,807.782],[1177.58,910.462]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[992.488,311.173],[992.488,209.579],[982.282,314.724],[982.282,214.711]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[992.488,311.173],[1054.23,311.304],[992.488,209.579],[1054.23,209.767]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[1054.23,311.304],[1098.26,311.564],[1054.23,209.767],[1098.26,210.143]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[1098.26,311.564],[1098.26,210.143],[1162.51,312.386],[1162.51,211.331]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[1166.97,312.506],[1166.97,211.505],[1224.27,314.948],[1224.27,215.034]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[1179.41,431.889],[1179.41,329.175],[1416.88,434.925],[1416.88,335.115]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[1179.41,553.15],[1179.41,450.436],[1416.88,552.757],[1416.88,452.947]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[1179.41,567.975],[1179.41,670.689],[1416.88,567.163],[1416.88,666.973]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[1179.41,686.137],[1179.41,788.851],[1416.88,681.983],[1416.88,781.793]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[1181.6,808.146],[1181.6,910.964],[1419.24,800.535],[1419.24,900.444]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[1224.27,314.948],[1224.27,215.034],[1260.66,316.825],[1260.66,217.747]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[1260.66,316.825],[1260.66,217.747],[1309.06,319.584],[1309.06,221.735]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[1294.47,322.88],[1294.47,226.499],[1347.46,324.264],[1347.46,228.5]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[1347.46,324.264],[1347.46,228.5],[1375.17,330.477],[1375.17,237.481]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[1375.17,330.477],[1375.17,237.481],[1379.98,337.811],[1379.98,248.081]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[1416.88,434.925],[1416.88,335.115],[1453.92,437.682],[1453.92,340.51]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[1416.88,552.757],[1416.88,452.947],[1453.92,552.4],[1453.92,455.228]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[1416.88,567.163],[1416.88,666.973],[1453.92,566.425],[1453.92,663.597]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[1416.88,681.983],[1416.88,781.793],[1453.92,678.211],[1453.92,775.383]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[1419.24,800.535],[1419.24,900.444],[1456.01,793.58],[1456.01,890.829]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[1425.65,440.253],[1425.65,345.54],[1465.02,440.731],[1465.02,346.476]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[1425.65,552.068],[1425.65,457.355],[1465.02,552.006],[1465.02,457.75]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[1425.65,565.738],[1425.65,660.451],[1465.02,565.61],[1465.02,659.865]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[1425.65,674.694],[1425.65,769.407],[1465.02,674.04],[1465.02,768.296]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[1428.98,787.437],[1428.98,882.338],[1469.87,786.192],[1469.87,880.616]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[1408.87,445.635],[1408.88,356.07],[1473.02,446.37],[1473.02,357.509]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[1408.87,551.371],[1408.88,461.807],[1473.02,551.276],[1473.02,462.415]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[1408.88,564.298],[1408.87,653.862],[1473.02,564.101],[1473.02,652.962]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[1408.88,667.332],[1408.87,756.896],[1473.02,666.326],[1473.02,755.187]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:48,
                    verts:[[1410.42,773.844],[1410.42,863.547],[1474.39,772.007],[1474.39,861.007]]
                },
                ],
                [
                {
                    num:"503",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[670.938,444.113],[670.938,350.128],[596.607,457.322],[596.607,376.385]]
                },{
                    num:"403",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[670.938,555.069],[670.938,461.083],[596.607,552.873],[596.607,471.936]]
                },{
                    num:"303",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[670.938,568.634],[670.938,662.62],[596.607,564.555],[596.607,645.492]]
                },{
                    num:"203",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[670.938,676.754],[670.938,770.74],[596.607,657.664],[596.607,738.601]]
                },{
                    num:"103",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[670.938,785.044],[670.938,879.03],[596.607,750.92],[596.607,831.857]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[724.601,798.112],[724.601,897.095],[654.637,786.18],[654.637,880.6]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[722.914,435.774],[722.914,336.776],[656.447,440.279],[656.447,345.59]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[722.914,552.647],[722.914,453.649],[656.447,552.064],[656.447,457.376]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[722.914,566.936],[722.914,665.934],[656.447,565.731],[656.447,660.419]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[722.914,680.822],[722.914,779.82],[656.447,674.659],[656.447,769.348]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[663.081,350.087],[663.081,265.825],[658.988,358.905],[658.988,278.571]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[692.804,339.428],[692.804,250.419],[663.08,350.087],[663.08,265.825]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[744.448,330.132],[744.448,236.979],[692.804,339.428],[692.804,250.419]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[722.914,435.774],[722.914,336.776],[798.288,436.93],[798.288,339.038]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[722.914,552.647],[722.914,453.649],[798.288,552.498],[798.288,454.605]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[722.914,566.936],[722.914,665.934],[798.288,566.627],[798.288,664.519]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[722.914,680.822],[722.914,779.82],[798.288,679.241],[798.288,777.133]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[724.603,798.112],[724.603,897.095],[799.634,795.233],[799.634,893.114]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[828.3,320.857],[828.3,223.575],[755.056,329.973],[755.056,236.752]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[834.22,809.84],[834.22,913.306],[794.693,794.532],[794.693,892.145]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[835.43,431.195],[835.431,327.817],[798.288,436.93],[798.288,339.038]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[835.43,553.24],[835.431,449.862],[798.288,552.498],[798.288,454.605]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[835.431,568.161],[835.43,671.539],[798.288,566.627],[798.288,664.519]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[835.431,687.086],[835.43,790.465],[798.288,679.241],[798.288,777.133]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[894.022,314.987],[894.022,215.09],[828.3,320.857],[828.3,223.575]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[834.217,809.84],[834.217,913.306],[881.01,807.932],[881.01,910.669]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[835.43,431.195],[835.43,327.817],[880.508,431.929],[880.508,329.253]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[835.43,553.24],[835.43,449.861],[880.508,553.145],[880.508,450.469]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[835.43,568.161],[835.43,671.539],[880.508,567.964],[880.508,670.64]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[835.43,687.086],[835.43,790.465],[880.508,686.082],[880.508,788.758]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[900.997,428.978],[900.997,323.477],[880.508,431.929],[880.508,329.253]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[900.997,553.527],[900.997,448.027],[880.508,553.145],[880.508,450.469]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[900.997,568.754],[900.997,674.254],[880.508,567.964],[880.508,670.641]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[900.997,690.12],[900.997,795.62],[880.508,686.082],[880.508,788.758]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[900.525,814.965],[900.525,920.391],[881.011,807.932],[881.011,910.669]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[969.431,311.504],[969.431,210.057],[894.022,314.987],[894.022,215.09]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[982.462,817.951],[982.462,924.519],[900.525,814.965],[900.525,920.391]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[982.894,427.804],[982.894,321.182],[900.997,428.978],[900.997,323.478]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[982.894,553.679],[982.894,447.056],[900.997,553.527],[900.997,448.027]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[982.894,569.068],[982.894,675.69],[900.997,568.754],[900.997,674.254]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[982.894,691.725],[982.894,798.348],[900.997,690.12],[900.997,795.62]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[969.432,311.504],[969.432,210.057],[1025.83,313.48],[1025.83,212.913]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[982.461,817.951],[982.461,924.519],[1225.91,807.493],[1225.91,910.062]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[982.894,427.804],[982.894,321.182],[1226.44,431.988],[1226.44,329.369]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[982.894,553.679],[982.894,447.056],[1226.44,553.137],[1226.44,450.518]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[982.894,569.068],[982.894,675.69],[1226.44,567.949],[1226.44,670.568]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[982.894,691.725],[982.894,798.348],[1226.44,686.001],[1226.44,788.621]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[1039.64,309.978],[1039.64,207.851],[1025.83,313.48],[1025.83,212.913]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[1039.64,309.978],[1101.07,310.595],[1039.64,207.851],[1101.07,208.742]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[1101.07,310.595],[1144.56,311.201],[1101.07,208.742],[1144.56,209.618]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[1144.56,311.201],[1144.56,209.618],[1207.33,312.525],[1207.33,211.532]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[1211.61,312.68],[1211.61,211.756],[1265.62,315.565],[1265.62,215.927]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[1227.79,432.012],[1227.79,329.414],[1453.62,435.891],[1453.62,337.005]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[1227.79,553.134],[1227.79,450.537],[1453.62,552.632],[1453.62,453.746]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[1227.79,567.942],[1227.79,670.54],[1453.62,566.904],[1453.62,665.79]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[1227.79,685.97],[1227.79,788.567],[1453.62,680.662],[1453.62,779.548]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[1230.19,807.82],[1230.19,910.515],[1456.14,798.096],[1456.14,897.072]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[1265.62,315.565],[1265.62,215.927],[1299.48,317.718],[1299.48,219.038]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[1299.48,317.718],[1299.48,219.038],[1344.11,320.834],[1344.11,223.542]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[1326.51,324.014],[1326.51,228.139],[1376.91,325.78],[1376.91,230.691]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[1376.91,325.78],[1376.91,230.691],[1397.66,332.162],[1397.66,239.916]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[1453.62,435.891],[1453.62,337.005],[1483.58,438.757],[1483.58,342.613]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[1453.62,552.632],[1453.62,453.746],[1483.58,552.261],[1483.58,456.117]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[1453.62,566.904],[1453.62,665.79],[1483.58,566.138],[1483.58,662.282]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[1453.62,680.662],[1453.62,779.548],[1483.58,676.741],[1483.58,772.885]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[1456.14,798.096],[1456.14,897.072],[1485.78,790.872],[1485.78,887.086]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[1450.62,441.214],[1450.62,347.421],[1487.75,441.819],[1487.75,348.604]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[1450.62,551.943],[1450.62,458.15],[1487.75,551.865],[1487.75,458.65]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[1450.62,565.48],[1450.62,659.274],[1487.75,565.319],[1487.75,658.533]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[1450.62,673.379],[1450.62,767.172],[1487.75,672.552],[1487.75,765.766]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:49,
                    verts:[[1454.27,785.001],[1454.27,878.97],[1492.83,783.426],[1492.83,876.793]]
                },
                ],
                [
                {
                    num:"503",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[695.966,442.427],[695.966,346.776],[589.594,455.702],[589.594,373.164]]
                },{
                    num:"403",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[695.966,555.349],[695.966,459.698],[589.594,553.142],[589.594,470.605]]
                },{
                    num:"303",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[695.966,569.155],[695.966,664.806],[589.594,565.055],[589.594,647.593]]
                },{
                    num:"203",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[695.966,679.191],[695.966,774.842],[589.594,660.006],[589.594,742.543]]
                },{
                    num:"103",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[695.966,789.401],[695.966,885.052],[589.594,755.106],[589.594,837.643]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[665.523,346.767],[665.523,261.027],[652.287,355.747],[652.287,274.007]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[706.874,336.09],[706.874,245.593],[665.523,346.767],[665.523,261.027]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[762.307,802.265],[762.307,902.835],[680.27,790.706],[680.27,886.856]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[760.621,434.108],[760.621,333.516],[682.745,438.47],[682.745,342.051]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[760.621,552.863],[760.621,452.271],[682.745,552.298],[682.745,455.879]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[760.621,567.382],[760.621,667.974],[682.745,566.215],[682.745,662.633]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[760.621,683.102],[760.621,783.694],[682.745,677.134],[682.745,773.553]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[769.109,326.982],[769.109,232.427],[706.874,336.09],[706.874,245.593]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[760.621,434.108],[760.621,333.516],[834.742,435.562],[834.743,336.361]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[760.621,552.863],[760.621,452.271],[834.742,552.675],[834.743,453.474]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[760.621,567.382],[760.621,667.974],[834.743,566.993],[834.742,666.194]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[760.621,683.102],[760.621,783.694],[834.743,681.112],[834.742,780.313]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[762.308,802.264],[762.308,902.835],[836.083,798.643],[836.083,897.828]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[863.753,318.175],[863.753,219.699],[780.067,326.899],[780.067,232.309]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[883.969,813.183],[883.969,917.928],[830.454,797.974],[830.454,896.903]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[884.992,429.865],[884.993,325.214],[834.742,435.562],[834.743,336.361]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[884.992,553.412],[884.993,448.761],[834.742,552.675],[834.743,453.474]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[884.993,568.517],[884.992,673.168],[834.743,566.993],[834.742,666.194]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[884.993,688.906],[884.992,793.557],[834.743,681.112],[834.742,780.313]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[936.144,312.726],[936.144,211.823],[863.753,318.175],[863.753,219.699]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[883.968,813.183],[883.968,917.928],[929.555,810.798],[929.555,914.631]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[884.991,429.865],[884.992,325.214],[928.909,430.783],[928.909,327.01]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[884.991,553.412],[884.992,448.761],[928.909,553.293],[928.909,449.52]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[884.992,568.517],[884.991,673.167],[928.909,568.271],[928.909,672.044]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[884.992,688.906],[884.991,793.557],[928.909,687.651],[928.909,791.424]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[956.047,427.865],[956.047,321.3],[928.909,430.783],[928.909,327.01]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[956.047,553.671],[956.047,447.106],[928.909,553.293],[928.909,449.52]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[956.047,569.052],[956.047,675.616],[928.909,568.271],[928.909,672.044]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[956.047,691.643],[956.047,798.208],[928.909,687.651],[928.909,791.424]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[955.402,817.751],[955.402,924.242],[929.555,810.798],[929.555,914.631]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[1015.49,309.796],[1015.49,207.588],[936.143,312.726],[936.143,211.823]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[1040.3,819.979],[1040.3,927.323],[955.402,817.751],[955.402,924.242]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[1040.86,426.995],[1040.86,319.598],[956.047,427.865],[956.047,321.3]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[1040.86,553.784],[1040.86,446.387],[956.047,553.671],[956.047,447.106]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[1040.86,569.285],[1040.86,676.682],[956.047,569.052],[956.047,675.616]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[1040.86,692.833],[1040.86,800.23],[956.047,691.643],[956.047,798.208]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[1015.49,309.796],[1015.49,207.588],[1069.89,312.242],[1069.89,211.122]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[1040.3,819.979],[1040.3,927.323],[1272.85,807.128],[1272.85,909.557]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[1040.86,426.995],[1040.86,319.597],[1273.49,432.136],[1273.49,329.658]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[1040.86,553.784],[1040.86,446.387],[1273.49,553.118],[1273.49,450.64]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[1040.86,569.284],[1040.86,676.682],[1273.49,567.909],[1273.49,670.387]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[1040.86,692.833],[1040.86,800.23],[1273.49,685.799],[1273.49,788.278]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[1087.25,308.815],[1087.25,206.169],[1069.89,312.242],[1069.89,211.122]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[1087.25,308.815],[1087.25,206.169],[1147.76,309.926],[1147.76,207.776]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[1147.76,309.926],[1147.76,207.776],[1190.27,310.881],[1190.27,209.156]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[1190.27,310.881],[1190.27,209.155],[1250.94,312.705],[1250.94,211.792]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[1255.01,312.894],[1255.01,212.065],[1305.2,316.205],[1305.2,216.851]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[1274.77,432.164],[1274.77,329.713],[1486.92,436.853],[1486.92,338.887]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[1274.77,553.115],[1274.77,450.663],[1486.92,552.508],[1486.92,454.542]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[1274.77,567.901],[1274.77,670.353],[1486.92,566.647],[1486.92,664.613]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[1274.77,685.761],[1274.77,788.212],[1486.92,679.346],[1486.92,777.312]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[1277.35,807.417],[1277.35,909.957],[1489.57,795.666],[1489.57,893.713]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[1305.2,316.205],[1305.2,216.851],[1336.22,318.618],[1336.22,220.339]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[1336.22,318.618],[1336.22,220.339],[1376.72,322.068],[1376.72,225.326]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[1356.29,325.115],[1356.29,229.73],[1403.7,327.246],[1403.7,232.81]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:50,
                    verts:[[1403.7,327.246],[1403.7,232.81],[1417.43,333.757],[1417.43,242.221]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[569.337,450.865],[569.337,366.304],[566.373,454.909],[566.373,374.217]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[569.337,550.694],[569.337,466.133],[566.373,550.17],[566.373,469.478]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[569.337,562.899],[569.337,647.459],[566.373,561.817],[566.373,642.509]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[569.337,660.177],[569.337,744.737],[566.373,654.644],[566.373,735.336]]
                },{
                    num:"503",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[723.994,440.658],[723.994,343.258],[584.329,453.916],[584.329,369.615]]
                },{
                    num:"403",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[723.994,555.644],[723.994,458.244],[584.329,553.439],[584.329,469.138]]
                },{
                    num:"303",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[723.994,569.701],[723.994,667.101],[584.329,565.607],[584.329,649.908]]
                },{
                    num:"203",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[723.994,681.748],[723.994,779.148],[584.329,662.586],[584.329,746.887]]
                },{
                    num:"103",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[723.994,793.972],[723.994,891.372],[584.329,759.718],[584.329,844.019]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[669.845,343.15],[669.845,255.798],[647,352.253],[647,268.957]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[723.21,332.519],[723.21,240.432],[669.844,343.15],[669.844,255.798]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[803.115,806.516],[803.115,908.712],[709.078,795.452],[709.078,893.417]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[801.449,432.402],[801.449,330.177],[712.236,436.575],[712.236,338.344]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[801.449,553.084],[801.449,450.859],[712.236,552.544],[712.236,454.312]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[801.449,567.838],[801.449,670.062],[712.236,566.721],[712.236,664.953]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[801.449,685.436],[801.449,787.66],[712.236,679.726],[712.236,777.958]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[796.108,323.678],[796.108,227.651],[723.21,332.519],[723.21,240.432]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[801.449,432.402],[801.449,330.177],[873.521,434.165],[873.522,333.627]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[801.449,553.084],[801.449,450.859],[873.521,552.856],[873.522,452.318]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[801.449,567.838],[801.449,670.062],[873.522,567.366],[873.521,667.904]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[801.449,685.436],[801.449,787.66],[873.522,683.024],[873.521,783.562]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[803.115,806.516],[803.115,908.712],[874.843,802.125],[874.843,902.642]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[901.207,315.436],[901.207,215.739],[807.34,323.677],[807.34,227.652]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[936.143,816.479],[936.143,922.484],[868.547,801.496],[868.547,901.772]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[936.958,428.554],[936.958,322.648],[873.521,434.165],[873.522,333.627]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[936.958,553.582],[936.958,447.676],[873.521,552.856],[873.522,452.318]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[936.958,568.867],[936.958,674.773],[873.522,567.366],[873.521,667.904]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[936.958,690.7],[936.958,796.606],[873.522,683.024],[873.521,783.562]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[979.829,310.474],[979.829,208.567],[901.207,315.436],[901.207,215.739]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[936.142,816.479],[936.142,922.485],[979.979,813.608],[979.979,918.516]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[936.957,428.553],[936.958,322.648],[979.189,429.658],[979.189,324.809]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[936.957,553.582],[936.958,447.676],[979.189,553.439],[979.189,448.59]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[936.958,568.867],[936.957,674.773],[979.189,568.572],[979.189,673.421]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[936.958,690.7],[936.957,796.606],[979.189,689.189],[979.189,794.038]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[1012.93,426.8],[1012.93,319.216],[979.189,429.658],[979.189,324.809]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[1012.93,553.809],[1012.93,446.225],[979.189,553.439],[979.189,448.59]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[1012.93,569.337],[1012.93,676.921],[979.189,568.572],[979.189,673.421]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[1012.93,693.1],[1012.93,800.684],[979.189,689.189],[979.189,794.038]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[1062.44,308.145],[1062.44,205.201],[979.828,310.474],[979.828,208.567]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[1012.12,820.419],[1012.12,927.931],[979.98,813.608],[979.98,918.516]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[1099.1,821.836],[1012.12,820.419],[1099.1,929.889],[1012.12,927.931]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[1099.78,426.254],[1012.93,426.8],[1099.78,318.149],[1012.93,319.216]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[1099.78,553.88],[1099.78,445.774],[1012.93,553.809],[1012.93,446.225]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[1099.78,569.483],[1099.78,677.588],[1012.93,569.337],[1012.93,676.921]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[1099.78,693.846],[1012.93,693.1],[1099.78,801.952],[1012.93,800.684]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[1062.44,308.145],[1062.44,205.201],[1114.23,311.059],[1114.23,209.414]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[1099.1,821.836],[1099.1,929.889],[1318.06,806.635],[1318.06,908.876]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[1099.78,426.254],[1099.78,318.148],[1318.8,432.335],[1318.8,330.048]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[1099.78,553.88],[1099.78,445.774],[1318.8,553.092],[1318.8,450.805]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[1099.78,569.483],[1099.78,677.588],[1318.8,567.856],[1318.8,670.143]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[1099.78,693.846],[1099.78,801.952],[1318.8,685.527],[1318.8,787.814]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[1135.04,307.736],[1135.04,204.61],[1114.23,311.059],[1114.23,209.414]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[1135.04,307.736],[1135.04,204.61],[1194,309.348],[1194,206.94]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[1194,309.348],[1194,206.94],[1235.08,310.651],[1235.08,208.824]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[1235.08,310.651],[1235.08,208.824],[1293.03,312.968],[1293.03,212.173]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[1296.83,313.19],[1296.83,212.494],[1342.72,316.905],[1342.72,217.864]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[1320,432.368],[1320,330.112],[1516.53,437.825],[1516.53,340.79]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[1320,553.088],[1320,450.832],[1516.53,552.382],[1516.53,455.346]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[1320,567.847],[1320,670.103],[1516.53,566.387],[1516.53,663.422]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[1320,685.481],[1320,787.737],[1516.53,678.016],[1516.53,775.051]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[1322.74,806.883],[1322.74,909.219],[1519.27,793.209],[1519.27,890.317]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[1342.72,316.906],[1342.72,217.864],[1370.62,319.562],[1370.62,221.703]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[1370.62,319.562],[1370.62,221.703],[1406.63,323.321],[1406.63,227.137]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[1383.56,326.215],[1383.56,231.32],[1427.62,328.694],[1427.62,234.903]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:51,
                    verts:[[1427.62,328.694],[1427.62,234.903],[1434.31,335.291],[1434.31,244.439]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[566.195,448.798],[566.195,362.26],[554.11,452.95],[554.11,370.384]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[566.195,550.961],[566.195,464.423],[554.11,550.424],[554.11,467.858]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[566.195,563.451],[566.195,649.989],[554.11,562.341],[554.11,644.906]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[566.195,663.004],[566.195,749.542],[554.11,657.323],[554.11,739.889]]
                },{
                    num:"503",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[755.179,438.829],[755.179,339.623],[581.085,451.97],[581.085,365.747]]
                },{
                    num:"403",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[755.179,555.948],[755.179,456.742],[581.085,553.763],[581.085,467.539]]
                },{
                    num:"303",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[755.179,570.266],[755.179,669.472],[581.085,566.208],[581.085,652.431]]
                },{
                    num:"203",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[755.179,684.391],[755.179,783.597],[581.085,665.398],[581.085,751.622]]
                },{
                    num:"103",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[755.179,798.697],[755.179,897.902],[581.085,764.745],[581.085,850.969]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[652.838,348.912],[652.838,264.127],[640.638,357.545],[640.638,276.606]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[676.265,339.257],[676.265,250.172],[643.341,348.436],[643.341,263.439]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[741.985,328.754],[741.985,234.991],[676.265,339.257],[676.265,250.172]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[847.038,810.784],[847.038,914.612],[741.241,800.354],[741.241,900.194]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[825.522,320.271],[825.522,222.726],[741.985,328.754],[741.985,234.99]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[845.413,430.688],[845.413,326.825],[745.095,434.62],[745.095,334.519]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[845.413,553.306],[845.413,449.442],[745.095,552.797],[745.095,452.695]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[845.413,568.296],[845.413,672.16],[745.095,567.244],[745.095,667.346]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[845.413,687.78],[845.413,791.643],[745.095,682.4],[745.095,782.502]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[940.578,312.701],[940.578,211.786],[836.94,320.359],[836.94,222.855]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[845.412,430.688],[845.412,326.825],[914.564,432.769],[914.564,330.895]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[845.412,553.306],[845.412,449.442],[914.564,553.036],[914.564,451.163]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[845.412,568.296],[845.412,672.16],[914.564,567.74],[914.564,669.613]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[845.412,687.78],[845.412,791.643],[914.564,684.934],[914.564,786.807]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[847.039,810.784],[847.039,914.612],[915.852,805.605],[915.852,907.452]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[990.514,819.634],[990.514,926.845],[908.922,805.023],[908.922,906.647]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[991.1,427.298],[991.101,320.191],[914.564,432.769],[914.564,330.895]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[991.1,553.745],[991.101,446.637],[914.564,553.036],[914.564,451.163]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[991.101,569.203],[991.1,676.31],[914.564,567.74],[914.564,669.613]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[991.101,692.418],[991.1,799.525],[914.564,684.934],[914.564,786.807]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[1024.87,308.296],[1024.87,205.42],[940.578,312.701],[940.578,211.786]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[990.512,819.634],[990.512,926.846],[1032.02,816.274],[1032.02,922.201]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[991.1,427.298],[991.1,320.191],[1031.09,428.591],[1031.09,322.72]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[991.1,553.744],[991.1,446.637],[1031.09,553.577],[1031.09,447.707]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[991.1,569.203],[991.1,676.31],[1031.09,568.858],[1031.09,674.728]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[991.1,692.418],[991.1,799.525],[1031.09,690.65],[1031.09,796.52]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[1109.96,306.618],[1109.96,202.993],[1024.87,308.296],[1024.87,205.42]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[1071.3,425.821],[1071.3,317.3],[1031.09,428.591],[1031.09,322.72]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[1071.3,553.936],[1071.3,445.415],[1031.09,553.577],[1031.09,447.707]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[1071.3,569.599],[1071.3,678.119],[1031.09,568.858],[1031.09,674.728]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[1071.3,694.439],[1071.3,802.96],[1031.09,690.65],[1031.09,796.52]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[1070.31,822.874],[1070.31,931.325],[1032.02,816.274],[1032.02,922.201]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[1070.31,822.874],[1158.41,823.428],[1070.31,931.325],[1158.41,932.09]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[1071.3,425.821],[1159.2,425.62],[1071.3,317.3],[1159.2,316.907]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[1071.3,553.936],[1159.2,553.962],[1071.3,445.415],[1159.2,445.249]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[1071.3,569.599],[1159.2,569.652],[1071.3,678.119],[1159.2,678.365]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[1071.3,694.439],[1159.2,694.714],[1071.3,802.96],[1159.2,803.427]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[1109.96,306.618],[1109.96,202.994],[1158.53,309.996],[1158.53,207.876]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[1182.65,306.806],[1182.65,203.266],[1158.53,309.996],[1158.53,207.876]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[1158.4,823.428],[1158.4,932.09],[1361.08,805.953],[1361.08,907.934]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[1159.2,425.62],[1159.2,316.907],[1361.92,432.61],[1361.92,330.586]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[1159.2,553.962],[1159.2,445.249],[1361.92,553.057],[1361.92,451.032]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[1159.2,569.652],[1159.2,678.365],[1361.92,567.782],[1361.92,669.807]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[1159.2,694.714],[1159.2,803.427],[1361.92,685.15],[1361.92,787.175]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[1182.65,306.806],[1182.65,203.266],[1239.37,308.92],[1239.37,206.321]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[1239.37,308.92],[1239.37,206.321],[1278.57,310.568],[1278.57,208.704]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[1278.57,310.568],[1278.57,208.704],[1333.17,313.366],[1333.17,212.748]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[1336.67,313.62],[1336.67,213.115],[1377.79,317.713],[1377.79,219.03]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[1363.01,432.648],[1363.01,330.659],[1542.11,438.824],[1542.11,342.744]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[1363.01,553.052],[1363.01,451.063],[1542.11,552.253],[1542.11,456.173]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[1363.01,567.772],[1363.01,669.761],[1542.11,566.12],[1542.11,662.2]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[1363.01,685.099],[1363.01,787.087],[1542.11,676.649],[1542.11,772.729]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[1365.89,806.158],[1365.89,908.217],[1544.93,790.685],[1544.93,886.828]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[1377.79,317.713],[1377.79,219.03],[1402.3,320.592],[1402.3,223.193]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[1402.3,320.592],[1402.3,223.193],[1433.53,324.63],[1433.53,229.03]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:52,
                    verts:[[1408.05,327.353],[1408.05,232.964],[1448.4,330.159],[1448.4,237.021]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[565.534,446.571],[565.534,357.903],[543.683,450.812],[543.683,366.201]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[565.534,551.25],[565.534,462.581],[543.683,550.701],[543.683,466.09]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[565.534,564.047],[565.534,652.716],[543.683,562.913],[543.683,647.524]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[565.534,666.05],[565.534,754.719],[543.683,660.248],[543.683,744.859]]
                },{
                    num:"503",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[789.65,436.974],[789.65,335.935],[580.206,449.873],[580.206,361.577]]
                },{
                    num:"403",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[789.65,556.256],[789.65,455.217],[580.206,554.112],[580.206,465.816]]
                },{
                    num:"303",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[789.65,570.839],[789.65,671.878],[580.206,566.855],[580.206,655.151]]
                },{
                    num:"203",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[789.65,687.073],[789.65,788.111],[580.206,668.43],[580.206,756.726]]
                },{
                    num:"103",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[789.65,803.49],[789.65,904.528],[580.206,770.164],[580.206,858.46]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[629.271,353.66],[629.271,270.99],[626.977,359.551],[626.977,279.505]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[650.857,344.874],[650.857,258.29],[629.271,353.66],[629.271,270.991]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[685.042,335.125],[685.042,244.199],[641.579,344.317],[641.579,257.485]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[763.377,324.849],[763.377,229.345],[685.041,335.125],[685.041,244.199]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[857.391,316.828],[857.391,217.749],[763.377,324.849],[763.377,229.345]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[894.007,814.966],[894.007,920.392],[776.902,805.327],[776.902,907.068]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[892.441,429.01],[892.441,323.54],[781.457,432.641],[781.457,330.645]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[892.441,553.523],[892.441,448.054],[781.457,553.053],[781.457,451.057]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[892.441,568.745],[892.441,674.215],[781.457,567.774],[781.457,669.77]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[892.441,690.076],[892.441,795.546],[781.457,685.109],[781.457,787.105]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[981.705,310.047],[981.705,207.951],[868.888,317.011],[868.888,218.016]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[892.441,429.01],[892.441,323.54],[957.729,431.411],[957.729,328.24]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[892.441,553.523],[892.441,448.054],[957.729,553.212],[957.729,450.04]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[892.441,568.745],[892.441,674.215],[957.729,568.103],[957.729,671.275]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[892.441,690.076],[892.441,795.546],[957.729,686.791],[957.729,789.963]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[894.008,814.966],[894.008,920.392],[958.969,808.986],[958.969,912.127]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[1046.72,822.534],[1046.72,930.854],[951.449,808.461],[951.449,911.4]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[1047.06,426.143],[1047.07,317.932],[957.729,431.411],[957.729,328.24]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[1047.06,553.894],[1047.07,445.682],[957.729,553.212],[957.729,450.04]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[1047.07,569.512],[1047.06,677.724],[957.729,568.103],[957.729,671.275]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[1047.07,693.998],[1047.06,802.21],[957.729,686.791],[957.729,789.963]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[1070.97,306.274],[1070.97,202.497],[981.705,310.047],[981.705,207.951]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[1047.06,426.143],[1047.06,317.931],[1084.23,427.622],[1084.23,320.825]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[1047.06,553.894],[1047.06,445.682],[1084.23,553.703],[1084.23,446.906]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[1047.06,569.512],[1047.06,677.724],[1084.23,569.117],[1084.23,675.913]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[1047.06,693.998],[1047.06,802.21],[1084.23,691.975],[1084.23,798.771]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[1046.72,822.534],[1046.72,930.854],[1085.29,818.69],[1085.29,925.541]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[1157.65,305.292],[1070.97,306.274],[1157.65,201.078],[1070.97,202.497]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[1130.64,424.973],[1130.64,315.641],[1084.23,427.622],[1084.23,320.825]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[1130.64,554.046],[1130.64,444.714],[1084.23,553.703],[1084.23,446.906]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[1130.64,569.825],[1130.64,679.157],[1084.23,569.117],[1084.23,675.914]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[1130.64,695.599],[1130.64,804.931],[1084.23,691.975],[1084.23,798.772]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[1129.49,825.003],[1129.49,934.267],[1085.29,818.69],[1085.29,925.541]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[1129.49,825.003],[1217.61,824.651],[1129.49,934.267],[1217.61,933.781]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[1130.64,424.973],[1130.64,315.641],[1218.52,425.134],[1218.52,315.956]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[1130.64,554.046],[1130.64,444.714],[1218.52,554.025],[1218.52,444.847]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[1130.64,569.825],[1130.64,679.157],[1218.52,569.782],[1218.52,678.96]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[1130.64,695.599],[1130.64,804.931],[1218.52,695.38],[1218.52,804.557]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[1157.65,305.292],[1157.65,201.078],[1202.35,309.121],[1202.35,206.611]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[1229.58,306.098],[1229.58,202.242],[1202.35,309.121],[1202.35,206.611]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[1218.52,425.133],[1218.52,315.956],[1402.32,432.987],[1402.32,331.322]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[1218.52,554.025],[1218.52,444.847],[1402.32,553.008],[1402.32,451.344]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[1218.52,569.782],[1218.52,678.96],[1402.32,567.682],[1402.32,669.346]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[1218.52,695.379],[1218.52,804.557],[1402.32,684.635],[1402.32,786.3]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[1217.6,824.651],[1217.6,933.781],[1401.4,805.019],[1401.4,906.642]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[1229.58,306.098],[1229.58,202.243],[1283.41,308.707],[1283.41,206.014]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[1283.41,308.707],[1283.41,206.014],[1320.26,310.693],[1320.26,208.885]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[1320.26,310.693],[1320.26,208.885],[1370.9,313.954],[1370.9,213.598]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[1374.07,314.237],[1374.07,214.007],[1409.98,318.674],[1409.98,220.421]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[1403.31,433.029],[1403.31,331.405],[1563.32,439.866],[1563.32,344.782]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[1403.31,553.003],[1403.31,451.378],[1563.32,552.118],[1563.32,457.034]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[1403.31,567.67],[1403.31,669.294],[1563.32,565.841],[1563.32,660.925]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[1403.31,684.578],[1403.31,786.202],[1563.32,675.224],[1563.32,770.308]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[1406.28,805.179],[1406.28,906.863],[1566.19,788.054],[1566.19,883.19]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[1409.98,318.674],[1409.98,220.421],[1430.88,321.753],[1430.88,224.871]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[1430.88,321.753],[1430.88,224.871],[1457.05,326.037],[1457.05,231.063]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:53,
                    verts:[[1429.42,328.568],[1429.42,234.721],[1465.73,331.677],[1465.73,239.215]]
                },
                ],
                [
                {
                    num:"104",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[594.837,762.285],[594.837,847.568],[528.161,754.07],[528.161,836.211]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[592.817,450.304],[592.818,365.207],[530.5,453.37],[530.501,371.205]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[592.817,550.766],[592.818,465.669],[530.5,550.37],[530.501,468.205]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[592.818,563.049],[592.817,648.146],[530.501,562.228],[530.5,644.393]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[592.818,660.943],[592.817,746.041],[530.501,656.749],[530.5,738.914]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[567.768,444.2],[567.768,353.263],[535.491,448.504],[535.491,361.685]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[567.768,551.557],[567.768,460.619],[535.491,551],[535.491,464.18]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[567.768,564.682],[567.768,655.619],[535.491,563.53],[535.491,650.349]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[567.768,669.295],[567.768,760.232],[535.491,663.406],[535.491,750.226]]
                },{
                    num:"503",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[827.457,435.133],[827.457,332.276],[582.087,447.639],[582.087,357.137]]
                },{
                    num:"403",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[827.457,556.562],[827.457,453.705],[582.087,554.483],[582.087,463.981]]
                },{
                    num:"303",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[827.457,571.407],[827.457,674.264],[582.087,567.545],[582.087,658.047]]
                },{
                    num:"203",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[827.457,689.733],[827.457,792.59],[582.087,671.658],[582.087,762.16]]
                },{
                    num:"103",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[827.457,808.245],[827.457,911.102],[582.087,775.935],[582.087,866.437]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[619.482,349.458],[619.482,264.916],[610.907,355.504],[610.907,273.656]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[650.997,340.571],[650.997,252.071],[619.482,349.458],[619.482,264.916]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[696.444,330.802],[696.444,237.951],[642.024,339.929],[642.024,251.143]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[787.529,320.871],[787.529,223.596],[696.444,330.802],[696.444,237.951]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[891.678,313.432],[891.678,212.84],[787.529,320.871],[787.529,223.596]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[943.813,818.934],[943.813,925.877],[816.122,810.26],[816.122,913.887]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[942.332,427.416],[942.332,320.422],[821.373,430.681],[821.373,326.81]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[942.332,553.729],[942.332,446.735],[821.373,553.307],[821.373,449.436]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[942.332,569.172],[942.332,676.166],[821.373,568.298],[821.373,672.169]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[942.332,692.256],[942.332,799.25],[821.373,687.791],[821.373,791.661]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[1024.32,307.566],[1024.32,204.365],[903.135,313.715],[903.135,213.253]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[942.332,427.416],[942.332,320.422],[1002.76,430.138],[1002.76,325.747]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[942.332,553.729],[942.332,446.735],[1002.76,553.377],[1002.76,448.987]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[942.332,569.172],[942.332,676.166],[1002.76,568.444],[1002.76,672.834]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[942.332,692.256],[942.332,799.25],[1002.76,688.533],[1002.76,792.924]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[943.815,818.934],[943.815,925.877],[1003.93,812.159],[1003.93,916.512]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[1104.24,825.05],[1104.24,934.333],[995.882,811.699],[995.882,915.877]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[1104.33,425.141],[1104.33,315.97],[1002.76,430.138],[1002.76,325.747]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[1104.33,554.024],[1104.33,444.853],[1002.76,553.377],[1002.76,448.987]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[1104.33,569.78],[1104.33,678.951],[1002.76,568.444],[1002.76,672.834]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[1104.33,695.369],[1104.33,804.54],[1002.76,688.533],[1002.76,792.924]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[1117.69,304.499],[1117.69,199.931],[1024.32,307.566],[1024.32,204.365]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[1104.33,425.141],[1104.33,315.97],[1138.08,426.8],[1138.08,319.217]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[1104.33,554.024],[1104.33,444.853],[1138.08,553.809],[1138.08,446.226]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[1104.33,569.78],[1104.33,678.951],[1138.08,569.336],[1138.08,676.92]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[1104.33,695.369],[1104.33,804.54],[1138.08,693.099],[1138.08,800.682]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[1104.24,825.05],[1104.24,934.333],[1139.27,820.738],[1139.27,928.371]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[1117.69,304.499],[1204.97,304.255],[1117.69,199.931],[1204.97,199.579]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[1190.28,424.306],[1190.28,314.336],[1138.08,426.8],[1138.08,319.217]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[1190.28,554.132],[1190.28,444.162],[1138.08,553.809],[1138.08,446.226]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[1190.28,570.004],[1190.28,679.973],[1138.08,569.337],[1138.08,676.92]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[1190.28,696.512],[1190.28,806.481],[1138.08,693.099],[1138.08,800.682]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[1188.98,826.681],[1188.98,936.587],[1139.27,820.738],[1139.27,928.371]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[1188.98,826.681],[1188.98,936.587],[1275.95,825.393],[1275.95,934.807]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[1190.28,424.306],[1190.28,314.336],[1276.96,424.84],[1276.96,315.382]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[1190.28,554.132],[1190.28,444.162],[1276.96,554.063],[1276.96,444.604]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[1190.28,570.004],[1190.28,679.973],[1276.96,569.861],[1276.96,679.319]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[1190.28,696.512],[1190.28,806.481],[1276.96,695.781],[1276.96,805.239]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[1204.97,304.255],[1204.97,199.579],[1245.19,308.512],[1245.19,205.731]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[1275.27,305.691],[1275.27,201.653],[1245.19,308.511],[1245.19,205.731]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[1275.27,305.691],[1275.27,201.653],[1325.51,308.781],[1325.51,206.121]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[1275.95,825.393],[1275.95,934.807],[1438.42,803.766],[1438.42,904.91]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[1276.96,424.84],[1276.96,315.382],[1439.42,433.491],[1439.42,332.309]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[1276.96,554.063],[1276.96,444.604],[1439.42,552.943],[1439.42,451.761]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[1276.96,569.861],[1276.96,679.319],[1439.42,567.547],[1439.42,668.729]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[1276.96,695.781],[1276.96,805.239],[1439.42,683.945],[1439.42,785.128]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[1325.51,308.781],[1325.51,206.121],[1359.58,311.091],[1359.58,209.46]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[1359.58,311.091],[1359.58,209.459],[1405.68,314.788],[1405.68,214.803]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[1408.47,315.098],[1408.47,215.251],[1438.8,319.84],[1438.8,222.105]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[1438.8,319.84],[1438.8,222.105],[1455.89,323.09],[1455.89,226.804]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[1440.28,433.537],[1440.28,332.399],[1579.78,440.965],[1579.78,346.934]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[1440.28,552.937],[1440.28,451.799],[1579.78,551.975],[1579.78,457.944]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[1440.28,567.534],[1440.28,668.672],[1579.78,565.547],[1579.78,659.578]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[1440.28,683.883],[1440.28,785.021],[1579.78,673.72],[1579.78,767.751]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[1443.31,803.879],[1443.31,905.067],[1582.66,785.276],[1582.66,879.35]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[1455.89,323.091],[1455.89,226.804],[1476.81,327.581],[1476.81,233.295]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:54,
                    verts:[[1447.31,329.901],[1447.31,236.648],[1479.29,333.285],[1479.29,241.54]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[544.582,452.136],[544.582,368.791],[511.675,453.456],[511.675,371.374]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[544.582,550.529],[544.582,467.185],[511.675,550.359],[511.675,468.277]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[544.582,562.559],[544.582,645.903],[511.675,562.205],[511.675,644.287]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[544.582,658.437],[544.582,741.782],[511.675,656.632],[511.675,738.714]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[587.903,767.79],[587.903,855.178],[511.213,759.88],[511.213,844.243]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[585.368,448.103],[585.369,360.9],[513.7,451.055],[513.701,366.676]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[585.368,551.051],[585.369,463.848],[513.7,550.669],[513.701,466.29]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[585.369,563.637],[585.368,650.841],[513.701,562.848],[513.7,647.227]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[585.369,663.955],[585.368,751.158],[513.701,659.917],[513.7,744.296]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[573.361,441.708],[573.361,348.387],[530.005,446.041],[530.005,356.865]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[573.361,551.879],[573.361,458.558],[530.005,551.318],[530.005,462.142]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[573.361,565.348],[573.361,658.669],[530.005,564.189],[530.005,653.365]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[573.361,672.704],[573.361,766.025],[530.005,666.776],[530.005,755.952]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[576.865,783.747],[576.865,877.236],[530.454,772.27],[530.454,861.371]]
                },{
                    num:"503",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[868.53,433.357],[868.53,328.745],[587.165,445.293],[587.165,352.472]]
                },{
                    num:"403",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[868.53,556.857],[868.53,452.246],[587.165,554.873],[587.165,462.053]]
                },{
                    num:"303",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[868.53,571.956],[868.53,676.567],[587.165,568.27],[587.165,661.09]]
                },{
                    num:"203",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[868.53,692.3],[868.53,796.911],[587.165,675.049],[587.165,767.87]]
                },{
                    num:"103",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[868.53,812.833],[868.53,917.445],[587.165,781.997],[587.165,874.818]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[611.618,344.968],[611.618,258.426],[596.329,351.137],[596.329,267.343]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[653.587,336.052],[653.587,245.539],[611.618,344.968],[611.618,258.427]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[710.738,326.357],[710.738,231.525],[645.02,335.32],[645.02,244.481]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[814.526,316.908],[814.526,217.867],[710.738,326.356],[710.738,231.525]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[928.247,310.181],[928.247,208.141],[814.526,316.908],[814.526,217.867]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[996.082,822.543],[996.082,930.867],[858.844,815.018],[858.844,920.465]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[994.708,425.966],[994.708,317.585],[864.768,428.794],[864.768,323.118]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[994.708,553.917],[994.708,445.536],[864.768,553.551],[864.768,447.875]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[994.708,569.56],[994.708,677.941],[864.768,568.803],[864.768,674.479]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[994.708,694.24],[994.708,802.621],[864.768,690.371],[864.768,796.047]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[1068.01,305.359],[1068.01,201.174],[939.526,310.57],[939.526,208.707]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[994.707,425.966],[994.707,317.585],[1049.24,428.998],[1049.24,323.518]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[994.707,553.917],[994.707,445.536],[1049.24,553.524],[1049.24,448.044]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[994.707,569.56],[994.707,677.941],[1049.24,568.749],[1049.24,674.229]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[994.707,694.24],[994.707,802.621],[1049.24,690.092],[1049.24,795.573]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[996.082,822.543],[996.082,930.867],[1050.33,814.996],[1050.33,920.434]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[1162.36,827.043],[1162.36,937.088],[1041.83,814.611],[1041.83,919.902]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[1162.18,424.347],[1162.18,314.416],[1049.24,428.998],[1049.24,323.518]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[1162.18,554.127],[1162.18,444.196],[1049.24,553.524],[1049.24,448.044]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[1162.18,569.993],[1162.18,679.924],[1049.24,568.749],[1049.24,674.229]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[1162.18,696.456],[1162.18,806.387],[1049.24,690.092],[1049.24,795.573]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[1164.48,303.069],[1164.48,197.865],[1068.01,305.359],[1068.01,201.174]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[1162.18,424.346],[1162.18,314.416],[1191.94,426.175],[1191.94,317.994]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[1162.18,554.126],[1162.18,444.196],[1191.94,553.89],[1191.94,445.709]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[1162.18,569.993],[1162.18,679.924],[1191.94,569.504],[1191.94,677.685]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[1162.18,696.456],[1162.18,806.387],[1191.94,693.954],[1191.94,802.135]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[1162.36,827.043],[1162.36,937.089],[1193.24,822.291],[1193.24,930.518]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[1164.48,303.069],[1164.48,197.865],[1251.26,303.596],[1251.26,198.626]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[1249.38,423.872],[1249.38,313.487],[1191.94,426.175],[1191.94,317.994]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[1249.38,554.188],[1249.38,443.803],[1191.94,553.89],[1191.94,445.709]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[1249.38,570.12],[1249.38,680.505],[1191.94,569.504],[1191.94,677.685]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[1249.38,697.106],[1249.38,807.491],[1191.94,693.954],[1191.94,802.135]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[1247.95,827.779],[1247.95,938.105],[1193.25,822.29],[1193.25,930.518]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[1247.95,827.779],[1247.95,938.105],[1332.52,825.541],[1332.52,935.011]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[1249.38,423.872],[1249.38,313.487],[1333.62,424.785],[1333.62,315.274]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[1249.38,554.188],[1249.38,443.803],[1333.62,554.07],[1333.62,444.559]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[1249.38,570.12],[1249.38,680.505],[1333.62,569.876],[1333.62,679.387]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[1249.38,697.106],[1249.38,807.491],[1333.62,695.856],[1333.62,805.367]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[1251.26,303.596],[1251.26,198.626],[1286.41,308.247],[1286.41,205.349]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[1319.01,305.663],[1319.01,201.614],[1286.41,308.247],[1286.41,205.349]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[1319.01,305.663],[1319.01,201.614],[1365.01,309.211],[1365.01,206.742]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[1332.52,825.541],[1332.52,935.011],[1471.5,802.134],[1471.5,902.654]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[1333.62,424.785],[1333.62,315.274],[1472.55,434.147],[1472.55,333.593]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[1333.62,554.07],[1333.62,444.559],[1472.55,552.858],[1472.55,452.304]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[1333.62,569.876],[1333.62,679.387],[1472.55,567.371],[1472.55,667.925]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[1333.62,695.856],[1333.62,805.367],[1472.55,683.048],[1472.55,783.602]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[1365.01,309.211],[1365.01,206.742],[1395.88,311.824],[1395.88,210.519]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[1395.88,311.824],[1395.88,210.519],[1436.9,315.922],[1436.9,216.442]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[1439.29,316.256],[1439.29,216.925],[1463.74,321.255],[1463.74,224.151]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[1463.74,321.255],[1463.74,224.151],[1476.87,324.645],[1476.87,229.051]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[1473.29,434.197],[1473.29,333.69],[1591.11,442.136],[1591.11,349.225]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[1473.29,552.852],[1473.29,452.344],[1591.11,551.824],[1591.11,458.912]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[1473.29,567.358],[1473.29,667.865],[1591.11,565.234],[1591.11,658.145]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[1473.29,682.98],[1473.29,783.487],[1591.11,672.118],[1591.11,765.03]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[1476.88,324.645],[1476.88,229.051],[1492.38,329.3],[1492.38,235.779]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:55,
                    verts:[[1476.35,802.199],[1476.35,902.744],[1593.98,782.321],[1593.98,875.265]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[528.88,449.803],[528.88,364.227],[491.584,451.053],[491.584,366.673]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[528.88,550.831],[528.88,465.255],[491.584,550.669],[491.584,466.289]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[528.88,563.183],[528.88,648.759],[491.584,562.848],[491.584,647.228]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[528.88,661.629],[528.88,747.205],[491.584,659.918],[491.584,744.299]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[527.371,762.919],[527.371,848.445],[491.868,759.942],[491.868,844.329]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[583.577,773.588],[583.577,863.192],[496.596,766.102],[496.596,852.845]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[580.506,445.783],[580.506,356.36],[499.228,448.576],[499.228,361.825]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[580.506,551.352],[580.506,461.929],[499.228,550.99],[499.228,464.24]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[580.506,564.258],[580.506,653.681],[499.228,563.511],[499.228,650.261]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[580.506,667.129],[580.506,756.552],[499.228,663.308],[499.228,750.058]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[582.805,439.13],[582.805,343.343],[527.766,443.446],[527.766,351.787]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[582.805,552.213],[582.805,456.426],[527.766,551.654],[527.766,459.996]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[582.805,566.038],[582.805,661.825],[527.766,564.883],[527.766,656.542]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[582.805,676.231],[582.805,772.018],[527.766,670.326],[527.766,761.985]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[586.844,790.177],[586.844,886.125],[528.053,778.751],[528.053,870.33]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[606.087,340.237],[606.087,251.588],[583.65,346.482],[583.65,260.615]]
                },{
                    num:"503",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[912.651,431.704],[912.651,325.46],[595.907,442.865],[595.907,347.647]]
                },{
                    num:"403",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[912.651,557.132],[912.651,450.888],[595.907,555.276],[595.907,460.058]]
                },{
                    num:"303",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[912.651,572.466],[912.651,678.71],[595.907,569.019],[595.907,664.238]]
                },{
                    num:"203",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[912.651,694.689],[912.651,800.933],[595.907,678.558],[595.907,773.776]]
                },{
                    num:"103",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[912.651,817.103],[912.651,923.348],[595.907,788.269],[595.907,883.487]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[658.984,331.38],[658.984,238.785],[606.087,340.237],[606.087,251.588]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[728.165,321.872],[728.165,225.042],[650.937,330.556],[650.937,237.595]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[844.374,313.063],[844.374,212.309],[728.165,321.872],[728.165,225.042]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[966.832,307.188],[966.832,203.816],[844.373,313.063],[844.373,212.309]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[1050.23,825.634],[1050.23,935.14],[904.847,819.445],[904.847,926.585]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[1048.99,424.724],[1048.99,315.154],[911.406,427.044],[911.406,319.695]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[1048.99,554.078],[1048.99,444.508],[911.406,553.777],[911.406,446.428]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[1048.99,569.892],[1048.99,679.462],[911.406,569.271],[911.406,676.621]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[1048.99,695.94],[1048.99,805.51],[911.406,692.765],[911.406,800.115]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[1112.24,303.536],[1112.24,198.539],[977.783,307.687],[977.783,204.539]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[1048.99,424.724],[1048.99,315.154],[1096.61,428.047],[1096.61,321.657]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[1048.99,554.078],[1048.99,444.508],[1096.61,553.648],[1096.61,447.257]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[1048.99,569.892],[1048.99,679.462],[1096.61,569.003],[1096.61,675.393]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[1048.99,695.94],[1048.99,805.51],[1096.61,691.393],[1096.61,797.784]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[1050.24,825.634],[1050.24,935.14],[1097.6,817.362],[1097.6,923.704]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[1219.72,423.817],[1219.72,313.38],[1096.61,428.047],[1096.61,321.657]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[1219.72,554.195],[1219.72,443.758],[1096.61,553.648],[1096.61,447.257]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[1219.72,570.135],[1219.72,680.572],[1096.61,569.003],[1096.61,675.393]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[1219.72,697.181],[1219.72,807.618],[1096.61,691.393],[1096.61,797.784]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[1220.18,828.37],[1220.18,938.923],[1088.75,817.061],[1088.75,923.289]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[1210.61,302.088],[1112.24,303.536],[1210.61,196.446],[1112.24,198.539]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[1210.61,302.088],[1210.61,196.446],[1295.73,303.404],[1295.73,198.348]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[1219.72,423.817],[1219.72,313.379],[1244.96,425.798],[1244.96,317.257]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[1219.72,554.195],[1219.72,443.758],[1244.96,553.939],[1244.96,445.397]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[1219.72,570.135],[1219.72,680.572],[1244.96,569.604],[1244.96,678.146]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[1219.72,697.181],[1219.72,807.618],[1244.96,694.47],[1244.96,803.011]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[1220.17,828.37],[1220.17,938.923],[1246.36,823.22],[1246.36,931.804]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[1306.92,423.721],[1306.92,313.193],[1244.96,425.798],[1244.96,317.257]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[1306.92,554.207],[1306.92,443.679],[1244.96,553.939],[1244.96,445.397]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[1306.92,570.16],[1306.92,680.689],[1244.96,569.604],[1244.96,678.146]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[1306.92,697.311],[1306.92,807.84],[1244.96,694.47],[1244.96,803.011]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[1305.37,828.17],[1305.37,938.645],[1246.36,823.22],[1246.36,931.803]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[1295.73,303.404],[1295.73,198.348],[1325.29,308.405],[1325.29,205.577]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[1305.37,828.17],[1305.37,938.645],[1386.28,824.988],[1386.28,934.246]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[1306.92,423.722],[1306.92,313.193],[1387.45,425.011],[1387.45,315.715]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[1306.92,554.207],[1306.92,443.679],[1387.45,554.041],[1387.45,444.745]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[1306.92,570.16],[1306.92,680.689],[1387.45,569.815],[1387.45,679.111]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[1306.92,697.311],[1306.92,807.84],[1387.45,695.548],[1387.45,804.843]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[1360.02,306.091],[1360.02,202.233],[1325.29,308.405],[1325.29,205.577]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[1360.02,306.091],[1360.02,202.233],[1401.18,310.062],[1401.18,207.971]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[1386.28,824.988],[1386.28,934.246],[1499.97,800.069],[1499.97,899.799]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[1387.45,425.011],[1387.45,315.715],[1501.08,434.977],[1501.08,335.216]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[1387.45,554.041],[1387.45,444.745],[1501.08,552.751],[1501.08,452.99]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[1387.45,569.815],[1387.45,679.11],[1501.08,567.149],[1501.08,666.91]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[1387.45,695.547],[1387.45,804.843],[1501.08,681.913],[1501.08,781.674]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[1401.18,310.062],[1401.18,207.971],[1428.46,312.95],[1428.46,212.147]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[1428.46,312.95],[1428.46,212.147],[1463.95,317.403],[1463.95,218.583]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[1465.91,317.758],[1465.91,219.095],[1484.27,322.96],[1484.27,226.616]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[1484.27,322.96],[1484.27,226.616],[1493.36,326.454],[1493.36,231.665]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[1493.36,326.454],[1493.36,231.665],[1503.38,331.224],[1503.38,238.56]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[1501.67,435.029],[1501.67,335.318],[1596.98,443.388],[1596.98,351.674]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[1501.67,552.744],[1501.67,453.033],[1596.98,551.662],[1596.98,459.948]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[1501.67,567.135],[1501.67,666.846],[1596.98,564.899],[1596.98,656.613]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[1501.67,681.841],[1501.67,781.552],[1596.98,670.406],[1596.98,762.12]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:56,
                    verts:[[1504.73,800.086],[1504.73,899.824],[1599.81,779.163],[1599.81,870.899]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[515.731,447.334],[515.731,359.396],[473.935,448.492],[473.935,361.661]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[515.731,551.151],[515.731,463.212],[473.935,551.001],[473.935,464.17]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[515.731,563.843],[515.731,651.782],[473.935,563.534],[473.935,650.364]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[515.731,665.007],[515.731,752.945],[473.935,663.423],[473.935,750.254]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[514.037,769.106],[514.037,856.997],[474.248,766.349],[474.248,853.186]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[582.344,779.603],[582.344,871.507],[484.912,772.685],[484.912,861.944]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[578.718,443.373],[578.719,351.645],[487.678,445.954],[487.678,356.696]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[578.718,551.664],[578.719,459.936],[487.678,551.33],[487.678,462.071]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[578.719,564.903],[578.718,656.631],[487.678,564.212],[487.678,653.471]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[578.719,670.426],[578.718,762.154],[487.678,666.894],[487.678,756.153]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[596.582,436.51],[596.582,338.217],[529.362,440.753],[529.362,346.518]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[596.582,552.552],[596.582,454.258],[529.362,552.003],[529.362,457.768]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[596.582,566.739],[596.582,665.032],[529.362,565.604],[529.362,659.838]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[596.582,679.815],[596.582,778.108],[529.362,674.01],[529.362,768.245]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[601.158,796.704],[601.158,895.148],[529.468,785.479],[529.468,879.63]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[573.335,341.589],[573.335,253.542],[568.683,347.499],[568.683,262.085]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[603.332,335.326],[603.332,244.489],[573.335,341.589],[573.335,253.542]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[667.537,326.635],[667.537,231.928],[603.332,335.326],[603.332,244.489]]
                },{
                    num:"503",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[959.411,430.238],[959.411,322.546],[608.771,440.399],[608.771,342.744]]
                },{
                    num:"403",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[959.411,557.376],[959.411,449.684],[608.771,555.687],[608.771,458.032]]
                },{
                    num:"303",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[959.411,572.919],[959.411,680.611],[608.771,569.781],[608.771,667.436]]
                },{
                    num:"203",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[959.411,696.807],[959.411,804.499],[608.771,682.122],[608.771,779.777]]
                },{
                    num:"103",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[959.411,820.89],[959.411,928.582],[608.771,794.64],[608.771,892.295]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[748.907,317.451],[748.907,218.652],[660.135,325.719],[660.135,230.603]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[876.952,309.454],[876.952,207.094],[748.907,317.451],[748.907,218.652]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[1007.02,304.574],[1007.02,200.038],[876.952,309.454],[876.952,207.094]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[1105.47,828.042],[1105.47,938.469],[953.705,823.37],[953.705,932.01]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[1104.39,423.754],[1104.39,313.257],[960.84,425.501],[960.84,316.674]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[1104.39,554.203],[1104.39,443.706],[960.84,553.977],[960.84,445.151]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[1104.39,570.151],[1104.39,680.649],[960.84,569.684],[960.84,678.511]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[1104.39,697.266],[1104.39,807.764],[960.84,694.877],[960.84,803.704]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[1156.31,302.206],[1156.31,196.616],[1017.48,305.183],[1017.48,200.92]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[1104.39,423.754],[1104.39,313.257],[1144.15,427.34],[1144.15,320.274]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[1104.39,554.203],[1104.39,443.706],[1144.15,553.739],[1144.15,446.673]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[1104.39,570.151],[1104.39,680.649],[1144.15,569.192],[1144.15,676.259]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[1104.39,697.266],[1104.39,807.764],[1144.15,692.36],[1144.15,799.427]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[1105.47,828.042],[1105.47,938.469],[1145.01,819.118],[1145.01,926.132]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[1276.59,828.897],[1276.59,939.651],[1135.93,818.91],[1135.93,925.844]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[1275.86,423.605],[1275.86,312.966],[1144.15,427.34],[1144.15,320.274]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[1275.86,554.223],[1275.86,443.583],[1144.15,553.739],[1144.15,446.673]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[1275.86,570.191],[1275.86,680.831],[1144.15,569.192],[1144.15,676.259]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[1275.86,697.47],[1275.86,808.11],[1144.15,692.36],[1144.15,799.427]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[1156.31,302.206],[1255.26,301.651],[1156.31,196.616],[1255.26,195.814]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[1255.26,301.651],[1255.26,195.814],[1337.52,303.758],[1337.52,198.861]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[1275.86,423.605],[1275.86,312.965],[1296.12,425.717],[1296.12,317.098]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[1275.86,554.222],[1275.86,443.583],[1296.12,553.949],[1296.12,445.33]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[1275.86,570.191],[1275.86,680.831],[1296.12,569.626],[1296.12,678.245]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[1275.86,697.47],[1275.86,808.11],[1296.12,694.58],[1296.12,803.2]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[1276.59,828.897],[1276.59,939.651],[1297.6,823.409],[1297.6,932.064]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[1361.73,423.9],[1361.73,313.542],[1296.12,425.717],[1296.12,317.098]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[1361.73,554.184],[1361.73,443.827],[1296.12,553.949],[1296.12,445.33]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[1361.73,570.112],[1361.73,680.47],[1296.12,569.626],[1296.12,678.245]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[1361.73,697.067],[1361.73,807.425],[1296.12,694.58],[1296.12,803.2]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[1360.08,827.739],[1360.08,938.05],[1297.6,823.408],[1297.6,932.064]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[1337.52,303.758],[1337.52,198.861],[1361.06,309.052],[1361.06,206.512]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[1360.08,827.739],[1360.08,938.05],[1436.09,823.646],[1436.09,932.391]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[1397.46,307.04],[1397.46,203.604],[1361.06,309.052],[1361.06,206.512]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[1361.73,423.9],[1361.73,313.542],[1437.32,425.552],[1437.32,316.775]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[1361.73,554.184],[1361.73,443.827],[1437.32,553.971],[1437.32,445.193]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[1361.73,570.112],[1361.73,680.47],[1437.32,569.67],[1437.32,678.448]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[1361.73,697.067],[1361.73,807.425],[1437.32,694.807],[1437.32,803.584]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[1397.46,307.04],[1397.46,203.604],[1433.25,311.385],[1433.25,209.885]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[1433.25,311.385],[1433.25,209.885],[1456.63,314.514],[1456.63,214.408]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[1436.09,823.646],[1436.09,932.391],[1523.21,797.535],[1523.21,896.296]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[1437.32,425.552],[1437.32,316.775],[1524.34,435.994],[1524.34,337.207]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[1437.32,553.97],[1437.32,445.193],[1524.34,552.619],[1524.34,453.831]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[1437.32,569.67],[1437.32,678.448],[1524.34,566.877],[1524.34,665.664]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[1437.32,694.807],[1437.32,803.584],[1524.34,680.521],[1524.34,779.308]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[1456.63,314.514],[1456.63,214.408],[1486.21,319.268],[1486.21,221.279]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[1487.72,319.639],[1487.72,221.815],[1499.87,324.984],[1499.87,229.541]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[1499.87,324.984],[1499.87,229.541],[1504.89,328.542],[1504.89,234.683]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[1504.9,328.542],[1504.9,234.683],[1509.44,333.375],[1509.44,241.669]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[1524.8,436.049],[1524.8,337.313],[1597.11,444.725],[1597.11,354.291]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[1524.8,552.612],[1524.8,453.876],[1597.11,551.489],[1597.11,461.054]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[1524.8,566.862],[1524.8,665.598],[1597.11,564.541],[1597.11,654.976]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[1524.8,680.446],[1524.8,779.182],[1597.11,668.576],[1597.11,759.01]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:57,
                    verts:[[1527.81,797.505],[1527.81,896.255],[1599.88,775.79],[1599.88,866.237]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[505.76,444.757],[505.76,354.353],[459.411,445.795],[459.411,356.385]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[505.76,551.485],[505.76,461.081],[459.411,551.35],[459.411,461.94]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[505.76,564.533],[505.76,654.936],[459.411,564.255],[459.411,653.665]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[505.76,668.532],[505.76,758.936],[459.411,667.112],[459.411,756.522]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[503.878,775.566],[503.878,865.927],[459.751,773.093],[459.751,862.508]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[584.718,785.738],[584.718,879.988],[476.845,779.55],[476.845,871.435]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[580.526,440.912],[580.526,346.83],[479.731,443.221],[479.731,351.348]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[580.526,551.982],[580.526,457.9],[479.731,551.683],[479.731,459.81]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[580.526,565.561],[580.526,659.643],[479.731,564.943],[479.731,656.817]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[580.526,673.792],[580.526,767.874],[479.731,670.633],[479.731,762.507]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[615.137,433.905],[615.137,333.119],[535.408,438.006],[535.408,341.144]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[615.137,552.889],[615.137,452.103],[535.408,552.358],[535.408,455.496]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[615.137,567.436],[615.137,668.222],[535.408,566.339],[535.408,663.201]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[615.137,683.379],[615.137,784.165],[535.408,677.768],[535.408,774.631]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[620.242,803.186],[620.242,904.109],[535.314,792.342],[535.314,889.118]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[565.918,336.52],[565.918,246.216],[554.637,342.578],[554.637,254.972]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[603.833,330.313],[603.833,237.243],[565.918,336.52],[565.918,246.216]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[679.575,321.919],[679.575,225.111],[603.833,330.313],[603.833,237.243]]
                },{
                    num:"503",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1008.19,429.027],[1008.19,320.138],[626.178,437.946],[626.178,337.869]]
                },{
                    num:"403",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1008.19,557.577],[1008.19,448.688],[626.178,556.094],[626.178,456.017]]
                },{
                    num:"303",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1008.19,573.293],[1008.19,682.182],[626.178,570.539],[626.178,670.616]]
                },{
                    num:"203",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1008.19,698.558],[1008.19,807.447],[626.178,685.667],[626.178,785.744]]
                },{
                    num:"103",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1008.19,824.021],[1008.19,932.91],[626.178,800.976],[626.178,901.054]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[773.064,313.214],[773.064,212.528],[672.955,320.911],[672.955,223.654]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[912.008,306.212],[912.008,202.407],[773.064,313.214],[773.064,212.528]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1048.23,302.464],[1048.23,196.987],[912.007,306.212],[912.007,202.407]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1160.8,829.609],[1004.78,826.61],[1160.8,940.635],[1004.78,936.49]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1159.89,423.122],[1159.89,312.02],[1012.4,424.234],[1012.4,314.197]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1159.89,554.285],[1159.89,443.183],[1012.4,554.141],[1012.4,444.103]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1159.89,570.321],[1159.89,681.423],[1012.4,570.023],[1012.4,680.061]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1159.89,698.131],[1159.89,809.233],[1012.4,696.609],[1012.4,806.647]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1199.39,301.473],[1058.03,303.181],[1199.39,195.557],[1058.03,198.025]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1159.89,423.122],[1159.89,312.02],[1190.95,426.93],[1190.95,319.47]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1159.89,554.285],[1159.89,443.183],[1190.95,553.792],[1190.95,446.333]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1159.89,570.321],[1159.89,681.423],[1190.95,569.302],[1190.95,676.761]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1159.89,698.131],[1159.89,809.233],[1190.95,692.922],[1190.95,800.382]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1160.8,829.609],[1160.8,940.635],[1191.68,820.134],[1191.68,927.537]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1330.4,828.509],[1330.4,939.115],[1182.49,820.025],[1182.49,927.386]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1329.41,423.758],[1329.41,313.264],[1190.95,426.93],[1190.95,319.47]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1329.41,554.203],[1329.41,443.709],[1190.95,553.792],[1190.95,446.333]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1329.41,570.15],[1329.41,680.644],[1190.95,569.302],[1190.95,676.761]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1329.41,697.261],[1329.41,807.755],[1190.95,692.922],[1190.95,800.382]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1199.39,301.473],[1199.39,195.557],[1297.51,301.843],[1297.51,196.092]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1297.51,301.843],[1297.51,196.092],[1375.71,304.724],[1375.71,200.257]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1329.41,423.758],[1329.41,313.264],[1344.32,425.972],[1344.32,317.597]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1329.41,554.203],[1329.41,443.709],[1344.32,553.916],[1344.32,445.541]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1329.41,570.15],[1329.41,680.644],[1344.32,569.558],[1344.32,677.933]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1329.41,697.261],[1329.41,807.755],[1344.32,694.232],[1344.32,802.607]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1330.4,828.509],[1330.4,939.115],[1345.85,822.755],[1345.85,931.161]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1412.58,424.443],[1412.58,314.605],[1344.32,425.972],[1344.32,317.597]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1412.58,554.114],[1412.58,444.276],[1344.32,553.916],[1344.32,445.541]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1412.58,569.967],[1412.58,679.805],[1344.32,569.558],[1344.32,677.933]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1412.58,696.324],[1412.58,806.162],[1344.32,694.232],[1344.32,802.607]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1410.86,826.399],[1410.86,936.197],[1345.85,822.755],[1345.85,931.161]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1375.71,304.724],[1375.71,200.257],[1392.92,310.242],[1392.92,208.233]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1430.48,308.558],[1392.92,310.242],[1430.48,205.798],[1392.92,208.233]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1410.86,826.399],[1410.86,936.197],[1480.83,821.453],[1480.83,929.36]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1412.58,424.443],[1412.58,314.605],[1482.1,426.434],[1482.1,318.5]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1412.58,554.114],[1412.58,444.276],[1482.1,553.856],[1482.1,445.923]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1412.58,569.967],[1412.58,679.805],[1482.1,569.435],[1482.1,677.368]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1412.58,696.324],[1412.58,806.162],[1482.1,693.6],[1482.1,801.534]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1430.48,308.558],[1430.48,205.798],[1460.48,313.22],[1460.48,212.536]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1460.48,313.22],[1460.48,212.536],[1479.72,316.547],[1479.72,217.346]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1479.72,316.547],[1479.72,217.346],[1503.14,321.539],[1503.14,224.561]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1480.83,821.453],[1480.83,929.36],[1540.63,794.512],[1540.63,892.118]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1482.1,426.434],[1482.1,318.5],[1541.79,437.207],[1541.79,339.58]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1482.1,553.856],[1482.1,445.923],[1541.79,552.462],[1541.79,454.835]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1482.1,569.435],[1482.1,677.368],[1541.79,566.552],[1541.79,664.18]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1482.1,693.6],[1482.1,801.534],[1541.79,678.862],[1541.79,776.489]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1504.2,321.921],[1504.2,225.113],[1510.14,327.342],[1510.14,232.95]]
                },{
                    num:"601",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1510.14,327.342],[1510.14,232.95],[1511.13,330.922],[1511.13,238.124]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1542.1,437.263],[1542.1,339.689],[1591.34,446.148],[1591.34,357.076]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1542.1,552.455],[1542.1,454.881],[1591.34,551.304],[1591.34,462.232]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1542.1,566.538],[1542.1,664.111],[1591.34,564.16],[1591.34,653.233]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1542.1,678.785],[1542.1,776.359],[1591.34,666.629],[1591.34,755.702]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:58,
                    verts:[[1545.03,794.437],[1545.03,892.014],[1594.01,772.204],[1594.01,861.279]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[448.762,442.998],[448.762,350.911],[445.23,445.892],[445.23,356.574]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[448.762,551.712],[448.762,459.625],[445.23,551.338],[445.23,462.019]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[448.762,565.003],[448.762,657.09],[445.23,564.229],[445.23,653.547]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[448.762,670.939],[448.762,763.026],[445.23,666.98],[445.23,756.298]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[449.13,780.089],[449.13,872.179],[445.23,772.839],[445.23,862.157]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[499.636,442.11],[499.636,349.173],[448.762,442.998],[448.762,350.911]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[499.636,551.827],[499.636,458.891],[448.762,551.712],[448.762,459.625]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[499.636,565.241],[499.636,658.178],[448.762,565.003],[448.762,657.09]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[499.636,672.154],[499.636,765.091],[448.762,670.939],[448.762,763.026]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[497.567,782.205],[497.567,875.105],[449.13,780.089],[449.13,872.179]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[591.192,791.872],[591.192,888.468],[473.121,786.597],[473.121,881.177]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[586.434,438.448],[586.434,342.009],[476.108,440.417],[476.109,345.861]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[586.434,552.301],[586.434,455.862],[476.108,552.046],[476.109,457.49]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[586.434,566.22],[586.434,662.66],[476.109,565.694],[476.108,660.25]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[586.434,677.163],[586.434,773.603],[476.109,674.47],[476.108,769.026]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[571.18,341.77],[571.18,253.803],[542.65,342.77],[542.65,255.249]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[561.952,331.358],[561.952,238.754],[543.573,337.505],[543.573,247.64]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[638.807,431.38],[638.807,328.179],[546.487,435.261],[546.487,335.772]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[638.807,553.216],[638.807,450.015],[546.487,552.714],[546.487,453.225]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[638.807,568.111],[638.807,671.312],[546.487,567.073],[546.487,666.562]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[638.807,686.833],[638.807,790.034],[546.487,681.524],[546.487,781.013]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[644.416,809.456],[644.416,912.776],[546.175,799.205],[546.175,898.605]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[608.054,325.294],[608.054,229.989],[561.951,331.358],[561.951,238.754]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[695.357,317.346],[695.357,218.5],[608.054,325.294],[608.054,229.989]]
                },{
                    num:"503",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[1058.15,428.133],[1058.15,318.361],[648.453,435.57],[648.453,333.144]]
                },{
                    num:"403",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[1058.15,557.726],[1058.15,447.954],[648.453,556.489],[648.453,454.064]]
                },{
                    num:"303",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[1058.15,573.569],[1058.15,683.341],[648.453,571.272],[648.453,673.698]]
                },{
                    num:"203",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[1058.15,699.85],[1058.15,809.621],[648.453,689.102],[648.453,791.527]]
                },{
                    num:"103",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[1058.15,826.329],[1058.15,936.101],[648.453,807.116],[648.453,909.542]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[800.6,309.292],[800.6,206.858],[689.662,316.251],[689.662,216.918]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[949.113,303.468],[949.113,198.44],[800.6,309.291],[800.6,206.858]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[1089.75,300.973],[1089.75,194.832],[949.112,303.468],[949.112,198.44]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[1057.17,828.995],[1215.02,830.198],[1057.17,939.786],[1215.02,941.45]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[1065.18,423.315],[1214.31,422.882],[1065.18,312.397],[1214.31,311.55]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[1065.18,554.26],[1065.18,443.342],[1214.31,554.316],[1214.31,442.984]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[1065.18,570.269],[1214.31,570.385],[1065.18,681.187],[1214.31,681.717]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[1065.18,697.868],[1214.31,698.46],[1065.18,808.785],[1214.31,809.792]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[1098.72,301.792],[1240.56,301.423],[1098.72,196.019],[1240.56,195.485]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[1214.31,422.882],[1214.31,311.55],[1236.02,426.859],[1236.02,319.332]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[1214.31,554.316],[1214.31,442.984],[1236.02,553.801],[1236.02,446.274]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[1214.31,570.385],[1214.31,681.717],[1236.02,569.321],[1236.02,676.848]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[1214.31,698.46],[1214.31,809.792],[1236.02,693.019],[1236.02,800.546]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[1215.02,830.198],[1215.02,941.45],[1236.6,820.302],[1236.6,927.769]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[1379.08,424.307],[1379.08,314.338],[1236.02,426.859],[1236.02,319.332]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[1379.08,554.132],[1379.08,444.163],[1236.02,553.801],[1236.02,446.274]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[1379.08,570.004],[1379.08,679.973],[1236.02,569.321],[1236.02,676.848]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[1379.08,696.511],[1379.08,806.48],[1236.02,693.019],[1236.02,800.546]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[1380.32,827.125],[1380.32,937.202],[1227.44,820.296],[1227.44,927.76]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[1240.56,301.423],[1240.56,195.485],[1336.39,302.728],[1336.39,197.371]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[1336.38,302.728],[1336.38,197.371],[1409.41,306.342],[1409.41,202.595]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[1379.08,424.306],[1379.08,314.337],[1388.43,426.59],[1388.43,318.805]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[1379.08,554.132],[1379.08,444.163],[1388.43,553.836],[1388.43,446.052]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[1379.08,570.004],[1379.08,679.973],[1388.43,569.393],[1388.43,677.177]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[1379.08,696.511],[1379.08,806.48],[1388.43,693.387],[1388.43,801.171]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[1380.32,827.126],[1380.32,937.202],[1389.99,821.193],[1389.99,929.001]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[1458.24,425.371],[1458.24,316.42],[1388.43,426.59],[1388.43,318.805]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[1458.24,553.994],[1458.24,445.043],[1388.43,553.836],[1388.43,446.052]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[1458.24,569.719],[1458.24,678.669],[1388.43,569.393],[1388.43,677.177]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[1458.24,695.055],[1458.24,804.005],[1388.43,693.387],[1388.43,801.171]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[1456.48,824.097],[1389.99,821.193],[1456.48,933.015],[1389.99,929]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[1409.41,306.342],[1409.41,202.596],[1420.12,312.007],[1420.12,210.784]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[1458.31,310.669],[1420.12,312.007],[1458.31,208.849],[1420.12,210.784]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[1456.48,824.097],[1456.48,933.015],[1519.41,818.386],[1519.41,925.12]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[1458.31,310.669],[1458.31,208.849],[1482.22,315.579],[1482.22,215.946]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[1458.24,425.371],[1458.24,316.42],[1520.69,427.666],[1520.69,320.91]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[1458.24,553.994],[1458.24,445.043],[1520.69,553.697],[1520.69,446.942]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[1458.24,569.719],[1458.24,678.669],[1520.69,569.105],[1520.69,675.86]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[1458.24,695.055],[1458.24,804.005],[1520.69,691.915],[1520.69,798.671]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[1482.22,315.579],[1482.22,215.946],[1497.16,319.057],[1497.16,220.973]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[1497.16,319.057],[1497.16,220.973],[1514.29,324.217],[1514.29,228.432]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[1519.41,818.386],[1519.41,925.12],[1551.81,791.006],[1551.81,887.271]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[1520.69,427.666],[1520.69,320.91],[1552.97,438.613],[1552.97,342.331]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[1520.69,553.697],[1520.69,446.942],[1552.97,552.28],[1552.97,455.998]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[1520.69,569.105],[1520.69,675.86],[1552.97,566.176],[1552.97,662.458]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[1520.69,691.915],[1520.69,798.671],[1552.97,676.938],[1552.97,773.22]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[1553.14,438.67],[1553.14,342.442],[1579.62,447.651],[1579.62,360.016]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[1553.14,552.272],[1553.14,456.045],[1579.62,551.11],[1579.62,463.475]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[1553.14,566.161],[1553.14,662.389],[1579.62,563.758],[1579.62,651.393]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[1553.14,676.861],[1553.14,773.088],[1579.62,664.573],[1579.62,752.208]]
                },{
                    num:"101",
                    tipo:"TorreD",
                    frame:59,
                    verts:[[1555.95,790.887],[1555.95,887.107],[1582.18,768.419],[1582.18,856.048]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[442.789,440.144],[442.789,345.327],[432.177,443.12],[432.177,351.15]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[442.789,552.082],[442.789,457.264],[432.177,551.696],[432.177,459.726]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[442.789,565.767],[442.789,660.584],[432.177,564.971],[432.177,656.941]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[442.789,674.844],[442.789,769.661],[432.177,670.772],[432.177,762.742]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[443.183,787.226],[443.183,882.046],[432.177,779.774],[432.177,871.744]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[498.045,439.439],[498.045,343.947],[442.789,440.144],[442.789,345.327]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[498.045,552.173],[498.045,456.681],[442.789,552.082],[442.789,457.264]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[498.045,565.955],[498.045,661.447],[442.789,565.767],[442.789,660.584]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[498.045,675.808],[498.045,771.3],[442.789,674.844],[442.789,769.661]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[495.797,788.906],[495.797,884.367],[443.183,787.226],[443.183,882.046]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[602.209,797.863],[602.209,896.75],[474.48,793.697],[474.48,890.99]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[596.898,436.038],[596.898,337.292],[477.542,437.593],[477.542,340.335]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[596.898,552.613],[596.898,453.868],[477.542,552.412],[477.542,455.154]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[596.898,566.865],[596.898,665.611],[477.542,566.449],[477.542,663.707]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[596.898,680.461],[596.898,779.207],[477.542,678.334],[477.542,775.592]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[560.015,336.986],[560.015,246.889],[529.305,337.774],[529.305,248.027]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[561.995,326.201],[561.995,231.299],[536.103,332.364],[536.103,240.209]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[616.421,320.385],[616.421,222.893],[561.994,326.201],[561.994,231.299]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[673.841,815.325],[673.841,920.889],[562.56,805.9],[562.56,907.86]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[667.772,429.012],[667.772,323.546],[563.105,432.584],[563.105,330.533]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[667.772,553.523],[667.772,448.056],[563.105,553.06],[563.105,451.01]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[667.772,568.745],[667.772,674.211],[563.105,567.789],[563.105,669.84]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[667.772,690.073],[667.772,795.539],[563.105,685.187],[563.105,787.237]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[715.039,313.046],[715.039,212.285],[616.421,320.385],[616.421,222.893]]
                },{
                    num:"503",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[1108.27,427.614],[1108.27,317.33],[675.77,433.339],[675.77,328.711]]
                },{
                    num:"403",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[1108.27,557.812],[1108.27,447.528],[675.77,556.86],[675.77,452.232]]
                },{
                    num:"303",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[1108.27,573.729],[1108.27,684.013],[675.77,571.961],[675.77,676.59]]
                },{
                    num:"203",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[1108.27,700.599],[1108.27,810.883],[675.77,692.325],[675.77,796.954]]
                },{
                    num:"103",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[1108.27,827.669],[1108.27,937.953],[675.77,812.878],[675.77,917.507]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[831.326,305.823],[831.326,201.845],[710.411,311.872],[710.411,210.588]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[987.672,301.349],[987.672,195.378],[831.326,305.823],[831.326,201.845]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[1130.7,300.204],[987.672,301.349],[1130.7,193.72],[987.672,195.378]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[1109.8,830.371],[1109.8,941.688],[1266.83,829.707],[1266.83,940.771]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[1118.07,422.802],[1118.07,311.394],[1266.34,423.074],[1266.34,311.927]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[1118.07,554.326],[1118.07,442.918],[1266.34,554.291],[1266.34,443.144]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[1118.07,570.406],[1118.07,681.814],[1266.34,570.333],[1266.34,681.481]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[1118.07,698.569],[1118.07,809.977],[1266.34,698.197],[1266.34,809.344]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[1138.7,301.116],[1138.69,195.042],[1278.85,302.119],[1278.85,196.49]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[1266.34,423.074],[1266.34,311.927],[1278.3,427.16],[1278.3,319.922]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[1266.34,554.291],[1266.34,443.144],[1278.3,553.762],[1278.3,446.524]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[1266.34,570.333],[1266.34,681.481],[1278.3,569.24],[1278.3,676.479]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[1266.34,698.197],[1266.34,809.344],[1278.3,692.607],[1278.3,799.845]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[1266.83,829.707],[1266.83,940.771],[1278.73,819.541],[1278.73,926.717]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[1423.64,425.267],[1423.64,316.217],[1278.3,427.16],[1278.3,319.922]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[1423.64,554.007],[1423.64,444.957],[1278.3,553.762],[1278.3,446.524]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[1423.64,569.747],[1423.64,678.797],[1278.3,569.24],[1278.3,676.479]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[1423.64,695.197],[1423.64,804.247],[1278.3,692.607],[1278.3,799.845]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[1425.1,824.707],[1425.1,933.859],[1269.74,819.639],[1269.74,926.853]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[1278.85,302.119],[1278.85,196.49],[1370.94,304.339],[1370.94,199.7]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[1370.94,304.34],[1370.94,199.7],[1437.8,308.625],[1437.8,205.895]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[1423.64,425.267],[1423.64,316.216],[1427.36,427.583],[1427.36,320.748]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[1423.64,554.007],[1423.64,444.957],[1427.36,553.708],[1427.36,446.873]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[1423.64,569.747],[1423.64,678.797],[1427.36,569.127],[1427.36,675.962]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[1423.64,695.197],[1423.64,804.247],[1427.36,692.029],[1427.36,798.864]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[1425.1,824.707],[1425.1,933.859],[1428.93,818.691],[1428.93,925.542]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[1497.57,426.687],[1427.36,427.583],[1497.57,318.995],[1427.36,320.748]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[1497.57,553.824],[1497.57,446.132],[1427.36,553.708],[1427.36,446.873]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[1497.57,569.367],[1497.57,677.059],[1427.36,569.127],[1427.36,675.962]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[1497.57,693.255],[1427.36,692.029],[1497.57,800.946],[1427.36,798.864]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[1495.8,820.826],[1428.93,818.691],[1495.8,928.493],[1428.93,925.542]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[1437.8,308.625],[1437.8,205.895],[1441.99,314.353],[1441.99,214.175]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[1480.27,313.371],[1441.99,314.353],[1480.27,212.756],[1441.99,214.175]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[1480.27,313.371],[1480.27,212.756],[1497.94,318.454],[1497.94,220.103]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[1495.8,820.826],[1495.8,928.493],[1550.9,814.46],[1550.9,919.693]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[1497.94,318.454],[1497.94,220.103],[1508.52,322.031],[1508.52,225.272]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[1497.57,426.687],[1497.57,318.995],[1552.18,429.241],[1552.18,323.992]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[1497.57,553.824],[1497.57,446.132],[1552.18,553.493],[1552.18,448.245]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[1497.57,569.367],[1497.57,677.059],[1552.18,568.684],[1552.18,673.932]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[1497.57,693.255],[1497.57,800.946],[1552.18,689.76],[1552.18,795.009]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[1508.52,322.031],[1508.52,225.272],[1519.37,327.286],[1519.37,232.868]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[1550.9,814.46],[1550.9,919.693],[1556.45,787.044],[1556.45,881.794]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[1552.18,429.241],[1552.18,323.992],[1557.6,440.201],[1557.6,345.439]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[1552.18,553.493],[1552.18,448.245],[1557.6,552.074],[1557.6,457.312]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[1552.18,568.684],[1552.18,673.932],[1557.6,565.751],[1557.6,660.514]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[1552.18,689.76],[1552.18,795.009],[1557.6,674.765],[1557.6,769.528]]
                },{
                    num:"501",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[1557.63,440.258],[1557.63,345.55],[1562.07,449.223],[1562.07,363.091]]
                },{
                    num:"401",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[1557.63,552.067],[1557.63,457.359],[1562.07,550.906],[1562.07,464.775]]
                },{
                    num:"301",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[1557.63,565.736],[1557.63,660.444],[1562.07,563.338],[1562.07,649.47]]
                },{
                    num:"201",
                    tipo:"TorreD",
                    frame:60,
                    verts:[[1557.63,674.688],[1557.63,769.396],[1562.07,662.423],[1562.07,748.555]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[442.28,437.288],[442.28,339.738],[424.014,440.312],[424.014,345.655]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[442.28,552.451],[442.28,454.902],[424.014,552.06],[424.014,457.403]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[442.28,566.531],[442.28,664.08],[424.014,565.722],[424.014,660.379]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[442.28,678.751],[442.28,776.301],[424.014,674.614],[424.014,769.271]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[442.699,794.368],[442.699,891.918],[424.014,786.8],[424.014,881.457]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[501.639,436.801],[501.639,338.786],[442.28,437.288],[442.28,339.738]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[501.639,552.514],[501.639,454.499],[442.28,552.451],[442.28,454.902]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[501.639,566.661],[501.639,664.676],[442.28,566.531],[442.28,664.08]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[501.639,679.417],[501.639,777.432],[442.28,678.751],[442.28,776.301]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[499.224,795.527],[499.224,893.521],[442.699,794.368],[442.699,891.918]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[618.104,803.552],[618.104,904.615],[481.609,800.692],[481.609,900.661]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[612.269,433.744],[612.269,332.804],[484.712,434.812],[484.712,334.893]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[612.269,552.91],[612.269,451.97],[484.712,552.772],[484.712,452.853]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[612.269,567.479],[612.269,668.419],[484.712,567.193],[484.712,667.112]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[612.269,683.599],[612.269,784.539],[484.712,682.139],[484.712,782.058]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[552.476,332.21],[552.476,239.985],[519.736,332.75],[519.736,240.766]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[566.559,321.164],[566.559,224.02],[532.835,327.255],[532.835,232.824]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[629.269,315.712],[629.269,216.138],[566.559,321.164],[566.559,224.02]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[708.454,820.591],[708.454,928.169],[584.829,812.241],[584.829,916.626]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[701.99,426.881],[701.99,319.375],[585.619,430.049],[585.619,325.574]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[701.99,553.798],[701.99,446.293],[585.619,553.388],[585.619,448.913]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[701.99,569.315],[701.99,676.821],[585.619,568.467],[585.619,672.942]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[701.99,692.988],[701.99,800.494],[585.619,688.654],[585.619,793.129]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[738.631,309.155],[738.631,206.661],[629.269,315.712],[629.269,216.138]]
                },{
                    num:"503",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[1157.36,427.514],[1157.36,317.13],[708.096,431.33],[708.096,324.717]]
                },{
                    num:"403",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[1157.36,557.829],[1157.36,447.445],[708.096,557.194],[708.096,450.581]]
                },{
                    num:"303",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[1157.36,573.76],[1157.36,684.144],[708.096,572.582],[708.096,679.195]]
                },{
                    num:"203",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[1157.36,700.745],[1157.36,811.129],[708.096,695.229],[708.096,801.843]]
                },{
                    num:"103",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[1157.36,827.93],[1157.36,938.313],[708.096,818.069],[708.096,924.683]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[864.869,302.943],[864.869,197.683],[735.206,307.913],[735.206,204.865]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[1026.94,299.966],[1026.94,193.378],[864.868,302.943],[864.868,197.682]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[1026.94,299.965],[1170.15,300.229],[1026.94,193.378],[1170.15,193.757]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[1161.42,830.622],[1161.42,942.035],[1314.94,828.084],[1314.94,938.527]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[1169.81,422.741],[1169.81,311.274],[1314.66,423.721],[1314.66,313.192]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[1169.81,554.334],[1169.81,442.868],[1314.66,554.208],[1314.66,443.679]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[1169.81,570.422],[1169.81,681.889],[1314.66,570.16],[1314.66,680.689]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[1169.81,698.653],[1169.81,810.119],[1314.66,697.312],[1314.66,807.841]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[1177.03,301.223],[1177.03,195.196],[1313.34,303.589],[1313.34,198.616]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[1313.34,303.589],[1313.34,198.616],[1400.35,306.679],[1400.35,203.082]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[1314.66,423.721],[1314.66,313.192],[1316.75,427.849],[1316.75,321.269]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[1314.66,554.208],[1314.66,443.679],[1316.75,553.673],[1316.75,447.093]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[1314.66,570.16],[1314.66,680.689],[1316.75,569.056],[1316.75,675.636]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[1314.66,697.312],[1314.66,807.84],[1316.75,691.665],[1316.75,798.245]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[1314.94,828.084],[1314.94,938.527],[1317.01,817.814],[1317.01,924.33]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[1316.75,427.849],[1461.98,426.633],[1316.75,321.269],[1461.98,318.891]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[1316.75,553.673],[1461.98,553.831],[1316.75,447.093],[1461.98,446.088]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[1316.75,569.056],[1461.98,569.381],[1316.75,675.636],[1461.98,677.124]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[1316.75,691.665],[1461.98,693.327],[1316.75,798.245],[1461.98,801.07]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[1308.34,818.015],[1463.63,821.269],[1308.34,924.607],[1463.63,929.105]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[1400.35,306.679],[1400.35,203.082],[1460.21,311.554],[1460.21,210.128]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[1458.03,317.26],[1495.87,316.635],[1458.03,218.376],[1495.87,217.473]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[1460.16,428.943],[1529.66,428.374],[1460.16,323.411],[1529.66,322.296]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[1460.16,553.532],[1460.16,447.999],[1529.66,553.605],[1529.66,447.527]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[1460.16,568.763],[1529.66,568.916],[1460.16,674.296],[1529.66,674.993]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[1460.16,690.167],[1529.66,690.946],[1460.16,795.7],[1529.66,797.024]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[1461.71,815.268],[1527.9,816.625],[1461.71,920.81],[1527.9,922.687]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[1495.87,316.635],[1495.87,217.473],[1507.31,321.812],[1507.31,224.956]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[1507.31,321.812],[1507.31,224.956],[1513.57,325.433],[1513.57,230.19]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[1513.57,325.433],[1513.57,230.19],[1518.26,330.708],[1518.26,237.815]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[1527.9,816.625],[1527.9,922.687],[1574.63,809.734],[1574.63,913.16]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[1529.66,428.374],[1529.66,322.296],[1575.89,431.135],[1575.89,327.7]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[1529.66,553.605],[1529.66,447.527],[1575.89,553.248],[1575.89,449.812]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[1529.66,568.916],[1529.66,674.993],[1575.89,568.177],[1575.89,671.613]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:61,
                    verts:[[1529.66,690.946],[1529.66,797.024],[1575.89,687.168],[1575.89,790.604]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[447.958,434.494],[447.958,334.272],[421.545,437.523],[421.545,340.198]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[447.958,552.813],[447.958,452.591],[421.545,552.421],[421.545,455.096]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[447.958,567.278],[447.958,667.5],[421.545,566.468],[421.545,663.793]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[447.958,682.573],[447.958,782.795],[421.545,678.43],[421.545,775.755]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[448.398,801.353],[448.398,901.574],[421.545,793.778],[421.545,891.103]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[510.974,434.261],[510.974,333.815],[447.958,434.494],[447.958,334.272]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[510.974,552.843],[510.974,452.398],[447.958,552.813],[447.958,452.591]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[510.974,567.341],[510.974,667.786],[447.958,567.278],[447.958,667.5]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[510.974,682.892],[510.974,783.338],[447.958,682.573],[447.958,782.795]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[508.41,801.909],[508.41,902.343],[448.398,801.353],[448.398,901.574]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[639.051,808.77],[639.051,911.828],[495.074,807.407],[495.074,909.943]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[632.739,431.634],[632.739,328.676],[498.176,432.143],[498.176,329.672]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[632.739,553.183],[632.739,450.225],[498.176,553.117],[498.176,450.646]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[632.739,568.043],[632.739,671.002],[498.176,567.907],[498.176,670.379]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[632.739,686.485],[632.739,789.444],[498.176,685.789],[498.176,788.261]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[549.113,327.541],[514.565,327.799],[549.113,233.237],[514.565,233.61]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[576.06,316.375],[576.06,217.097],[534.322,322.291],[534.322,225.648]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[646.793,311.408],[646.793,209.918],[576.06,316.375],[576.06,217.097]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[747.924,825.058],[747.924,934.343],[613.127,818.029],[613.127,924.627]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[741.148,425.066],[741.148,315.823],[614.168,427.737],[614.168,321.051]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[741.148,554.033],[741.148,444.791],[614.168,553.688],[614.168,447.001]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[741.148,569.801],[741.148,679.043],[614.168,569.086],[614.168,675.772]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[741.148,695.472],[741.148,804.715],[614.168,691.817],[614.168,798.504]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[765.968,305.806],[765.968,201.819],[646.793,311.408],[646.793,209.918]]
                },{
                    num:"503",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[1204.2,427.854],[1204.2,317.807],[745.147,429.616],[745.147,321.308]]
                },{
                    num:"403",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[1204.2,557.772],[1204.2,447.725],[745.147,557.479],[745.147,449.172]]
                },{
                    num:"303",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[1204.2,573.655],[1204.2,683.703],[745.147,573.111],[745.147,681.419]]
                },{
                    num:"203",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[1204.2,700.253],[1204.2,810.3],[745.147,697.707],[745.147,806.014]]
                },{
                    num:"103",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[1204.2,827.05],[1204.2,937.097],[745.147,822.499],[745.147,930.806]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[900.672,300.773],[900.672,194.545],[763.863,304.511],[763.863,199.948]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[1066.04,299.4],[900.672,300.773],[1066.04,192.561],[900.672,194.545]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[1066.04,299.4],[1066.04,192.56],[1207.15,301.089],[1207.15,195]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[1210.72,829.687],[1210.72,940.743],[1358.1,825.332],[1358.1,934.723]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[1212.82,302.147],[1212.81,196.531],[1343.2,305.825],[1343.2,201.848]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[1219.09,423.156],[1219.09,312.085],[1358.04,424.821],[1358.04,315.344]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[1219.09,554.281],[1219.09,443.211],[1358.04,554.065],[1358.04,444.588]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[1219.09,570.312],[1219.09,681.382],[1358.04,569.866],[1358.04,679.343]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[1219.09,698.086],[1219.09,809.156],[1358.04,695.808],[1358.04,805.285]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[1343.2,305.825],[1343.2,201.848],[1423.96,309.712],[1423.96,207.465]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[1350.43,428.921],[1350.43,323.366],[1493.23,428.381],[1493.23,322.309]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[1350.43,553.534],[1350.43,447.98],[1493.23,553.604],[1493.23,447.533]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[1350.43,568.769],[1350.43,674.324],[1493.23,568.914],[1493.23,674.985]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[1350.43,690.198],[1350.43,795.753],[1493.23,690.937],[1493.23,797.009]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[1342.3,815.429],[1342.3,921.032],[1495.05,816.875],[1495.05,923.032]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[1423.96,309.712],[1423.96,207.465],[1476.2,315.077],[1476.2,215.22]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[1467.94,320.677],[1504.85,320.402],[1467.94,223.315],[1504.85,222.917]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[1486.12,430.648],[1486.12,326.745],[1553.86,430.397],[1553.86,326.254]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[1486.12,553.311],[1486.12,449.409],[1553.86,553.343],[1553.86,449.201]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[1486.12,568.307],[1486.12,672.209],[1553.86,568.374],[1553.86,672.517]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[1486.12,687.835],[1486.12,791.738],[1553.86,688.179],[1553.86,792.321]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[1487.63,810.986],[1552.14,811.584],[1487.63,914.891],[1552.14,915.718]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[1504.85,320.402],[1504.85,222.917],[1510.19,325.593],[1510.19,230.421]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[1510.19,325.593],[1510.19,230.421],[1512.27,329.207],[1512.26,235.645]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[1552.14,811.584],[1552.14,915.718],[1590.23,804.308],[1590.23,905.66]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[1553.86,430.397],[1553.86,326.254],[1591.44,433.31],[1591.44,331.954]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[1553.86,553.343],[1553.86,449.201],[1591.44,552.966],[1591.44,451.611]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[1553.86,568.374],[1553.86,672.517],[1591.44,567.595],[1591.44,668.951]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:62,
                    verts:[[1553.86,688.179],[1553.86,792.321],[1591.44,684.194],[1591.44,785.549]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[460.393,431.834],[460.393,329.067],[425.48,434.817],[425.48,334.903]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[460.393,553.157],[460.393,450.39],[425.48,552.771],[425.48,452.857]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[460.393,567.99],[460.393,670.757],[425.48,567.192],[425.48,667.106]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[460.393,686.212],[460.393,788.979],[425.48,682.132],[425.48,782.046]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[460.849,808.003],[460.849,910.767],[425.48,800.549],[425.48,900.462]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[526.443,431.886],[526.443,329.168],[460.393,431.834],[460.393,329.067]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[526.443,553.151],[526.443,450.433],[460.393,553.157],[460.393,450.39]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[526.443,567.976],[526.443,670.694],[460.393,567.99],[460.393,670.757]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[526.443,686.141],[526.443,788.859],[460.393,686.212],[460.393,788.979]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[523.756,807.88],[460.849,808.003],[523.756,910.597],[460.849,910.767]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[510.372,328.194],[510.372,234.18],[509.215,331.777],[509.215,239.36]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[514.344,323.03],[514.344,226.717],[510.373,328.194],[510.373,234.18]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[550.4,323.087],[514.344,323.03],[550.4,226.799],[514.344,226.717]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[665.014,813.351],[665.014,918.16],[515.245,813.651],[515.245,918.575]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[658.295,429.776],[658.295,325.039],[518.298,429.664],[518.299,324.82]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[658.295,553.424],[658.295,448.687],[518.298,553.438],[518.299,448.595]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[658.295,568.54],[658.295,673.277],[518.299,568.57],[518.298,673.414]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[658.295,689.028],[658.295,793.765],[518.299,689.182],[518.298,794.026]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[590.763,311.964],[590.763,210.721],[541.008,317.594],[541.008,218.858]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[669.008,307.607],[669.008,204.423],[590.763,311.964],[590.763,210.721]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[791.633,828.547],[791.633,939.167],[647.328,823.067],[647.328,931.592]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[784.648,423.639],[784.648,313.031],[648.619,425.728],[648.619,317.118]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[784.648,554.218],[784.648,443.61],[648.619,553.948],[648.619,445.338]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[784.648,570.182],[784.648,680.79],[648.619,569.624],[648.619,678.233]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[784.648,697.425],[784.648,808.033],[648.619,694.567],[648.619,803.177]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[796.69,303.119],[796.69,197.936],[669.008,307.607],[669.008,204.423]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[938.016,299.406],[938.016,192.569],[795.996,301.79],[795.996,196.015]]
                },{
                    num:"503",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[786.369,428.263],[786.369,318.619],[1247.61,428.637],[1247.61,319.364]]
                },{
                    num:"403",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[786.369,557.704],[786.369,448.06],[1247.61,557.642],[1247.61,448.368]]
                },{
                    num:"303",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[786.369,573.529],[786.369,683.173],[1247.61,573.413],[1247.61,682.687]]
                },{
                    num:"203",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[786.369,699.663],[786.369,809.307],[1247.61,699.121],[1247.61,808.395]]
                },{
                    num:"103",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[786.369,825.995],[786.369,935.639],[1247.61,825.026],[1247.61,934.3]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[938.016,299.406],[1104.05,299.698],[938.016,192.569],[1104.05,192.991]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[1104.05,299.698],[1104.05,192.991],[1240.82,302.779],[1240.82,197.443]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[1245.18,303.884],[1245.18,199.042],[1367.78,308.781],[1367.78,206.12]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[1256.44,827.562],[1256.44,937.806],[1395.31,821.514],[1395.31,929.445]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[1264.63,424.045],[1264.63,313.825],[1395.46,426.348],[1395.46,318.331]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[1264.63,554.166],[1264.63,443.946],[1395.46,553.868],[1395.46,445.851]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[1264.63,570.074],[1264.63,680.293],[1395.46,569.458],[1395.46,677.474]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[1264.63,696.869],[1264.63,807.088],[1395.46,693.719],[1395.46,801.735]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[1367.78,308.781],[1367.78,206.12],[1441.32,313.368],[1441.32,212.75]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[1370.87,811.936],[1370.87,916.204],[1518.77,811.639],[1518.77,915.794]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[1378.59,430.353],[1378.59,326.168],[1516.84,430.463],[1516.84,326.384]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[1378.59,553.349],[1378.59,449.164],[1516.84,553.335],[1516.84,449.256]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[1378.59,568.386],[1378.59,672.571],[1516.84,568.357],[1516.84,672.435]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[1378.59,688.239],[1378.59,792.424],[1516.84,688.088],[1516.84,792.167]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[1441.32,313.368],[1441.32,212.75],[1485.57,319.115],[1485.57,221.057]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[1471.64,324.534],[1507.2,324.59],[1471.64,228.89],[1507.2,228.971]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[1504.82,432.654],[1504.82,330.67],[1569.86,432.705],[1569.86,330.77]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[1504.82,553.051],[1504.82,451.068],[1569.86,553.045],[1569.86,451.11]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[1504.82,567.771],[1504.82,669.754],[1569.86,567.757],[1569.86,669.692]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[1504.82,685.091],[1504.82,787.075],[1569.86,685.021],[1569.86,786.956]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[1506.27,805.951],[1506.27,907.931],[1568.22,805.829],[1568.22,907.763]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[1568.22,805.829],[1568.22,907.763],[1597.63,798.312],[1597.63,897.371]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[1569.86,432.705],[1569.86,330.77],[1598.79,435.711],[1598.79,336.653]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[1569.86,553.045],[1569.86,451.11],[1598.79,552.655],[1598.79,453.598]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[1569.86,567.757],[1569.86,669.692],[1598.79,566.953],[1598.79,666.01]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:63,
                    verts:[[1569.86,685.021],[1569.86,786.956],[1598.79,680.908],[1598.79,779.966]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[479.931,429.381],[479.931,324.267],[436.355,432.26],[436.355,329.901]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[479.931,553.475],[479.931,448.361],[436.355,553.102],[436.355,450.743]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[479.931,568.646],[479.931,673.76],[436.355,567.876],[436.355,670.235]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[479.931,689.569],[479.931,794.683],[436.355,685.629],[436.355,787.989]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[480.397,814.136],[480.397,919.245],[436.355,806.944],[436.355,909.304]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[548.211,429.745],[479.931,429.381],[548.211,324.979],[479.931,324.267]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[548.211,553.428],[548.211,448.662],[479.931,553.475],[479.931,448.361]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[548.211,568.549],[548.211,673.315],[479.931,568.646],[479.931,673.76]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[548.211,689.071],[479.931,689.569],[548.211,793.837],[479.931,794.683]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[545.434,813.268],[480.397,814.136],[545.434,918.046],[480.397,919.245]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[504.314,327.409],[504.314,233.046],[501,332.68],[501,240.665]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[509.557,323.772],[509.557,227.789],[504.314,327.409],[504.314,233.046]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[519.493,318.556],[519.493,220.249],[509.557,323.772],[509.557,227.79]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[556.68,318.955],[519.493,318.556],[556.68,220.826],[519.493,220.249]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[695.72,817.145],[542.225,819.237],[695.72,923.405],[542.225,926.297]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[688.68,428.228],[545.177,427.447],[688.68,322.011],[545.177,320.483]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[688.68,553.624],[688.68,447.407],[545.177,553.725],[545.177,446.761]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[688.68,568.954],[688.68,675.172],[545.177,569.163],[545.177,676.128]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[688.68,691.146],[545.177,692.214],[688.68,797.363],[545.177,799.178]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[610.735,308.058],[610.735,205.075],[553.176,313.284],[553.176,212.629]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[695.715,304.427],[695.715,199.827],[610.735,308.058],[610.735,205.075]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[838.686,830.919],[838.686,942.446],[686.994,827.177],[686.994,937.273]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[831.61,422.656],[831.61,311.108],[688.526,424.09],[688.526,313.914]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[831.61,554.345],[831.61,442.797],[688.526,554.16],[688.526,443.984]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[831.61,570.445],[831.61,681.993],[688.526,570.062],[688.526,680.237]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[831.61,698.769],[831.61,810.317],[688.526,696.807],[688.526,806.983]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[830.244,301.19],[830.244,195.148],[695.715,304.427],[695.715,199.828]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[976.057,298.901],[831.019,299.848],[976.057,191.839],[831.019,193.208]]
                },{
                    num:"503",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[830.945,427.324],[830.945,316.752],[1286.56,429.841],[1286.56,321.757]]
                },{
                    num:"403",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[830.945,557.86],[830.945,447.289],[1286.56,557.442],[1286.56,449.357]]
                },{
                    num:"303",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[830.945,573.819],[830.945,684.391],[1286.56,573.042],[1286.56,681.126]]
                },{
                    num:"203",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[830.945,701.019],[830.945,811.591],[1286.56,697.381],[1286.56,805.465]]
                },{
                    num:"103",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[830.945,828.42],[830.945,938.992],[1286.56,821.916],[1286.56,930.001]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[976.058,298.901],[976.058,191.839],[1140.06,300.861],[1140.06,194.672]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[1140.06,300.861],[1140.06,194.672],[1270.39,305.257],[1270.39,201.024]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[1273.43,306.388],[1273.43,202.662],[1386.67,312.374],[1386.67,211.314]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[1297.47,824.311],[1297.47,933.311],[1425.83,816.749],[1425.83,922.858]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[1305.36,425.383],[1305.36,316.444],[1426.18,428.255],[1426.18,322.063]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[1305.36,553.992],[1305.36,445.053],[1426.18,553.621],[1426.18,447.429]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[1305.36,569.716],[1305.36,678.655],[1426.18,568.947],[1426.18,675.139]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[1305.36,695.038],[1305.36,803.977],[1426.18,691.109],[1426.18,797.301]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[1386.67,312.374],[1386.67,211.314],[1452.29,317.55],[1452.29,218.796]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[1400.75,432.104],[1400.75,329.595],[1532.58,432.821],[1532.58,330.999]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[1400.75,553.122],[1400.75,450.613],[1532.58,553.03],[1532.58,451.207]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[1400.75,567.918],[1400.75,670.427],[1532.58,567.726],[1532.58,669.549]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[1400.75,685.843],[1400.75,788.353],[1532.58,684.862],[1532.58,786.685]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[1393.52,807.636],[1393.52,910.26],[1534.6,805.713],[1534.6,907.602]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[1452.29,317.55],[1452.29,218.796],[1488.39,323.566],[1488.39,227.492]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[1469.31,328.739],[1469.31,234.968],[1503.15,329.102],[1503.15,235.493]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[1516.14,434.905],[1516.14,335.077],[1577.73,435.234],[1577.73,335.719]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[1516.14,552.76],[1516.14,452.931],[1577.73,552.717],[1577.73,453.203]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[1516.14,567.168],[1516.14,666.997],[1577.73,567.08],[1577.73,666.595]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[1516.14,682.01],[1516.14,781.839],[1577.73,681.561],[1577.73,781.076]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[1517.51,800.301],[1517.51,900.121],[1576.17,799.519],[1576.17,899.039]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[1576.17,799.519],[1576.17,899.039],[1597.12,791.898],[1597.12,888.504]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[1577.73,435.234],[1577.73,335.719],[1598.21,438.28],[1598.21,341.679]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[1577.73,552.717],[1577.73,453.203],[1598.21,552.323],[1598.21,455.722]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[1577.73,567.08],[1577.73,666.595],[1598.21,566.266],[1598.21,662.866]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:64,
                    verts:[[1577.73,681.561],[1577.73,781.076],[1598.21,677.394],[1598.21,773.995]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[506.633,427.206],[506.633,320.01],[454.471,429.922],[454.471,325.324]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[506.633,553.756],[506.633,446.561],[454.471,553.405],[454.471,448.808]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[506.633,569.228],[506.633,676.424],[454.471,568.502],[454.471,673.099]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[506.633,692.545],[506.633,799.74],[454.471,688.829],[454.471,793.426]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[507.102,819.573],[507.102,926.761],[454.471,812.796],[454.471,917.393]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[504.599,323.317],[504.599,227.131],[495.221,328.633],[495.221,234.815]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[514.122,319.678],[514.122,221.871],[504.599,323.317],[504.599,227.131]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[506.633,427.206],[576.174,427.901],[506.633,320.01],[576.174,321.371]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[506.633,553.757],[506.633,446.561],[576.174,553.667],[576.174,447.136]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[506.633,569.228],[576.174,569.042],[506.633,676.424],[576.174,675.572]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[506.633,692.545],[576.174,691.593],[506.633,799.74],[576.174,798.124]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[507.102,819.573],[573.348,817.915],[507.102,926.761],[573.348,924.47]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[530.265,314.486],[530.265,214.367],[514.122,319.678],[514.122,221.872]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[530.265,314.486],[568.131,315.247],[530.265,214.367],[568.131,215.467]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[570.902,309.477],[570.902,207.127],[568.131,315.247],[568.131,215.467]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[635.818,304.77],[635.818,200.322],[570.903,309.477],[570.903,207.127]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[575.808,823.99],[575.808,932.867],[573.348,817.915],[573.348,924.47]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[575.808,823.99],[730.655,820.031],[575.808,932.867],[730.655,927.394]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[578.603,425.563],[578.603,316.796],[576.174,427.901],[576.174,321.37]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[578.603,553.969],[578.603,445.202],[576.174,553.666],[576.174,447.136]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[578.603,569.668],[578.603,678.434],[576.174,569.042],[576.174,675.572]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[578.603,694.792],[578.603,803.559],[576.174,691.593],[576.174,798.124]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[578.603,425.563],[578.603,316.796],[723.398,427.042],[723.397,319.689]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[578.603,553.969],[578.603,445.202],[723.398,553.778],[723.397,446.425]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[578.603,569.668],[578.603,678.434],[723.397,569.272],[723.398,676.624]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[578.603,694.792],[578.603,803.559],[723.397,692.769],[723.398,800.121]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[726.5,301.968],[726.5,196.273],[635.818,304.77],[635.818,200.322]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[731.384,830.215],[731.384,941.473],[721.749,819.866],[721.749,927.166]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[733.14,422.883],[733.14,311.552],[723.398,427.042],[723.397,319.689]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[733.14,554.316],[733.14,442.985],[723.398,553.778],[723.397,446.425]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[733.14,570.385],[733.14,681.715],[723.397,569.272],[723.398,676.624]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[733.14,698.459],[733.14,809.789],[723.397,692.769],[723.398,800.121]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[865.919,300.083],[865.919,193.548],[726.5,301.968],[726.5,196.273]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[887.974,832.087],[887.974,944.06],[731.384,830.216],[731.384,941.473]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[880.933,422.154],[880.933,310.126],[733.141,422.883],[733.141,311.552]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[880.933,554.41],[880.933,442.382],[733.141,554.316],[733.141,442.985]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[880.933,570.579],[880.933,682.608],[733.141,570.385],[733.141,681.715]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[880.933,699.455],[880.933,811.483],[733.141,698.459],[733.141,809.79]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[868.179,298.75],[1013.9,299.275],[868.179,191.621],[1013.9,192.379]]
                },{
                    num:"503",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[877.846,426.833],[877.846,315.777],[1320.23,431.423],[1320.23,324.902]]
                },{
                    num:"403",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[877.846,557.942],[877.846,446.886],[1320.23,557.179],[1320.23,450.657]]
                },{
                    num:"303",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[877.846,573.971],[877.846,685.027],[1320.23,572.553],[1320.23,679.075]]
                },{
                    num:"203",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[877.846,701.728],[877.846,812.784],[1320.23,695.094],[1320.23,801.616]]
                },{
                    num:"103",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[877.846,829.687],[877.846,940.743],[1320.23,817.829],[1320.23,924.35]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[1013.9,299.275],[1013.9,192.379],[1173.26,302.849],[1173.26,197.546]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[1173.26,302.849],[1173.26,197.546],[1295.31,308.44],[1295.31,205.625]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[1297.04,309.579],[1297.04,207.273],[1399.71,316.499],[1399.71,217.276]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[1332.97,820.048],[1332.97,927.419],[1449.26,811.194],[1449.26,915.179]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[1340.43,427.122],[1340.43,319.846],[1449.79,430.479],[1449.79,326.415]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[1340.43,553.767],[1340.43,446.492],[1449.79,553.333],[1449.79,449.269]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[1340.43,569.251],[1340.43,676.526],[1449.79,568.352],[1449.79,672.417]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[1340.43,692.659],[1340.43,799.935],[1449.79,688.067],[1449.79,792.131]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[1399.71,316.499],[1399.71,217.276],[1456.97,322.143],[1456.97,225.435]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[1410.02,802.661],[1410.02,903.383],[1542.68,799.269],[1542.68,898.694]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[1416.67,434.121],[1416.67,333.541],[1540.61,435.386],[1540.61,336.017]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[1416.67,552.861],[1416.67,452.282],[1540.61,552.698],[1540.61,453.329]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[1416.67,567.378],[1416.67,667.958],[1540.61,567.04],[1540.61,666.409]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[1416.67,683.084],[1416.67,783.664],[1540.61,681.353],[1540.61,780.722]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[1456.97,322.143],[1456.97,225.435],[1484.98,328.32],[1484.98,234.362]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[1461.32,333.192],[1461.32,241.405],[1493.15,333.832],[1493.15,242.33]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[1520.28,437.341],[1520.28,339.842],[1577.84,437.916],[1577.84,340.968]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[1520.28,552.444],[1520.28,454.946],[1577.84,552.37],[1577.84,455.422]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[1520.28,566.517],[1520.28,664.016],[1577.84,566.363],[1577.84,663.311]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[1520.28,678.678],[1520.28,776.177],[1577.84,677.891],[1577.84,774.839]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[1521.55,794.194],[1521.55,891.679],[1576.38,792.823],[1576.38,889.783]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[1576.38,792.823],[1576.38,889.783],[1589.25,785.223],[1589.25,879.277]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[1577.84,437.917],[1577.84,340.968],[1590.27,440.952],[1590.27,346.907]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[1577.84,552.37],[1577.84,455.422],[1590.27,551.977],[1590.27,457.933]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[1577.84,566.363],[1577.84,663.311],[1590.27,565.551],[1590.27,659.595]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:65,
                    verts:[[1577.84,677.891],[1577.84,774.839],[1590.27,673.739],[1590.27,767.783]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[453.682,439.032],[453.682,343.15],[432.409,448.118],[432.409,360.93]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[453.682,552.226],[453.682,456.344],[432.409,551.049],[432.409,463.861]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[453.682,566.064],[453.682,661.946],[432.409,563.633],[432.409,650.822]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[453.682,676.365],[453.682,772.247],[432.409,663.934],[432.409,751.123]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[479.832,427.862],[479.832,321.294],[453.816,438.974],[453.816,343.038]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[479.832,553.671],[479.832,447.104],[453.816,552.233],[453.816,456.297]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[479.832,569.052],[479.832,675.62],[453.816,566.08],[453.816,662.016]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[479.832,691.647],[479.832,798.214],[453.816,676.444],[453.816,772.38]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[479.832,817.949],[479.832,924.516],[453.816,790.146],[453.816,886.083]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[540.234,425.37],[540.234,316.418],[479.832,427.862],[479.832,321.295]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[540.234,553.994],[540.234,445.042],[479.832,553.672],[479.832,447.104]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[540.234,569.719],[540.234,678.671],[479.832,569.052],[479.832,675.62]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[540.234,695.056],[540.234,804.008],[479.832,691.647],[479.832,798.214]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[540.699,824.159],[540.699,933.102],[479.832,817.949],[479.832,924.516]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[510.322,319.586],[510.322,221.739],[494.65,324.872],[494.65,229.379]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[524.238,316.001],[524.238,216.557],[510.322,319.587],[510.322,221.739]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[546.697,310.918],[546.697,209.209],[524.238,316.001],[524.238,216.557]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[540.234,425.37],[540.234,316.418],[609.94,426.406],[609.94,318.445]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[540.234,553.994],[540.234,445.042],[609.94,553.86],[609.94,445.899]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[540.234,569.719],[540.234,678.671],[609.94,569.442],[609.94,677.403]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[540.234,695.056],[540.234,804.008],[609.94,693.639],[609.94,801.6]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[540.699,824.159],[607.108,821.691],[540.699,933.102],[607.108,929.689]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[546.697,310.918],[584.731,312.052],[546.697,209.209],[584.731,210.848]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[594.037,306.27],[594.037,202.491],[584.731,312.051],[584.731,210.848]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[665.62,302.186],[665.62,196.588],[594.037,306.27],[594.037,202.491]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[615.46,827.769],[615.46,938.092],[607.108,821.691],[607.108,929.689]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[618.042,424.067],[618.042,313.868],[609.94,426.406],[609.94,318.445]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[618.042,554.163],[618.042,443.964],[609.94,553.86],[609.94,445.899]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[618.042,570.068],[618.042,680.266],[609.94,569.442],[609.94,677.403]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[618.042,696.839],[618.042,807.037],[609.94,693.639],[609.94,801.6]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[615.46,827.769],[615.46,938.092],[769.087,821.929],[769.087,930.018]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[618.042,424.067],[618.042,313.868],[761.727,426.248],[761.727,318.137]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[618.042,554.163],[618.042,443.964],[761.727,553.88],[761.727,445.769]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[618.042,570.068],[618.042,680.266],[761.727,569.484],[761.727,677.595]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[618.042,696.839],[618.042,807.037],[761.727,693.854],[761.727,801.966]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[760.744,300.294],[760.744,193.852],[665.62,302.186],[665.62,196.588]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[902.895,299.819],[760.744,300.294],[902.895,193.166],[760.744,193.853]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[779.495,832.092],[779.495,944.068],[759.932,821.87],[759.932,929.937]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[781.449,422.142],[781.449,310.101],[761.727,426.248],[761.727,318.137]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[781.449,554.412],[781.449,442.372],[761.727,553.88],[761.727,445.769]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[781.449,570.583],[781.449,682.623],[761.727,569.484],[761.727,677.596]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[781.449,699.473],[781.449,811.513],[761.727,693.854],[761.727,801.966]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[938.258,832.026],[779.496,832.092],[938.258,943.977],[779.496,944.068]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[931.377,422.144],[781.449,422.142],[931.377,310.107],[781.449,310.101]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[931.377,554.412],[931.377,442.374],[781.449,554.412],[781.449,442.372]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[931.377,570.582],[931.377,682.62],[781.449,570.583],[781.449,682.623]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[931.377,699.469],[781.449,699.473],[931.377,811.507],[781.449,811.513]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[906.612,298.517],[906.612,191.285],[1050.65,300.499],[1050.65,194.149]]
                },{
                    num:"503",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[925.912,426.801],[925.912,315.714],[1348.11,433.324],[1348.11,328.68]]
                },{
                    num:"403",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[925.912,557.947],[925.912,446.86],[1348.11,556.863],[1348.11,452.219]]
                },{
                    num:"303",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[925.912,573.98],[925.912,685.068],[1348.11,571.966],[1348.11,676.61]]
                },{
                    num:"203",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[925.912,701.774],[925.912,812.862],[1348.11,692.347],[1348.11,796.991]]
                },{
                    num:"103",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[925.912,829.769],[925.912,940.857],[1348.11,812.918],[1348.11,917.562]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[1050.65,300.499],[1050.65,194.149],[1202.97,305.582],[1202.97,201.496]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[1202.97,305.582],[1202.97,201.496],[1315.27,312.217],[1315.27,211.084]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[1315.72,313.345],[1315.71,212.718],[1406.99,321.029],[1406.99,223.824]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[1362.38,814.938],[1362.38,920.354],[1465.55,805.035],[1465.55,906.665]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[1369.32,429.196],[1369.32,323.904],[1466.24,432.945],[1466.24,331.241]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[1369.32,553.499],[1369.32,448.207],[1466.24,553.014],[1466.24,451.309]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[1369.32,568.696],[1369.32,673.987],[1466.24,567.693],[1466.24,669.397]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[1369.32,689.822],[1369.32,795.114],[1466.24,684.692],[1466.24,786.397]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[1406.99,321.029],[1406.99,223.824],[1455.69,327.021],[1455.69,232.485]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[1455.69,327.021],[1455.69,232.485],[1475.85,333.256],[1475.85,241.497]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[1426.41,436.34],[1426.41,337.884],[1541.34,438.085],[1541.34,341.298]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[1426.41,552.574],[1426.41,454.118],[1541.34,552.348],[1541.34,455.561]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[1426.41,566.784],[1426.41,665.241],[1541.34,566.318],[1541.34,663.105]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[1426.41,680.048],[1426.41,778.504],[1541.34,677.66],[1541.34,774.448]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[1420.4,797.168],[1420.4,895.789],[1543.43,792.491],[1543.43,889.324]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[1448.19,337.789],[1448.19,248.049],[1477.82,338.672],[1477.82,249.326]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[1517.7,439.894],[1517.7,344.837],[1570.82,440.683],[1570.82,346.381]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[1517.7,552.114],[1517.7,457.057],[1570.82,552.012],[1570.82,457.71]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[1517.7,565.834],[1517.7,660.89],[1570.82,565.622],[1570.82,659.924]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[1517.7,675.186],[1517.7,770.243],[1570.82,674.106],[1570.82,768.408]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[1518.88,787.796],[1518.88,882.833],[1569.47,785.915],[1569.47,880.233]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[1569.47,785.915],[1569.47,880.233],[1574.8,778.445],[1574.8,869.907]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[1570.82,440.683],[1570.82,346.381],[1575.73,443.665],[1575.73,352.216]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[1570.82,552.012],[1570.82,457.71],[1575.73,551.626],[1575.73,460.177]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[1570.82,565.622],[1570.82,659.924],[1575.73,564.825],[1575.73,656.274]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:66,
                    verts:[[1570.82,674.106],[1570.82,768.408],[1575.73,670.027],[1575.73,761.476]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[458.158,437.266],[458.158,339.696],[414.091,446.357],[414.091,357.483]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[458.158,552.454],[458.158,454.884],[414.091,551.277],[414.091,462.404]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[458.158,566.537],[458.158,664.107],[414.091,564.105],[414.091,652.978]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[458.158,678.781],[458.158,776.351],[414.091,666.344],[414.091,755.217]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[457.979,794.327],[457.979,891.862],[413.942,771.599],[413.942,860.443]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[512.127,426.133],[512.127,317.911],[458.436,437.209],[458.436,339.583]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[512.127,553.895],[512.127,445.674],[458.436,552.462],[458.436,454.836]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[512.127,569.515],[512.127,677.737],[458.436,566.552],[458.436,664.177]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[512.127,694.012],[512.127,802.234],[458.436,678.859],[458.436,776.485]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[512.127,822.275],[512.127,930.497],[458.436,794.563],[458.436,892.189]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[497.386,321.807],[497.386,224.949],[492.728,327.324],[492.728,232.923]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[521.542,316.291],[521.542,216.976],[499.471,321.466],[499.471,224.456]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[580.143,423.921],[580.143,313.584],[512.126,426.133],[512.126,317.911]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[580.143,554.182],[580.143,443.844],[512.126,553.895],[512.126,445.674]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[580.143,570.107],[580.143,680.444],[512.126,569.515],[512.126,677.737]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[580.143,697.038],[580.143,807.375],[512.126,694.012],[512.126,802.234]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[580.595,827.778],[580.595,938.104],[512.126,822.275],[512.126,930.497]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[539.865,312.818],[539.865,211.955],[521.541,316.291],[521.541,216.976]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[568.597,307.927],[568.597,204.887],[539.866,312.818],[539.866,211.955]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[568.598,307.927],[606.252,309.435],[568.598,204.886],[606.252,207.065]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[580.143,423.921],[580.143,313.584],[648.841,425.295],[648.841,316.272]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[580.143,554.182],[580.143,443.844],[648.841,554.004],[648.841,444.981]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[580.143,570.107],[580.143,680.444],[648.841,569.739],[648.841,678.762]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[580.143,697.038],[580.143,807.375],[648.841,695.158],[648.841,804.181]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[580.595,827.778],[580.595,938.104],[646.05,824.503],[646.05,933.576]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[622.192,303.733],[622.192,198.823],[606.251,309.435],[606.251,207.065]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[699.533,300.363],[699.533,193.953],[622.192,303.733],[622.192,198.823]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[660.346,830.48],[660.346,941.839],[646.05,824.503],[646.05,933.576]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[662.663,422.996],[662.663,311.773],[648.841,425.295],[648.841,316.272]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[662.663,554.301],[662.663,443.079],[648.841,554.004],[648.841,444.981]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[662.663,570.354],[662.663,681.577],[648.841,569.739],[648.841,678.762]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[662.663,698.304],[662.663,809.527],[648.841,695.158],[648.841,804.181]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[660.346,830.479],[660.346,941.838],[810.121,822.809],[810.121,931.234]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[662.662,422.996],[662.662,311.773],[802.779,425.862],[802.778,317.381]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[662.662,554.301],[662.662,443.079],[802.779,553.93],[802.778,445.449]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[662.662,570.354],[662.662,681.577],[802.778,569.588],[802.779,678.069]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[662.662,698.304],[662.662,809.526],[802.778,694.383],[802.779,802.864]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[797.674,299.431],[797.674,192.606],[699.532,300.363],[699.532,193.953]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[797.674,299.431],[940.304,300.379],[797.674,192.606],[940.304,193.975]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[832.253,421.878],[832.253,309.586],[802.779,425.862],[802.778,317.381]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[832.253,554.446],[832.253,442.154],[802.779,553.93],[802.778,445.449]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[832.253,570.653],[832.253,682.945],[802.778,569.588],[802.779,678.069]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[832.253,699.833],[832.253,812.125],[802.778,694.383],[802.779,802.864]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[830.134,832.776],[830.134,945.013],[800.865,822.859],[800.865,931.304]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[830.135,832.776],[988.272,830.778],[830.135,945.013],[988.272,942.251]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[832.253,421.878],[832.253,309.586],[981.67,422.611],[981.67,311.02]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[832.253,554.446],[832.253,442.154],[981.67,554.351],[981.67,442.76]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[832.253,570.653],[832.253,682.945],[981.67,570.457],[981.67,682.048]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[832.253,699.833],[832.253,812.125],[981.67,698.83],[981.67,810.421]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[945.41,299.13],[945.41,192.17],[1085.52,302.504],[1085.52,197.048]]
                },{
                    num:"503",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[973.945,427.215],[973.945,316.536],[1369.98,435.473],[1369.98,332.953]]
                },{
                    num:"403",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[973.945,557.878],[973.945,447.199],[1369.98,556.505],[1369.98,453.985]]
                },{
                    num:"303",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[973.945,573.853],[973.945,684.531],[1369.98,571.302],[1369.98,673.823]]
                },{
                    num:"203",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[973.945,701.177],[973.945,811.855],[1369.98,689.241],[1369.98,791.761]]
                },{
                    num:"103",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[973.945,828.701],[973.945,939.38],[1369.98,807.365],[1369.98,909.886]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[1085.52,302.504],[1085.52,197.048],[1228.72,308.948],[1228.72,206.362]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[1228.72,308.948],[1228.72,206.362],[1330.17,316.458],[1330.17,217.215]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[1329.4,317.56],[1329.4,218.809],[1408.81,325.833],[1408.81,230.769]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[1385.47,809.169],[1385.47,912.379],[1474.95,798.467],[1474.95,897.585]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[1391.82,431.528],[1391.82,328.468],[1475.79,435.576],[1475.79,336.388]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[1391.82,553.197],[1391.82,450.137],[1475.79,552.673],[1475.79,453.485]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[1391.82,568.072],[1391.82,671.132],[1475.79,566.989],[1475.79,666.176]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[1391.82,686.631],[1391.82,789.691],[1475.79,681.093],[1475.79,780.281]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[1408.81,325.833],[1408.81,230.769],[1448.98,332.057],[1448.98,239.764]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[1448.98,332.057],[1448.98,239.764],[1461.66,338.261],[1461.66,248.732]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[1424.93,791.321],[1424.93,887.707],[1537.54,785.554],[1537.54,879.735]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[1430.28,438.696],[1430.28,342.494],[1535.46,440.847],[1535.46,346.703]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[1430.28,552.269],[1430.28,456.067],[1535.46,551.991],[1535.46,457.846]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[1430.28,566.154],[1430.28,662.356],[1535.46,565.579],[1535.46,659.723]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[1430.28,676.824],[1430.28,773.027],[1535.46,673.881],[1535.46,768.026]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[1509.07,442.5],[1509.07,349.936],[1557.51,443.468],[1557.51,351.832]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[1509.07,551.777],[1509.07,459.213],[1557.51,551.651],[1557.51,460.015]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[1509.07,565.136],[1509.07,657.7],[1557.51,564.877],[1557.51,656.514]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[1509.07,671.621],[1509.07,764.184],[1557.51,670.295],[1557.51,761.932]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:67,
                    verts:[[1510.14,781.266],[1510.14,873.806],[1556.27,778.957],[1556.27,870.615]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[468.554,435.689],[468.554,336.61],[401.032,444.66],[401.032,354.163]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[468.554,552.658],[468.554,453.579],[401.032,551.497],[401.032,461]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[468.554,566.958],[468.554,666.037],[401.032,564.559],[401.032,655.055]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[468.554,680.938],[468.554,780.017],[401.032,668.665],[401.032,759.162]]
                },{
                    num:"105",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[468.28,798.274],[468.28,897.318],[400.803,775.845],[400.803,866.313]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[550.742,424.77],[550.742,315.245],[468.978,435.633],[468.978,336.5]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[550.742,554.072],[550.742,444.546],[468.978,552.666],[468.978,453.533]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[550.742,569.88],[550.742,679.405],[468.978,566.974],[468.978,666.107]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[550.742,695.877],[550.742,805.402],[468.978,681.015],[468.978,780.148]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[550.742,825.685],[550.742,935.21],[468.978,798.506],[468.978,897.639]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[491.953,327.928],[491.953,233.796],[488.446,332.859],[488.446,240.924]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[496.201,324.288],[496.201,228.534],[491.953,327.928],[491.953,233.796]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[507.159,318.792],[507.159,220.59],[496.201,324.288],[496.201,228.534]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[538.12,313.485],[538.12,212.919],[509.684,318.468],[509.684,220.123]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[560.762,310.18],[560.762,208.142],[538.12,313.485],[538.12,212.919]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[625.483,422.888],[625.483,311.562],[550.742,424.77],[550.742,315.245]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[625.483,554.315],[625.483,442.989],[550.742,554.072],[550.742,444.546]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[625.483,570.383],[625.483,681.709],[550.742,569.88],[550.742,679.405]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[625.483,698.452],[625.483,809.777],[550.742,695.877],[550.742,805.402]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[625.914,830.358],[625.914,941.67],[550.742,825.685],[550.742,935.21]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[595.564,305.566],[595.564,201.473],[560.762,310.18],[560.762,208.142]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[595.564,305.566],[595.564,201.473],[632.272,307.436],[632.272,204.177]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[625.483,422.888],[625.483,311.562],[691.987,424.587],[691.987,314.886]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[625.483,554.315],[625.483,442.989],[691.987,554.096],[691.987,444.395]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[625.483,570.383],[625.483,681.709],[691.987,569.929],[691.987,679.63]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[625.483,698.452],[625.483,809.777],[691.987,696.128],[691.987,805.829]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[625.914,830.358],[625.914,941.67],[689.285,826.308],[689.285,936.072]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[654.78,301.904],[654.78,196.181],[632.272,307.436],[632.272,204.177]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[736.787,299.318],[736.787,192.442],[654.78,301.905],[654.78,196.181]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[709.397,832.08],[709.397,944.051],[689.285,826.308],[689.285,936.072]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[711.404,422.367],[711.404,310.542],[691.987,424.587],[691.987,314.885]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[711.404,554.383],[711.404,442.558],[691.987,554.095],[691.987,444.394]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[711.404,570.523],[711.404,682.347],[691.987,569.929],[691.987,679.63]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[711.404,699.165],[711.404,810.99],[691.987,696.128],[691.987,805.829]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[709.397,832.08],[709.397,944.051],[852.775,822.691],[852.775,931.072]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[711.403,422.367],[711.403,310.542],[845.569,425.875],[845.569,317.407]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[711.403,554.383],[711.403,442.558],[845.569,553.929],[845.569,445.46]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[711.403,570.523],[711.403,682.347],[845.569,569.584],[845.569,678.052]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[711.403,699.165],[711.403,810.989],[845.569,694.365],[845.569,802.833]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[836.423,299.368],[736.786,299.318],[836.423,192.514],[736.786,192.442]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[836.423,299.368],[836.423,192.515],[977.307,301.704],[977.307,195.891]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[884.277,422.081],[884.277,309.982],[845.569,425.875],[845.569,317.407]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[884.277,554.42],[884.277,442.321],[845.569,553.929],[845.569,445.46]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[884.277,570.599],[884.277,682.698],[845.569,569.584],[845.569,678.052]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[884.277,699.556],[884.277,811.655],[845.569,694.365],[845.569,802.833]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[882.031,832.298],[882.031,944.352],[843.568,822.85],[843.568,931.291]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[882.032,832.298],[882.032,944.352],[1036.84,828.442],[1036.84,939.022]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[884.277,422.081],[884.277,309.982],[1030.62,423.516],[1030.62,312.791]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[884.277,554.42],[884.277,442.321],[1030.62,554.234],[1030.62,443.509]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[884.277,570.599],[884.277,682.698],[1030.62,570.215],[1030.62,680.94]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[884.277,699.556],[884.277,811.655],[1030.62,697.592],[1030.62,808.318]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[983.699,300.525],[983.699,194.187],[1117.84,305.19],[1117.84,200.929]]
                },{
                    num:"503",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[1020.82,428.039],[1020.82,318.173],[1385.92,437.798],[1385.92,337.573]]
                },{
                    num:"403",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[1020.82,557.741],[1020.82,447.876],[1385.92,556.119],[1385.92,455.895]]
                },{
                    num:"303",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[1020.82,573.598],[1020.82,683.463],[1385.92,570.584],[1385.92,670.809]]
                },{
                    num:"203",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[1020.82,699.986],[1020.82,809.851],[1385.92,685.882],[1385.92,786.106]]
                },{
                    num:"103",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[1020.82,826.573],[1020.82,936.438],[1385.92,801.361],[1385.92,901.585]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[1117.84,305.19],[1117.84,200.929],[1250.27,312.818],[1250.27,211.955]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[1250.27,312.817],[1250.27,211.955],[1340.13,321.025],[1340.13,223.817]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[1338.24,322.087],[1338.24,225.353],[1405.64,330.784],[1405.64,237.924]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[1402.32,802.941],[1402.32,903.769],[1477.97,791.679],[1477.97,888.201]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[1405.64,330.784],[1405.64,237.924],[1437.49,337.134],[1437.49,247.102]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[1408.03,434.039],[1408.03,333.381],[1478.93,438.295],[1478.93,341.709]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[1408.03,552.872],[1408.03,452.214],[1478.93,552.321],[1478.93,455.735]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[1408.03,567.4],[1408.03,668.058],[1478.93,566.261],[1478.93,662.848]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[1408.03,683.196],[1408.03,783.853],[1478.93,677.373],[1478.93,773.96]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[1437.49,337.134],[1437.49,247.102],[1443.14,343.231],[1443.14,255.916]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[1424.09,785.282],[1424.09,879.359],[1525.82,778.621],[1525.82,870.15]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[1428.76,441.125],[1428.76,347.246],[1523.78,443.609],[1523.77,352.107]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[1428.76,551.955],[1428.76,458.076],[1523.78,551.633],[1523.77,460.131]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[1428.76,565.504],[1428.76,659.383],[1523.77,564.84],[1523.78,656.342]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[1428.76,673.502],[1428.76,767.381],[1523.77,670.103],[1523.78,761.605]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[1495.16,445.101],[1495.16,355.025],[1538.82,446.216],[1538.82,357.207]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[1495.16,551.44],[1495.16,461.365],[1538.82,551.296],[1538.82,462.287]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[1495.16,564.441],[1495.16,654.516],[1538.82,564.142],[1538.82,653.151]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[1495.16,668.062],[1495.16,758.137],[1538.82,666.537],[1538.82,755.545]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:68,
                    verts:[[1496.12,774.75],[1496.12,864.799],[1537.71,772.093],[1537.71,861.126]]
                },
                ],
                [
                {
                    num:"105",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[484.341,801.698],[484.341,902.052],[393.184,779.885],[393.184,871.898]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[484.71,434.322],[484.71,333.935],[393.493,443.046],[393.493,351.005]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[484.71,552.835],[484.71,452.448],[393.493,551.706],[393.493,459.665]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[484.71,567.324],[484.71,667.711],[393.493,564.99],[393.493,657.031]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[484.71,682.809],[484.71,783.196],[393.493,670.873],[393.493,762.915]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[594.811,423.792],[594.811,313.33],[485.282,434.267],[485.282,333.828]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[594.811,554.198],[594.811,443.737],[485.282,552.842],[485.282,452.403]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[594.811,570.141],[594.811,680.603],[485.282,567.339],[485.282,667.779]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[594.811,697.215],[594.811,807.677],[485.282,682.884],[485.282,783.323]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[594.811,828.132],[594.811,938.594],[485.282,801.923],[485.282,902.363]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[496.409,325.221],[496.409,229.883],[487.319,330.131],[487.319,236.981]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[504.817,321.613],[504.817,224.668],[496.409,325.221],[496.409,229.883]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[522.16,316.213],[522.16,216.863],[504.817,321.613],[504.817,224.668]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[559.729,311.199],[559.729,209.615],[525.106,315.913],[525.106,216.43]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[586.494,308.116],[586.494,205.159],[559.728,311.199],[559.728,209.615]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[627.008,303.854],[627.008,198.998],[586.495,308.116],[586.495,205.159]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[675.165,422.278],[675.165,310.368],[594.811,423.792],[594.811,313.33]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[675.165,554.394],[675.165,442.484],[594.811,554.198],[594.811,443.737]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[675.165,570.546],[675.165,682.456],[594.811,570.141],[594.811,680.603]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[675.165,699.287],[675.165,811.196],[594.811,697.215],[594.811,807.677]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[675.568,831.88],[675.568,943.774],[594.811,828.132],[594.811,938.594]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[627.009,303.854],[627.009,198.998],[662.216,306.067],[662.216,202.197]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[691.055,300.791],[691.055,194.571],[662.216,306.067],[662.216,202.197]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[675.165,422.278],[675.165,310.368],[738.341,424.277],[738.341,314.28]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[675.165,554.394],[675.165,442.484],[738.341,554.136],[738.341,444.138]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[675.165,570.546],[675.165,682.456],[738.341,570.012],[738.341,680.009]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[675.165,699.287],[675.165,811.196],[738.341,696.551],[738.341,806.549]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[675.568,831.88],[675.568,943.774],[735.773,827.113],[735.773,937.185]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[776.507,299.031],[776.507,192.028],[691.055,300.791],[691.055,194.571]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[761.401,832.585],[761.401,944.749],[735.774,827.113],[735.774,937.185]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[763.062,422.173],[763.061,310.162],[738.342,424.277],[738.342,314.279]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[763.062,554.408],[763.061,442.398],[738.342,554.136],[738.342,444.138]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[763.061,570.574],[763.062,682.585],[738.342,570.012],[738.342,680.009]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[763.061,699.43],[763.062,811.44],[738.342,696.551],[738.342,806.549]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[761.4,832.585],[761.4,944.749],[896.058,821.644],[896.058,929.624]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[763.061,422.173],[763.06,310.163],[889.101,426.262],[889.101,318.164]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[763.061,554.408],[763.06,442.398],[889.101,553.879],[889.101,445.781]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[763.06,570.575],[763.061,682.585],[889.101,569.48],[889.101,677.578]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[763.06,699.43],[763.061,811.44],[889.101,693.835],[889.101,801.933]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[776.507,299.031],[876.101,300.054],[776.507,192.028],[876.101,193.506]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[876.101,300.054],[876.101,193.506],[1013.15,303.704],[1013.15,198.782]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[933.939,830.744],[933.939,942.205],[887.045,821.905],[887.045,929.985]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[936.272,422.713],[936.272,311.219],[889.101,426.262],[889.101,318.164]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[936.272,554.338],[936.272,442.844],[889.101,553.879],[889.101,445.781]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[936.272,570.43],[936.272,681.924],[889.101,569.481],[889.101,677.578]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[936.272,698.691],[936.272,810.185],[889.101,693.835],[889.101,801.933]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[933.94,830.745],[933.94,942.205],[1082.95,825.162],[1082.95,934.488]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[936.272,422.713],[936.272,311.219],[1077.2,424.802],[1077.2,315.307]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[936.272,554.338],[936.272,442.844],[1077.2,554.068],[1077.2,444.573]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[936.272,570.43],[936.272,681.924],[1077.2,569.871],[1077.2,679.366]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[936.272,698.692],[936.272,810.185],[1077.2,695.833],[1077.2,805.328]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[1020.7,302.611],[1020.7,197.202],[1147.13,308.431],[1147.13,205.615]]
                },{
                    num:"503",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[1065.55,429.22],[1065.55,320.521],[1396.21,440.225],[1396.21,342.398]]
                },{
                    num:"403",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[1065.55,557.545],[1065.55,448.847],[1396.21,555.716],[1396.21,457.889]]
                },{
                    num:"303",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[1065.55,573.234],[1065.55,681.932],[1396.21,569.835],[1396.21,667.662]]
                },{
                    num:"203",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[1065.55,698.279],[1065.55,806.977],[1396.21,682.374],[1396.21,780.201]]
                },{
                    num:"103",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[1065.55,823.522],[1065.55,932.22],[1396.21,795.09],[1396.21,892.917]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[1147.13,308.431],[1147.13,205.615],[1267.54,317.051],[1267.54,218.074]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[1267.54,317.051],[1267.54,218.074],[1345.46,325.784],[1345.46,230.696]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[1342.55,326.796],[1342.55,232.159],[1398.07,335.762],[1398.07,245.119]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[1398.07,335.762],[1398.07,245.119],[1421.92,342.147],[1421.92,254.349]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[1413.24,796.447],[1413.24,894.793],[1475.27,784.843],[1475.27,878.751]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[1418.29,436.651],[1418.29,338.493],[1476.33,441.033],[1476.33,347.067]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[1418.29,552.534],[1418.29,454.375],[1476.33,551.966],[1476.33,458]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[1418.29,566.701],[1418.29,664.859],[1476.33,565.529],[1476.33,659.495]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[1418.29,679.622],[1418.29,777.78],[1476.33,673.627],[1476.33,767.593]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[1418.46,779.198],[1418.46,870.948],[1509.18,771.827],[1509.18,860.759]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[1422.45,443.567],[1422.45,352.024],[1507.18,446.316],[1507.18,357.403]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[1422.45,551.639],[1422.45,460.096],[1507.18,551.283],[1507.18,462.37]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[1422.45,564.851],[1422.45,656.394],[1507.18,564.116],[1507.18,653.028]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[1422.45,670.161],[1422.45,761.703],[1507.18,666.4],[1507.18,755.312]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[1476.83,447.646],[1476.83,360.007],[1515.72,448.877],[1515.72,362.415]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[1476.83,551.11],[1476.83,463.471],[1515.72,550.951],[1515.72,464.489]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[1476.83,563.76],[1476.83,651.399],[1515.72,563.43],[1515.72,649.892]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[1476.83,664.579],[1476.83,752.219],[1515.72,662.896],[1515.72,749.358]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:69,
                    verts:[[1477.68,768.374],[1477.68,855.985],[1514.72,765.442],[1514.72,851.931]]
                },
                ],
                [
                {
                    num:"105",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[505.827,804.576],[505.827,906.029],[391.193,783.688],[391.193,877.155]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[506.289,433.173],[506.289,331.687],[391.584,441.527],[391.584,348.033]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[506.289,552.984],[506.289,451.498],[391.584,551.903],[391.584,458.408]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[506.289,567.632],[506.289,669.117],[391.584,565.397],[391.584,658.891]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[506.289,684.38],[506.289,785.866],[391.584,672.952],[391.584,766.446]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[505.778,322.842],[505.778,226.445],[491.034,327.67],[491.034,233.424]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[518.37,319.315],[518.37,221.346],[505.778,322.842],[505.778,226.445]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[643.292,423.196],[643.292,312.165],[507.004,433.121],[507.004,331.585]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[643.292,554.276],[643.292,443.244],[507.004,552.991],[507.004,451.455]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[643.292,570.301],[643.292,681.332],[507.004,567.646],[507.004,669.181]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[643.292,698.03],[643.292,809.061],[507.004,684.451],[507.004,785.987]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[643.292,829.623],[643.292,940.654],[507.004,804.79],[507.004,906.326]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[542.056,314.086],[542.056,213.788],[518.37,319.315],[518.37,221.346]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[585.887,309.439],[585.887,207.071],[545.397,313.814],[545.397,213.395]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[616.484,306.625],[616.484,203.004],[585.887,309.439],[585.887,207.071]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[662.211,302.78],[662.211,197.446],[616.485,306.625],[616.485,203.004]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[727.985,422.076],[727.985,309.974],[643.291,423.196],[643.291,312.165]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[727.985,554.42],[727.985,442.318],[643.291,554.276],[643.291,443.244]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[727.985,570.6],[727.985,682.703],[643.291,570.301],[643.291,681.332]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[727.985,699.562],[727.985,811.665],[643.291,698.03],[643.291,809.061]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[728.353,832.38],[728.353,944.465],[643.291,829.623],[643.291,940.654]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[662.212,302.78],[662.212,197.446],[695.399,305.307],[695.399,201.098]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[730.182,300.362],[730.182,193.952],[695.399,305.307],[695.399,201.098]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[727.985,422.076],[727.985,309.974],[786.809,424.344],[786.809,314.411]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[727.985,554.42],[727.985,442.318],[786.809,554.127],[786.809,444.194]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[727.985,570.6],[727.985,682.703],[786.809,569.994],[786.809,679.927]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[727.985,699.562],[727.985,811.665],[786.809,696.46],[786.809,806.393]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[728.353,832.38],[728.353,944.465],[784.415,826.973],[784.415,936.991]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[817.794,299.449],[817.794,192.631],[730.181,300.362],[730.181,193.952]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[815.107,832.063],[815.107,944.028],[784.416,826.973],[784.416,936.991]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[816.398,422.386],[816.398,310.581],[786.81,424.344],[786.81,314.41]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[816.398,554.38],[816.398,442.574],[786.81,554.127],[786.81,444.194]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[816.398,570.517],[816.398,682.323],[786.81,569.994],[786.81,679.927]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[816.398,699.138],[816.398,810.943],[786.81,696.46],[786.81,806.393]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[815.106,832.063],[815.106,944.027],[939.05,819.772],[939.05,927.036]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[816.397,422.387],[816.397,310.581],[932.442,426.982],[932.441,319.572]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[816.397,554.38],[816.397,442.575],[932.442,553.785],[932.441,446.376]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[816.397,570.517],[816.397,682.323],[932.441,569.288],[932.442,676.698]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[816.397,699.137],[816.397,810.943],[932.441,692.851],[932.442,800.261]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[817.794,299.449],[817.794,192.632],[915.865,301.407],[915.865,195.462]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[915.865,301.407],[915.865,195.462],[1047.22,306.267],[1047.22,202.486]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[987.115,423.721],[987.115,313.193],[932.442,426.982],[932.441,319.572]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[987.115,554.207],[987.115,443.679],[932.442,553.785],[932.441,446.376]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[987.115,570.16],[987.115,680.689],[932.441,569.288],[932.442,676.698]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[987.115,697.311],[987.115,807.84],[932.441,692.851],[932.442,800.261]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[984.736,828.25],[984.736,938.756],[930.362,820.129],[930.362,927.53]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[984.736,828.25],[984.736,938.756],[1125.82,821.115],[1125.82,928.893]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[987.115,423.721],[987.115,313.193],[1120.61,426.399],[1120.61,318.431]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[987.115,554.207],[987.115,443.679],[1120.61,553.861],[1120.61,445.893]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[987.115,570.16],[987.115,680.689],[1120.61,569.444],[1120.61,677.412]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[987.115,697.311],[987.115,807.84],[1120.61,693.649],[1120.61,801.616]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[1055.76,305.27],[1055.76,201.045],[1173.1,312.094],[1173.1,210.909]]
                },{
                    num:"503",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[1107.38,430.694],[1107.38,323.452],[1401.33,442.689],[1401.33,347.296]]
                },{
                    num:"403",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[1107.38,557.3],[1107.38,450.058],[1401.33,555.306],[1401.33,459.913]]
                },{
                    num:"303",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[1107.38,572.778],[1107.38,680.02],[1401.33,569.074],[1401.33,664.467]]
                },{
                    num:"203",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[1107.38,696.148],[1107.38,803.39],[1401.33,678.813],[1401.33,774.206]]
                },{
                    num:"103",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[1107.38,819.713],[1107.38,926.955],[1401.33,788.725],[1401.33,884.118]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[1173.1,312.094],[1173.1,210.909],[1280.67,321.511],[1280.67,224.521]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[1280.66,321.511],[1280.66,224.521],[1346.56,330.61],[1346.56,237.671]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[1342.74,331.563],[1342.74,239.05],[1386.72,340.664],[1386.72,252.205]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[1386.72,340.664],[1386.72,252.205],[1402.99,347.009],[1402.99,261.376]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[1418.73,789.865],[1418.73,885.694],[1467.62,778.106],[1467.62,869.439]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[1423.11,439.295],[1423.11,343.665],[1468.74,443.732],[1468.74,352.348]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[1423.11,552.192],[1423.11,456.562],[1468.74,551.617],[1468.74,460.233]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[1423.11,565.994],[1423.11,661.624],[1468.74,564.807],[1468.74,656.191]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[1423.11,676.005],[1423.11,771.635],[1468.74,669.935],[1468.74,761.319]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[1408.69,773.198],[1408.69,862.654],[1488.48,765.286],[1488.48,851.716]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[1412.03,445.972],[1412.03,356.73],[1486.55,448.923],[1486.55,362.504]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[1412.03,551.327],[1412.03,462.085],[1486.55,550.945],[1486.55,464.527]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[1412.03,564.208],[1412.03,653.45],[1486.55,563.418],[1486.55,649.837]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[1412.03,666.871],[1412.03,756.112],[1486.55,662.833],[1486.55,749.252]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[1454.88,450.096],[1454.88,364.8],[1489.1,451.415],[1489.1,367.381]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[1454.88,550.793],[1454.88,465.498],[1489.1,550.623],[1489.1,466.589]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[1454.88,563.104],[1454.88,648.4],[1489.1,562.751],[1489.1,646.785]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:70,
                    verts:[[1454.88,661.228],[1454.88,746.523],[1489.1,659.423],[1489.1,743.457]]
                },
                ],
                [
                {
                    num:"105",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[532.253,806.906],[532.253,909.25],[394.796,787.236],[394.796,882.06]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[532.803,432.244],[532.803,329.87],[395.268,440.11],[395.268,345.261]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[532.803,553.104],[532.803,450.729],[395.268,552.086],[395.268,457.237]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[532.803,567.88],[532.803,670.255],[395.268,565.776],[395.268,660.625]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[532.803,685.651],[532.803,788.026],[395.268,674.89],[395.268,769.739]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[529.313,327.766],[529.313,233.562],[497.706,331.345],[497.706,238.736]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[519.804,320.793],[519.804,223.484],[499.43,325.48],[499.43,230.257]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[536.527,317.391],[536.527,218.566],[519.804,320.794],[519.804,223.484]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[695.05,422.965],[695.05,311.713],[533.657,432.196],[533.657,329.774]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[695.05,554.305],[695.05,443.053],[533.657,553.111],[533.657,450.689]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[695.05,570.363],[695.05,681.615],[533.657,567.893],[533.657,670.315]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[695.05,698.346],[695.05,809.599],[533.657,685.718],[533.657,788.139]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[695.05,830.201],[695.05,941.453],[533.657,807.106],[533.657,909.528]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[566.387,312.402],[566.387,211.354],[536.527,317.391],[536.527,218.566]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[616.003,308.188],[616.003,205.264],[570.086,312.162],[570.086,211.007]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[650.055,305.683],[650.055,201.642],[616.003,308.188],[616.003,205.264]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[700.383,302.307],[700.383,196.763],[650.055,305.683],[650.055,201.642]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[782.72,422.253],[782.72,310.319],[695.05,422.965],[695.05,311.713]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[782.72,554.398],[782.72,442.464],[695.05,554.305],[695.05,443.053]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[782.72,570.553],[782.72,682.487],[695.05,570.363],[695.05,681.615]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[782.72,699.32],[782.72,811.254],[695.05,698.346],[695.05,809.599]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[783.047,831.934],[783.047,943.849],[695.05,830.201],[695.05,941.453]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[700.383,302.307],[700.383,196.763],[731.087,305.112],[731.087,200.818]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[771.296,300.563],[771.296,194.242],[731.087,305.112],[731.087,200.818]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[859.78,300.491],[771.295,300.563],[859.78,194.138],[771.295,194.242]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[782.72,422.253],[782.72,310.319],[836.32,424.751],[836.32,315.206]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[782.72,554.398],[782.72,442.464],[836.32,554.074],[836.32,444.53]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[782.72,570.553],[782.72,682.487],[836.32,569.885],[836.32,679.429]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[782.72,699.32],[782.72,811.254],[836.32,695.903],[836.32,805.448]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[783.047,831.934],[783.047,943.849],[834.134,825.978],[834.134,935.616]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[869.325,830.623],[869.325,942.037],[834.135,825.978],[834.135,935.616]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[870.232,422.965],[870.232,311.712],[836.32,424.75],[836.32,315.206]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[870.232,554.305],[870.232,443.053],[836.32,554.074],[836.32,444.53]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[870.232,570.363],[870.232,681.615],[836.32,569.885],[836.32,679.429]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[870.232,698.346],[870.232,809.599],[836.32,695.903],[836.32,805.448]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[859.78,300.491],[859.78,194.138],[954.969,303.326],[954.969,198.236]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[869.323,830.623],[869.323,942.036],[980.949,817.207],[980.949,923.49]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[870.231,422.965],[870.231,311.713],[974.775,427.982],[974.775,321.528]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[870.231,554.305],[870.231,443.053],[974.775,553.656],[974.775,447.203]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[870.231,570.363],[870.231,681.615],[974.775,569.021],[974.775,675.474]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[870.231,698.346],[870.231,809.599],[974.775,691.483],[974.775,797.936]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[954.969,303.327],[954.969,198.236],[1079.03,309.268],[1079.03,206.824]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[1035.87,425.042],[1035.87,315.777],[974.775,427.982],[974.775,321.528]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[1035.87,554.036],[1035.87,444.772],[974.775,553.656],[974.775,447.203]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[1035.87,569.807],[1035.87,679.072],[974.775,569.021],[974.775,675.474]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[1035.87,695.504],[1035.87,804.769],[974.775,691.483],[974.775,797.936]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[1033.48,824.973],[1033.48,934.226],[972.704,817.651],[972.704,924.104]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[1033.48,824.973],[1033.48,934.226],[1164.91,816.487],[1164.91,922.495]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[1035.87,425.042],[1035.87,315.777],[1160.29,428.232],[1160.29,322.018]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[1035.87,554.036],[1035.87,444.772],[1160.29,553.624],[1160.29,447.41]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[1035.87,569.807],[1035.87,679.072],[1160.29,568.953],[1160.29,675.167]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[1035.87,695.504],[1035.87,804.769],[1160.29,691.141],[1160.29,797.354]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[1088.42,308.374],[1088.42,205.533],[1195.61,316.043],[1195.61,216.617]]
                },{
                    num:"503",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[1145.75,432.392],[1145.75,326.828],[1401.82,445.132],[1401.82,352.153]]
                },{
                    num:"403",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[1145.75,557.018],[1145.75,451.453],[1401.82,554.9],[1401.82,461.921]]
                },{
                    num:"303",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[1145.75,572.254],[1145.75,677.818],[1401.82,568.319],[1401.82,661.298]]
                },{
                    num:"203",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[1145.75,693.694],[1145.75,799.258],[1401.82,675.281],[1401.82,768.26]]
                },{
                    num:"103",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[1145.75,815.325],[1145.75,920.889],[1401.82,782.412],[1401.82,875.39]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[1195.61,316.043],[1195.61,216.617],[1289.88,326.072],[1289.88,231.114]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[1289.88,326.072],[1289.88,231.114],[1343.93,335.394],[1343.93,244.586]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[1339.31,336.284],[1339.31,245.875],[1372.21,345.406],[1372.21,259.06]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[1372.21,345.406],[1372.21,259.06],[1381.38,351.649],[1381.38,268.083]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[1419.39,783.345],[1419.39,876.68],[1455.76,771.589],[1455.76,860.43]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[1423.11,441.909],[1423.11,348.781],[1456.95,446.343],[1456.95,357.456]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[1423.11,551.853],[1423.11,458.725],[1456.95,551.279],[1456.95,462.393]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[1423.11,565.294],[1423.11,658.423],[1456.95,564.108],[1456.95,652.995]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[1423.11,672.428],[1423.11,765.557],[1456.95,666.363],[1456.95,755.249]]
                },{
                    num:"102",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[1395.46,767.388],[1395.46,854.623],[1464.58,759.081],[1464.58,843.138]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[1398.15,448.297],[1398.15,361.281],[1462.72,451.396],[1462.72,367.343]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[1398.15,551.026],[1398.15,464.009],[1462.72,550.625],[1462.72,466.572]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[1398.15,563.585],[1398.15,650.602],[1462.72,562.757],[1462.72,646.809]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:71,
                    verts:[[1398.15,663.689],[1398.15,750.706],[1462.72,659.45],[1462.72,743.503]]
                },
                ],
                [
                {
                    num:"105",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[563.031,808.713],[563.031,911.748],[403.828,790.526],[403.828,886.608]]
                },{
                    num:"505",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[563.664,431.525],[563.664,328.461],[404.378,438.797],[404.378,342.691]]
                },{
                    num:"405",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[563.664,553.197],[563.664,450.134],[404.378,552.256],[404.378,456.15]]
                },{
                    num:"305",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[563.664,568.073],[563.664,671.136],[404.378,566.127],[404.378,662.233]]
                },{
                    num:"205",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[563.664,686.636],[563.664,789.699],[404.378,676.686],[404.378,772.792]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[540.286,326.074],[540.286,231.116],[504.11,329.375],[504.11,235.888]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[538.127,319.058],[538.127,220.975],[512.239,323.547],[512.239,227.463]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[558.855,315.822],[558.855,216.298],[538.128,319.058],[538.128,220.975]]
                },{
                    num:"605",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[594.608,311.135],[594.608,209.522],[558.855,315.822],[558.855,216.298]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[748.954,423.065],[748.954,311.908],[564.646,431.48],[564.646,328.374]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[748.954,554.292],[748.954,443.136],[564.646,553.203],[564.646,450.097]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[748.954,570.336],[748.954,681.493],[564.646,568.085],[564.646,671.191]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[748.954,698.21],[748.954,809.367],[564.646,686.697],[564.646,789.803]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[748.954,829.951],[748.954,941.108],[564.646,808.897],[564.646,912.003]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[649.419,307.409],[649.419,204.137],[598.623,310.93],[598.623,209.226]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[686.485,305.242],[686.485,201.005],[649.419,307.409],[649.419,204.137]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[740.721,302.375],[740.721,196.86],[686.485,305.242],[686.485,201.005]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[740.721,302.375],[740.721,196.86],[768.548,305.419],[768.548,201.261]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[838.216,422.762],[838.216,311.315],[748.954,423.065],[748.954,311.908]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[838.216,554.332],[838.216,442.885],[748.954,554.292],[748.954,443.136]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[838.216,570.417],[838.216,681.863],[748.954,570.336],[748.954,681.493]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[838.216,698.624],[838.216,810.07],[748.954,698.21],[748.954,809.367]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[838.498,830.657],[748.954,829.951],[838.498,942.085],[748.954,941.108]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[813.569,301.314],[813.569,195.327],[768.548,305.419],[768.548,201.261]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[813.568,301.314],[901.687,302.059],[813.568,195.327],[901.687,196.404]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[838.216,422.762],[838.216,311.315],[885.897,425.448],[885.897,316.572]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[838.216,554.332],[838.216,442.885],[885.897,553.984],[885.897,445.107]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[838.216,570.417],[838.216,681.864],[885.897,569.698],[885.897,678.575]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[838.216,698.624],[838.216,810.071],[885.897,694.949],[885.897,803.825]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[838.498,830.657],[838.498,942.085],[883.948,824.251],[883.948,933.229]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[922.994,828.404],[922.994,938.969],[883.948,824.251],[883.948,933.229]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[923.515,423.852],[923.515,313.448],[885.898,425.448],[885.898,316.572]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[923.515,554.19],[923.515,443.787],[885.898,553.984],[885.898,445.107]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[923.515,570.125],[923.515,680.529],[885.898,569.698],[885.898,678.575]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[923.515,697.133],[923.515,807.536],[885.898,694.949],[885.898,803.825]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[901.687,302.059],[901.687,196.404],[992.797,305.696],[992.797,201.662]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[923.514,423.852],[923.514,313.448],[1015.44,429.204],[1015.44,323.92]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[923.514,554.191],[923.514,443.787],[1015.44,553.498],[1015.44,448.214]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[923.514,570.125],[923.514,680.529],[1015.44,568.694],[1015.44,673.977]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[923.514,697.133],[923.514,807.536],[1015.44,689.811],[1015.44,795.095]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[922.994,828.404],[922.994,938.969],[1021.12,814.095],[1021.12,919.189]]
                },{
                    num:"604",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[992.797,305.696],[992.797,201.662],[1108.29,312.582],[1108.29,211.614]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[1081.83,426.605],[1081.83,318.835],[1015.44,429.204],[1015.44,323.92]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[1081.83,553.834],[1081.83,446.064],[1015.44,553.498],[1015.44,448.214]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[1081.83,569.389],[1081.83,677.159],[1015.44,568.694],[1015.44,673.977]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[1081.83,693.366],[1081.83,801.136],[1015.44,689.811],[1015.44,795.095]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[1079.47,821.09],[1079.47,928.858],[1013.41,814.615],[1013.41,919.907]]
                },{
                    num:"104",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[1079.47,821.09],[1079.47,928.858],[1199.94,811.463],[1199.94,915.55]]
                },{
                    num:"504",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[1081.83,426.605],[1081.83,318.835],[1195.93,430.228],[1195.93,325.923]]
                },{
                    num:"404",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[1081.83,553.834],[1081.83,446.064],[1195.93,553.365],[1195.93,449.061]]
                },{
                    num:"304",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[1081.83,569.389],[1081.83,677.159],[1195.93,568.42],[1195.93,672.724]]
                },{
                    num:"204",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[1081.83,693.366],[1081.83,801.136],[1195.93,688.41],[1195.93,792.715]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[1118.36,311.795],[1118.36,210.478],[1214.68,320.151],[1214.68,222.555]]
                },{
                    num:"503",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[1180.35,434.246],[1180.35,330.512],[1398.3,447.509],[1398.3,356.878]]
                },{
                    num:"403",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[1180.35,556.709],[1180.35,452.976],[1398.3,554.505],[1398.3,463.874]]
                },{
                    num:"303",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[1180.35,571.681],[1180.35,675.415],[1398.3,567.585],[1398.3,658.216]]
                },{
                    num:"203",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[1180.35,691.015],[1180.35,794.749],[1398.3,671.846],[1398.3,762.477]]
                },{
                    num:"103",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[1180.35,810.537],[1180.35,914.271],[1398.3,776.272],[1398.3,866.903]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[1214.68,320.151],[1214.68,222.555],[1295.51,330.623],[1295.51,237.692]]
                },{
                    num:"603",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[1295.51,330.623],[1295.51,237.692],[1338.07,340.046],[1338.07,251.31]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[1332.74,340.87],[1332.74,252.503],[1355.15,349.921],[1355.15,265.585]]
                },{
                    num:"602",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[1355.15,349.921],[1355.15,265.585],[1357.68,356.013],[1357.68,274.392]]
                },{
                    num:"502",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[1418.93,444.446],[1418.93,353.744],[1441.69,448.829],[1441.69,362.321]]
                },{
                    num:"402",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[1418.93,551.525],[1418.93,460.823],[1441.69,550.957],[1441.69,464.449]]
                },{
                    num:"302",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[1418.93,564.616],[1418.93,655.317],[1441.69,563.443],[1441.69,649.951]]
                },{
                    num:"202",
                    tipo:"TorreD",
                    frame:72,
                    verts:[[1418.93,668.958],[1418.93,759.66],[1441.69,662.961],[1441.69,749.47]]
                },
                ],
                [
                
                ]
        ]
    }
}